/**
 * @packageDocumentation
 * @category Translation
 */

import { Translation } from '@bomdisoft/translations';

export const metaDescription: Translation = {
  amharic: 'ለጽዳት፣ ለሕፃናት እንክብካቤ፣ ለምግብ ማብሰል፣ ለጥገና እና ለሌሎችም የተረጋገጠ የአካባቢ ባለሙያ ያግኙ፣ ወይም የራስዎን ክህሎት በዚያው ቀን ወደ ገቢ ይለውጡ። አንድ መተግበሪያ፣ ሁለት የማሸነፊያ መንገዶች።',
  arabic: 'اعثر على محترف محلي موثوق للتنظيف ورعاية الأطفال والطهي والإصلاحات وغيرها، أو حوّل مهاراتك إلى دخل في اليوم نفسه. تطبيق واحد وطريقتان للفوز.',
  bengali: 'পরিচ্ছন্নতা, শিশু পরিচর্যা, রান্না, মেরামত ও আরও অনেক কাজের জন্য যাচাই করা স্থানীয় পেশাদার খুঁজুন, অথবা নিজের দক্ষতাকে সেদিনই আয়ে পরিণত করুন। একটি অ্যাপ, জেতার দুটি উপায়।',
  chinese: '寻找经过验证的本地专业人员，提供保洁、育儿、烹饪、维修等服务；或将你的技能当天变成收入。一个应用，两种赢法。',
  english: 'Find a verified local pro for cleaning, childcare, cooking, repairs and more, or turn your own skills into same-day income. One app, two ways to win.',
  estonian: 'Leia kontrollitud kohalik professionaal koristuseks, lapsehoiuks, toiduvalmistamiseks, remondiks ja muuks, või muuda oma oskused samal päeval sissetulekuks. Üks rakendus, kaks võimalust võita.',
  filipino: 'Maghanap ng beripikadong lokal na propesyonal para sa paglilinis, pag-aalaga ng bata, pagluluto, pagkukumpuni at iba pa, o gawing kita ang sarili mong kakayahan sa parehong araw. Isang app, dalawang paraan para manalo.',
  french: 'Trouvez un pro local vérifié pour le ménage, la garde d’enfants, la cuisine, les réparations et plus encore, ou transformez vos propres compétences en revenus le jour même. Une application, deux façons de gagner.',
  german: 'Finden Sie geprüfte Fachkräfte vor Ort für Reinigung, Kinderbetreuung, Kochen, Reparaturen und mehr, oder machen Sie Ihre eigenen Fähigkeiten noch am selben Tag zu Einkommen. Eine App, zwei Wege zum Erfolg.',
  hindi: 'सफ़ाई, बच्चों की देखभाल, खाना पकाने, मरम्मत और अन्य कामों के लिए सत्यापित स्थानीय पेशेवर खोजें, या अपने हुनर को उसी दिन आमदनी में बदलें। एक ऐप, जीतने के दो तरीके।',
  indonesian: 'Temukan tenaga profesional lokal terverifikasi untuk kebersihan, pengasuhan anak, memasak, perbaikan, dan lainnya, atau ubah keahlian Anda menjadi penghasilan di hari yang sama. Satu aplikasi, dua cara menang.',
  japanese: '清掃、育児、調理、修理などに対応する認証済みの地元プロを見つけましょう。あるいは自分のスキルを当日中の収入に変えることもできます。ひとつのアプリに、２通りの活かし方。',
  korean: '청소, 육아, 요리, 수리 등 검증된 지역 전문가를 찾아보세요. 또는 나의 기술을 당일 수입으로 바꿔보세요. 하나의 앱, 두 가지 방법.',
  portuguese: 'Encontre um profissional local verificado para limpeza, cuidado infantil, cozinha, reparações e muito mais, ou transforme as suas competências em rendimento no próprio dia. Uma app, duas formas de ganhar.',
  russian: 'Найдите проверенного местного специалиста для уборки, ухода за детьми, готовки, ремонта и другого, или превратите собственные навыки в доход в тот же день. Одно приложение, два способа выиграть.',
  spanish: 'Encuentra un profesional local verificado para limpieza, cuidado infantil, cocina, reparaciones y más, o convierte tus propias habilidades en ingresos el mismo día. Una app, dos formas de ganar.',
  swahili: 'Pata mtaalamu wa eneo lako aliyethibitishwa kwa usafi, malezi ya watoto, upishi, matengenezo na mengineyo, au geuza ujuzi wako kuwa kipato siku hiyo hiyo. Programu moja, njia mbili za kufanikiwa.',
  vietnamese: 'Tìm thợ địa phương đã được xác minh cho việc dọn dẹp, trông trẻ, nấu ăn, sửa chữa và nhiều hơn nữa, hoặc biến kỹ năng của bạn thành thu nhập ngay trong ngày. Một ứng dụng, hai cách để thắng.',
};

export const send: Translation = {
  amharic: 'ላክ',
  arabic: 'إرسال',
  bengali: 'পাঠান',
  chinese: '发送',
  english: `send`,
  estonian: 'saada',
  filipino: 'ipadala',
  french: 'envoyer',
  german: 'senden',
  hindi: 'भेजें',
  indonesian: 'kirim',
  japanese: '送信',
  korean: '보내기',
  portuguese: 'enviar',
  russian: 'отправить',
  spanish: 'enviar',
  swahili: 'tuma',
  vietnamese: 'gửi',
};

export const or: Translation = {
  amharic: 'ወይም',
  arabic: 'أو',
  bengali: 'অথবা',
  chinese: '或',
  english: 'OR',
  estonian: `VÕI`,
  filipino: 'O',
  french: 'OU',
  german: `ODER`,
  hindi: 'या',
  indonesian: 'ATAU',
  japanese: 'または',
  korean: '또는',
  portuguese: 'OU',
  russian: `ИЛИ`,
  spanish: 'O',
  swahili: 'AU',
  vietnamese: 'HOẶC',
};
export const tryAgain: Translation = {
  amharic: 'እባክዎ ቆይተው ይሞክሩ!',
  arabic: 'يرجى المحاولة لاحقًا!',
  bengali: 'অনুগ্রহ করে পরে চেষ্টা করুন!',
  chinese: '请稍后再试！',
  english: 'Please try later!',
  estonian: 'Palun proovige hiljem!',
  filipino: 'Mangyaring subukan mamaya!',
  french: `Merci d'essayer plus tard!`,
  german: 'Bitte versuchen Sie es später!',
  hindi: 'कृपया बाद में कोशिश करें!',
  indonesian: 'Silakan coba lagi nanti!',
  japanese: '後でもう一度お試しください！',
  korean: '나중에 다시 시도해주세요!',
  portuguese: 'Por favor, tente mais tarde!',
  russian: 'Пожалуйста, попробуйте позднее!',
  spanish: '¡Por favor, intente más tarde!',
  swahili: 'Tafadhali jaribu baadaye!',
  vietnamese: 'Vui lòng thử lại sau!',
};

export const terms: Translation = {
  amharic: 'ውሎች',
  arabic: 'الشروط',
  bengali: 'শর্তাবলী',
  chinese: '条款',
  english: 'Terms',
  estonian: `Kasutustingimused`,
  filipino: 'Mga tuntunin',
  french: `Conditions d'utilisation`,
  german: `Nutzungsbedingungen`,
  hindi: 'नियम',
  indonesian: 'Ketentuan',
  japanese: '利用規約',
  korean: '약관',
  portuguese: 'Termos',
  russian: `Условия использования`,
  spanish: 'Términos',
  swahili: 'Masharti',
  vietnamese: 'Điều khoản',
};
export const privacy: Translation = {
  amharic: 'ግላዊነት',
  arabic: 'الخصوصية',
  bengali: 'গোপনীয়তা',
  chinese: '隐私',
  english: 'Privacy',
  estonian: `Privaatsus`,
  filipino: 'Pagkapribado',
  french: 'Confidentialité',
  german: `Datenschutzbestimmungen`,
  hindi: 'गोपनीयता',
  indonesian: 'Privasi',
  japanese: 'プライバシー',
  korean: '개인정보 보호',
  portuguese: 'Privacidade',
  russian: `Конфиденциальность`,
  spanish: 'Privacidad',
  swahili: 'Faragha',
  vietnamese: 'Quyền riêng tư',
};

export const faq: Translation = {
  amharic: 'ተደጋጋሚ ጥያቄዎች',
  arabic: 'الأسئلة الشائعة',
  bengali: 'প্রায়শই জিজ্ঞাসিত প্রশ্ন',
  chinese: '常见问题',
  english: 'FAQ',
  estonian: 'KKK',
  filipino: 'Mga Madalas Itanong',
  french: 'FAQ',
  german: 'FAQ',
  hindi: 'अक्सर पूछे जाने वाले प्रश्न',
  indonesian: 'Pertanyaan Umum',
  japanese: 'よくある質問',
  korean: '자주 묻는 질문',
  portuguese: 'Perguntas frequentes',
  russian: 'FAQ',
  spanish: 'Preguntas frecuentes',
  swahili: 'Maswali Yanayoulizwa Mara kwa Mara',
  vietnamese: 'Câu hỏi thường gặp',
};

export const visionTitle: Translation = {
  amharic: 'ራዕያችን',
  arabic: 'رؤيتنا',
  bengali: 'আমাদের দৃষ্টিভঙ্গি',
  chinese: '我们的愿景',
  english: 'Our Vision',
  estonian: 'Meie Visioon',
  filipino: 'Ang aming pananaw',
  french: 'Notre Vision',
  german: 'Unsere Vision',
  hindi: 'हमारी दृष्टि',
  indonesian: 'Visi kami',
  japanese: '私たちのビジョン',
  korean: '우리의 비전',
  portuguese: 'Nossa visão',
  russian: 'Наше Видение',
  spanish: 'Nuestra visión',
  swahili: 'Maono yetu',
  vietnamese: 'Tầm nhìn của chúng tôi',
};

export const visionDescription: Translation = {
  amharic: 'ሁሉም ሰው ከክህሎቶቻቸው እና ተሰጥኦቻቸው ሊጠቀም የሚችል ዓለም። ሰዎች ችሎታዎቻቸውን ለማሳየት እና በማህበረሰቦቻቸው ውስጥ ትርጉም ያላቸውን ግንኙነቶች ለመገንባት እድሎችን ለመፍጠር እናምናለን።',
  arabic: 'عالم يمكن للجميع فيه الاستفادة من مهاراتهم ومواهبهم. نؤمن بخلق الفرص للأشخاص لعرض قدراتهم وبناء روابط ذات معنى في مجتمعاتهم.',
  bengali: 'একটি বিশ্ব যেখানে সবাই তাদের দক্ষতা এবং প্রতিভা থেকে উপকৃত হতে পারে। আমরা মানুষের জন্য তাদের ক্ষমতা প্রদর্শন এবং তাদের সম্প্রদায়ে অর্থপূর্ণ সংযোগ তৈরি করার সুযোগ তৈরি করতে বিশ্বাস করি।',
  chinese: '一个每个人都能从自己的技能和才能中受益的世界。我们相信为人们创造机会展示他们的能力并在他们的社区中建立有意义的联系。',
  english: 'A world where everyone can benefit from their skills and talent. We believe in creating opportunities for people to showcase their abilities and build meaningful connections in their communities.',
  estonian: 'Maailm, kus igaüks saab kasu oma oskustest ja andest. Usume võimaluste loomisse inimestele oma võimete demonstreerimiseks ja mõtestatud ühenduste loomiseks oma kogukondades.',
  filipino: 'Isang mundo kung saan ang lahat ay maaaring makinabang mula sa kanilang mga kasanayan at talento. Naniniwala kami sa paglikha ng mga oportunidad para sa mga tao na ipakita ang kanilang mga kakayahan at bumuo ng makabuluhang koneksyon sa kanilang mga komunidad.',
  french: "Un monde où chacun peut bénéficier de ses compétences et de son talent. Nous croyons en la création d'opportunités pour que les gens puissent montrer leurs capacités et établir des connexions significatives dans leurs communautés.",
  german: 'Eine Welt, in der jeder von seinen Fähigkeiten und Talenten profitieren kann. Wir glauben daran, Möglichkeiten zu schaffen, damit Menschen ihre Fähigkeiten zeigen und bedeutungsvolle Verbindungen in ihren Gemeinschaften aufbauen können.',
  hindi: 'एक ऐसी दुनिया जहाँ हर कोई अपने कौशल और प्रतिभा से लाभान्वित हो सके। हम लोगों के लिए अपनी क्षमताओं को प्रदर्शित करने और अपने समुदायों में सार्थक संबंध बनाने के अवसर पैदा करने में विश्वास करते हैं।',
  indonesian: 'Dunia di mana setiap orang dapat memanfaatkan keterampilan dan bakat mereka. Kami percaya dalam menciptakan peluang bagi orang untuk menampilkan kemampuan mereka dan membangun koneksi yang bermakna di komunitas mereka.',
  japanese: '誰もが自分のスキルと才能から恩恵を受けることができる世界。私たちは、人々が自分の能力を示し、コミュニティで意味のあるつながりを築く機会を作ることを信じています。',
  korean: '모든 사람이 자신의 기술과 재능으로 혜택을 받을 수 있는 세상. 우리는 사람들이 자신의 능력을 보여주고 커뮤니티에서 의미 있는 연결을 구축할 수 있는 기회를 만드는 것을 믿습니다.',
  portuguese: 'Um mundo onde todos possam se beneficiar de suas habilidades e talento. Acreditamos em criar oportunidades para as pessoas mostrarem suas capacidades e construírem conexões significativas em suas comunidades.',
  russian: 'Мир, где каждый может извлечь пользу из своих навыков и талантов. Мы верим в создание возможностей для людей демонстрировать свои способности и строить значимые связи в своих сообществах.',
  spanish: 'Un mundo donde todos puedan beneficiarse de sus habilidades y talento. Creemos en crear oportunidades para que las personas muestren sus capacidades y construyan conexiones significativas en sus comunidades.',
  swahili: 'Dunia ambayo kila mtu anaweza kufaidika na ujuzi na talanta zao. Tunaamini katika kuunda fursa kwa watu kuonyesha uwezo wao na kujenga uhusiano wa maana katika jamii zao.',
  vietnamese: 'Một thế giới nơi mọi người đều có thể hưởng lợi từ kỹ năng và tài năng của họ. Chúng tôi tin vào việc tạo cơ hội cho mọi người thể hiện khả năng của họ và xây dựng các kết nối có ý nghĩa trong cộng đồng của họ.',
};

export const missionTitle: Translation = {
  amharic: 'ተልዕኮችን',
  arabic: 'مهمتنا',
  bengali: 'আমাদের মিশন',
  chinese: '我们的使命',
  english: 'Our Mission',
  estonian: 'Meie Missioon',
  filipino: 'Ang aming misyon',
  french: 'Notre Mission',
  german: 'Unsere Mission',
  hindi: 'हमारा मिशन',
  indonesian: 'Misi kami',
  japanese: '私たちのミッション',
  korean: '우리의 사명',
  portuguese: 'Nossa missão',
  russian: 'Наша Миссия',
  spanish: 'Nuestra misión',
  swahili: 'Lengo letu',
  vietnamese: 'Sứ mệnh của chúng tôi',
};

export const missionDescription: Translation = {
  amharic: 'የተለመዱ አገልግሎቶችን ለመፈለግ የቤት ስም እና ነባሪ ቦታ ለመሆን። 5 ሰዓታት የሚቆይ ኣጎት ያስፈልግዎት ወይም ልዩ ክህሎቶችዎን ገንዘብ ለማድረግ ቢፈልጉም፣ Workadabra የመጀመሪያው ሀሳብዎ መሆን አለበት።',
  arabic: 'أن نصبح الاسم المألوف والمكان الافتراضي للبحث عن الخدمات الشائعة. سواء كنت بحاجة إلى مربية لمدة 5 ساعات أو تريد استثمار مهاراتك الفريدة، يجب أن يكون Workadabra هو فكرتك الأولى.',
  bengali: 'সাধারণ সেবা খোঁজার জন্য গৃহস্থালি নাম এবং ডিফল্ট স্থান হয়ে উঠতে। আপনার 5 ঘন্টার জন্য ন্যানি প্রয়োজন হোক বা আপনার অনন্য দক্ষতা আয় করতে চান, Workadabra আপনার প্রথম চিন্তা হওয়া উচিত।',
  chinese: '成为寻求常见服务的家喻户晓的名称和默认场所。无论您需要保姆5小时还是想将您的独特技能货币化，Workadabra都应该是您的首选。',
  english: 'To become the household name and default place for seeking common services. Whether you need a nanny for 5 hours or want to monetize your unique skills, Workadabra should be your first thought.',
  estonian: 'Saada kodu nimi ja vaikimisi koht tavaliste teenuste otsimiseks. Kas vajate lapsehoidjat 5 tunni jooksul või soovite oma ainulaadsete oskuste rahastamist, Workadabra peaks olema teie esimene mõte.',
  filipino: 'Maging pamilyar na pangalan at default na lugar para sa paghahanap ng mga karaniwang serbisyo. Maging kailangan mo ng nanny sa loob ng 5 oras o gusto mong kumita mula sa inyong natatanging kasanayan, ang Workadabra ay dapat na inyong unang naisip.',
  french: "Devenir le nom familier et l'endroit par défaut pour rechercher des services communs. Que vous ayez besoin d'une nounou pendant 5 heures ou que vous souhaitiez monétiser vos compétences uniques, Workadabra devrait être votre première pensée.",
  german: 'Der Haushaltsname und Standardort für die Suche nach gängigen Dienstleistungen zu werden. Ob Sie eine Nanny für 5 Stunden benötigen oder Ihre einzigartigen Fähigkeiten monetarisieren möchten, Workadabra sollte Ihr erster Gedanke sein.',
  hindi: 'सामान्य सेवाओं की तलाश के लिए घरेलू नाम और डिफ़ॉल्ट स्थान बनना। चाहे आपको 5 घंटे के लिए नैनी की जरूरत हो या आप अपने अद्वितीय कौशल को मुद्रीकृत करना चाहते हों, Workadabra आपका पहला विचार होना चाहिए।',
  indonesian: 'Menjadi nama rumah tangga dan tempat default untuk mencari layanan umum. Baik Anda membutuhkan pengasuh selama 5 jam atau ingin memonetisasi keterampilan unik Anda, Workadabra harus menjadi pikiran pertama Anda.',
  japanese: '一般的なサービスを探すための家庭用の名前とデフォルトの場所になること。5時間のベビーシッターが必要でも、独自のスキルを収益化したい場合でも、Workadabraが最初の選択肢であるべきです。',
  korean: '일반적인 서비스를 찾기 위한 가정용 이름과 기본 장소가 되기. 5시간 동안 보모가 필요하든 고유한 기술을 수익화하고 싶든, Workadabra가 첫 번째 선택이어야 합니다.',
  portuguese: 'Tornar-se o nome familiar e o lugar padrão para buscar serviços comuns. Se você precisa de uma babá por 5 horas ou quer monetizar suas habilidades únicas, Workadabra deve ser seu primeiro pensamento.',
  russian: 'Стать домашним именем и местом по умолчанию для поиска обычных услуг. Нужна ли вам няня на 5 часов или вы хотите монетизировать свои уникальные навыки, Workadabra должна быть вашей первой мыслью.',
  spanish: 'Convertirse en el nombre familiar y el lugar predeterminado para buscar servicios comunes. Ya sea que necesite una niñera por 5 horas o quiera monetizar sus habilidades únicas, Workadabra debería ser su primer pensamiento.',
  swahili: 'Kuwa jina la kaya na mahali pa kawaida pa kutafuta huduma za kawaida. Iwe unahitaji mlezi kwa masaa 5 au unataka kuongeza mapato kwa ujuzi wako wa kipekee, Workadabra inapaswa kuwa mawazo yako ya kwanza.',
  vietnamese: 'Trở thành tên gọi quen thuộc và nơi mặc định để tìm kiếm các dịch vụ phổ biến. Dù bạn cần bảo mẫu trong 5 giờ hay muốn kiếm tiền từ các kỹ năng độc đáo của mình, Workadabra nên là suy nghĩ đầu tiên của bạn.',
};

export const featureSecureTitle: Translation = {
  amharic: 'ደህንነቱ የተጠበቀ ክፍያዎች',
  arabic: 'مدفوعات آمنة',
  bengali: 'নিরাপদ পেমেন্ট',
  chinese: '安全支付',
  english: 'Secure Payments',
  estonian: 'Turvalised Maksed',
  filipino: 'Ligtas na mga bayad',
  french: 'Paiements Sécurisés',
  german: 'Sichere Zahlungen',
  hindi: 'सुरक्षित भुगतान',
  indonesian: 'Pembayaran aman',
  japanese: '安全な支払い',
  korean: '안전한 결제',
  portuguese: 'Pagamentos seguros',
  russian: 'Безопасные Платежи',
  spanish: 'Pagos seguros',
  swahili: 'Malipo salama',
  vietnamese: 'Thanh toán an toàn',
};

export const featureSecureDescription: Translation = {
  amharic: 'ክሪፕቶ፣ Paypal፣ ሞባይል ገንዘብ እና ባንክ ማስተላለፍን ጨምሮ በርካታ የክፍያ አማራጮች። አገልግሎቱ እስኪጠናቀቅ ድረስ ገንዘብዎ ይጠበቃል።',
  arabic: 'خيارات دفع متعددة تشمل العملات المشفرة وPayPal والمال المحمول والتحويلات المصرفية. أموالك محمية حتى اكتمال الخدمة.',
  bengali: 'ক্রিপ্টো, Paypal, মোবাইল মানি এবং ব্যাঙ্ক ট্রান্সফার সহ একাধিক পেমেন্ট বিকল্প। সেবা সম্পন্ন না হওয়া পর্যন্ত আপনার টাকা সুরক্ষিত।',
  chinese: '多种支付选项，包括加密货币、PayPal、移动货币和银行转账。您的资金在服务完成之前都受到保护。',
  english: 'Multiple payment options including crypto, PayPal, mobile money, and bank transfers. Your money is protected until service completion.',
  estonian: 'Mitmed makseviisid, sealhulgas krüpto, PayPal, mobiilraha ja pangakannete. Teie raha on kaitstud kuni teenuse lõpetamiseni.',
  filipino: 'Maraming opsyon sa pagbabayad kabilang ang crypto, PayPal, mobile money, at bank transfers. Ang inyong pera ay protektado hanggang matapos ang serbisyo.',
  french: "Plusieurs options de paiement incluant crypto, PayPal, mobile money et virements bancaires. Votre argent est protégé jusqu'à la fin du service.",
  german: 'Mehrere Zahlungsoptionen einschließlich Krypto, PayPal, Mobile Money und Banküberweisungen. Ihr Geld ist bis zur Fertigstellung des Services geschützt.',
  hindi: 'क्रिप्टो, PayPal, मोबाइल मनी और बैंक ट्रांसफर सहित कई भुगतान विकल्प। आपका पैसा सेवा पूरी होने तक सुरक्षित है।',
  indonesian: 'Berbagai opsi pembayaran termasuk crypto, PayPal, uang seluler, dan transfer bank. Uang Anda dilindungi sampai layanan selesai.',
  japanese: '暗号通貨、Paypal、モバイルマネー、銀行振込を含む複数の支払いオプション。サービスが完了するまで資金は保護されます。',
  korean: '암호화폐, PayPal, 모바일 머니 및 은행 송금을 포함한 다양한 결제 옵션. 서비스가 완료될 때까지 자금이 보호됩니다.',
  portuguese: 'Múltiplas opções de pagamento, incluindo cripto, PayPal, dinheiro móvel e transferências bancárias. Seu dinheiro está protegido até a conclusão do serviço.',
  russian: 'Множественные варианты оплаты, включая криптовалюту, PayPal, мобильные деньги и банковские переводы. Ваши деньги защищены до завершения услуги.',
  spanish: 'Múltiples opciones de pago que incluyen cripto, PayPal, dinero móvil y transferencias bancarias. Su dinero está protegido hasta la finalización del servicio.',
  swahili: 'Chaguzi nyingi za malipo zikiwemo crypto, PayPal, pesa za simu, na uhamisho wa benki. Pesa zako zinalindwa hadi huduma ikamilike.',
  vietnamese: 'Nhiều tùy chọn thanh toán bao gồm tiền điện tử, PayPal, tiền di động và chuyển khoản ngân hàng. Tiền của bạn được bảo vệ cho đến khi dịch vụ hoàn thành.',
};

export const featureVerifiedTitle: Translation = {
  amharic: 'የተረጋገጡ አቅራቢዎች',
  arabic: 'مزودون موثقون',
  bengali: 'যাচাইকৃত প্রদানকারী',
  chinese: '已验证的提供商',
  english: 'Verified Providers',
  estonian: 'Kinnitatud Pakkujad',
  filipino: 'Mga verified na provider',
  french: 'Prestataires Vérifiés',
  german: 'Verifizierte Anbieter',
  hindi: 'सत्यापित प्रदाता',
  indonesian: 'Penyedia terverifikasi',
  japanese: '認証済みプロバイダー',
  korean: '인증된 제공업체',
  portuguese: 'Provedores verificados',
  russian: 'Проверенные Поставщики',
  spanish: 'Proveedores verificados',
  swahili: 'Watoa huduma waliohakikiwa',
  vietnamese: 'Nhà cung cấp đã xác minh',
};

export const featureVerifiedDescription: Translation = {
  amharic: 'ሁሉም የአገልግሎት አቅራቢዎች ጥራት እና ደህንነት ለማረጋገጥ የማንነት ማረጋገጥ ያልፋሉ። በመድረኩ ላይ በሙያዊ ደረጃዎች ይጠበቃሉ።',
  arabic: 'جميع مقدمي الخدمات يخضعون للتحقق من الهوية لضمان الجودة والسلامة. معايير مهنية محفوظة عبر المنصة.',
  bengali: 'সমস্ত সেবা প্রদানকারী গুণমান এবং নিরাপত্তা নিশ্চিত করতে পরিচয় যাচাইকরণের মধ্য দিয়ে যায়। প্ল্যাটফর্ম জুড়ে পেশাদার মান বজায় রাখা হয়।',
  chinese: '所有服务提供商都经过身份验证，以确保质量和安全。在整个平台上保持专业标准。',
  english: 'All service providers go through identity verification to ensure quality and safety. Professional standards maintained across the platform.',
  estonian: 'Kõik teenusepakkujad läbivad identiteedi kinnitamise kvaliteedi ja ohutuse tagamiseks. Professionaalsed standardid säilitatakse kogu platvormil.',
  filipino: 'Lahat ng service provider ay dumadaan sa identity verification upang matiyak ang kalidad at kaligtasan. Ang mga propesyonal na pamantayan ay pinapanatili sa buong platform.',
  french: "Tous les prestataires de services passent par une vérification d'identité pour assurer qualité et sécurité. Standards professionnels maintenus sur toute la plateforme.",
  german: 'Alle Dienstleister durchlaufen eine Identitätsverifizierung, um Qualität und Sicherheit zu gewährleisten. Professionelle Standards werden auf der gesamten Plattform aufrechterhalten.',
  hindi: 'गुणवत्ता और सुरक्षा सुनिश्चित करने के लिए सभी सेवा प्रदाता पहचान सत्यापन से गुजरते हैं। प्लेटफॉर्म भर में पेशेवर मानक बनाए रखे जाते हैं।',
  indonesian: 'Semua penyedia layanan melalui verifikasi identitas untuk memastikan kualitas dan keamanan. Standar profesional dipertahankan di seluruh platform.',
  japanese: 'すべてのサービスプロバイダーは、品質と安全性を確保するために身元確認を通過します。プラットフォーム全体で専門基準が維持されます。',
  korean: '모든 서비스 제공업체는 품질과 안전을 보장하기 위해 신원 확인을 거칩니다. 플랫폼 전반에 걸쳐 전문 표준이 유지됩니다.',
  portuguese: 'Todos os provedores de serviços passam por verificação de identidade para garantir qualidade e segurança. Padrões profissionais mantidos em toda a plataforma.',
  russian: 'Все поставщики услуг проходят проверку личности для обеспечения качества и безопасности. Профессиональные стандарты поддерживаются на всей платформе.',
  spanish: 'Todos los proveedores de servicios pasan por verificación de identidad para garantizar calidad y seguridad. Estándares profesionales mantenidos en toda la plataforma.',
  swahili: 'Watoa huduma wote hupitia uthibitisho wa utambulisho ili kuhakikisha ubora na usalama. Viwango vya kitaalamu vinadumishwa kwenye jukwaa zima.',
  vietnamese: 'Tất cả nhà cung cấp dịch vụ đều trải qua xác minh danh tính để đảm bảo chất lượng và an toàn. Tiêu chuẩn chuyên nghiệp được duy trì trên toàn bộ nền tảng.',
};

export const footerLinkGdpr: Translation = {
  amharic: 'GDPR',
  arabic: 'GDPR',
  bengali: 'GDPR',
  chinese: 'GDPR',
  english: 'GDPR',
  estonian: 'GDPR',
  filipino: 'GDPR',
  french: 'RGPD',
  german: 'DSGVO',
  hindi: 'GDPR',
  indonesian: 'GDPR',
  japanese: 'GDPR',
  korean: 'GDPR',
  portuguese: 'GDPR',
  russian: 'GDPR',
  spanish: 'GDPR',
  swahili: 'GDPR',
  vietnamese: 'GDPR',
};

export const careersHeroTitle: Translation = {
  amharic: 'በተልዕኮችን ይቀላቀሉ',
  arabic: 'انضم إلى مهمتنا',
  bengali: 'আমাদের মিশনে যোগ দিন',
  chinese: '加入我们的使命',
  english: 'Join Our Mission',
  estonian: 'Liitu Meie Missiooniga',
  filipino: 'Sumali sa aming misyon',
  french: 'Rejoignez Notre Mission',
  german: 'Schließen Sie sich unserer Mission an',
  hindi: 'हमारे मिशन में शामिल हों',
  indonesian: 'Bergabunglah dengan Misi Kami',
  japanese: '私たちのミッションに参加',
  korean: '우리의 사명에 참여하세요',
  portuguese: 'Junte-se à nossa missão',
  russian: 'Присоединяйтесь к нашей миссии',
  spanish: 'Únete a nuestra misión',
  swahili: 'Jiunge na Lengo Letu',
  vietnamese: 'Tham gia Sứ mệnh của chúng tôi',
};

export const careersHeroDescription: Translation = {
  amharic: 'በአዲሱ መድረካችን በኩል በለጸጉ ባለሙያዎችን ለማብቃት እና ማህበረሰቦችን ለማገናኘት በተልዕኮ ላይ ነን። በቡድናችን ይቀላቀሉ እና እውነተኛ ተጽዕኖ ያድርጉ።',
  arabic: 'نحن في مهمة لتمكين المحترفين المهرة وربط المجتمعات من خلال منصتنا المبتكرة. انضم إلى فريقنا واصنع تأثيرًا حقيقيًا.',
  bengali: 'আমরা আমাদের উদ্ভাবনী প্ল্যাটফর্মের মাধ্যমে দক্ষ পেশাদারদের ক্ষমতায়ন এবং সম্প্রদায়গুলিকে সংযুক্ত করার একটি মিশনে রয়েছি। আমাদের দলে যোগ দিন এবং একটি বাস্তব প্রভাব তৈরি করুন।',
  chinese: '我们的使命是通过我们创新的平台为熟练的专业人士赋能并连接社区。加入我们的团队，产生真正的影响。',
  english: "We're on a mission to empower skilled professionals and connect communities through our innovative platform. Join our team and make a real impact.",
  estonian: 'Meil on missioon võimustada oskuslikke professionaale ja ühendada kogukondi läbi meie innovaatilise platvormi. Liitu meie meeskonnaga ja tee tõeline mõju.',
  filipino: 'Nasa misyon kami na bigyan ng kapangyarihan ang mga bihasang propesyonal at ikonekta ang mga komunidad sa pamamagitan ng aming makabagong platform. Sumali sa aming team at gumawa ng tunay na epekto.',
  french: "Nous avons pour mission d'autonomiser les professionnels qualifiés et de connecter les communautés grâce à notre plateforme innovante. Rejoignez notre équipe et faites un véritable impact.",
  german: 'Wir haben die Mission, qualifizierte Fachkräfte zu stärken und Gemeinschaften durch unsere innovative Plattform zu verbinden. Schließen Sie sich unserem Team an und machen Sie einen echten Unterschied.',
  hindi: 'हम कुशल पेशेवरों को सशक्त बनाने और हमारे नवाचार मंच के माध्यम से समुदायों को जोड़ने के लिए एक मिशन पर हैं। हमारी टीम में शामिल हों और वास्तविक प्रभाव डालें।',
  indonesian: 'Kami memiliki misi untuk memberdayakan profesional terampil dan menghubungkan komunitas melalui platform inovatif kami. Bergabunglah dengan tim kami dan buat dampak nyata.',
  japanese: '私たちは、革新的なプラットフォームを通じて熟練した専門家に力を与え、コミュニティを結びつける使命を負っています。私たちのチームに参加して、実際の影響を与えてください。',
  korean: '우리는 혁신적인 플랫폼을 통해 숙련된 전문가에게 권한을 부여하고 커뮤니티를 연결하는 사명을 가지고 있습니다. 우리 팀에 합류하여 실제 영향을 미치세요.',
  portuguese: 'Estamos em uma missão para capacitar profissionais qualificados e conectar comunidades através de nossa plataforma inovadora. Junte-se à nossa equipe e faça um impacto real.',
  russian: 'Наша миссия - расширять возможности квалифицированных специалистов и соединять сообщества через нашу инновационную платформу. Присоединяйтесь к нашей команде и окажите реальное влияние.',
  spanish: 'Estamos en una misión para empoderar a profesionales calificados y conectar comunidades a través de nuestra plataforma innovadora. Únete a nuestro equipo y haz un impacto real.',
  swahili: 'Tuna lengo la kuwezesha wataalamu wenye ujuzi na kuunganisha jamii kupitia jukwaa letu la ubunifu. Jiunge na timu yetu na fanya athari halisi.',
  vietnamese: 'Chúng tôi đang thực hiện sứ mệnh trao quyền cho các chuyên gia có kỹ năng và kết nối cộng đồng thông qua nền tảng sáng tạo của chúng tôi. Tham gia đội ngũ của chúng tôi và tạo ra tác động thực sự.',
};

export const careersCultureTitle: Translation = {
  amharic: 'ባህላችን',
  arabic: 'ثقافتنا',
  bengali: 'আমাদের সংস্কৃতি',
  chinese: '我们的文化',
  english: 'Our Culture',
  estonian: 'Meie Kultuur',
  filipino: 'Ang aming kultura',
  french: 'Notre Culture',
  german: 'Unsere Kultur',
  hindi: 'हमारी संस्कृति',
  indonesian: 'Budaya kami',
  japanese: '私たちの文化',
  korean: '우리의 문화',
  portuguese: 'Nossa cultura',
  russian: 'Наша культура',
  spanish: 'Nuestra cultura',
  swahili: 'Utamaduni Wetu',
  vietnamese: 'Văn hóa của chúng tôi',
};

export const careersMissionDrivenTitle: Translation = {
  amharic: 'በተልዕኮ የተነዳ',
  arabic: 'مدفوع بالمهمة',
  bengali: 'মিশন-চালিত',
  chinese: '使命驱动',
  english: 'Mission-Driven',
  estonian: 'Missioonipõhine',
  filipino: 'Mission-Driven',
  french: 'Axé sur la Mission',
  german: 'Mission-getrieben',
  hindi: 'मिशन-संचालित',
  indonesian: 'Didorong oleh Misi',
  japanese: 'ミッション駆動',
  korean: '미션 중심',
  portuguese: 'Impulsionado pela missão',
  russian: 'Ориентированный на миссию',
  spanish: 'Impulsado por la misión',
  swahili: 'Inayoendeshwa na Lengo',
  vietnamese: 'Được thúc đẩy bởi Sứ mệnh',
};

export const careersMissionDrivenText: Translation = {
  amharic: 'በማህበረሰብ ኃይል እና በሙያዊ ስራ ክብር እናምናለን። እያንዳንዱ የቡድን አባል በችሎታ ያላቸውን ባለሙያዎችን አገልግሎቶቻቸውን የሚፈልጉ ሰዎች ጋር ለማገናኘት የሚሰራውን ተልዕኮችን ያስተዋግዳል።',
  arabic: 'نؤمن بقوة المجتمع وكرامة العمل الماهر. كل عضو في الفريق يساهم في مهمتنا لربط المحترفين الموهوبين بالأشخاص الذين يحتاجون خدماتهم.',
  bengali: 'আমরা সম্প্রদায়ের শক্তি এবং দক্ষ কাজের মর্যাদায় বিশ্বাস করি। দলের প্রতিটি সদস্য প্রতিভাবান পেশাদারদের তাদের সেবা প্রয়োজন এমন লোকদের সাথে সংযুক্ত করার আমাদের মিশনে অবদান রাখে।',
  chinese: '我们相信社区的力量和熟练工作的尊严。每个团队成员都为我们的使命做出贡献，即连接有才华的专业人士与需要他们服务的人。',
  english: 'We believe in the power of community and the dignity of skilled work. Every team member contributes to our mission of connecting talented professionals with people who need their services.',
  estonian: 'Usume kogukonna jõusse ja oskusliku töö väärikusse. Iga meeskonnaliige aitab kaasa meie missioonile ühendada andekaid professionaale inimestega, kes vajavad nende teenuseid.',
  filipino: 'Naniniwala kami sa kapangyarihan ng komunidad at dignidad ng bihasang trabaho. Bawat miyembro ng team ay nag-aambag sa aming misyon na ikonekta ang mga talentadong propesyonal sa mga taong nangangailangan ng kanilang mga serbisyo.',
  french: "Nous croyons au pouvoir de la communauté et à la dignité du travail qualifié. Chaque membre de l'équipe contribue à notre mission de connecter des professionnels talentueux avec des personnes qui ont besoin de leurs services.",
  german: 'Wir glauben an die Kraft der Gemeinschaft und die Würde qualifizierter Arbeit. Jedes Teammitglied trägt zu unserer Mission bei, talentierte Fachkräfte mit Menschen zu verbinden, die ihre Dienstleistungen benötigen.',
  hindi: 'हम समुदाय की शक्ति और कुशल काम की गरिमा में विश्वास करते हैं। टीम का हर सदस्य प्रतिभाशाली पेशेवरों को उन लोगों से जोड़ने के हमारे मिशन में योगदान देता है जिन्हें उनकी सेवाओं की आवश्यकता है।',
  indonesian: 'Kami percaya pada kekuatan komunitas dan martabat pekerjaan terampil. Setiap anggota tim berkontribusi pada misi kami untuk menghubungkan profesional berbakat dengan orang yang membutuhkan layanan mereka.',
  japanese: '私たちはコミュニティの力と熟練した仕事の尊厳を信じています。チームの各メンバーが、才能のある専門家をサービスを必要とする人々とつなぐという私たちの使命に貢献しています。',
  korean: '우리는 커뮤니티의 힘과 숙련된 일의 존엄성을 믿습니다. 모든 팀원이 재능 있는 전문가를 서비스가 필요한 사람들과 연결하는 우리의 사명에 기여합니다.',
  portuguese: 'Acreditamos no poder da comunidade e na dignidade do trabalho qualificado. Cada membro da equipe contribui para nossa missão de conectar profissionais talentosos com pessoas que precisam de seus serviços.',
  russian: 'Мы верим в силу сообщества и достоинство квалифицированного труда. Каждый член команды вносит вклад в нашу миссию по соединению талантливых специалистов с людьми, которым нужны их услуги.',
  spanish: 'Creemos en el poder de la comunidad y la dignidad del trabajo calificado. Cada miembro del equipo contribuye a nuestra misión de conectar profesionales talentosos con personas que necesitan sus servicios.',
  swahili: 'Tunaamini katika nguvu ya jamii na heshima ya kazi ya ujuzi. Kila mwanachama wa timu huchangia lengo letu la kuunganisha wataalamu wenye vipawa na watu wanaohitaji huduma zao.',
  vietnamese: 'Chúng tôi tin vào sức mạnh của cộng đồng và phẩm giá của công việc có kỹ năng. Mỗi thành viên trong nhóm đóng góp vào sứ mệnh của chúng tôi là kết nối các chuyên gia tài năng với những người cần dịch vụ của họ.',
};

export const careersInnovationTitle: Translation = {
  amharic: 'በጥንቃቄ የተተኮሰ',
  arabic: 'مركز على الابتكار',
  bengali: 'নবীকরণ-কেন্দ্রিক',
  chinese: '以创新为中心',
  english: 'Innovation-Focused',
  estonian: 'Innovatsioonipõhine',
  filipino: 'Nakatuon sa Innovation',
  french: "Axé sur l'Innovation",
  german: 'Innovationsorientiert',
  hindi: 'नवाचार-केंद्रित',
  indonesian: 'Berfokus pada Inovasi',
  japanese: 'イノベーション重視',
  korean: '혁신 중심',
  portuguese: 'Focado em inovação',
  russian: 'Ориентированный на инновации',
  spanish: 'Enfocado en la innovación',
  swahili: 'Inayolenga Ubunifu',
  vietnamese: 'Tập trung vào Đổi mới',
};

export const careersInnovationText: Translation = {
  amharic: 'የእውነተኛውን ዓለም ችግሮችን ለመፍታት አዲስ ቴክኖሎጂዎችን እና ፈጣን መፍትሄዎችን እንቀበላለን። ቡድናችን ከሳጥኑ ውጭ ለመደምደም እና ወሰኖችን ለመግፋት ይበረታታሉ።',
  arabic: 'نعتمد التقنيات الجديدة والحلول الإبداعية لحل مشاكل العالم الحقيقي. يتم تشجيع فريقنا على التفكير خارج الصندوق ودفع الحدود.',
  bengali: 'আমরা বাস্তব বিশ্বের সমস্যা সমাধানের জন্য নতুন প্রযুক্তি এবং সৃজনশীল সমাধান গ্রহণ করি। আমাদের দলকে বাক্সের বাইরে চিন্তা করতে এবং সীমানা ঠেলে দেওয়ার জন্য উত্সাহিত করা হয়।',
  chinese: '我们采用新技术和创造性解决方案来解决现实世界的问题。我们鼓励团队跳出框框思考并突破界限。',
  english: 'We embrace new technologies and creative solutions to solve real-world problems. Our team is encouraged to think outside the box and push boundaries.',
  estonian: 'Võtame omaks uued tehnoloogiad ja loovad lahendused reaalsete probleemide lahendamiseks. Meie meeskonda julgustatakse mõtlema väljaspool kasti ja suruma piire.',
  filipino: 'Tinatanggap namin ang mga bagong teknolohiya at malikhaing solusyon upang malutas ang mga problema sa totoong mundo. Ang aming team ay hinihikayat na mag-isip nang labas sa kahon at itulak ang mga hangganan.',
  french: 'Nous adoptons les nouvelles technologies et les solutions créatives pour résoudre les problèmes du monde réel. Notre équipe est encouragée à penser différemment et à repousser les limites.',
  german: 'Wir umarmen neue Technologien und kreative Lösungen, um reale Probleme zu lösen. Unser Team wird ermutigt, über den Tellerrand hinauszudenken und Grenzen zu verschieben.',
  hindi: 'हम वास्तविक दुनिया की समस्याओं को हल करने के लिए नई तकनीकों और रचनात्मक समाधानों को अपनाते हैं। हमारी टीम को बॉक्स के बाहर सोचने और सीमाओं को आगे बढ़ाने के लिए प्रोत्साहित किया जाता है।',
  indonesian: 'Kami mengadopsi teknologi baru dan solusi kreatif untuk menyelesaikan masalah dunia nyata. Tim kami didorong untuk berpikir di luar kotak dan mendorong batas.',
  japanese: '私たちは現実世界の問題を解決するために新しい技術と創造的なソリューションを採用しています。私たちのチームは既存の枠を超えて考え、限界を押し広げるよう奨励されています。',
  korean: '우리는 실제 문제를 해결하기 위해 새로운 기술과 창의적인 솔루션을 채택합니다. 우리 팀은 틀에 박힌 사고를 벗어나고 한계를 뛰어넘도록 장려됩니다.',
  portuguese: 'Adotamos novas tecnologias e soluções criativas para resolver problemas do mundo real. Nossa equipe é encorajada a pensar fora da caixa e empurrar limites.',
  russian: 'Мы принимаем новые технологии и творческие решения для решения реальных проблем. Наша команда поощряется думать нестандартно и раздвигать границы.',
  spanish: 'Adoptamos nuevas tecnologías y soluciones creativas para resolver problemas del mundo real. Nuestro equipo es alentado a pensar fuera de la caja y empujar límites.',
  swahili: 'Tunakubali teknolojia mpya na suluhisho za ubunifu ili kutatua matatizo ya ulimwengu halisi. Timu yetu inahimizwa kufikiria nje ya sanduku na kusukuma mipaka.',
  vietnamese: 'Chúng tôi áp dụng các công nghệ mới và giải pháp sáng tạo để giải quyết các vấn đề thực tế. Nhóm của chúng tôi được khuyến khích suy nghĩ ngoài khuôn khổ và đẩy lùi ranh giới.',
};

export const careersBenefitsTitle: Translation = {
  amharic: 'ለምን ከእኛ ጋር ይስሩ',
  arabic: 'لماذا العمل معنا',
  bengali: 'কেন আমাদের সাথে কাজ করবেন',
  chinese: '为什么与我们合作',
  english: 'Why Work With Us',
  estonian: 'Miks Meiega Töötada',
  filipino: 'Bakit magtrabaho sa amin',
  french: 'Pourquoi Travailler Avec Nous',
  german: 'Warum Mit Uns Arbeiten',
  hindi: 'हमारे साथ क्यों काम करें',
  indonesian: 'Mengapa bekerja dengan kami',
  japanese: '私たちと働く理由',
  korean: '우리와 함께 일하는 이유',
  portuguese: 'Por que trabalhar conosco',
  russian: 'Почему работать с нами',
  spanish: 'Por qué trabajar con nosotros',
  swahili: 'Kwa nini ufanye kazi nasi',
  vietnamese: 'Tại sao làm việc với chúng tôi',
};

export const careersCareerGrowthTitle: Translation = {
  amharic: 'የሙያ እድገት',
  arabic: 'النمو المهني',
  bengali: 'ক্যারিয়ার বৃদ্ধি',
  chinese: '职业发展',
  english: 'Career Growth',
  estonian: 'Karjääri Kasv',
  filipino: 'Career Growth',
  french: 'Croissance de Carrière',
  german: 'Karrierewachstum',
  hindi: 'करियर विकास',
  indonesian: 'Pertumbuhan Karir',
  japanese: 'キャリア成長',
  korean: '경력 성장',
  portuguese: 'Crescimento profissional',
  russian: 'Карьерный рост',
  spanish: 'Crecimiento profesional',
  swahili: 'Ukuaji wa Kazi',
  vietnamese: 'Phát triển Sự nghiệp',
};

export const careersCareerGrowthDescription: Translation = {
  amharic: 'ቀጣይነት ያለው ትምህርት እና የማሻሻያ እድሎች',
  arabic: 'التعلم المستمر وفرص التقدم',
  bengali: 'অবিচ্ছিন্ন শেখার এবং অগ্রগতির সুযোগ',
  chinese: '持续学习和晋升机会',
  english: 'Continuous learning and advancement opportunities',
  estonian: 'Pidev õppimine ja edenemisvõimalused',
  filipino: 'Patuloy na pag-aaral at oportunidad sa pag-unlad',
  french: "Opportunités d'apprentissage continu et d'avancement",
  german: 'Kontinuierliche Lern- und Aufstiegsmöglichkeiten',
  hindi: 'निरंतर सीखने और उन्नति के अवसर',
  indonesian: 'Pembelajaran berkelanjutan dan peluang kemajuan',
  japanese: '継続的な学習と昇進の機会',
  korean: '지속적인 학습 및 승진 기회',
  portuguese: 'Aprendizado contínuo e oportunidades de avanço',
  russian: 'Постоянные возможности обучения и продвижения',
  spanish: 'Aprendizaje continuo y oportunidades de avance',
  swahili: 'Kujifunza endelevu na fursa za maendeleo',
  vietnamese: 'Học tập liên tục và cơ hội thăng tiến',
};

export const careersTeamCultureTitle: Translation = {
  amharic: 'የቡድን ባህል',
  arabic: 'ثقافة الفريق',
  bengali: 'দল সংস্কৃতি',
  chinese: '团队文化',
  english: 'Team Culture',
  estonian: 'Meeskonna Kultuur',
  filipino: 'Kultura ng Team',
  french: "Culture d'Équipe",
  german: 'Teamkultur',
  hindi: 'टीम संस्कृति',
  indonesian: 'Budaya Tim',
  japanese: 'チーム文化',
  korean: '팀 문화',
  portuguese: 'Cultura da equipe',
  russian: 'Культура команды',
  spanish: 'Cultura del equipo',
  swahili: 'Utamaduni wa Timu',
  vietnamese: 'Văn hóa Đội ngũ',
};

export const careersTeamCultureDescription: Translation = {
  amharic: 'በመንፈስ የተሞሉ ባለሙያዎች ያሉት የጋራ አካባቢ',
  arabic: 'بيئة تعاونية مع محترفين متحمسين',
  bengali: 'আবেগপ্রবণ পেশাদারদের সাথে সহযোগিতামূলক পরিবেশ',
  chinese: '与充满热情的专业人士合作的协作环境',
  english: 'Collaborative environment with passionate professionals',
  estonian: 'Koostöökeskkond kirglike professionaalidega',
  filipino: 'Collaborative na kapaligiran na may mga passionate na propesyonal',
  french: 'Environnement collaboratif avec des professionnels passionnés',
  german: 'Kollaborative Umgebung mit leidenschaftlichen Fachleuten',
  hindi: 'उत्साही पेशेवरों के साथ सहयोगी वातावरण',
  indonesian: 'Lingkungan kolaboratif dengan profesional yang bersemangat',
  japanese: '情熱的な専門家との協力的な環境',
  korean: '열정적인 전문가들과 함께하는 협업 환경',
  portuguese: 'Ambiente colaborativo com profissionais apaixonados',
  russian: 'Совместная среда с увлеченными профессионалами',
  spanish: 'Entorno colaborativo con profesionales apasionados',
  swahili: 'Mazingira ya ushirikiano na wataalamu wenye shauku',
  vietnamese: 'Môi trường hợp tác với các chuyên gia đam mê',
};

export const careersCompetitiveBenefitsTitle: Translation = {
  amharic: 'ውድድር ያላቸው ጥቅሞች',
  arabic: 'مزايا تنافسية',
  bengali: 'প্রতিযোগিতামূলক সুবিধা',
  chinese: '有竞争力的福利',
  english: 'Competitive Benefits',
  estonian: 'Konkurentsivõimelised Hüved',
  filipino: 'Competitive na benepisyo',
  french: 'Avantages Concurrentiels',
  german: 'Wettbewerbsfähige Vorteile',
  hindi: 'प्रतिस्पर्धी लाभ',
  indonesian: 'Manfaat kompetitif',
  japanese: '競争力のある福利厚生',
  korean: '경쟁력 있는 혜택',
  portuguese: 'Benefícios competitivos',
  russian: 'Конкурентные преимущества',
  spanish: 'Beneficios competitivos',
  swahili: 'Faida za Ushindani',
  vietnamese: 'Lợi ích cạnh tranh',
};

export const careersCompetitiveBenefitsDescription: Translation = {
  amharic: 'የጤና ኢንሹራንስ፣ ተለዋዋጭ ሰዓታት እና ርቀት ላይ የስራ አማራጮች',
  arabic: 'تأمين صحي، ساعات مرنة وخيارات العمل عن بُعد',
  bengali: 'স্বাস্থ্য বীমা, নমনীয় ঘন্টা এবং দূরবর্তী কাজের বিকল্প',
  chinese: '健康保险、灵活工作时间和远程工作选择',
  english: 'Health insurance, flexible hours, and remote work options',
  estonian: 'Tervisekindlustus, paindlikud tööajad ja kaugtöö võimalused',
  filipino: 'Health insurance, flexible hours, at remote work options',
  french: 'Assurance maladie, horaires flexibles et options de travail à distance',
  german: 'Krankenversicherung, flexible Arbeitszeiten und Remote-Arbeitsoptionen',
  hindi: 'स्वास्थ्य बीमा, लचीले घंटे और दूरस्थ कार्य विकल्प',
  indonesian: 'Asuransi kesehatan, jam kerja fleksibel, dan opsi kerja jarak jauh',
  japanese: '健康保険、柔軟な勤務時間、リモートワークオプション',
  korean: '건강 보험, 유연한 근무 시간 및 원격 근무 옵션',
  portuguese: 'Seguro de saúde, horários flexíveis e opções de trabalho remoto',
  russian: 'Медицинская страховка, гибкий график и возможности удаленной работы',
  spanish: 'Seguro de salud, horarios flexibles y opciones de trabajo remoto',
  swahili: 'Bima ya afya, masaa ya kubadilika, na chaguzi za kazi ya mbali',
  vietnamese: 'Bảo hiểm sức khỏe, giờ làm việc linh hoạt và tùy chọn làm việc từ xa',
};

export const careersLearningBudgetTitle: Translation = {
  amharic: 'የትምህርት በጀት',
  arabic: 'ميزانية التعلم',
  bengali: 'শেখার বাজেট',
  chinese: '学习预算',
  english: 'Learning Budget',
  estonian: 'Õppe Eelarve',
  filipino: 'Learning budget',
  french: 'Budget de Formation',
  german: 'Lernbudget',
  hindi: 'सीखने का बजट',
  indonesian: 'Anggaran pembelajaran',
  japanese: '学習予算',
  korean: '학습 예산',
  portuguese: 'Orçamento de aprendizado',
  russian: 'Бюджет на обучение',
  spanish: 'Presupuesto de aprendizaje',
  swahili: 'Bajeti ya Kujifunza',
  vietnamese: 'Ngân sách học tập',
};

export const careersLearningBudgetDescription: Translation = {
  amharic: 'ለኮርሶች፣ ለኮንፈረንሶች እና ለማረጋገጫዎች ዓመታዊ በጀት',
  arabic: 'الميزانية السنوية للدورات والمؤتمرات والشهادات',
  bengali: 'কোর্স, সম্মেলন এবং সার্টিফিকেশনের জন্য বার্ষিক বাজেট',
  chinese: '用于课程、会议和认证的年度预算',
  english: 'Annual budget for courses, conferences, and certifications',
  estonian: 'Aastane eelarve kursuste, konverentside ja sertifitseerimise jaoks',
  filipino: 'Taunang budget para sa mga kurso, conference, at certifications',
  french: 'Budget annuel pour les cours, conférences et certifications',
  german: 'Jährliches Budget für Kurse, Konferenzen und Zertifizierungen',
  hindi: 'पाठ्यक्रम, सम्मेलन और प्रमाणपत्रों के लिए वार्षिक बजट',
  indonesian: 'Anggaran tahunan untuk kursus, konferensi, dan sertifikasi',
  japanese: 'コース、会議、認定のための年間予算',
  korean: '과정, 컨퍼런스 및 인증을 위한 연간 예산',
  portuguese: 'Orçamento anual para cursos, conferências e certificações',
  russian: 'Годовой бюджет на курсы, конференции и сертификацию',
  spanish: 'Presupuesto anual para cursos, conferencias y certificaciones',
  swahili: 'Bajeti ya kila mwaka kwa kozi, mikutano, na vyeti',
  vietnamese: 'Ngân sách hàng năm cho khóa học, hội nghị và chứng chỉ',
};

export const careersNoPositionsTitle: Translation = {
  amharic: 'በአሁኑ ጊዜ ክፍት የሆኑ የስራ ቦታዎች የሉም',
  arabic: 'لا توجد مناصب مفتوحة في الوقت الحالي',
  bengali: 'এই মুহূর্তে কোন খোলা পদ নেই',
  chinese: '目前没有空缺职位',
  english: 'No Open Positions at the Moment',
  estonian: 'Praegu Pole Vabu Kohti',
  filipino: 'Walang bukas na posisyon sa ngayon',
  french: 'Aucun Poste Ouvert Actuellement',
  german: 'Derzeit Keine Offenen Positionen',
  hindi: 'इस समय कोई खुली स्थिति नहीं',
  indonesian: 'Tidak Ada Posisi Terbuka Saat Ini',
  japanese: '現在、空いているポジションはありません',
  korean: '현재 공개 채용 없음',
  portuguese: 'Nenhuma posição aberta no momento',
  russian: 'В настоящее время нет открытых вакансий',
  spanish: 'No hay posiciones abiertas en este momento',
  swahili: 'Hakuna Nafasi Wazi Kwa Sasa',
  vietnamese: 'Không có vị trí mở vào lúc này',
};

export const careersNoPositionsText: Translation = {
  amharic: 'አሁን አንቀጥርም፣ ነገር ግን በቡድናችን ለመቀላቀል በችሎታ ያላቸውን ሰዎችን ሁልጊዜ እያፈለግን ነን። የእርስዎን የስራ ታሪክ ይላኩልን እና ለወደፊት እድሎች እናስቀምጠዋለን።',
  arabic: 'نحن لا نوظف حاليًا، لكننا نبحث دائمًا عن أفراد موهوبين للانضمام إلى فريقنا. أرسل لنا سيرتك الذاتية وسنحتفظ بها للمستقبل.',
  bengali: 'আমরা বর্তমানে নিয়োগ দিচ্ছি না, কিন্তু আমরা সবসময় প্রতিভাবান ব্যক্তিদের খুঁজছি যারা আমাদের দলে যোগ দিতে পারে। আমাদের আপনার রিজিউমে পাঠান এবং আমরা ভবিষ্যতের সুযোগের জন্য এটি ফাইলে রাখব।',
  chinese: '我们目前不招聘，但我们一直在寻找有才华的个人加入我们的团队。向我们发送您的简历，我们将为您保留以备将来的机会。',
  english: "We're not currently hiring, but we're always looking for talented individuals to join our team. Send us your resume and we'll keep it on file for future opportunities.",
  estonian: 'Me ei pruugi praegu värbama, kuid otsime alati andekaid inimesi meeskonda. Saadke meile oma CV ja me säilitame selle tulevaste võimaluste jaoks.',
  filipino: 'Hindi kami kumukuha ngayon, ngunit palagi naming hinahanap ang mga talentadong indibidwal na sumali sa aming team. Ipadala sa amin ang inyong resume at itatago namin ito para sa mga oportunidad sa hinaharap.',
  french: 'Nous ne recrutons pas actuellement, mais nous cherchons toujours des personnes talentueuses pour rejoindre notre équipe. Envoyez-nous votre CV et nous le conserverons pour de futures opportunités.',
  german: 'Wir stellen derzeit nicht ein, aber wir suchen immer talentierte Menschen, die unserem Team beitreten möchten. Senden Sie uns Ihren Lebenslauf und wir bewahren ihn für zukünftige Gelegenheiten auf.',
  hindi: 'हम वर्तमान में भर्ती नहीं कर रहे हैं, लेकिन हम हमेशा प्रतिभाशाली व्यक्तियों की तलाश कर रहे हैं जो हमारी टीम में शामिल हों। हमें अपना रिज्यूमे भेजें और हम इसे भविष्य के अवसरों के लिए फाइल में रखेंगे।',
  indonesian: 'Kami saat ini tidak merekrut, tetapi kami selalu mencari individu berbakat untuk bergabung dengan tim kami. Kirimkan resume Anda kepada kami dan kami akan menyimpannya untuk peluang di masa depan.',
  japanese: '現在採用は行っていませんが、常にチームに参加する才能のある個人を探しています。履歴書を送ってください。今後の機会のために保管いたします。',
  korean: '현재 채용 중이 아니지만, 항상 우리 팀에 합류할 재능 있는 개인을 찾고 있습니다. 이력서를 보내주시면 향후 기회를 위해 보관하겠습니다.',
  portuguese: 'Não estamos contratando no momento, mas sempre procuramos pessoas talentosas para se juntar à nossa equipe. Envie-nos seu currículo e o manteremos em arquivo para oportunidades futuras.',
  russian: 'Мы сейчас не нанимаем, но всегда ищем талантливых людей для нашей команды. Отправьте нам свое резюме, и мы сохраним его для будущих возможностей.',
  spanish: 'Actualmente no estamos contratando, pero siempre estamos buscando personas talentosas para unirse a nuestro equipo. Envíenos su currículum y lo guardaremos para futuras oportunidades.',
  swahili: 'Hatuaajiri kwa sasa, lakini tunatafuta kila wakati watu wenye vipawa kujiunga na timu yetu. Tutumie wasifu wako na tutaweka kwenye faili kwa fursa za baadaye.',
  vietnamese: 'Chúng tôi hiện không tuyển dụng, nhưng chúng tôi luôn tìm kiếm những cá nhân tài năng để tham gia đội ngũ của chúng tôi. Gửi cho chúng tôi sơ yếu lý lịch của bạn và chúng tôi sẽ lưu giữ nó cho các cơ hội trong tương lai.',
};

export const careersSendResume: Translation = {
  amharic: 'የስራ ታሪክ ይላኩ',
  arabic: 'إرسال السيرة الذاتية',
  bengali: 'রিজিউমে পাঠান',
  chinese: '发送简历',
  english: 'Send Resume',
  estonian: 'Saada CV',
  filipino: 'Magpadala ng resume',
  french: 'Envoyer le CV',
  german: 'Lebenslauf Senden',
  hindi: 'रिज्यूमे भेजें',
  indonesian: 'Kirim resume',
  japanese: '履歴書を送信',
  korean: '이력서 보내기',
  portuguese: 'Enviar currículo',
  russian: 'Отправить резюме',
  spanish: 'Enviar currículum',
  swahili: 'Tuma Wasifu',
  vietnamese: 'Gửi sơ yếu lý lịch',
};

export const communityHeroTitle: Translation = {
  amharic: 'ማህበረሰባችን',
  arabic: 'مجتمعنا',
  bengali: 'আমাদের সম্প্রদায়',
  chinese: '我们的社区',
  english: 'Our Community',
  estonian: 'Meie Kogukond',
  filipino: 'Ang aming komunidad',
  french: 'Notre Communauté',
  german: 'Unsere Gemeinschaft',
  hindi: 'हमारा समुदाय',
  indonesian: 'Komunitas kami',
  japanese: '私たちのコミュニティ',
  korean: '우리의 커뮤니티',
  portuguese: 'Nossa comunidade',
  russian: 'Наше сообщество',
  spanish: 'Nuestra comunidad',
  swahili: 'Jamii Yetu',
  vietnamese: 'Cộng đồng của chúng tôi',
};

export const communityHeroDescription: Translation = {
  amharic: 'በWorkadabra በኩል የተሳኩ ንግዶችን የሚገነቡ እና ማህበረሰቦቻቸውን የሚያገለግሉ በሺዎች የሚቆጠሩ በለጸጉ ባለሙያዎች ይቀላቀሉ።',
  arabic: 'انضم إلى آلاف المحترفين المهرة الذين يبنون أعمالًا ناجحة وخدمة مجتمعاتهم من خلال Workadabra.',
  bengali: 'হাজার হাজার দক্ষ পেশাদারদের সাথে যোগ দিন যারা Workadabra এর মাধ্যমে সফল ব্যবসা গড়ে তুলছেন এবং তাদের সম্প্রদায়ের সেবা করছেন।',
  chinese: '加入数千名熟练的专业人士，他们通过Workadabra建立成功的企业并为他们的社区服务。',
  english: 'Join thousands of skilled professionals who are building successful businesses and serving their communities through Workadabra.',
  estonian: 'Liitu tuhandete oskuslike professionaalidega, kes ehitavad edukaid ettevõtteid ja teenivad oma kogukondi läbi Workadabra.',
  filipino: 'Sumali sa libu-libong bihasang propesyonal na nagtatayo ng matagumpay na negosyo at naglilingkod sa kanilang mga komunidad sa pamamagitan ng Workadabra.',
  french: 'Rejoignez des milliers de professionnels qualifiés qui construisent des entreprises prospères et servent leurs communautés grâce à Workadabra.',
  german: 'Schließen Sie sich Tausenden von qualifizierten Fachkräften an, die erfolgreiche Unternehmen aufbauen und ihre Gemeinschaften durch Workadabra bedienen.',
  hindi: 'हजारों कुशल पेशेवरों से जुड़ें जो Workadabra के माध्यम से सफल व्यवसाय बना रहे हैं और अपने समुदायों की सेवा कर रहे हैं।',
  indonesian: 'Bergabunglah dengan ribuan profesional terampil yang membangun bisnis sukses dan melayani komunitas mereka melalui Workadabra.',
  japanese: 'Workadabraを通じて成功したビジネスを構築し、コミュニティに奉仕している何千人もの熟練した専門家に参加してください。',
  korean: 'Workadabra를 통해 성공적인 비즈니스를 구축하고 커뮤니티에 봉사하는 수천 명의 숙련된 전문가들과 함께하세요.',
  portuguese: 'Junte-se a milhares de profissionais qualificados que estão construindo negócios de sucesso e servindo suas comunidades através do Workadabra.',
  russian: 'Присоединяйтесь к тысячам квалифицированных специалистов, которые строят успешный бизнес и служат своим сообществам через Workadabra.',
  spanish: 'Únete a miles de profesionales calificados que están construyendo negocios exitosos y sirviendo a sus comunidades a través de Workadabra.',
  swahili: 'Jiunge na maelfu ya wataalamu wenye ujuzi ambao wanajenga biashara za mafanikio na kuhudumia jamii zao kupitia Workadabra.',
  vietnamese: 'Tham gia cùng hàng nghìn chuyên gia có kỹ năng đang xây dựng doanh nghiệp thành công và phục vụ cộng đồng của họ thông qua Workadabra.',
};

export const communityGuidelinesTitle: Translation = {
  amharic: 'የማህበረሰብ መመሪያዎች',
  arabic: 'إرشادات المجتمع',
  bengali: 'সম্প্রদায় নির্দেশিকা',
  chinese: '社区准则',
  english: 'Community Guidelines',
  estonian: 'Kogukonna Juhised',
  filipino: 'Mga alituntunin ng komunidad',
  french: 'Directives de la Communauté',
  german: 'Community-Richtlinien',
  hindi: 'समुदाय दिशानिर्देश',
  indonesian: 'Pedoman komunitas',
  japanese: 'コミュニティガイドライン',
  korean: '커뮤니티 가이드라인',
  portuguese: 'Diretrizes da comunidade',
  russian: 'Руководящие принципы сообщества',
  spanish: 'Pautas de la comunidad',
  swahili: 'Miongozo ya Jamii',
  vietnamese: 'Hướng dẫn cộng đồng',
};

export const communityGuidelinesIntro: Translation = {
  amharic: 'ደህንነቱ የተጠበቀ እና በሙያዊ አካባቢን ለመጠበቅ፣ ሁሉም አባላት እነዚህን መመሪያዎች መከተል አለባቸው:',
  arabic: 'للحفاظ على بيئة آمنة ومهنية، يجب على جميع الأعضاء اتباع هذه الإرشادات:',
  bengali: 'একটি নিরাপদ এবং পেশাদার পরিবেশ বজায় রাখতে, সমস্ত সদস্যদের এই নির্দেশিকাগুলি অনুসরণ করতে হবে:',
  chinese: '为了维护安全和专业的环境，所有成员必须遵循这些准则：',
  english: 'To maintain a safe and professional environment, all members must follow these guidelines:',
  estonian: 'Turvalise ja professionaalse keskkonna säilitamiseks peavad kõik liikmed järgima neid juhiseid:',
  filipino: 'Upang mapanatili ang ligtas at propesyonal na kapaligiran, lahat ng miyembro ay dapat sundin ang mga alituntuning ito:',
  french: 'Pour maintenir un environnement sûr et professionnel, tous les membres doivent suivre ces directives:',
  german: 'Um eine sichere und professionelle Umgebung zu gewährleisten, müssen alle Mitglieder diese Richtlinien befolgen:',
  hindi: 'एक सुरक्षित और पेशेवर वातावरण बनाए रखने के लिए, सभी सदस्यों को इन दिशानिर्देशों का पालन करना चाहिए:',
  indonesian: 'Untuk mempertahankan lingkungan yang aman dan profesional, semua anggota harus mengikuti pedoman ini:',
  japanese: '安全で専門的な環境を維持するために、すべてのメンバーは次のガイドラインに従う必要があります:',
  korean: '안전하고 전문적인 환경을 유지하기 위해 모든 회원은 다음 가이드라인을 따라야 합니다:',
  portuguese: 'Para manter um ambiente seguro e profissional, todos os membros devem seguir estas diretrizes:',
  russian: 'Для поддержания безопасной и профессиональной среды все участники должны следовать этим руководящим принципам:',
  spanish: 'Para mantener un entorno seguro y profesional, todos los miembros deben seguir estas pautas:',
  swahili: 'Ili kudumisha mazingira salama na ya kitaalamu, wanachama wote lazima wafuate miongozo hii:',
  vietnamese: 'Để duy trì một môi trường an toàn và chuyên nghiệp, tất cả các thành viên phải tuân theo các hướng dẫn này:',
};

export const contactHeroTitle: Translation = {
  amharic: 'ያግኙን',
  arabic: 'تواصل معنا',
  bengali: 'যোগাযোগ করুন',
  chinese: '联系我们',
  english: 'Get in Touch',
  estonian: 'Võta Ühendust',
  filipino: 'Makipag-ugnayan',
  french: 'Contactez-nous',
  german: 'Kontaktieren Sie uns',
  hindi: 'संपर्क करें',
  indonesian: 'Hubungi kami',
  japanese: 'お問い合わせ',
  korean: '연락하기',
  portuguese: 'Entre em contato',
  russian: 'Свяжитесь с нами',
  spanish: 'Ponerse en contacto',
  swahili: 'Wasiliana',
  vietnamese: 'Liên hệ',
};

export const contactHeroDescription: Translation = {
  amharic: 'ንግድዎን ለማሳደግ የሚፈልጉ የአገልግሎት አቅራቢ ወይም ጥራት ያላቸውን አገልግሎቶች የሚፈልጉ ደንበኞች ይሁኑ፣ ቡድናችን እርዳታ ለመስጠት ዝግጁ ነው።',
  arabic: 'سواء كنت مقدم خدمة تتطلع إلى تنمية عملك أو عميل يبحث عن خدمات عالية الجودة، فريقنا جاهز لمساعدتك.',
  bengali: 'আপনি একজন সেবা প্রদানকারী যিনি আপনার ব্যবসা বাড়াতে চান বা একজন ক্লায়েন্ট যিনি মানসম্পন্ন সেবা খুঁজছেন, আমাদের দল আপনাকে সহায়তা করতে প্রস্তুত।',
  chinese: '无论您是寻求发展业务的服务提供商，还是寻求优质服务的客户，我们的团队都随时准备为您提供帮助。',
  english: "Whether you're a service provider looking to grow your business or a client seeking quality services, our team is ready to assist you.",
  estonian: 'Olen teie teenusepakkuja, kes soovib oma ettevõtet kasvatada, või klient, kes otsib kvaliteetseid teenuseid, meie meeskond on valmis teid aitama.',
  filipino: 'Maging ikaw ay isang service provider na naghahanap na palaguin ang inyong negosyo o isang client na naghahanap ng de-kalidad na serbisyo, ang aming team ay handa na tumulong sa inyo.',
  french: 'Que vous soyez un prestataire de services cherchant à développer votre entreprise ou un client recherchant des services de qualité, notre équipe est prête à vous assister.',
  german: 'Ob Sie ein Dienstleister sind, der sein Geschäft ausbauen möchte, oder ein Kunde, der qualitativ hochwertige Dienstleistungen sucht, unser Team ist bereit, Ihnen zu helfen.',
  hindi: 'चाहे आप अपने व्यवसाय को बढ़ाने की तलाश कर रहे सेवा प्रदाता हों या गुणवत्तापूर्ण सेवाओं की तलाश कर रहे ग्राहक हों, हमारी टीम आपकी सहायता के लिए तैयार है।',
  indonesian: 'Baik Anda penyedia layanan yang ingin mengembangkan bisnis Anda atau klien yang mencari layanan berkualitas, tim kami siap membantu Anda.',
  japanese: 'ビジネスを成長させたいサービスプロバイダーでも、質の高いサービスを求めるクライアントでも、私たちのチームはあなたをサポートする準備ができています。',
  korean: '비즈니스를 성장시키려는 서비스 제공업체이든 품질 서비스를 찾는 고객이든, 우리 팀은 여러분을 도울 준비가 되어 있습니다.',
  portuguese: 'Seja você um provedor de serviços que busca expandir seu negócio ou um cliente que busca serviços de qualidade, nossa equipe está pronta para ajudá-lo.',
  russian: 'Будь вы поставщик услуг, стремящийся развивать свой бизнес, или клиент, ищущий качественные услуги, наша команда готова помочь вам.',
  spanish: 'Ya sea que sea un proveedor de servicios que busca hacer crecer su negocio o un cliente que busca servicios de calidad, nuestro equipo está listo para ayudarlo.',
  swahili: 'Iwe wewe ni mtoa huduma anayetaka kukuza biashara yako au mteja anayetafuta huduma za ubora, timu yetu iko tayari kukusaidia.',
  vietnamese: 'Dù bạn là nhà cung cấp dịch vụ muốn phát triển doanh nghiệp hay khách hàng tìm kiếm dịch vụ chất lượng, đội ngũ của chúng tôi sẵn sàng hỗ trợ bạn.',
};

export const contactUsTitle: Translation = {
  amharic: 'ያግኙን',
  arabic: 'اتصل بنا',
  bengali: 'আমাদের সাথে যোগাযোগ করুন',
  chinese: '联系我们',
  english: 'Contact Us',
  estonian: 'Võta Meiega Ühendust',
  filipino: 'Makipag-ugnayan sa amin',
  french: 'Contactez-nous',
  german: 'Kontaktieren Sie uns',
  hindi: 'हमसे संपर्क करें',
  indonesian: 'Hubungi kami',
  japanese: 'お問い合わせ',
  korean: '문의하기',
  portuguese: 'Entre em contato',
  russian: 'Свяжитесь с нами',
  spanish: 'Contáctenos',
  swahili: 'Wasiliana Nasi',
  vietnamese: 'Liên hệ với chúng tôi',
};

export const contactEmailSupport: Translation = {
  amharic: 'የኢሜይል ድጋፍ',
  arabic: 'دعم البريد الإلكتروني',
  bengali: 'ইমেইল সহায়তা',
  chinese: '电子邮件支持',
  english: 'Email Support',
  estonian: 'E-posti Tugi',
  filipino: 'Email support',
  french: 'Support par Email',
  german: 'E-Mail-Support',
  hindi: 'ईमेल सहायता',
  indonesian: 'Dukungan email',
  japanese: 'メールサポート',
  korean: '이메일 지원',
  portuguese: 'Suporte por e-mail',
  russian: 'Поддержка по электронной почте',
  spanish: 'Soporte por correo electrónico',
  swahili: 'Msaada wa Barua Pepe',
  vietnamese: 'Hỗ trợ email',
};

export const contactEmailDescription: Translation = {
  amharic: 'በኢሜይል በኩል እርዳታ ያግኙ',
  arabic: 'احصل على المساعدة عبر البريد الإلكتروني',
  bengali: 'ইমেইলের মাধ্যমে সাহায্য পান',
  chinese: '通过电子邮件获得帮助',
  english: 'Get help via email',
  estonian: 'Saa abi e-posti teel',
  filipino: 'Kumuha ng tulong sa pamamagitan ng email',
  french: "Obtenez de l'aide par email",
  german: 'Erhalten Sie Hilfe per E-Mail',
  hindi: 'ईमेल के माध्यम से सहायता प्राप्त करें',
  indonesian: 'Dapatkan bantuan melalui email',
  japanese: 'メールでサポートを受ける',
  korean: '이메일을 통해 도움을 받으세요',
  portuguese: 'Obtenha ajuda por e-mail',
  russian: 'Получите помощь по электронной почте',
  spanish: 'Obtenga ayuda por correo electrónico',
  swahili: 'Pata msaada kupitia barua pepe',
  vietnamese: 'Nhận trợ giúp qua email',
};

export const contactPhoneSupport: Translation = {
  amharic: 'የስልክ ድጋፍ',
  arabic: 'دعم الهاتف',
  bengali: 'ফোন সহায়তা',
  chinese: '电话支持',
  english: 'Phone Support',
  estonian: 'Telefoni Tugi',
  filipino: 'Phone support',
  french: 'Support Téléphonique',
  german: 'Telefon-Support',
  hindi: 'फोन सहायता',
  indonesian: 'Dukungan telepon',
  japanese: '電話サポート',
  korean: '전화 지원',
  portuguese: 'Suporte telefônico',
  russian: 'Телефонная поддержка',
  spanish: 'Soporte telefónico',
  swahili: 'Msaada wa Simu',
  vietnamese: 'Hỗ trợ điện thoại',
};

export const contactPhoneDescription: Translation = {
  amharic: 'ከቡድናችን ጋር ይናገሩ',
  arabic: 'تحدث مع فريقنا',
  bengali: 'আমাদের দলের সাথে কথা বলুন',
  chinese: '与我们的团队交谈',
  english: 'Speak with our team',
  estonian: 'Räägi meie meeskonnaga',
  filipino: 'Makipag-usap sa aming team',
  french: 'Parlez avec notre équipe',
  german: 'Sprechen Sie mit unserem Team',
  hindi: 'हमारी टीम से बात करें',
  indonesian: 'Bicara dengan tim kami',
  japanese: '私たちのチームと話す',
  korean: '우리 팀과 대화하세요',
  portuguese: 'Fale com nossa equipe',
  russian: 'Поговорите с нашей командой',
  spanish: 'Hable con nuestro equipo',
  swahili: 'Zungumza na timu yetu',
  vietnamese: 'Nói chuyện với đội ngũ của chúng tôi',
};

export const contactLiveChat: Translation = {
  amharic: 'የቀጥታ ውይይት',
  arabic: 'دردشة مباشرة',
  bengali: 'লাইভ চ্যাট',
  chinese: '在线聊天',
  english: 'Live Chat',
  estonian: 'Otsevestlus',
  filipino: 'Live chat',
  french: 'Chat en Direct',
  german: 'Live-Chat',
  hindi: 'लाइव चैट',
  indonesian: 'Obrolan langsung',
  japanese: 'ライブチャット',
  korean: '실시간 채팅',
  portuguese: 'Chat ao vivo',
  russian: 'Живой чат',
  spanish: 'Chat en vivo',
  swahili: 'Mazungumzo ya Moja kwa Moja',
  vietnamese: 'Trò chuyện trực tiếp',
};

export const contactLiveChatDescription: Translation = {
  amharic: 'የፈጣን መልዕክት ድጋፍ',
  arabic: 'دعم المراسلة الفورية',
  bengali: 'তাত্ক্ষণিক বার্তা সহায়তা',
  chinese: '即时消息支持',
  english: 'Instant messaging support',
  estonian: 'Kiirsuhtluse tugi',
  filipino: 'Instant messaging support',
  french: 'Support par messagerie instantanée',
  german: 'Sofortnachrichten-Support',
  hindi: 'तत्काल मैसेजिंग सहायता',
  indonesian: 'Dukungan pesan instan',
  japanese: 'インスタントメッセージングサポート',
  korean: '인스턴트 메시징 지원',
  portuguese: 'Suporte de mensagens instantâneas',
  russian: 'Поддержка через мгновенные сообщения',
  spanish: 'Soporte de mensajería instantánea',
  swahili: 'Msaada wa ujumbe wa papo hapo',
  vietnamese: 'Hỗ trợ nhắn tin tức thời',
};

export const contactResponseTime: Translation = {
  amharic: 'የመልስ ጊዜ:',
  arabic: 'وقت الاستجابة:',
  bengali: 'প্রতিক্রিয়া সময়:',
  chinese: '响应时间：',
  english: 'Response time:',
  estonian: 'Vastuse aeg:',
  filipino: 'Oras ng pagtugon:',
  french: 'Temps de réponse:',
  german: 'Antwortzeit:',
  hindi: 'प्रतिक्रिया समय:',
  indonesian: 'Waktu respons:',
  japanese: '応答時間:',
  korean: '응답 시간:',
  portuguese: 'Tempo de resposta:',
  russian: 'Время ответа:',
  spanish: 'Tiempo de respuesta:',
  swahili: 'Muda wa kujibu:',
  vietnamese: 'Thời gian phản hồi:',
};

export const helpCenterTitle: Translation = {
  amharic: 'የእርዳታ ማዕከል',
  arabic: 'مركز المساعدة',
  bengali: 'সহায়তা কেন্দ্র',
  chinese: '帮助中心',
  english: 'Help Center',
  estonian: 'Abikeskus',
  filipino: 'Help Center',
  french: `Centre d'Aide`,
  german: 'Hilfezentrum',
  hindi: 'सहायता केंद्र',
  indonesian: 'Pusat Bantuan',
  japanese: 'ヘルプセンター',
  korean: '고객센터',
  portuguese: 'Central de ajuda',
  russian: 'Центр помощи',
  spanish: 'Centro de ayuda',
  swahili: 'Kituo cha Msaada',
  vietnamese: 'Trung tâm Trợ giúp',
};

export const helpCenterSubtitle: Translation = {
  amharic: 'ለጥያቄዎችዎ መልሶች ያግኙ',
  arabic: 'ابحث عن إجابات لأسئلتك',
  bengali: 'আপনার প্রশ্নের উত্তর খুঁজুন',
  chinese: '找到您问题的答案',
  english: 'Find answers to your questions',
  estonian: 'Leia vastused oma küsimustele',
  filipino: 'Maghanap ng mga sagot sa inyong mga tanong',
  french: 'Trouvez des réponses à vos questions',
  german: 'Finden Sie Antworten auf Ihre Fragen',
  hindi: 'अपने प्रश्नों के उत्तर खोजें',
  indonesian: 'Temukan jawaban untuk pertanyaan Anda',
  japanese: '質問への回答を見つける',
  korean: '질문에 대한 답변 찾기',
  portuguese: 'Encontre respostas para suas perguntas',
  russian: 'Найдите ответы на ваши вопросы',
  spanish: 'Encuentra respuestas a tus preguntas',
  swahili: 'Pata majibu ya maswali yako',
  vietnamese: 'Tìm câu trả lời cho câu hỏi của bạn',
};

export const helpCenterSearchPlaceholder: Translation = {
  amharic: 'የእርዳታ መጣጥፎች፣ መመሪያዎች እና ተደጋጋሚ ጥያቄዎችን ይፈልጉ...',
  arabic: 'ابحث عن مقالات المساعدة والأدلة والأسئلة الشائعة...',
  bengali: 'সাহায্য নিবন্ধ, গাইড এবং FAQ অনুসন্ধান করুন...',
  chinese: '搜索帮助文章、指南和常见问题...',
  english: 'Search for help articles, guides, and FAQs...',
  estonian: 'Otsi abiartikleid, juhendeid ja KKK...',
  filipino: 'Maghanap ng help articles, guides, at FAQs...',
  french: "Recherchez des articles d'aide, des guides et des FAQ...",
  german: 'Suchen Sie nach Hilfeartikeln, Anleitungen und FAQ...',
  hindi: 'सहायता लेख, गाइड और अक्सर पूछे जाने वाले प्रश्न खोजें...',
  indonesian: 'Cari artikel bantuan, panduan, dan FAQ...',
  japanese: 'ヘルプ記事、ガイド、FAQを検索...',
  korean: '도움말 문서, 가이드 및 FAQ 검색...',
  portuguese: 'Pesquise artigos de ajuda, guias e perguntas frequentes...',
  russian: 'Ищите статьи помощи, руководства и FAQ...',
  spanish: 'Busca artículos de ayuda, guías y preguntas frecuentes...',
  swahili: 'Tafuta makala za msaada, miongozo na maswali yanayoulizwa mara kwa mara...',
  vietnamese: 'Tìm kiếm bài viết trợ giúp, hướng dẫn và câu hỏi thường gặp...',
};

export const communityGuideline1: Translation = {
  amharic: 'በሁሉም ግንኙነቶች አክብሮት እና በሙያዊ ይሁኑ',
  arabic: 'كن محترمًا ومهنيًا في جميع التفاعلات',
  bengali: 'সমস্ত মিথস্ক্রিয়ায় সম্মানজনক এবং পেশাদার হন',
  chinese: '在所有互动中保持尊重和专业',
  english: 'Be respectful and professional in all interactions',
  estonian: 'Ole kõigis suhetes lugupidav ja professionaalne',
  filipino: 'Maging respetado at propesyonal sa lahat ng pakikipag-ugnayan',
  french: 'Soyez respectueux et professionnel dans toutes les interactions',
  german: 'Seien Sie in allen Interaktionen respektvoll und professionell',
  hindi: 'सभी बातचीत में सम्मानजनक और पेशेवर रहें',
  indonesian: 'Bersikap hormat dan profesional dalam semua interaksi',
  japanese: 'すべての相互作用で敬意を持ち、専門的に行動してください',
  korean: '모든 상호작용에서 존중하고 전문적으로 행동하세요',
  portuguese: 'Seja respeitoso e profissional em todas as interações',
  russian: 'Будьте уважительными и профессиональными во всех взаимодействиях',
  spanish: 'Sé respetuoso y profesional en todas las interacciones',
  swahili: 'Kuwa na heshima na kitaalamu katika mazungumzo yote',
  vietnamese: 'Hãy tôn trọng và chuyên nghiệp trong mọi tương tác',
};

export const communityGuideline2: Translation = {
  amharic: 'ስለ አገልግሎቶችዎ እና ልምድዎ ትክክለኛ መረጃ ይስጡ',
  arabic: 'قدم معلومات دقيقة حول خدماتك وخبرتك',
  bengali: 'আপনার সেবা এবং অভিজ্ঞতা সম্পর্কে সঠিক তথ্য প্রদান করুন',
  chinese: '提供有关您的服务和经验的准确信息',
  english: 'Provide accurate information about your services and experience',
  estonian: 'Pakku täpseid teavet oma teenuste ja kogemuse kohta',
  filipino: 'Magbigay ng tumpak na impormasyon tungkol sa inyong mga serbisyo at karanasan',
  french: 'Fournissez des informations précises sur vos services et votre expérience',
  german: 'Geben Sie genaue Informationen über Ihre Dienstleistungen und Erfahrungen an',
  hindi: 'अपनी सेवाओं और अनुभव के बारे में सटीक जानकारी प्रदान करें',
  indonesian: 'Berikan informasi yang akurat tentang layanan dan pengalaman Anda',
  japanese: 'サービスと経験について正確な情報を提供してください',
  korean: '서비스와 경험에 대한 정확한 정보를 제공하세요',
  portuguese: 'Forneça informações precisas sobre seus serviços e experiência',
  russian: 'Предоставляйте точную информацию о своих услугах и опыте',
  spanish: 'Proporciona información precisa sobre tus servicios y experiencia',
  swahili: 'Toa taarifa sahihi kuhusu huduma zako na uzoefu wako',
  vietnamese: 'Cung cấp thông tin chính xác về dịch vụ và kinh nghiệm của bạn',
};

export const communityGuideline3: Translation = {
  amharic: 'እንደተስማማነው አገልግሎቶችን ያጠናቅቁ እና ከፍተኛ የጥራት ደረጃዎችን ይጠብቁ',
  arabic: 'أكمل الخدمات كما تم الاتفاق عليه وحافظ على معايير الجودة العالية',
  bengali: 'চুক্তি অনুযায়ী সেবা সম্পূর্ণ করুন এবং উচ্চ মানের মান বজায় রাখুন',
  chinese: '按照约定完成服务并保持高质量标准',
  english: 'Complete services as agreed and maintain high quality standards',
  estonian: 'Täida teenused kokkulepitud ja säilita kõrged kvaliteedistandardid',
  filipino: 'Kumpletuhin ang mga serbisyo ayon sa napagkasunduan at panatilihin ang mataas na pamantayan sa kalidad',
  french: 'Terminez les services comme convenu et maintenez des normes de qualité élevées',
  german: 'Führen Sie Dienstleistungen wie vereinbart aus und halten Sie hohe Qualitätsstandards ein',
  hindi: 'सहमति के अनुसार सेवाएं पूरी करें और उच्च गुणवत्ता मानक बनाए रखें',
  indonesian: 'Selesaikan layanan sesuai kesepakatan dan pertahankan standar kualitas tinggi',
  japanese: '合意通りにサービスを完了し、高い品質基準を維持してください',
  korean: '합의한 대로 서비스를 완료하고 높은 품질 기준을 유지하세요',
  portuguese: 'Complete os serviços conforme acordado e mantenha altos padrões de qualidade',
  russian: 'Выполняйте услуги согласно договоренности и поддерживайте высокие стандарты качества',
  spanish: 'Completa los servicios según lo acordado y mantén altos estándares de calidad',
  swahili: 'Kamilisha huduma kama ilivyo kubaliwa na udumishe viwango vya juu vya ubora',
  vietnamese: 'Hoàn thành dịch vụ như đã thỏa thuận và duy trì tiêu chuẩn chất lượng cao',
};

export const communityGuideline4: Translation = {
  amharic: 'ማንኛውም አጠራጣሪ እንቅስቃሴ ወይም ጥሰት ወዲያውኑ ሪፖርት ያድርጉ',
  arabic: 'أبلغ عن أي نشاط مشبوه أو انتهاكات على الفور',
  bengali: 'যেকোনো সন্দেহজনক কার্যকলাপ বা লঙ্ঘন অবিলম্বে রিপোর্ট করুন',
  chinese: '立即报告任何可疑活动或违规行为',
  english: 'Report any suspicious activity or violations immediately',
  estonian: 'Teata kohe igasugusest kahtlasest tegevusest või rikkumisest',
  filipino: 'I-report kaagad ang anumang kahina-hinalang aktibidad o paglabag',
  french: 'Signalez immédiatement toute activité suspecte ou violation',
  german: 'Melden Sie sofort verdächtige Aktivitäten oder Verstöße',
  hindi: 'किसी भी संदिग्ध गतिविधि या उल्लंघन की तुरंत रिपोर्ट करें',
  indonesian: 'Laporkan segera aktivitas mencurigakan atau pelanggaran apa pun',
  japanese: '不審な活動や違反をすぐに報告してください',
  korean: '의심스러운 활동이나 위반 사항을 즉시 신고하세요',
  portuguese: 'Denuncie imediatamente qualquer atividade suspeita ou violações',
  russian: 'Немедленно сообщайте о любой подозрительной деятельности или нарушениях',
  spanish: 'Reporta cualquier actividad sospechosa o violaciónes inmediatamente',
  swahili: 'Ripoti shughuli zozote za kushukuwa au ukiukaji mara moja',
  vietnamese: 'Báo cáo ngay lập tức bất kỳ hoạt động đáng ngờ hoặc vi phạm nào',
};

export const aboutHeroTitle: Translation = {
  amharic: 'ስለ Workadabra',
  arabic: 'حول Workadabra',
  bengali: 'Workadabra সম্পর্কে',
  chinese: '关于Workadabra',
  english: 'About Workadabra',
  estonian: 'Workadabrast',
  filipino: 'Tungkol sa Workadabra',
  french: 'À propos de Workadabra',
  german: 'Über Workadabra',
  hindi: 'Workadabra के बारे में',
  indonesian: 'Tentang Workadabra',
  japanese: 'Workadabraについて',
  korean: 'Workadabra 소개',
  portuguese: 'Sobre o Workadabra',
  russian: 'О Workadabra',
  spanish: 'Acerca de Workadabra',
  swahili: 'Kuhusu Workadabra',
  vietnamese: 'Về Workadabra',
};
export const aboutHeroDescription: Translation = {
  amharic: 'Workadabra ለሰማያዊ-አንገት አገልግሎቶች የገበያ ቦታ ነው፣ ሰዎችን ስራ ለማግኘት፣ ንግዶቻቸውን ለማሳደግ እና በአካባቢያቸው የታመነ እርዳታ ለማግኘት ይረዳል። ተልዕኮዎችን ለሁሉም ሰው፣ በሁሉም ቦታ ለመድረስ የሚያስችል ማድረግ የእኛ ተልዕኮ ነው።',
  arabic: 'Workadabra هي السوق لخدمات ذوي الياقات الزرقاء، مما يساعد الناس على العثور على عمل ونمو أعمالهم والوصول إلى مساعدة موثوقة في منطقتهم المحلية. مهمتنا هي جعل الفرص في متناول الجميع، في كل مكان.',
  bengali: 'Workadabra হল ব্লু-কলার সেবার জন্য বাজার, যা মানুষকে কাজ খুঁজতে, তাদের ব্যবসা বাড়াতে এবং তাদের স্থানীয় এলাকায় বিশ্বস্ত সাহায্য অ্যাক্সেস করতে সাহায্য করে। আমাদের মিশন হল সুযোগকে সবার কাছে, সর্বত্র অ্যাক্সেসযোগ্য করা।',
  chinese: 'Workadabra是蓝领服务的市场，帮助人们找工作、发展业务并在当地获得值得信赖的帮助。我们的使命是让机会在任何地方、对任何人都可及。',
  english: 'Workadabra is the marketplace for blue-collar services, helping people find work, grow their businesses, and access trusted help in their local area. Our mission is to make opportunity accessible to everyone, everywhere.',
  estonian: 'Workadabra on sinise kaelusega teenuste turuplats, mis aitab inimestel leida tööd, kasvatada oma ettevõtteid ja pääseda ligi usaldusväärsele abile oma piirkonnas. Meie missioon on muuta võimalused kõigile kättesaadavaks kõikjal.',
  filipino:
    'Ang Workadabra ay ang marketplace para sa blue-collar services, na tumutulong sa mga tao na makahanap ng trabaho, palaguin ang kanilang mga negosyo, at ma-access ang mapagkakatiwalaang tulong sa kanilang lokal na lugar. Ang aming misyon ay gawing accessible ang opportunity sa lahat, saanman.',
  french: 'Workadabra est la place de marché pour les services de cols bleus, aidant les gens à trouver du travail, à développer leurs entreprises et à accéder à une aide de confiance dans leur région. Notre mission est de rendre les opportunités accessibles à tous, partout.',
  german: 'Workadabra ist der Marktplatz für Dienstleistungen für Arbeiter, der Menschen hilft, Arbeit zu finden, ihre Unternehmen zu vergrößern und vertrauenswürdige Hilfe in ihrer Region zu finden. Unsere Mission ist es, Chancen für alle überall zugänglich zu machen.',
  hindi: 'Workadabra ब्लू-कॉलर सेवाओं के लिए बाज़ार है, जो लोगों को काम खोजने, अपने व्यवसायों को बढ़ाने और अपने स्थानीय क्षेत्र में विश्वसनीय सहायता प्राप्त करने में मदद करता है। हमारा मिशन हर जगह, सभी के लिए अवसरों को सुलभ बनाना है।',
  indonesian: 'Workadabra adalah pasar untuk layanan kerah biru, membantu orang menemukan pekerjaan, mengembangkan bisnis mereka, dan mengakses bantuan terpercaya di daerah mereka. Misi kami adalah membuat peluang dapat diakses oleh semua orang, di mana saja.',
  japanese: 'Workadabraはブルーカラーサービスのマーケットプレイスで、人々が仕事を見つけ、ビジネスを成長させ、地域で信頼できる支援にアクセスできるように支援します。私たちの使命は、どこでも、すべての人に機会を提供することです。',
  korean: 'Workadabra는 블루칼라 서비스를 위한 마켓플레이스로, 사람들이 일자리를 찾고, 비즈니스를 성장시키며, 지역에서 신뢰할 수 있는 도움을 받을 수 있도록 돕습니다. 우리의 사명은 모든 곳에서 모든 사람에게 기회를 제공하는 것입니다.',
  portuguese: 'Workadabra é o mercado para serviços de colarinho azul, ajudando as pessoas a encontrar trabalho, expandir seus negócios e acessar ajuda confiável em sua área local. Nossa missão é tornar as oportunidades acessíveis a todos, em todos os lugares.',
  russian: 'Workadabra, это торговая площадка для рабочих услуг, помогающая людям находить работу, развивать свой бизнес и получать надежную помощь в своем районе. Наша миссия, сделать возможности доступными для всех, везде.',
  spanish: 'Workadabra es el mercado para servicios de cuello azul, ayudando a las personas a encontrar trabajo, hacer crecer sus negocios y acceder a ayuda confiable en su área local. Nuestra misión es hacer que las oportunidades sean accesibles para todos, en todas partes.',
  swahili: 'Workadabra ni soko la huduma za wafanyakazi, kusaidia watu kupata kazi, kukuza biashara zao, na kupata msaada wa kuaminika katika eneo lao. Dhamira yetu ni kufanya fursa zipatikane kwa kila mtu, kila mahali.',
  vietnamese: 'Workadabra là thị trường cho các dịch vụ lao động chân tay, giúp mọi người tìm việc, phát triển doanh nghiệp và tiếp cận sự giúp đỡ đáng tin cậy trong khu vực địa phương của họ. Sứ mệnh của chúng tôi là làm cho cơ hội có thể tiếp cận được với mọi người, ở mọi nơi.',
};

export const securityPageTitle: Translation = {
  amharic: 'ደህንነት እና እምነት',
  arabic: 'الأمان والثقة',
  bengali: 'নিরাপত্তা এবং বিশ্বাস',
  chinese: '安全与信任',
  english: 'Security & Trust',
  estonian: 'Turvalisus ja Usaldus',
  filipino: 'Seguridad at tiwala',
  french: 'Sécurité et Confiance',
  german: 'Sicherheit und Vertrauen',
  hindi: 'सुरक्षा और विश्वास',
  indonesian: 'Keamanan dan kepercayaan',
  japanese: 'セキュリティと信頼',
  korean: '보안 및 신뢰',
  portuguese: 'Segurança e confiança',
  russian: 'Безопасность и доверие',
  spanish: 'Seguridad y confianza',
  swahili: 'Usalama na Uaminifu',
  vietnamese: 'Bảo mật và tin cậy',
};
export const securityPageDescription: Translation = {
  amharic: 'ውሂብዎን እንዴት እንጠብቃለን እና ለሁሉም ተጠቃሚዎች ደህንነቱ የተጠበቀ ልምድ እንደምናረጋግጥ ይማሩ።',
  arabic: 'تعرف على كيفية حماية بياناتك وضمان تجربة آمنة لجميع المستخدمين.',
  bengali: 'আমরা কীভাবে আপনার ডেটা রক্ষা করি এবং সমস্ত ব্যবহারকারীর জন্য একটি নিরাপদ অভিজ্ঞতা নিশ্চিত করি তা জানুন।',
  chinese: '了解我们如何保护您的数据并确保所有用户的安全体验。',
  english: 'Learn how we protect your data and ensure a secure experience for all users.',
  estonian: 'Uurige, kuidas me teie andmeid kaitseme ja tagame turvalise kogemuse kõigile kasutajatele.',
  filipino: 'Alamin kung paano namin pinoprotektahan ang inyong data at tinitiyak ang secure na experience para sa lahat ng user.',
  french: 'Découvrez comment nous protégeons vos données et assurons une expérience sécurisée pour tous les utilisateurs.',
  german: 'Erfahren Sie, wie wir Ihre Daten schützen und eine sichere Erfahrung für alle Benutzer gewährleisten.',
  hindi: 'जानें कि हम आपके डेटा की सुरक्षा कैसे करते हैं और सभी उपयोगकर्ताओं के लिए सुरक्षित अनुभव सुनिश्चित करते हैं।',
  indonesian: 'Pelajari cara kami melindungi data Anda dan memastikan pengalaman yang aman untuk semua pengguna.',
  japanese: 'データを保護し、すべてのユーザーに安全な体験を提供する方法をご確認ください。',
  korean: '데이터를 보호하고 모든 사용자에게 안전한 경험을 보장하는 방법을 알아보세요.',
  portuguese: 'Saiba como protegemos seus dados e garantimos uma experiência segura para todos os usuários.',
  russian: 'Узнайте, как мы защищаем ваши данные и обеспечиваем безопасный опыт для всех пользователей.',
  spanish: 'Aprende cómo protegemos tus datos y garantizamos una experiencia segura para todos los usuarios.',
  swahili: 'Jifunze jinsi tunavyolinda data yako na kuhakikisha uzoefu salama kwa watumiaji wote.',
  vietnamese: 'Tìm hiểu cách chúng tôi bảo vệ dữ liệu của bạn và đảm bảo trải nghiệm an toàn cho tất cả người dùng.',
};

export const securityBestPracticesTitle: Translation = {
  amharic: 'የደህንነት ምርጥ ልምዶች',
  arabic: 'أفضل ممارسات الأمان',
  bengali: 'নিরাপত্তা সেরা অনুশীলন',
  chinese: '安全最佳实践',
  english: 'Security Best Practices',
  estonian: 'Turvalisuse bomdisoftad tavad',
  filipino: 'Mga best practices sa seguridad',
  french: 'Meilleures pratiques de sécurité',
  german: 'Sicherheitspraxistipps',
  hindi: 'सुरक्षा सर्वोत्तम प्रथाएं',
  indonesian: 'Praktik keamanan terbaik',
  japanese: 'セキュリティのベストプラクティス',
  korean: '보안 모범 사례',
  portuguese: 'Melhores práticas de segurança',
  russian: 'Лучшие практики безопасности',
  spanish: 'Mejores prácticas de seguridad',
  swahili: 'Mazoea Bora ya Usalama',
  vietnamese: 'Thực hành bảo mật tốt nhất',
};

export const securityBestPracticesDescription: Translation = {
  amharic: 'በWorkadabra ላይ መለያዎን እና ውሂብዎን ደህንነቱ የተጠበቀ ለማድረግ እነዚህን ምክሮች ይከተሉ።',
  arabic: 'اتبع هذه النصائح للحفاظ على حسابك وبياناتك آمنة على Workadabra.',
  bengali: 'Workadabra-তে আপনার অ্যাকাউন্ট এবং ডেটা নিরাপদ রাখতে এই টিপসগুলি অনুসরণ করুন।',
  chinese: '遵循这些提示，在Workadabra上保护您的账户和数据安全。',
  english: 'Follow these tips to keep your account and data safe on Workadabra.',
  estonian: 'Järgige neid näpunäiteid, et hoida oma kontot ja andmeid Workadabras turvalisena.',
  filipino: 'Sundin ang mga tip na ito upang mapanatiling ligtas ang inyong account at data sa Workadabra.',
  french: 'Suivez ces conseils pour garder votre compte et vos données sécurisées sur Workadabra.',
  german: 'Folgen Sie diesen Tipps, um Ihr Konto und Ihre Daten auf Workadabra sicher zu halten.',
  hindi: 'Workadabra पर अपने खाते और डेटा को सुरक्षित रखने के लिए इन सुझावों का पालन करें।',
  indonesian: 'Ikuti tips ini untuk menjaga akun dan data Anda tetap aman di Workadabra.',
  japanese: 'Workadabraでアカウントとデータを安全に保つために、これらのヒントに従ってください。',
  korean: 'Workadabra에서 계정과 데이터를 안전하게 유지하기 위해 다음 팁을 따르세요.',
  portuguese: 'Siga estas dicas para manter sua conta e dados seguros no Workadabra.',
  russian: 'Следуйте этим советам, чтобы сохранить вашу учетную запись и данные в безопасности в Workadabra.',
  spanish: 'Sigue estos consejos para mantener tu cuenta y datos seguros en Workadabra.',
  swahili: 'Fuata vidokezo hivi ili kuweka akaunti yako na data salama kwenye Workadabra.',
  vietnamese: 'Làm theo các mẹo này để giữ tài khoản và dữ liệu của bạn an toàn trên Workadabra.',
};

export const securityStrongPasswordsTitle: Translation = {
  amharic: 'ኃይለኛ የይለፍ ቃላት ይጠቀሙ',
  arabic: 'استخدم كلمات مرور قوية',
  bengali: 'শক্তিশালী পাসওয়ার্ড ব্যবহার করুন',
  chinese: '使用强密码',
  english: 'Use Strong Passwords',
  estonian: 'Kasutage tugevaid paroole',
  filipino: 'Gumamit ng malakas na password',
  french: 'Utilisez des mots de passe forts',
  german: 'Starkes Passwort verwenden',
  hindi: 'मजबूत पासवर्ड का उपयोग करें',
  indonesian: 'Gunakan kata sandi yang kuat',
  japanese: '強力なパスワードを使用',
  korean: '강력한 비밀번호 사용',
  portuguese: 'Use senhas fortes',
  russian: 'Используйте надежные пароли',
  spanish: 'Usa contraseñas seguras',
  swahili: 'Tumia Nenosiri Ngumu',
  vietnamese: 'Sử dụng mật khẩu mạnh',
};

export const securityStrongPasswordsDescription: Translation = {
  amharic: 'በፊደላት፣ ቁጥሮች እና ምልክቶች ድብልቅ ልዩ የይለፍ ቃል ይፍጠሩ። የይለፍ ቃልዎን ለማንም አትጋሩ።',
  arabic: 'أنشئ كلمة مرور فريدة بمزيج من الأحرف والأرقام والرموز. لا تشارك كلمة المرور الخاصة بك مع أي شخص أبدًا.',
  bengali: 'অক্ষর, সংখ্যা এবং চিহ্নের মিশ্রণ সহ একটি অনন্য পাসওয়ার্ড তৈরি করুন। কখনই আপনার পাসওয়ার্ড কারো সাথে শেয়ার করবেন না।',
  chinese: '创建一个包含字母、数字和符号组合的唯一密码。永远不要与任何人分享您的密码。',
  english: 'Create a unique password with a mix of letters, numbers, and symbols. Never share your password with anyone.',
  estonian: 'Looge ainulaadne parool tähtede, numbrite ja sümbolite kombinatsiooniga. Ärge kunagi jagage oma parooli kellegagi.',
  filipino: 'Gumawa ng natatanging password na may kombinasyon ng mga titik, numero, at simbolo. Huwag kailanman ibahagi ang inyong password sa sinuman.',
  french: "Créez un mot de passe unique avec une combinaison de lettres, de chiffres et de symboles. Ne partagez jamais votre mot de passe à quelqu'un d'autre.",
  german: 'Erstellen Sie ein einzigartiges Passwort mit einer Kombination aus Buchstaben, Zahlen und Symbolen. Teilen Sie Ihr Passwort niemals mit jemand anderem.',
  hindi: 'अक्षरों, संख्याओं और प्रतीकों के मिश्रण के साथ एक अद्वितीय पासवर्ड बनाएं। कभी भी अपना पासवर्ड किसी के साथ साझा न करें।',
  indonesian: 'Buat kata sandi unik dengan kombinasi huruf, angka, dan simbol. Jangan pernah membagikan kata sandi Anda kepada siapa pun.',
  japanese: '文字、数字、記号を組み合わせた固有のパスワードを作成してください。パスワードを誰とも共有しないでください。',
  korean: '문자, 숫자 및 기호를 조합한 고유한 비밀번호를 만드세요. 비밀번호를 누구와도 공유하지 마세요.',
  portuguese: 'Crie uma senha única com uma combinação de letras, números e símbolos. Nunca compartilhe sua senha com ninguém.',
  russian: 'Создайте уникальный пароль с сочетанием букв, цифр и символов. Никогда не делитесь своим паролем ни с кем.',
  spanish: 'Crea una contraseña única con una combinación de letras, números y símbolos. Nunca compartas tu contraseña con nadie.',
  swahili: 'Unda nenosiri la kipekee lenye mchanganyiko wa herufi, nambari na alama. Kamwe usishirikishe nenosiri lako na mtu yeyote.',
  vietnamese: 'Tạo mật khẩu duy nhất với sự kết hợp của chữ cái, số và ký hiệu. Không bao giờ chia sẻ mật khẩu của bạn với bất kỳ ai.',
};

export const securityPhishingTitle: Translation = {
  amharic: 'ከፊሺንግ ይጠንቀቁ',
  arabic: 'احذر من التصيد الاحتيالي',
  bengali: 'ফিশিং থেকে সতর্ক থাকুন',
  chinese: '谨防网络钓鱼',
  english: 'Beware of Phishing',
  estonian: 'Olge valmis püüdmise suhtes',
  filipino: 'Mag-ingat sa phishing',
  french: 'Attention aux escroqueries',
  german: 'Aufmerksamkeit bei Phishing-Angriffen',
  hindi: 'फ़िशिंग से सावधान रहें',
  indonesian: 'Waspadai phishing',
  japanese: 'フィッシングに注意',
  korean: '피싱에 주의하세요',
  portuguese: 'Cuidado com phishing',
  russian: 'Остерегайтесь фишинга',
  spanish: 'Ten cuidado con el phishing',
  swahili: 'Jihadharini na Ujangili',
  vietnamese: 'Cẩn thận với lừa đảo',
};

export const securityPhishingDescription: Translation = {
  amharic: 'አጠራጣሪ አገናኞችን በጭራሽ አትጫኑ ወይም ለማይታመኑ ምንጮች የግላዊ መረጃ አትስጡ። ሁልጊዜ የመላኪያውን የኢሜይል አድራሻ ይፈትሹ።',
  arabic: 'لا تنقر أبدًا على الروابط المشبوهة أو تقدم معلومات شخصية لمصادر غير موثوقة. تحقق دائمًا من عنوان البريد الإلكتروني للمرسل.',
  bengali: 'কখনই সন্দেহজনক লিঙ্কে ক্লিক করবেন না বা অবিশ্বস্ত উত্সে ব্যক্তিগত তথ্য প্রদান করবেন না। সর্বদা প্রেরকের ইমেইল ঠিকানা পরীক্ষা করুন।',
  chinese: '永远不要点击可疑链接或向不可信来源提供个人信息。始终检查发件人的电子邮件地址。',
  english: "Never click suspicious links or provide personal info to untrusted sources. Always check the sender's email address.",
  estonian: 'Ärge kunagi klõpsake kahtlasi linke ega andke isiklikku teavet usaldamatuile allikatele. Kontrollige alati saatja e-posti aadressi.',
  filipino: 'Huwag kailanman mag-click sa mga kahina-hinalang link o magbigay ng personal na impormasyon sa mga hindi mapagkakatiwalaang pinagmulan. Laging suriin ang email address ng nagpadala.',
  french: "Ne jamais cliquez sur des liens suspects ou ne partagez aucune information personnelle à des sources inconnues. Toujours vérifier l'adresse e-mail de l'expéditeur.",
  german: 'Ärge niemals auf verdächtige Links klicken oder persönliche Daten an unbekannte Empfänger senden. Prüfen Sie immer die E-Mail-Adresse des Absenders.',
  hindi: 'कभी भी संदिग्ध लिंक पर क्लिक न करें या अविश्वसनीय स्रोतों को व्यक्तिगत जानकारी प्रदान न करें। हमेशा प्रेषक के ईमेल पते की जांच करें।',
  indonesian: 'Jangan pernah mengklik tautan mencurigakan atau memberikan informasi pribadi ke sumber yang tidak tepercaya. Selalu periksa alamat email pengirim.',
  japanese: '不審なリンクをクリックしたり、信頼できないソースに個人情報を提供したりしないでください。常に送信者のメールアドレスを確認してください。',
  korean: '의심스러운 링크를 클릭하거나 신뢰할 수 없는 소스에 개인 정보를 제공하지 마세요. 항상 발신자의 이메일 주소를 확인하세요.',
  portuguese: 'Nunca clique em links suspeitos ou forneça informações pessoais a fontes não confiáveis. Sempre verifique o endereço de e-mail do remetente.',
  russian: 'Никогда не переходите по подозрительным ссылкам и не предоставляйте личную информацию ненадежным источникам. Всегда проверяйте адрес электронной почты отправителя.',
  spanish: 'Nunca hagas clic en enlaces sospechosos ni proporciones información personal a fuentes no confiables. Siempre verifica la dirección de correo electrónico del remitente.',
  swahili: 'Kamwe usibofye viungo vya kushukuwa au utoe taarifa za kibinafsi kwa vyanzo visivyoaminika. Daima angalia anwani ya barua pepe ya mtumaji.',
  vietnamese: 'Không bao giờ nhấp vào các liên kết đáng ngờ hoặc cung cấp thông tin cá nhân cho các nguồn không đáng tin cậy. Luôn kiểm tra địa chỉ email của người gửi.',
};

export const securityVerifyIdentityTitle: Translation = {
  amharic: 'ማንነትዎን ያረጋግጡ',
  arabic: 'تحقق من هويتك',
  bengali: 'আপনার পরিচয় যাচাই করুন',
  chinese: '验证您的身份',
  english: 'Verify Your Identity',
  estonian: 'Kinnitage oma identiteet',
  filipino: 'I-verify ang inyong pagkakakilanlan',
  french: 'Vérifier votre identité',
  german: 'Überprüfen Sie Ihre Identität',
  hindi: 'अपनी पहचान सत्यापित करें',
  indonesian: 'Verifikasi identitas Anda',
  japanese: '本人確認',
  korean: '신원 확인',
  portuguese: 'Verifique sua identidade',
  russian: 'Подтвердите свою личность',
  spanish: 'Verifica tu identidad',
  swahili: 'Thibitisha Utambulisho Wako',
  vietnamese: 'Xác minh danh tính của bạn',
};

export const securityVerifyIdentityDescription: Translation = {
  amharic: 'ለሁሉም ሰው መድረኩን ደህንነቱ የተጠበቀ ለመጠበቅ የማንነት ማረጋገጫውን ያጠናቅቁ።',
  arabic: 'أكمل التحقق من الهوية للمساعدة في الحفاظ على أمان المنصة للجميع.',
  bengali: 'সবার জন্য প্ল্যাটফর্মকে নিরাপদ রাখতে পরিচয় যাচাইকরণ সম্পূর্ণ করুন।',
  chinese: '完成身份验证，帮助确保平台对所有人都是安全的。',
  english: 'Complete identity verification to help keep the platform safe for everyone.',
  estonian: 'Täitke identiteedi kinnitamine, et aidata hoida platvormi kõigile turvalisena.',
  filipino: 'Kumpletuhin ang identity verification upang makatulong na mapanatiling ligtas ang platform para sa lahat.',
  french: "Complétez la vérification d'identité pour aider à maintenir la plateforme sécurisée pour tous.",
  german: 'Führen Sie die Identitätsverifizierung durch, um die Sicherheit der Plattform für alle zu gewährleisten.',
  hindi: 'सभी के लिए प्लेटफॉर्म को सुरक्षित रखने में मदद करने के लिए पहचान सत्यापन पूरा करें।',
  indonesian: 'Lengkapi verifikasi identitas untuk membantu menjaga platform tetap aman untuk semua orang.',
  japanese: 'すべての人のためにプラットフォームを安全に保つために、本人確認を完了してください。',
  korean: '모든 사람을 위해 플랫폼을 안전하게 유지하기 위해 신원 확인을 완료하세요.',
  portuguese: 'Complete a verificação de identidade para ajudar a manter a plataforma segura para todos.',
  russian: 'Завершите проверку личности, чтобы помочь сохранить платформу безопасной для всех.',
  spanish: 'Completa la verificación de identidad para ayudar a mantener la plataforma segura para todos.',
  swahili: 'Kamilisha uthibitishaji wa utambulisho ili kusaidia kuweka jukwaa salama kwa kila mtu.',
  vietnamese: 'Hoàn tất xác minh danh tính để giúp giữ nền tảng an toàn cho mọi người.',
};

export const securityReportIssueTitle: Translation = {
  amharic: 'የደህንነት ጉዳይ ሪፖርት ያድርጉ',
  arabic: 'الإبلاغ عن مشكلة أمنية',
  bengali: 'নিরাপত্তা সমস্যা রিপোর্ট করুন',
  chinese: '报告安全问题',
  english: 'Report a Security Issue',
  estonian: 'Teatage turvaprobleemist',
  filipino: 'I-report ang isang security issue',
  french: 'Signaler un problème de sécurité',
  german: 'Einen Sicherheitsproblem melden',
  hindi: 'सुरक्षा समस्या की रिपोर्ट करें',
  indonesian: 'Laporkan masalah keamanan',
  japanese: 'セキュリティ問題を報告',
  korean: '보안 문제 신고',
  portuguese: 'Relatar um problema de segurança',
  russian: 'Сообщите о проблеме безопасности',
  spanish: 'Reportar un problema de seguridad',
  swahili: 'Ripoti Tatizo la Usalama',
  vietnamese: 'Báo cáo vấn đề bảo mật',
};

export const securityReportIssueDescription: Translation = {
  amharic: 'ማንኛውም አጠራጣሪ እንቅስቃሴ ካስተዋሉ ወይም መለያዎ እንደተጋረጠ ካመኑ፣ እባክዎን ወዲያውኑ ከደህንነት ቡድናችን ጋር ያገናኙ።',
  arabic: 'إذا لاحظت أي نشاط مشبوه أو تعتقد أن حسابك قد تم اختراقه، يرجى الاتصال بفريق الأمان لدينا على الفور.',
  bengali: 'যদি আপনি কোন সন্দেহজনক কার্যকলাপ লক্ষ্য করেন বা বিশ্বাস করেন যে আপনার অ্যাকাউন্ট আপস হয়েছে, অনুগ্রহ করে অবিলম্বে আমাদের নিরাপত্তা দলের সাথে যোগাযোগ করুন।',
  chinese: '如果您发现任何可疑活动或认为您的账户已遭泄露，请立即联系我们的安全团队。',
  english: 'If you notice any suspicious activity or believe your account has been compromised, please contact our security team immediately.',
  estonian: 'Kui märkate kahtlast tegevust või usute, et teie konto on kompromiteeritud, võtke kohe ühendust meie turvatiimiga.',
  filipino: 'Kung mapapansin ninyo ang anumang kahina-hinalang aktibidad o naniniwala na ang inyong account ay na-compromise, mangyaring makipag-ugnayan kaagad sa aming security team.',
  french: 'Si vous remarquez toute activité suspecte ou pensez que votre compte est compromis, veuillez contacter notre équipe de sécurité immédiatement.',
  german: 'Wenn Sie verdächtige Aktivitäten oder glauben, dass Ihr Konto kompromittiert ist, wenden Sie sich bitte sofort an unser Sicherheitsteam.',
  hindi: 'यदि आप कोई संदिग्ध गतिविधि देखते हैं या मानते हैं कि आपका खाता समझौता हो गया है, तो कृपया तुरंत हमारी सुरक्षा टीम से संपर्क करें।',
  indonesian: 'Jika Anda melihat aktivitas mencurigakan atau percaya akun Anda telah dikompromikan, harap hubungi tim keamanan kami segera.',
  japanese: '不審な活動に気づいた場合、またはアカウントが侵害されたと思われる場合は、すぐにセキュリティチームに連絡してください。',
  korean: '의심스러운 활동을 발견하거나 계정이 손상되었다고 생각되면 즉시 보안팀에 연락하세요.',
  portuguese: 'Se você notar qualquer atividade suspeita ou acreditar que sua conta foi comprometida, entre em contato com nossa equipe de segurança imediatamente.',
  russian: 'Если вы заметили подозрительную активность или считаете, что ваша учетная запись была скомпрометирована, немедленно свяжитесь с нашей командой безопасности.',
  spanish: 'Si notas alguna actividad sospechosa o crees que tu cuenta ha sido comprometida, contacta a nuestro equipo de seguridad de inmediato.',
  swahili: 'Ikiwa utagundua shughuli yoyote ya kushukuwa au unaamini akaunti yako imeathiriwa, tafadhali wasiliana na timu yetu ya usalama mara moja.',
  vietnamese: 'Nếu bạn nhận thấy bất kỳ hoạt động đáng ngờ nào hoặc tin rằng tài khoản của bạn đã bị xâm phạm, vui lòng liên hệ với đội ngũ bảo mật của chúng tôi ngay lập tức.',
};

export const securityEmail: Translation = {
  amharic: 'security@workadabra.com',
  arabic: 'security@workadabra.com',
  bengali: 'security@workadabra.com',
  chinese: 'security@workadabra.com',
  english: 'security@workadabra.com',
  estonian: 'security@workadabra.com',
  filipino: 'security@workadabra.com',
  french: 'security@workadabra.com',
  german: 'security@workadabra.com',
  hindi: 'security@workadabra.com',
  indonesian: 'security@workadabra.com',
  japanese: 'security@workadabra.com',
  korean: 'security@workadabra.com',
  portuguese: 'security@workadabra.com',
  russian: 'security@workadabra.com',
  spanish: 'security@workadabra.com',
  swahili: 'security@workadabra.com',
  vietnamese: 'security@workadabra.com',
};

export const aboutCoreValuesTitle: Translation = {
  amharic: 'የእኛ ዋና እሴቶች',
  arabic: 'قيمنا الأساسية',
  bengali: 'আমাদের মূল মূল্যবোধ',
  chinese: '我们的核心价值观',
  english: 'Our Core Values',
  estonian: 'Meie põhiväärtused',
  filipino: 'Ang aming core values',
  french: 'Nos valeurs fondamentales',
  german: 'Unsere Kernwerte',
  hindi: 'हमारे मूल मूल्य',
  indonesian: 'Nilai-nilai inti kami',
  japanese: '私たちのコアバリュー',
  korean: '핵심 가치',
  portuguese: 'Nossos valores fundamentais',
  russian: 'Наши основные ценности',
  spanish: 'Nuestros valores fundamentales',
  swahili: 'Maadili Yetu ya Msingi',
  vietnamese: 'Giá trị cốt lõi của chúng tôi',
};

export const aboutCommunityTitle: Translation = {
  amharic: 'ማህበረሰብ',
  arabic: 'المجتمع',
  bengali: 'সম্প্রদায়',
  chinese: '社区',
  english: 'Community',
  estonian: 'Kogukond',
  filipino: 'Komunidad',
  french: 'Communauté',
  german: 'Gemeinschaft',
  hindi: 'समुदाय',
  indonesian: 'Komunitas',
  japanese: 'コミュニティ',
  korean: '커뮤니티',
  portuguese: 'Comunidade',
  russian: 'Сообщество',
  spanish: 'Comunidad',
  swahili: 'Jamii',
  vietnamese: 'Cộng đồng',
};

export const aboutCommunityDescription: Translation = {
  amharic: 'በአካባቢያዊ ማህበረሰቦች ኃይል እና እርስ በርስ ለመድገም ለመርዳት እናምናለን።',
  arabic: 'نؤمن بقوة المجتمعات المحلية ومساعدتنا لبعضنا البعض على النمو.',
  bengali: 'আমরা স্থানীয় সম্প্রদায়ের শক্তিতে বিশ্বাস করি এবং একে অপরকে বৃদ্ধি করতে সাহায্য করি।',
  chinese: '我们相信当地社区的力量，并相互帮助成长。',
  english: 'We believe in the power of local communities and helping each other grow.',
  estonian: 'Me usume kohalike kogukondade jõudu ja üksteise kasvamise aitamist.',
  filipino: "Naniniwala kami sa kapangyarihan ng mga lokal na komunidad at pagtulong sa isa't isa na lumago.",
  french: "Nous croyons au pouvoir des communautés locales et à l'entraide pour grandir ensemble.",
  german: 'Wir glauben an die Kraft lokaler Gemeinschaften und daran, einander beim Wachstum zu helfen.',
  hindi: 'हम स्थानीय समुदायों की शक्ति में विश्वास करते हैं और एक दूसरे को बढ़ने में मदद करते हैं।',
  indonesian: 'Kami percaya pada kekuatan komunitas lokal dan saling membantu untuk tumbuh.',
  japanese: '私たちは地域コミュニティの力とお互いの成長を助けることを信じています。',
  korean: '우리는 지역 사회의 힘과 서로 성장을 돕는 것을 믿습니다.',
  portuguese: 'Acreditamos no poder das comunidades locais e em ajudar uns aos outros a crescer.',
  russian: 'Мы верим в силу местных сообществ и помогаем друг другу расти.',
  spanish: 'Creemos en el poder de las comunidades locales y en ayudarnos mutuamente a crecer.',
  swahili: 'Tunaamini katika nguvu za jamii za ndani na kusaidiana kukua.',
  vietnamese: 'Chúng tôi tin vào sức mạnh của cộng đồng địa phương và giúp đỡ lẫn nhau phát triển.',
};

export const aboutInnovationTitle: Translation = {
  amharic: 'ልምድ',
  arabic: 'الابتكار',
  bengali: 'নবীকরণ',
  chinese: '创新',
  english: 'Innovation',
  estonian: 'Innovatsioon',
  filipino: 'Innovation',
  french: 'Innovation',
  german: 'Innovation',
  hindi: 'नवाचार',
  indonesian: 'Inovasi',
  japanese: 'イノベーション',
  korean: '혁신',
  portuguese: 'Inovação',
  russian: 'Инновации',
  spanish: 'Innovación',
  swahili: 'Ubunifu',
  vietnamese: 'Đổi mới',
};

export const aboutInnovationDescription: Translation = {
  amharic: 'ለሁሉም ሰው የአገልግሎት መዳረሻን ለማቃለል አዲስ ሀሳቦችን እና ቴክኖሎጂን እንቀበላለን።',
  arabic: 'نتبنى أفكارًا وتقنيات جديدة لتسهيل الوصول إلى الخدمات للجميع.',
  bengali: 'আমরা নতুন ধারণা এবং প্রযুক্তি গ্রহণ করি যাতে সবার জন্য সেবা অ্যাক্সেস সহজ হয়।',
  chinese: '我们采用新想法和技术，使每个人都能更轻松地访问服务。',
  english: 'We embrace new ideas and technology to make service access easier for everyone.',
  estonian: 'Me omakseme uusi ideid ja tehnoloogiat, et teenuste juurdepääs oleks kõigile lihtsam.',
  filipino: 'Tinatanggap namin ang mga bagong ideya at teknolohiya upang gawing mas madali ang access sa serbisyo para sa lahat.',
  french: "Nous adoptons de nouvelles idées et technologies pour faciliter l'accès aux services pour tous.",
  german: 'Wir begrüßen neue Ideen und Technologien, um den Zugang zu Dienstleistungen für alle zu erleichtern.',
  hindi: 'हम सभी के लिए सेवा पहुंच को आसान बनाने के लिए नए विचारों और प्रौद्योगिकी को अपनाते हैं।',
  indonesian: 'Kami mengadopsi ide dan teknologi baru untuk memudahkan akses layanan bagi semua orang.',
  japanese: 'すべての人がサービスにアクセスしやすくするために、新しいアイデアとテクノロジーを受け入れます。',
  korean: '우리는 모든 사람이 서비스에 더 쉽게 접근할 수 있도록 새로운 아이디어와 기술을 수용합니다.',
  portuguese: 'Adotamos novas ideias e tecnologia para facilitar o acesso aos serviços para todos.',
  russian: 'Мы принимаем новые идеи и технологии, чтобы сделать доступ к услугам проще для всех.',
  spanish: 'Adoptamos nuevas ideas y tecnología para facilitar el acceso a los servicios para todos.',
  swahili: 'Tunakubali mawazo mapya na teknolojia ili kuwezesha ufikiaji wa huduma kwa kila mtu.',
  vietnamese: 'Chúng tôi chấp nhận những ý tưởng và công nghệ mới để làm cho việc tiếp cận dịch vụ dễ dàng hơn cho mọi người.',
};

export const aboutTrustTitle: Translation = {
  amharic: 'እምነት',
  arabic: 'الثقة',
  bengali: 'বিশ্বাস',
  chinese: '信任',
  english: 'Trust',
  estonian: 'Usaldus',
  filipino: 'Tiwalang',
  french: 'Confiance',
  german: 'Vertrauen',
  hindi: 'विश्वास',
  indonesian: 'Kepercayaan',
  japanese: '信頼',
  korean: '신뢰',
  portuguese: 'Confiança',
  russian: 'Доверие',
  spanish: 'Confianza',
  swahili: 'Uaminifu',
  vietnamese: 'Tin cậy',
};

export const aboutTrustDescription: Translation = {
  amharic: 'ለሁሉም ሰው ደህንነቱ የተጠበቀ፣ አስተማማኝ እና ግልጽ የሆነ መድረክ ለመገንባት ቁርጠኛ ነን።',
  arabic: 'نحن ملتزمون ببناء منصة آمنة وموثوقة وشفافة للجميع.',
  bengali: 'আমরা সবার জন্য একটি নিরাপদ, নির্ভরযোগ্য এবং স্বচ্ছ প্ল্যাটফর্ম গড়ে তোলার জন্য প্রতিশ্রুতিবদ্ধ।',
  chinese: '我们致力于为所有人构建一个安全、可靠和透明的平台。',
  english: 'We are committed to building a safe, reliable, and transparent platform for all.',
  estonian: 'Oleme pühendunud turvalise, usaldusväärse ja läbipaistva platvormi loomisele kõigile.',
  filipino: 'Nakatuon kami sa pagbuo ng isang ligtas, maaasahan, at transparent na platform para sa lahat.',
  french: 'Nous nous engageons à construire une plateforme sûre, fiable et transparente pour tous.',
  german: 'Wir setzen uns für den Aufbau einer sicheren, zuverlässigen und transparenten Plattform für alle ein.',
  hindi: 'हम सभी के लिए एक सुरक्षित, विश्वसनीय और पारदर्शी प्लेटफॉर्म बनाने के लिए प्रतिबद्ध हैं।',
  indonesian: 'Kami berkomitmen untuk membangun platform yang aman, dapat diandalkan, dan transparan untuk semua orang.',
  japanese: '私たちは、すべての人のための安全で信頼性が高く、透明性のあるプラットフォームの構築に取り組んでいます。',
  korean: '우리는 모든 사람을 위한 안전하고 신뢰할 수 있으며 투명한 플랫폼을 구축하기 위해 노력합니다.',
  portuguese: 'Estamos comprometidos em construir uma plataforma segura, confiável e transparente para todos.',
  russian: 'Мы стремимся создать безопасную, надежную и прозрачную платформу для всех.',
  spanish: 'Estamos comprometidos a construir una plataforma segura, confiable y transparente para todos.',
  swahili: 'Tunaahidi kujenga jukwaa salama, la kuaminika na wazi kwa wote.',
  vietnamese: 'Chúng tôi cam kết xây dựng một nền tảng an toàn, đáng tin cậy và minh bạch cho tất cả mọi người.',
};

export const faqGeneralTitle: Translation = {
  amharic: 'አጠቃላይ ጥያቄዎች',
  arabic: 'الأسئلة العامة',
  bengali: 'সাধারণ প্রশ্ন',
  chinese: '一般问题',
  english: 'General Questions',
  estonian: 'Üldised küsimused',
  filipino: 'Mga pangkalahatang tanong',
  french: 'Questions générales',
  german: 'Allgemeine Fragen',
  hindi: 'सामान्य प्रश्न',
  indonesian: 'Pertanyaan umum',
  japanese: '一般的な質問',
  korean: '일반 질문',
  portuguese: 'Perguntas gerais',
  russian: 'Общие вопросы',
  spanish: 'Preguntas generales',
  swahili: 'Maswali ya Jumla',
  vietnamese: 'Câu hỏi chung',
};

export const faqGeneralQuestion1: Translation = {
  amharic: 'Workadabra እንዴት ይሠራል?',
  arabic: 'كيف يعمل Workadabra؟',
  bengali: 'Workadabra কীভাবে কাজ করে?',
  chinese: 'Workadabra如何运作？',
  english: 'How does Workadabra work?',
  estonian: 'Kuidas Workadabra töötab?',
  filipino: 'Paano gumagana ang Workadabra?',
  french: 'Comment fonctionne Workadabra ?',
  german: 'Wie funktioniert Workadabra?',
  hindi: 'Workadabra कैसे काम करता है?',
  indonesian: 'Bagaimana cara kerja Workadabra?',
  japanese: 'Workadabraはどのように機能しますか？',
  korean: 'Workadabra는 어떻게 작동하나요?',
  portuguese: 'Como funciona o Workadabra?',
  russian: 'Как работает Workadabra?',
  spanish: '¿Cómo funciona Workadabra?',
  swahili: 'Workadabra inafanya kazi vipi?',
  vietnamese: 'Workadabra hoạt động như thế nào?',
};

export const faqGeneralAnswer1: Translation = {
  amharic: 'Workadabra ለተለያዩ አገልግሎቶች ከታመኑ አካባቢያዊ ባለሙያዎች ጋር ያገናኝዎታል። በቀላሉ አገልግሎት ይፈልጉ፣ አቅራቢዎችን ያስሱ፣ ግምገማዎችን ያንብቡ እና በቀጥታ በመድረካችን በኩል ቀጠሮዎችን ይዘዙ።',
  arabic: 'Workadabra يربطك بالمحترفين المحليين الموثوق بهم لمختلف الخدمات. ما عليك سوى البحث عن خدمة، وتصفح مقدمي الخدمات، وقراءة المراجعات، وحجز المواعيد مباشرة من خلال منصتنا.',
  bengali: 'Workadabra আপনাকে বিভিন্ন সেবার জন্য বিশ্বস্ত স্থানীয় পেশাদারদের সাথে সংযুক্ত করে। কেবল একটি সেবা অনুসন্ধান করুন, প্রদানকারীদের ব্রাউজ করুন, পর্যালোচনা পড়ুন এবং সরাসরি আমাদের প্ল্যাটফর্মের মাধ্যমে অ্যাপয়েন্টমেন্ট বুক করুন।',
  chinese: 'Workadabra将您与值得信赖的本地专业人士联系起来，提供各种服务。只需搜索服务、浏览提供商、阅读评论，并直接通过我们的平台预订预约。',
  english: 'Workadabra connects you with trusted local professionals for various services. Simply search for a service, browse providers, read reviews, and book appointments directly through our platform.',
  estonian: 'Workadabra ühendab teid usaldusväärsete kohalike professionaalidega erinevate teenuste jaoks. Lihtsalt otsige teenust, sirvige teenusepakkujaid, lugege arvustusi ja broneerige kohtumisi otse meie platvormi kaudu.',
  filipino: "Ikinonekta ng Workadabra ang inyong mga pinagkakatiwalaang lokal na propesyonal para sa iba't ibang serbisyo. Maghanap lang ng serbisyo, mag-browse ng mga provider, magbasa ng mga review, at mag-book ng appointments nang direkta sa pamamagitan ng aming platform.",
  french: 'Workadabra vous connecte avec des professionnels locaux de confiance pour divers services. Recherchez simplement un service, parcourez les prestataires, lisez les avis et réservez des rendez-vous directement via notre plateforme.',
  german: 'Workadabra verbindet Sie mit vertrauenswürdigen lokalen Fachleuten für verschiedene Dienstleistungen. Suchen Sie einfach nach einem Service, durchsuchen Sie Anbieter, lesen Sie Bewertungen und buchen Sie Termine direkt über unsere Plattform.',
  hindi: 'Workadabra आपको विभिन्न सेवाओं के लिए विश्वसनीय स्थानीय पेशेवरों से जोड़ता है। बस एक सेवा खोजें, प्रदाताओं को ब्राउज़ करें, समीक्षाएं पढ़ें, और सीधे हमारे प्लेटफॉर्म के माध्यम से अपॉइंटमेंट बुक करें।',
  indonesian: 'Workadabra menghubungkan Anda dengan profesional lokal terpercaya untuk berbagai layanan. Cukup cari layanan, jelajahi penyedia, baca ulasan, dan pesan janji temu langsung melalui platform kami.',
  japanese: 'Workadabraは、さまざまなサービスのために信頼できる地元の専門家とあなたを結びつけます。サービスを検索し、プロバイダーを閲覧し、レビューを読み、プラットフォームを通じて直接予約を予約するだけです。',
  korean: 'Workadabra는 다양한 서비스를 위해 신뢰할 수 있는 지역 전문가와 연결해줍니다. 서비스를 검색하고, 제공업체를 둘러보고, 리뷰를 읽고, 플랫폼을 통해 직접 약속을 예약하세요.',
  portuguese: 'Workadabra conecta você com profissionais locais confiáveis para vários serviços. Simplesmente pesquise um serviço, navegue pelos provedores, leia avaliações e reserve compromissos diretamente através da nossa plataforma.',
  russian: 'Workadabra связывает вас с надежными местными специалистами для различных услуг. Просто найдите услугу, просмотрите поставщиков, прочитайте отзывы и забронируйте встречи напрямую через нашу платформу.',
  spanish: 'Workadabra te conecta con profesionales locales de confianza para diversos servicios. Simplemente busca un servicio, explora proveedores, lee reseñas y reserva citas directamente a través de nuestra plataforma.',
  swahili: 'Workadabra inakuunganisha na wataalamu wa ndani wa kuaminika kwa huduma mbalimbali. Tafuta tu huduma, vinjari watoa huduma, soma hakiki, na weka miadi moja kwa moja kupitia jukwaa letu.',
  vietnamese: 'Workadabra kết nối bạn với các chuyên gia địa phương đáng tin cậy cho các dịch vụ khác nhau. Chỉ cần tìm kiếm dịch vụ, duyệt nhà cung cấp, đọc đánh giá và đặt lịch hẹn trực tiếp thông qua nền tảng của chúng tôi.',
};

export const faqGeneralQuestion2: Translation = {
  amharic: 'Workadabra በአካባቢዬ ይገኛል?',
  arabic: 'هل Workadabra متاح في منطقتي؟',
  bengali: 'Workadabra আমার এলাকায় উপলব্ধ?',
  chinese: 'Workadabra在我的地区可用吗？',
  english: 'Is Workadabra available in my area?',
  estonian: 'Kas Workadabra on saadaval minu piirkonnas?',
  filipino: 'Available ba ang Workadabra sa aking lugar?',
  french: 'Workadabra est-il disponible dans ma région ?',
  german: 'Ist Workadabra in meiner Region verfügbar?',
  hindi: 'क्या Workadabra मेरे क्षेत्र में उपलब्ध है?',
  indonesian: 'Apakah Workadabra tersedia di daerah saya?',
  japanese: 'Workadabraは私の地域で利用できますか？',
  korean: 'Workadabra가 내 지역에서 사용 가능한가요?',
  portuguese: 'O Workadabra está disponível na minha região?',
  russian: 'Доступен ли Workadabra в моем районе?',
  spanish: '¿Está Workadabra disponible en mi área?',
  swahili: 'Je, Workadabra inapatikana katika eneo langu?',
  vietnamese: 'Workadabra có sẵn trong khu vực của tôi không?',
};

export const faqGeneralAnswer2: Translation = {
  amharic: 'Workadabra በአሁኑ ጊዜ በኢስቶኒያ ዋና ከተማዎች ውስጥ ይገኛል። በተደጋጋሚ ወደ አዲስ አካባቢዎች እያሰፋን ነው። አገልግሎቶች በአካባቢዎ ይገኛሉ እንደሆነ ለማየት የእኛን መተግበሪያ ወይም ድር ጣቢያ ይፈትሹ።',
  arabic: 'Workadabra متاح حاليًا في المدن الكبرى في إستونيا. نحن نتوسع باستمرار إلى مناطق جديدة. تحقق من تطبيقنا أو موقعنا الإلكتروني لمعرفة ما إذا كانت الخدمات متاحة في موقعك.',
  bengali: 'Workadabra বর্তমানে এস্তোনিয়ার প্রধান শহরগুলিতে উপলব্ধ। আমরা ক্রমাগত নতুন এলাকায় প্রসারিত হচ্ছি। আপনার অবস্থানে পরিষেবা উপলব্ধ কিনা তা দেখতে আমাদের অ্যাপ বা ওয়েবসাইট পরীক্ষা করুন।',
  chinese: 'Workadabra目前在爱沙尼亚的主要城市可用。我们正在不断扩展到新地区。查看我们的应用程序或网站，了解您所在的位置是否有服务可用。',
  english: 'Workadabra is currently available in major cities across Estonia. We are continuously expanding to new areas. Check our app or website to see if services are available in your location.',
  estonian: 'Workadabra on praegu saadaval Eesti suuremates linnades. Me laiendame pidevalt uutesse piirkondadesse. Kontrollige meie rakendust või veebisaiti, et näha, kas teenused on teie asukohas saadaval.',
  filipino: 'Ang Workadabra ay kasalukuyang available sa mga major cities sa Estonia. Patuloy naming pinalalawak sa mga bagong lugar. Tingnan ang aming app o website upang makita kung available ang mga serbisyo sa inyong lokasyon.',
  french: "Workadabra est actuellement disponible dans les grandes villes d'Estonie. Nous nous développons continuellement vers de nouvelles régions. Vérifiez notre application ou notre site web pour voir si les services sont disponibles dans votre région.",
  german: 'Workadabra ist derzeit in den größten Städten Estlands verfügbar. Wir erweitern kontinuierlich in neue Gebiete. Überprüfen Sie unsere App oder Website, um zu sehen, ob Dienstleistungen in Ihrer Region verfügbar sind.',
  hindi: 'Workadabra वर्तमान में एस्टोनिया के प्रमुख शहरों में उपलब्ध है। हम लगातार नए क्षेत्रों में विस्तार कर रहे हैं। अपने स्थान पर सेवाएं उपलब्ध हैं या नहीं, यह देखने के लिए हमारे ऐप या वेबसाइट की जांच करें।',
  indonesian: 'Workadabra saat ini tersedia di kota-kota besar di Estonia. Kami terus memperluas ke area baru. Periksa aplikasi atau situs web kami untuk melihat apakah layanan tersedia di lokasi Anda.',
  japanese: 'Workadabraは現在、エストニアの主要都市で利用可能です。私たちは継続的に新しい地域に拡大しています。アプリまたはウェブサイトを確認して、お住まいの地域でサービスが利用可能かどうかを確認してください。',
  korean: 'Workadabra는 현재 에스토니아의 주요 도시에서 사용 가능합니다. 우리는 지속적으로 새로운 지역으로 확장하고 있습니다. 앱이나 웹사이트를 확인하여 귀하의 위치에서 서비스를 이용할 수 있는지 확인하세요.',
  portuguese: 'Workadabra está atualmente disponível nas principais cidades da Estônia. Estamos expandindo continuamente para novas áreas. Verifique nosso aplicativo ou site para ver se os serviços estão disponíveis em sua localização.',
  russian: 'Workadabra в настоящее время доступен в крупных городах Эстонии. Мы постоянно расширяемся в новые районы. Проверьте наше приложение или веб-сайт, чтобы узнать, доступны ли услуги в вашем районе.',
  spanish: 'Workadabra está actualmente disponible en las principales ciudades de Estonia. Estamos expandiéndonos continuamente a nuevas áreas. Consulta nuestra aplicación o sitio web para ver si los servicios están disponibles en tu ubicación.',
  swahili: 'Workadabra inapatikana kwa sasa katika miji mikuu ya Estonia. Tunapanua kila mara kwa maeneo mapya. Angalia programu yetu au tovuti ili kuona ikiwa huduma zinapatikana katika eneo lako.',
  vietnamese: 'Workadabra hiện có sẵn tại các thành phố lớn ở Estonia. Chúng tôi đang mở rộng liên tục sang các khu vực mới. Kiểm tra ứng dụng hoặc trang web của chúng tôi để xem dịch vụ có sẵn tại vị trí của bạn không.',
};

export const faqGeneralQuestion3: Translation = {
  amharic: 'መለያ እንዴት ማፍጠር እችላለሁ?',
  arabic: 'كيف أنشئ حسابًا؟',
  bengali: 'আমি কীভাবে একটি অ্যাকাউন্ট তৈরি করব?',
  chinese: '如何创建账户？',
  english: 'How do I create an account?',
  estonian: 'Kuidas luua konto?',
  filipino: 'Paano ako makakagawa ng account?',
  french: 'Comment créer un compte ?',
  german: 'Wie erstelle ich ein Konto?',
  hindi: 'मैं एक खाता कैसे बनाऊं?',
  indonesian: 'Bagaimana cara membuat akun?',
  japanese: 'アカウントを作成するにはどうすればよいですか？',
  korean: '계정을 어떻게 만들까요?',
  portuguese: 'Como criar uma conta?',
  russian: 'Как создать аккаунт?',
  spanish: '¿Cómo creo una cuenta?',
  swahili: 'Ninawezaje kuunda akaunti?',
  vietnamese: 'Làm thế nào để tạo tài khoản?',
};

export const faqGeneralAnswer3: Translation = {
  amharic: 'መለያ መፍጠር ቀላል ነው! የሞባይል መተግበሪያችንን ያውርዱ ወይም ድር ጣቢያችንን ይጎብኙ፣ "ተመዝግቡ" ይጫኑ እና ቀላሉን የምዝገባ ሂደት ይከተሉ። የGoogle ወይም የFacebook መለያዎን በመጠቀምም መመዝገብ ይችላሉ።',
  arabic: 'إنشاء حساب سهل! قم بتنزيل تطبيقنا المحمول أو زر موقعنا الإلكتروني، وانقر على "التسجيل" واتبع عملية التسجيل البسيطة. يمكنك أيضًا التسجيل باستخدام حساب Google أو Facebook الخاص بك.',
  bengali: 'একটি অ্যাকাউন্ট তৈরি করা সহজ! আমাদের মোবাইল অ্যাপ ডাউনলোড করুন বা আমাদের ওয়েবসাইটে যান, "সাইন আপ" ক্লিক করুন এবং সহজ নিবন্ধন প্রক্রিয়াটি অনুসরণ করুন। আপনি আপনার Google বা Facebook অ্যাকাউন্ট ব্যবহার করেও সাইন আপ করতে পারেন।',
  chinese: '创建账户很简单！下载我们的移动应用程序或访问我们的网站，点击"注册"并按照简单的注册流程操作。您也可以使用您的Google或Facebook账户注册。',
  english: 'Creating an account is easy! Download our mobile app or visit our website, click "Sign Up", and follow the simple registration process. You can also sign up using your Google or Facebook account.',
  estonian: 'Konto loomine on lihtne! Laadige alla meie mobiilirakendus või külastage meie veebisaiti, klõpsake "Registreeri" ja järgige lihtsat registreerimisprotsessi. Saate registreeruda ka Google\'i või Facebooki kontoga.',
  filipino: 'Madaling gumawa ng account! I-download ang aming mobile app o bisitahin ang aming website, i-click ang "Sign Up" at sundin ang simpleng registration process. Maaari ka ring mag-sign up gamit ang inyong Google o Facebook account.',
  french: 'Créer un compte est simple ! Téléchargez notre application mobile ou visitez notre site web, cliquez sur "S\'inscrire" et suivez le processus d\'inscription simple. Vous pouvez également vous inscrire en utilisant votre compte Google ou Facebook.',
  german: 'Ein Konto zu erstellen ist einfach! Laden Sie unsere mobile App herunter oder besuchen Sie unsere Website, klicken Sie auf "Registrieren" und folgen Sie dem einfachen Registrierungsprozess. Sie können sich auch mit Ihrem Google- oder Facebook-Konto registrieren.',
  hindi: 'खाता बनाना आसान है! हमारा मोबाइल ऐप डाउनलोड करें या हमारी वेबसाइट पर जाएं, "साइन अप" पर क्लिक करें और सरल पंजीकरण प्रक्रिया का पालन करें। आप अपने Google या Facebook खाते का उपयोग करके भी साइन अप कर सकते हैं।',
  indonesian: 'Membuat akun itu mudah! Unduh aplikasi seluler kami atau kunjungi situs web kami, klik "Daftar" dan ikuti proses pendaftaran sederhana. Anda juga dapat mendaftar menggunakan akun Google atau Facebook Anda.',
  japanese: 'アカウントの作成は簡単です！モバイルアプリをダウンロードするか、ウェブサイトにアクセスし、「サインアップ」をクリックして、簡単な登録プロセスに従ってください。GoogleまたはFacebookアカウントを使用して登録することもできます。',
  korean: '계정 만들기는 쉽습니다! 모바일 앱을 다운로드하거나 웹사이트를 방문하여 "가입하기"를 클릭하고 간단한 등록 절차를 따르세요. Google 또는 Facebook 계정을 사용하여 가입할 수도 있습니다.',
  portuguese: 'Criar uma conta é fácil! Baixe nosso aplicativo móvel ou visite nosso site, clique em "Inscrever-se" e siga o processo simples de registro. Você também pode se inscrever usando sua conta do Google ou Facebook.',
  russian: 'Создать аккаунт просто! Скачайте наше мобильное приложение или посетите наш веб-сайт, нажмите "Зарегистрироваться" и следуйте простому процессу регистрации. Вы также можете зарегистрироваться, используя свой аккаунт Google или Facebook.',
  spanish: '¡Crear una cuenta es fácil! Descarga nuestra aplicación móvil o visita nuestro sitio web, haz clic en "Registrarse" y sigue el sencillo proceso de registro. También puedes registrarte usando tu cuenta de Google o Facebook.',
  swahili: 'Kuunda akaunti ni rahisi! Pakua programu yetu ya simu au tembelea tovuti yetu, bofya "Jisajili" na ufuate mchakato rahisi wa usajili. Unaweza pia kujisajili kwa kutumia akaunti yako ya Google au Facebook.',
  vietnamese: 'Tạo tài khoản rất dễ! Tải xuống ứng dụng di động của chúng tôi hoặc truy cập trang web của chúng tôi, nhấp vào "Đăng ký" và làm theo quy trình đăng ký đơn giản. Bạn cũng có thể đăng ký bằng tài khoản Google hoặc Facebook của mình.',
};

export const faqGeneralQuestion4: Translation = {
  amharic: 'በWorkadabra ላይ ምን ዓይነት አገልግሎቶች ይገኛሉ?',
  arabic: 'ما الخدمات المتاحة على Workadabra؟',
  bengali: 'Workadabra-তে কোন সেবাগুলি উপলব্ধ?',
  chinese: 'Workadabra上提供哪些服务？',
  english: 'What services are available on Workadabra?',
  estonian: 'Millised teenused on Workadabras saadaval?',
  filipino: 'Anong mga serbisyo ang available sa Workadabra?',
  french: 'Quels services sont disponibles sur Workadabra ?',
  german: 'Welche Dienstleistungen sind auf Workadabra verfügbar?',
  hindi: 'Workadabra पर कौन सी सेवाएं उपलब्ध हैं?',
  indonesian: 'Layanan apa saja yang tersedia di Workadabra?',
  japanese: 'Workadabraではどのようなサービスが利用できますか？',
  korean: 'Workadabra에서 어떤 서비스를 이용할 수 있나요?',
  portuguese: 'Quais serviços estão disponíveis no Workadabra?',
  russian: 'Какие услуги доступны на Workadabra?',
  spanish: '¿Qué servicios están disponibles en Workadabra?',
  swahili: 'Huduma zipi zinapatikana kwenye Workadabra?',
  vietnamese: 'Những dịch vụ nào có sẵn trên Workadabra?',
};

export const faqGeneralAnswer4: Translation = {
  amharic: 'Workadabra የቤት ማጽዳት፣ ጠገባ፣ የውበት አገልግሎቶች፣ ማስተማሪያ፣ የቤት እንስሳት እንክብካቤ እና ሌሎችም በርካታ አገልግሎቶችን ያቀርባል። አዲስ አገልግሎቶች በተጠቃሚዎች ፍላጎት ላይ በመመርኮዝ በየጊዜው ይጨመራሉ።',
  arabic: 'يقدم Workadabra مجموعة واسعة من الخدمات بما في ذلك تنظيف المنزل والإصلاحات وخدمات التجميل والدروس الخصوصية ورعاية الحيوانات الأليفة وغير ذلك الكثير. تتم إضافة خدمات جديدة بانتظام بناءً على طلب المستخدم.',
  bengali: 'Workadabra বাড়ির পরিষ্কার, মেরামত, সৌন্দর্য সেবা, টিউশন, পোষা প্রাণীর যত্ন এবং আরও অনেক কিছু সহ বিস্তৃত পরিসরের সেবা প্রদান করে। ব্যবহারকারীর চাহিদার ভিত্তিতে নিয়মিত নতুন সেবা যোগ করা হয়।',
  chinese: 'Workadabra提供广泛的服务，包括家庭清洁、维修、美容服务、辅导、宠物护理等等。根据用户需求定期添加新服务。',
  english: 'Workadabra offers a wide range of services including home cleaning, repairs, beauty services, tutoring, pet care, and much more. New services are added regularly based on user demand.',
  estonian: 'Workadabra pakub laia valikut teenuseid, sealhulgas kodu koristamine, remont, iluteenused, juhendamine, lemmikloomade hooldus ja palju muud. Uusi teenuseid lisatakse regulaarselt kasutajate nõudluse alusel.',
  filipino: 'Nag-aalok ang Workadabra ng malawak na hanay ng mga serbisyo kabilang ang paglilinis ng bahay, pag-aayos, beauty services, tutoring, pet care, at marami pa. Regular na idinadagdag ang mga bagong serbisyo batay sa demand ng user.',
  french: 'Workadabra propose une large gamme de services, y compris le nettoyage de maison, les réparations, les services de beauté, le tutorat, les soins pour animaux de compagnie et bien plus encore. De nouveaux services sont ajoutés régulièrement selon la demande des utilisateurs.',
  german: 'Workadabra bietet eine breite Palette von Dienstleistungen, einschließlich Hausreinigung, Reparaturen, Schönheitsdienstleistungen, Nachhilfe, Haustierpflege und vieles mehr. Neue Dienstleistungen werden regelmäßig basierend auf der Nutzernachfrage hinzugefügt.',
  hindi: 'Workadabra घर की सफाई, मरम्मत, सौंदर्य सेवाएं, ट्यूशन, पालतू जानवरों की देखभाल और बहुत कुछ सहित विभिन्न प्रकार की सेवाएं प्रदान करता है। उपयोगकर्ता की मांग के आधार पर नई सेवाएं नियमित रूप से जोड़ी जाती हैं।',
  indonesian: 'Workadabra menawarkan berbagai layanan termasuk pembersihan rumah, perbaikan, layanan kecantikan, bimbingan belajar, perawatan hewan peliharaan, dan banyak lagi. Layanan baru ditambahkan secara teratur berdasarkan permintaan pengguna.',
  japanese: 'Workadabraは、家庭の清掃、修理、美容サービス、家庭教師、ペットケアなど、幅広いサービスを提供しています。ユーザーの需要に基づいて、新しいサービスが定期的に追加されます。',
  korean: 'Workadabra는 가정 청소, 수리, 미용 서비스, 과외, 반려동물 케어 등을 포함한 광범위한 서비스를 제공합니다. 사용자 수요에 따라 새로운 서비스가 정기적으로 추가됩니다.',
  portuguese: 'Workadabra oferece uma ampla gama de serviços, incluindo limpeza doméstica, reparos, serviços de beleza, tutoria, cuidados com animais de estimação e muito mais. Novos serviços são adicionados regularmente com base na demanda do usuário.',
  russian: 'Workadabra предлагает широкий спектр услуг, включая уборку дома, ремонт, услуги красоты, репетиторство, уход за домашними животными и многое другое. Новые услуги добавляются регулярно на основе спроса пользователей.',
  spanish: 'Workadabra ofrece una amplia gama de servicios que incluyen limpieza del hogar, reparaciones, servicios de belleza, tutoría, cuidado de mascotas y mucho más. Se agregan nuevos servicios regularmente según la demanda del usuario.',
  swahili: 'Workadabra inatoa anuwai ya huduma ikiwemo usafi wa nyumbani, ukarabati, huduma za urembo, kufundisha, utunzaji wa wanyama wa kipenzi na mengine mengi. Huduma mpya zinaongezwa mara kwa mara kulingana na mahitaji ya watumiaji.',
  vietnamese: 'Workadabra cung cấp nhiều loại dịch vụ bao gồm dọn dẹp nhà cửa, sửa chữa, dịch vụ làm đẹp, gia sư, chăm sóc thú cưng và nhiều hơn nữa. Các dịch vụ mới được thêm vào thường xuyên dựa trên nhu cầu của người dùng.',
};

export const faqGeneralQuestion5: Translation = {
  amharic: 'ለአገልግሎቶች እንዴት እከፍላለሁ?',
  arabic: 'كيف أدفع مقابل الخدمات؟',
  bengali: 'আমি সেবার জন্য কীভাবে অর্থ প্রদান করব?',
  chinese: '如何支付服务费用？',
  english: 'How do I pay for services?',
  estonian: 'Kuidas teenuste eest maksta?',
  filipino: 'Paano ako magbabayad para sa mga serbisyo?',
  french: 'Comment payer pour les services ?',
  german: 'Wie bezahle ich für Dienstleistungen?',
  hindi: 'मैं सेवाओं के लिए कैसे भुगतान करूं?',
  indonesian: 'Bagaimana cara membayar layanan?',
  japanese: 'サービスの支払い方法は？',
  korean: '서비스 요금을 어떻게 지불하나요?',
  portuguese: 'Como pago pelos serviços?',
  russian: 'Как оплатить услуги?',
  spanish: '¿Cómo pago por los servicios?',
  swahili: 'Ninawezaje kulipa huduma?',
  vietnamese: 'Làm thế nào để thanh toán cho dịch vụ?',
};

export const faqGeneralAnswer5: Translation = {
  amharic: 'የክሬዲት/ዲቢት ካርዶች፣ የባንክ ማስተላለፎች እና ዲጂታል የገንዘብ ቦርሳዎችን ጨምሮ በርካታ ደህንነቱ የተጠበቀ የክፍያ አማራጮችን እናቀርባለን። ሁሉም ክፍያዎች በመድረካችን በኩል በደህንነት ይከናወናሉ፣ እና አገልግሎቱ ከተጠናቀቀ በኋላ ብቻ እርስዎ የሚያረኩ እንደሆነ ይከፍላሉ።',
  arabic: 'نحن نقدم خيارات دفع آمنة متعددة بما في ذلك بطاقات الائتمان/الخصم والتحويلات المصرفية والمحافظ الرقمية. تتم معالجة جميع المدفوعات بأمان من خلال منصتنا، ويمكنك الدفع فقط بعد اكتمال الخدمة إلى رضاك.',
  bengali: 'আমরা ক্রেডিট/ডেবিট কার্ড, ব্যাঙ্ক ট্রান্সফার এবং ডিজিটাল ওয়ালেট সহ একাধিক নিরাপদ পেমেন্ট বিকল্প অফার করি। সমস্ত পেমেন্ট আমাদের প্ল্যাটফর্মের মাধ্যমে নিরাপদে প্রক্রিয়া করা হয়, এবং আপনি কেবলমাত্র সেবা সম্পূর্ণ হওয়ার পরে আপনার সন্তুষ্টি অনুযায়ী অর্থ প্রদান করেন।',
  chinese: '我们提供多种安全的支付方式，包括信用卡/借记卡、银行转账和数字钱包。所有付款都通过我们的平台安全处理，您只需在服务完成后根据您的满意度付款。',
  english: 'We offer multiple secure payment options including credit/debit cards, bank transfers, and digital wallets. All payments are processed securely through our platform, and you only pay after the service is completed to your satisfaction.',
  estonian: 'Pakume mitmeid turvalisi makseviise, sealhulgas krediit-/deebetkaardid, pangatehingud ja digitaalsed rahakotid. Kõik maksed töödeldakse turvaliselt meie platvormi kaudu ja maksate ainult pärast teenuse lõpetamist teie rahulolu järgi.',
  filipino: 'Nag-aalok kami ng maraming secure na payment options kabilang ang credit/debit cards, bank transfers, at digital wallets. Lahat ng mga bayad ay secure na na-proseso sa pamamagitan ng aming platform, at magbabayad ka lang pagkatapos makumpleto ang serbisyo sa inyong kasiyahan.',
  french:
    "Nous proposons plusieurs options de paiement sécurisées, y compris les cartes de crédit/débit, les virements bancaires et les portefeuilles numériques. Tous les paiements sont traités en toute sécurité via notre plateforme, et vous ne payez qu'après la fin du service à votre satisfaction.",
  german: 'Wir bieten mehrere sichere Zahlungsoptionen, einschließlich Kredit-/Debitkarten, Banküberweisungen und digitale Geldbörsen. Alle Zahlungen werden sicher über unsere Plattform abgewickelt, und Sie zahlen nur nach Abschluss des Service zu Ihrer Zufriedenheit.',
  hindi: 'हम क्रेडिट/डेबिट कार्ड, बैंक ट्रांसफर और डिजिटल वॉलेट सहित कई सुरक्षित भुगतान विकल्प प्रदान करते हैं। सभी भुगतान हमारे प्लेटफॉर्म के माध्यम से सुरक्षित रूप से संसाधित किए जाते हैं, और आप केवल सेवा के पूरा होने के बाद अपनी संतुष्टि के अनुसार भुगतान करते हैं।',
  indonesian: 'Kami menawarkan beberapa opsi pembayaran yang aman termasuk kartu kredit/debit, transfer bank, dan dompet digital. Semua pembayaran diproses dengan aman melalui platform kami, dan Anda hanya membayar setelah layanan selesai sesuai kepuasan Anda.',
  japanese: 'クレジット/デビットカード、銀行振込、デジタルウォレットを含む複数の安全な支払いオプションを提供しています。すべての支払いは当社のプラットフォームを通じて安全に処理され、サービスが完了し、ご満足いただいた後にのみお支払いいただきます。',
  korean: '신용/직불 카드, 은행 송금 및 디지털 지갑을 포함한 여러 안전한 결제 옵션을 제공합니다. 모든 결제는 우리 플랫폼을 통해 안전하게 처리되며, 서비스가 완료된 후 만족도에 따라 결제합니다.',
  portuguese: 'Oferecemos várias opções de pagamento seguras, incluindo cartões de crédito/débito, transferências bancárias e carteiras digitais. Todos os pagamentos são processados com segurança através da nossa plataforma, e você só paga após a conclusão do serviço à sua satisfação.',
  russian: 'Мы предлагаем несколько безопасных способов оплаты, включая кредитные/дебетовые карты, банковские переводы и цифровые кошельки. Все платежи обрабатываются безопасно через нашу платформу, и вы платите только после завершения услуги к вашему удовлетворению.',
  spanish: 'Ofrecemos múltiples opciones de pago seguras, incluidas tarjetas de crédito/débito, transferencias bancarias y billeteras digitales. Todos los pagos se procesan de forma segura a través de nuestra plataforma, y solo pagas después de que el servicio se complete a tu satisfacción.',
  swahili: 'Tunatoa chaguzi nyingi za malipo salama ikiwemo kadi za mkopo/debit, malipo ya benki, na pochi za dijitali. Malipo yote yanachakatwa kwa usalama kupitia jukwaa letu, na unalipa tu baada ya huduma kukamilika kwa kuridhika kwako.',
  vietnamese: 'Chúng tôi cung cấp nhiều phương thức thanh toán an toàn bao gồm thẻ tín dụng/ghi nợ, chuyển khoản ngân hàng và ví kỹ thuật số. Tất cả các khoản thanh toán được xử lý an toàn thông qua nền tảng của chúng tôi, và bạn chỉ thanh toán sau khi dịch vụ hoàn thành theo sự hài lòng của bạn.',
};

export const faqSectionAccountProfile: Translation = {
  amharic: 'መለያ እና መገለጫ',
  arabic: 'الحساب والملف الشخصي',
  bengali: 'অ্যাকাউন্ট এবং প্রোফাইল',
  chinese: '账户和资料',
  english: 'Account & Profile',
  estonian: 'Konto ja Profiil',
  filipino: 'Account at profile',
  french: 'Compte et Profil',
  german: 'Konto und Profil',
  hindi: 'खाता और प्रोफ़ाइल',
  indonesian: 'Akun dan profil',
  japanese: 'アカウントとプロフィール',
  korean: '계정 및 프로필',
  portuguese: 'Conta e perfil',
  russian: 'Аккаунт и профиль',
  spanish: 'Cuenta y perfil',
  swahili: 'Akaunti na Wasifu',
  vietnamese: 'Tài khoản và hồ sơ',
};

export const faqSectionServicesBookings: Translation = {
  amharic: 'አገልግሎቶች እና ምዝገባዎች',
  arabic: 'الخدمات والحجوزات',
  bengali: 'সেবা এবং বুকিং',
  chinese: '服务和预订',
  english: 'Services & Bookings',
  estonian: 'Teenused ja Broneeringud',
  filipino: 'Mga serbisyo at booking',
  french: 'Services et Réservations',
  german: 'Dienstleistungen und Buchungen',
  hindi: 'सेवाएं और बुकिंग',
  indonesian: 'Layanan dan pemesanan',
  japanese: 'サービスと予約',
  korean: '서비스 및 예약',
  portuguese: 'Serviços e reservas',
  russian: 'Услуги и бронирования',
  spanish: 'Servicios y reservas',
  swahili: 'Huduma na Uwekaji',
  vietnamese: 'Dịch vụ và đặt chỗ',
};

export const faqSectionPaymentsRefunds: Translation = {
  amharic: 'ክፍያዎች እና መመለሻዎች',
  arabic: 'المدفوعات والاسترداد',
  bengali: 'পেমেন্ট এবং রিফান্ড',
  chinese: '付款和退款',
  english: 'Payments & Refunds',
  estonian: 'Maksed ja Tagastused',
  filipino: 'Mga bayad at refund',
  french: 'Paiements et Remboursements',
  german: 'Zahlungen und Rückerstattungen',
  hindi: 'भुगतान और धनवापसी',
  indonesian: 'Pembayaran dan pengembalian dana',
  japanese: '支払いと返金',
  korean: '결제 및 환불',
  portuguese: 'Pagamentos e reembolsos',
  russian: 'Платежи и возвраты',
  spanish: 'Pagos y reembolsos',
  swahili: 'Malipo na Rudi',
  vietnamese: 'Thanh toán và hoàn tiền',
};

export const faqAccountVerifyQuestion: Translation = {
  amharic: 'መለያዬን እንዴት እረጋግጣለሁ?',
  arabic: 'كيف أتحقق من حسابي؟',
  bengali: 'আমি কীভাবে আমার অ্যাকাউন্ট যাচাই করব?',
  chinese: '如何验证我的账户？',
  english: 'How do I verify my account?',
  estonian: 'Kuidas kontot kinnitada?',
  filipino: 'Paano ko i-verify ang aking account?',
  french: 'Comment vérifier mon compte?',
  german: 'Wie verifiziere ich mein Konto?',
  hindi: 'मैं अपने खाते को कैसे सत्यापित करूं?',
  indonesian: 'Bagaimana cara memverifikasi akun saya?',
  japanese: 'アカウントを確認するにはどうすればよいですか？',
  korean: '계정을 어떻게 확인하나요?',
  portuguese: 'Como verifico minha conta?',
  russian: 'Как подтвердить мой аккаунт?',
  spanish: '¿Cómo verifico mi cuenta?',
  swahili: 'Ninawezaje kuthibitisha akaunti yangu?',
  vietnamese: 'Làm thế nào để xác minh tài khoản của tôi?',
};

export const faqAccountVerifyAnswer: Translation = {
  amharic: 'መለያዎን ለማረጋገጥ፣ ትክክለኛ የመንግስት የተሰጠ መለያ እና የአድራሻ ማስረጃ ማቅረብ ያስፈልግዎታል። የማረጋገጫ ቡድናችን ሰነዶችዎን በ24-48 ሰዓታት ውስጥ ይገምግማል።',
  arabic: 'للتحقق من حسابك، ستحتاج إلى تقديم هوية صالحة صادرة عن الحكومة وإثبات العنوان. سيراجع فريق التحقق لدينا مستنداتك خلال 24-48 ساعة.',
  bengali: 'আপনার অ্যাকাউন্ট যাচাই করতে, আপনাকে একটি বৈধ সরকার-জারি করা আইডি এবং ঠিকানার প্রমাণ প্রদান করতে হবে। আমাদের যাচাইকরণ দল 24-48 ঘন্টার মধ্যে আপনার নথি পর্যালোচনা করবে।',
  chinese: '要验证您的账户，您需要提供有效的政府签发的身份证件和地址证明。我们的验证团队将在24-48小时内审核您的文件。',
  english: "To verify your account, you'll need to provide a valid government-issued ID and proof of address. Our verification team will review your documents within 24-48 hours.",
  estonian: 'Konto kinnitamiseks peate esitama kehtiva valitsuse välja antud ID ja aadressi tõendi. Meie kinnitusteam vaatab teie dokumendid üle 24-48 tunni jooksul.',
  filipino: 'Upang i-verify ang inyong account, kailangan ninyong magbigay ng valid na government-issued ID at proof of address. Ang aming verification team ay magre-review ng inyong mga dokumento sa loob ng 24-48 oras.',
  french: "Pour vérifier votre compte, vous devrez fournir une pièce d'identité valide délivrée par le gouvernement et une preuve d'adresse. Notre équipe de vérification examinera vos documents sous 24-48 heures.",
  german: 'Um Ihr Konto zu verifizieren, müssen Sie einen gültigen staatlich ausgestellten Ausweis und einen Adressnachweis vorlegen. Unser Verifizierungsteam wird Ihre Dokumente innerhalb von 24-48 Stunden überprüfen.',
  hindi: 'अपने खाते को सत्यापित करने के लिए, आपको एक वैध सरकार-जारी आईडी और पते का प्रमाण प्रदान करना होगा। हमारी सत्यापन टीम 24-48 घंटों के भीतर आपके दस्तावेजों की समीक्षा करेगी।',
  indonesian: 'Untuk memverifikasi akun Anda, Anda perlu menyediakan ID yang valid yang dikeluarkan oleh pemerintah dan bukti alamat. Tim verifikasi kami akan meninjau dokumen Anda dalam 24-48 jam.',
  japanese: 'アカウントを確認するには、有効な政府発行のIDと住所証明が必要です。確認チームは24-48時間以内にあなたの書類を確認します。',
  korean: '계정을 확인하려면 유효한 정부 발급 신분증과 주소 증명이 필요합니다. 우리의 확인 팀은 24-48시간 이내에 귀하의 서류를 검토할 것입니다.',
  portuguese: 'Para verificar sua conta, você precisará fornecer uma identidade válida emitida pelo governo e comprovante de endereço. Nossa equipe de verificação revisará seus documentos em 24-48 horas.',
  russian: 'Для подтверждения аккаунта вам нужно будет предоставить действительное удостоверение личности, выданное государством, и подтверждение адреса. Наша команда проверки рассмотрит ваши документы в течение 24-48 часов.',
  spanish: 'Para verificar tu cuenta, necesitarás proporcionar una identificación válida emitida por el gobierno y una prueba de dirección. Nuestro equipo de verificación revisará tus documentos en 24-48 horas.',
  swahili: 'Ili kuthibitisha akaunti yako, utahitaji kutoa kitambulisho halali kilichotolewa na serikali na uthibitisho wa anwani. Timu yetu ya uthibitishaji itakagua hati zako ndani ya masaa 24-48.',
  vietnamese: 'Để xác minh tài khoản của bạn, bạn cần cung cấp ID hợp lệ do chính phủ cấp và bằng chứng địa chỉ. Đội ngũ xác minh của chúng tôi sẽ xem xét tài liệu của bạn trong vòng 24-48 giờ.',
};

export const faqAccountEmailQuestion: Translation = {
  amharic: 'የኢሜይል አድራሻዬን ልቀይር ይችላለሁ?',
  arabic: 'هل يمكنني تغيير عنوان بريدي الإلكتروني؟',
  bengali: 'আমি কি আমার ইমেইল ঠিকানা পরিবর্তন করতে পারি?',
  chinese: '我可以更改我的电子邮件地址吗？',
  english: 'Can I change my email address?',
  estonian: 'Kas saan e-posti aadressi muuta?',
  filipino: 'Maaari ko bang baguhin ang aking email address?',
  french: 'Puis-je changer mon adresse e-mail?',
  german: 'Kann ich meine E-Mail-Adresse ändern?',
  hindi: 'क्या मैं अपना ईमेल पता बदल सकता हूं?',
  indonesian: 'Bisakah saya mengubah alamat email saya?',
  japanese: 'メールアドレスを変更できますか？',
  korean: '이메일 주소를 변경할 수 있나요?',
  portuguese: 'Posso alterar meu endereço de e-mail?',
  russian: 'Могу ли я изменить мой адрес электронной почты?',
  spanish: '¿Puedo cambiar mi dirección de correo electrónico?',
  swahili: 'Naweza kubadilisha anwani yangu ya barua pepe?',
  vietnamese: 'Tôi có thể thay đổi địa chỉ email của mình không?',
};

export const faqAccountEmailAnswer: Translation = {
  amharic: 'አዎ፣ የኢሜይል አድራሻዎን በመለያ ማቀናበሪያዎች ውስጥ ማስተካከል ይችላሉ። ለውጡ ከመግባቱ በፊት አዲሱን የኢሜይል አድራሻ ማረጋገጥ ያስፈልግዎታል።',
  arabic: 'نعم، يمكنك تغيير عنوان بريدك الإلكتروني في إعدادات حسابك. ستحتاج إلى التحقق من عنوان البريد الإلكتروني الجديد قبل أن يدخل التغيير حيز التنفيذ.',
  bengali: 'হ্যাঁ, আপনি আপনার অ্যাকাউন্ট সেটিংসে আপনার ইমেইল ঠিকানা পরিবর্তন করতে পারেন। পরিবর্তন কার্যকর হওয়ার আগে আপনাকে নতুন ইমেইল ঠিকানা যাচাই করতে হবে।',
  chinese: '是的，您可以在账户设置中更改您的电子邮件地址。在更改生效之前，您需要验证新的电子邮件地址。',
  english: "Yes, you can change your email address in your account settings. You'll need to verify the new email address before the change takes effect.",
  estonian: 'Jah, saate e-posti aadressi muuta oma konto seadetes. Peate uue e-posti aadressi kinnitama, enne kui muudatus jõustub.',
  filipino: 'Oo, maaari mong baguhin ang inyong email address sa inyong account settings. Kailangan ninyong i-verify ang bagong email address bago magkabisa ang pagbabago.',
  french: 'Oui, vous pouvez changer votre adresse e-mail dans les paramètres de votre compte. Vous devrez vérifier la nouvelle adresse e-mail avant que le changement ne prenne effet.',
  german: 'Ja, Sie können Ihre E-Mail-Adresse in Ihren Kontoeinstellungen ändern. Sie müssen die neue E-Mail-Adresse verifizieren, bevor die Änderung wirksam wird.',
  hindi: 'हां, आप अपने खाता सेटिंग्स में अपना ईमेल पता बदल सकते हैं। परिवर्तन प्रभावी होने से पहले आपको नए ईमेल पते को सत्यापित करना होगा।',
  indonesian: 'Ya, Anda dapat mengubah alamat email Anda di pengaturan akun. Anda perlu memverifikasi alamat email baru sebelum perubahan berlaku.',
  japanese: 'はい、アカウント設定でメールアドレスを変更できます。変更が有効になる前に、新しいメールアドレスを確認する必要があります。',
  korean: '예, 계정 설정에서 이메일 주소를 변경할 수 있습니다. 변경 사항이 적용되기 전에 새 이메일 주소를 확인해야 합니다.',
  portuguese: 'Sim, você pode alterar seu endereço de e-mail nas configurações da sua conta. Você precisará verificar o novo endereço de e-mail antes que a alteração entre em vigor.',
  russian: 'Да, вы можете изменить адрес электронной почты в настройках аккаунта. Вам нужно будет подтвердить новый адрес электронной почты, прежде чем изменение вступит в силу.',
  spanish: 'Sí, puedes cambiar tu dirección de correo electrónico en la configuración de tu cuenta. Necesitarás verificar la nueva dirección de correo electrónico antes de que el cambio surta efecto.',
  swahili: 'Ndio, unaweza kubadilisha anwani yako ya barua pepe katika mipangilio ya akaunti yako. Utahitaji kuthibitisha anwani mpya ya barua pepe kabla ya mabadiliko kuanza kutumika.',
  vietnamese: 'Có, bạn có thể thay đổi địa chỉ email của mình trong cài đặt tài khoản. Bạn sẽ cần xác minh địa chỉ email mới trước khi thay đổi có hiệu lực.',
};

export const faqAccountDeleteQuestion: Translation = {
  amharic: 'መለያዬን እንዴት እሰርዛለሁ?',
  arabic: 'كيف أحذف حسابي؟',
  bengali: 'আমি কীভাবে আমার অ্যাকাউন্ট মুছব?',
  chinese: '如何删除我的账户？',
  english: 'How do I delete my account?',
  estonian: 'Kuidas konto kustutada?',
  filipino: 'Paano ko tatanggalin ang aking account?',
  french: 'Comment supprimer mon compte?',
  german: 'Wie lösche ich mein Konto?',
  hindi: 'मैं अपना खाता कैसे हटाऊं?',
  indonesian: 'Bagaimana cara menghapus akun saya?',
  japanese: 'アカウントを削除するにはどうすればよいですか？',
  korean: '계정을 어떻게 삭제하나요?',
  portuguese: 'Como excluo minha conta?',
  russian: 'Как удалить мой аккаунт?',
  spanish: '¿Cómo elimino mi cuenta?',
  swahili: 'Ninawezaje kufuta akaunti yangu?',
  vietnamese: 'Làm thế nào để xóa tài khoản của tôi?',
};

export const faqAccountDeleteAnswer: Translation = {
  amharic: 'መለያዎን ለማስወገድ፣ ወደ የመለያ ማቀናበሪያዎች > ግላዊነት እና ደህንነት > መለያ ማስወገድ ይሂዱ። እባክዎ ይህ እርምጃ የማይመለስ እና ሁሉንም ውሂብዎን ሁልጊዜ ያስወግዳል ማስታወስ።',
  arabic: 'لحذف حسابك، انتقل إلى إعدادات الحساب > الخصوصية والأمان > حذف الحساب. يرجى ملاحظة أن هذا الإجراء لا رجعة فيه وسيحذف جميع بياناتك بشكل دائم.',
  bengali: 'আপনার অ্যাকাউন্ট মুছতে, অ্যাকাউন্ট সেটিংস > গোপনীয়তা এবং নিরাপত্তা > অ্যাকাউন্ট মুছুন এ যান। অনুগ্রহ করে মনে রাখবেন যে এই ক্রিয়াটি অপরিবর্তনীয় এবং স্থায়ীভাবে আপনার সমস্ত ডেটা সরিয়ে দেবে।',
  chinese: '要删除您的账户，请转到账户设置 > 隐私和安全 > 删除账户。请注意，此操作不可逆，将永久删除您的所有数据。',
  english: 'To delete your account, go to Account Settings > Privacy & Security > Delete Account. Please note that this action is irreversible and will permanently remove all your data.',
  estonian: 'Konto kustutamiseks minge Konto seaded > Privaatsus ja Turvalisus > Konto kustutamine. Pange tähele, et see toiming on pöördumatu ja kustutab jäädavalt kõik teie andmed.',
  filipino: 'Upang tanggalin ang inyong account, pumunta sa Account Settings > Privacy & Security > Delete Account. Pakitandaan na ang aksyon na ito ay hindi na mababalik at permanenteng tatanggalin ang lahat ng inyong data.',
  french: 'Pour supprimer votre compte, allez dans Paramètres du compte > Confidentialité et Sécurité > Supprimer le compte. Veuillez noter que cette action est irréversible et supprimera définitivement toutes vos données.',
  german: 'Um Ihr Konto zu löschen, gehen Sie zu Kontoeinstellungen > Datenschutz und Sicherheit > Konto löschen. Bitte beachten Sie, dass diese Aktion nicht rückgängig gemacht werden kann und alle Ihre Daten dauerhaft entfernt werden.',
  hindi: 'अपना खाता हटाने के लिए, खाता सेटिंग्स > गोपनीयता और सुरक्षा > खाता हटाएं पर जाएं। कृपया ध्यान दें कि यह कार्रवाई अपरिवर्तनीय है और स्थायी रूप से आपके सभी डेटा को हटा देगी।',
  indonesian: 'Untuk menghapus akun Anda, buka Pengaturan Akun > Privasi & Keamanan > Hapus Akun. Harap dicatat bahwa tindakan ini tidak dapat dibatalkan dan akan menghapus semua data Anda secara permanen.',
  japanese: 'アカウントを削除するには、アカウント設定 > プライバシーとセキュリティ > アカウントを削除に移動してください。この操作は元に戻せず、すべてのデータが永続的に削除されることに注意してください。',
  korean: '계정을 삭제하려면 계정 설정 > 개인정보 보호 및 보안 > 계정 삭제로 이동하세요. 이 작업은 되돌릴 수 없으며 모든 데이터가 영구적으로 제거됩니다.',
  portuguese: 'Para excluir sua conta, vá para Configurações da conta > Privacidade e segurança > Excluir conta. Observe que esta ação é irreversível e removerá permanentemente todos os seus dados.',
  russian: 'Чтобы удалить аккаунт, перейдите в Настройки аккаунта > Конфиденциальность и безопасность > Удалить аккаунт. Обратите внимание, что это действие необратимо и навсегда удалит все ваши данные.',
  spanish: 'Para eliminar tu cuenta, ve a Configuración de cuenta > Privacidad y seguridad > Eliminar cuenta. Ten en cuenta que esta acción es irreversible y eliminará permanentemente todos tus datos.',
  swahili: 'Ili kufuta akaunti yako, nenda kwenye Mipangilio ya Akaunti > Faragha na Usalama > Futa Akaunti. Tafadhali kumbuka kuwa hatua hii haiwezi kurejeshwa na itaondoa data yako yote kwa kudumu.',
  vietnamese: 'Để xóa tài khoản của bạn, hãy vào Cài đặt tài khoản > Quyền riêng tư & Bảo mật > Xóa tài khoản. Vui lòng lưu ý rằng hành động này không thể hoàn tác và sẽ xóa vĩnh viễn tất cả dữ liệu của bạn.',
};

export const faqServiceBookQuestion: Translation = {
  amharic: 'አገልግሎት እንዴት እዘዝ?',
  arabic: 'كيف أحجز خدمة؟',
  bengali: 'আমি কীভাবে একটি সেবা বুক করব?',
  chinese: '如何预订服务？',
  english: 'How do I book a service?',
  estonian: 'Kuidas teenust broneerida?',
  filipino: 'Paano ako magbo-book ng serbisyo?',
  french: 'Comment réserver un service?',
  german: 'Wie buche ich einen Service?',
  hindi: 'मैं एक सेवा कैसे बुक करूं?',
  indonesian: 'Bagaimana cara memesan layanan?',
  japanese: 'サービスを予約するにはどうすればよいですか？',
  korean: '서비스를 어떻게 예약하나요?',
  portuguese: 'Como reservo um serviço?',
  russian: 'Как забронировать услугу?',
  spanish: '¿Cómo reservo un servicio?',
  swahili: 'Ninawezaje kuweka huduma?',
  vietnamese: 'Làm thế nào để đặt dịch vụ?',
};

export const faqServiceBookAnswer: Translation = {
  amharic: 'አገልግሎት ለመዘዝ፣ በአካባቢዎ የሚገኙ አቅራቢዎችን ያስሱ፣ የሚፈልጉትን አገልግሎት ይምረጡ፣ የሚመርጡትን የጊዜ ክፍት ይምረጡ እና በክፍያ ምዝገባውን ያጠናቅቁ።',
  arabic: 'لحجز خدمة، تصفح مقدمي الخدمات المتاحين في منطقتك، اختر الخدمة التي تحتاجها، اختر الفترة الزمنية المفضلة لديك وأكمل الحجز بالدفع.',
  bengali: 'একটি সেবা বুক করতে, আপনার এলাকায় উপলব্ধ প্রদানকারীদের ব্রাউজ করুন, আপনার প্রয়োজনীয় সেবাটি নির্বাচন করুন, আপনার পছন্দের সময় স্লট চয়ন করুন এবং পেমেন্ট দিয়ে বুকিং সম্পূর্ণ করুন।',
  chinese: '要预订服务，请浏览您所在地区的可用提供商，选择您需要的服务，选择您首选的时间段，并通过付款完成预订。',
  english: 'To book a service, browse available providers in your area, select the service you need, choose your preferred time slot, and complete the booking with payment.',
  estonian: 'Teenuse broneerimiseks sirvige oma piirkonnas saadaval olevaid pakkujaid, valige vajalik teenus, valige eelistatud ajavahemik ja lõpetage broneering maksega.',
  filipino: 'Upang mag-book ng serbisyo, mag-browse ng available na mga provider sa inyong lugar, piliin ang serbisyong kailangan ninyo, piliin ang inyong preferred time slot, at kumpletuhin ang booking sa pamamagitan ng payment.',
  french: 'Pour réserver un service, parcourez les prestataires disponibles dans votre région, sélectionnez le service dont vous avez besoin, choisissez votre créneau horaire préféré et complétez la réservation avec le paiement.',
  german: 'Um einen Service zu buchen, durchsuchen Sie verfügbare Anbieter in Ihrer Region, wählen Sie den benötigten Service, wählen Sie Ihren bevorzugten Zeitslot und vervollständigen Sie die Buchung mit der Zahlung.',
  hindi: 'सेवा बुक करने के लिए, अपने क्षेत्र में उपलब्ध प्रदाताओं को ब्राउज़ करें, आपको जिस सेवा की आवश्यकता है उसे चुनें, अपना पसंदीदा समय स्लॉट चुनें और भुगतान के साथ बुकिंग पूरी करें।',
  indonesian: 'Untuk memesan layanan, jelajahi penyedia yang tersedia di daerah Anda, pilih layanan yang Anda butuhkan, pilih slot waktu yang Anda inginkan, dan selesaikan pemesanan dengan pembayaran.',
  japanese: 'サービスを予約するには、お住まいの地域の利用可能なプロバイダーを閲覧し、必要なサービスを選択し、希望する時間枠を選択して、支払いで予約を完了してください。',
  korean: '서비스를 예약하려면 지역의 사용 가능한 제공업체를 둘러보고, 필요한 서비스를 선택하고, 선호하는 시간대를 선택한 다음 결제로 예약을 완료하세요.',
  portuguese: 'Para reservar um serviço, navegue pelos provedores disponíveis em sua área, selecione o serviço de que precisa, escolha seu horário preferido e complete a reserva com o pagamento.',
  russian: 'Чтобы забронировать услугу, просмотрите доступных поставщиков в вашем районе, выберите нужную услугу, выберите предпочтительное время и завершите бронирование оплатой.',
  spanish: 'Para reservar un servicio, explora los proveedores disponibles en tu área, selecciona el servicio que necesitas, elige tu franja horaria preferida y completa la reserva con el pago.',
  swahili: 'Ili kuweka huduma, vinjari watoa huduma wanaopatikana katika eneo lako, chagua huduma unayohitaji, chagua muda unayopendelea na ukamilishe uwekaji kwa malipo.',
  vietnamese: 'Để đặt dịch vụ, duyệt các nhà cung cấp có sẵn trong khu vực của bạn, chọn dịch vụ bạn cần, chọn khung giờ ưa thích của bạn và hoàn tất đặt chỗ bằng thanh toán.',
};

export const faqServiceCancelQuestion: Translation = {
  amharic: 'ምዝገባ ማስረግ ይችላለሁ?',
  arabic: 'هل يمكنني إلغاء الحجز؟',
  bengali: 'আমি কি একটি বুকিং বাতিল করতে পারি?',
  chinese: '我可以取消预订吗？',
  english: 'Can I cancel a booking?',
  estonian: 'Kas saan broneeringu tühistada?',
  filipino: 'Maaari ko bang kanselahin ang isang booking?',
  french: 'Puis-je annuler une réservation?',
  german: 'Kann ich eine Buchung stornieren?',
  hindi: 'क्या मैं एक बुकिंग रद्द कर सकता हूं?',
  indonesian: 'Bisakah saya membatalkan pemesanan?',
  japanese: '予約をキャンセルできますか？',
  korean: '예약을 취소할 수 있나요?',
  portuguese: 'Posso cancelar uma reserva?',
  russian: 'Могу ли я отменить бронирование?',
  spanish: '¿Puedo cancelar una reserva?',
  swahili: 'Naweza kughairi uwekaji?',
  vietnamese: 'Tôi có thể hủy đặt chỗ không?',
};

export const faqServiceCancelAnswer: Translation = {
  amharic: 'አዎ፣ ከታቀደው አገልግሎት 24 ሰዓታት በፊት ምዝገባ ማስረግ ይችላሉ። በ24 ሰዓታት ውስጥ የተደረጉ ማስረጎች የማስረግ ክፍያዎች ሊደርሱባቸው ይችላል።',
  arabic: 'نعم، يمكنك إلغاء الحجز حتى 24 ساعة قبل الخدمة المجدولة. قد تخضع عمليات الإلغاء التي تتم خلال 24 ساعة لرسوم الإلغاء.',
  bengali: 'হ্যাঁ, আপনি নির্ধারিত সেবার 24 ঘন্টা আগে পর্যন্ত একটি বুকিং বাতিল করতে পারেন। 24 ঘন্টার মধ্যে করা বাতিলকরণ বাতিলকরণ ফি সাপেক্ষ হতে পারে।',
  chinese: '是的，您可以在预定服务前24小时取消预订。在24小时内取消可能会产生取消费用。',
  english: 'Yes, you can cancel a booking up to 24 hours before the scheduled service. Cancellations made within 24 hours may be subject to cancellation fees.',
  estonian: 'Jah, saate broneeringu tühistada kuni 24 tundi enne planeeritud teenust. 24 tunni jooksul tehtud tühistamised võivad olla tühistamistasuga.',
  filipino: 'Oo, maaari mong kanselahin ang isang booking hanggang 24 na oras bago ang scheduled service. Ang mga cancellation na ginawa sa loob ng 24 na oras ay maaaring maging subject sa cancellation fees.',
  french: "Oui, vous pouvez annuler une réservation jusqu'à 24 heures avant le service prévu. Les annulations effectuées dans les 24 heures peuvent être soumises à des frais d'annulation.",
  german: 'Ja, Sie können eine Buchung bis zu 24 Stunden vor dem geplanten Service stornieren. Stornierungen innerhalb von 24 Stunden können mit Stornierungsgebühren verbunden sein.',
  hindi: 'हां, आप निर्धारित सेवा से 24 घंटे पहले तक बुकिंग रद्द कर सकते हैं। 24 घंटे के भीतर की गई रद्दीकरण पर रद्दीकरण शुल्क लागू हो सकता है।',
  indonesian: 'Ya, Anda dapat membatalkan pemesanan hingga 24 jam sebelum layanan yang dijadwalkan. Pembatalan yang dilakukan dalam 24 jam dapat dikenakan biaya pembatalan.',
  japanese: 'はい、予定されたサービスの24時間前まで予約をキャンセルできます。24時間以内のキャンセルにはキャンセル料がかかる場合があります。',
  korean: '예, 예정된 서비스 24시간 전까지 예약을 취소할 수 있습니다. 24시간 이내에 취소하면 취소 수수료가 부과될 수 있습니다.',
  portuguese: 'Sim, você pode cancelar uma reserva até 24 horas antes do serviço agendado. Cancelamentos feitos dentro de 24 horas podem estar sujeitos a taxas de cancelamento.',
  russian: 'Да, вы можете отменить бронирование до 24 часов до запланированной услуги. Отмены, сделанные в течение 24 часов, могут облагаться комиссией за отмену.',
  spanish: 'Sí, puedes cancelar una reserva hasta 24 horas antes del servicio programado. Las cancelaciones realizadas dentro de las 24 horas pueden estar sujetas a tarifas de cancelación.',
  swahili: 'Ndio, unaweza kughairi uwekaji hadi masaa 24 kabla ya huduma iliyopangwa. Ughairi unaofanywa ndani ya masaa 24 unaweza kuwa chini ya ada za ughairi.',
  vietnamese: 'Có, bạn có thể hủy đặt chỗ tối đa 24 giờ trước dịch vụ đã lên lịch. Các hủy đặt chỗ được thực hiện trong vòng 24 giờ có thể phải chịu phí hủy.',
};

export const faqServiceNoShowQuestion: Translation = {
  amharic: 'አገልግሎት አቅራቢ ካልተገኘስ?',
  arabic: 'ماذا لو لم يحضر مقدم الخدمة؟',
  bengali: 'যদি সেবা প্রদানকারী না আসে তাহলে কী হবে?',
  chinese: '如果服务提供商没有出现怎么办？',
  english: "What if a service provider doesn't show up?",
  estonian: 'Mida teha, kui teenusepakkuja ei ilmu?',
  filipino: 'Paano kung hindi dumating ang service provider?',
  french: 'Que faire si un prestataire de services ne se présente pas?',
  german: 'Was passiert, wenn ein Dienstleister nicht erscheint?',
  hindi: 'अगर सेवा प्रदाता नहीं आता है तो क्या होगा?',
  indonesian: 'Bagaimana jika penyedia layanan tidak muncul?',
  japanese: 'サービスプロバイダーが現れない場合はどうなりますか？',
  korean: '서비스 제공업체가 나타나지 않으면 어떻게 되나요?',
  portuguese: 'E se um provedor de serviços não aparecer?',
  russian: 'Что делать, если поставщик услуг не приходит?',
  spanish: '¿Qué pasa si un proveedor de servicios no se presenta?',
  swahili: 'Je, ikiwa mtoa huduma hatakuja?',
  vietnamese: 'Điều gì sẽ xảy ra nếu nhà cung cấp dịch vụ không xuất hiện?',
};

export const faqServiceNoShowAnswer: Translation = {
  amharic: 'አገልግሎት አቅራቢ ካልተገኘ፣ ወዲያውኑ ከድጋፍ ቡድናችን ጋር ያገናኙ። እንደገና ለመወሰን እንረዳዎታለን ወይም ሙሉ መመለስ እንሰጣለን።',
  arabic: 'إذا لم يحضر مقدم الخدمة، اتصل بفريق الدعم لدينا على الفور. سنساعدك في إعادة الجدولة أو نقدم استردادًا كاملاً.',
  bengali: 'যদি সেবা প্রদানকারী না আসে, অবিলম্বে আমাদের সহায়তা দলের সাথে যোগাযোগ করুন। আমরা আপনাকে পুনঃনির্ধারণ করতে সাহায্য করব বা সম্পূর্ণ রিফান্ড প্রদান করব।',
  chinese: '如果服务提供商没有出现，请立即联系我们的支持团队。我们将帮助您重新安排时间或提供全额退款。',
  english: "If a service provider doesn't show up, contact our support team immediately. We'll help you reschedule or provide a full refund.",
  estonian: 'Kui teenusepakkuja ei ilmu, võtke kohe ühendust meie tugimeeskonnaga. Aitame teil ümber planeerida või saate täieliku tagastuse.',
  filipino: 'Kung hindi darating ang service provider, makipag-ugnayan kaagad sa aming support team. Tutulungan namin kayong mag-reschedule o magbibigay ng full refund.',
  french: 'Si un prestataire de services ne se présente pas, contactez immédiatement notre équipe de support. Nous vous aiderons à reprogrammer ou à fournir un remboursement complet.',
  german: 'Wenn ein Dienstleister nicht erscheint, kontaktieren Sie sofort unser Support-Team. Wir helfen Ihnen bei der Neuplanung oder bieten eine vollständige Rückerstattung.',
  hindi: 'यदि सेवा प्रदाता नहीं आता है, तो तुरंत हमारी सहायता टीम से संपर्क करें। हम आपको पुनर्निर्धारित करने में मदद करेंगे या पूर्ण धनवापसी प्रदान करेंगे।',
  indonesian: 'Jika penyedia layanan tidak muncul, hubungi tim dukungan kami segera. Kami akan membantu Anda menjadwalkan ulang atau memberikan pengembalian dana penuh.',
  japanese: 'サービスプロバイダーが現れない場合は、すぐにサポートチームに連絡してください。再スケジュールをお手伝いするか、全額返金を提供します。',
  korean: '서비스 제공업체가 나타나지 않으면 즉시 지원팀에 연락하세요. 재예약을 도와드리거나 전액 환불을 제공해드립니다.',
  portuguese: 'Se um provedor de serviços não aparecer, entre em contato com nossa equipe de suporte imediatamente. Ajudaremos você a reagendar ou forneceremos um reembolso completo.',
  russian: 'Если поставщик услуг не приходит, немедленно свяжитесь с нашей службой поддержки. Мы поможем вам перенести или предоставим полный возврат средств.',
  spanish: 'Si un proveedor de servicios no se presenta, contacta a nuestro equipo de soporte de inmediato. Te ayudaremos a reprogramar o proporcionaremos un reembolso completo.',
  swahili: 'Ikiwa mtoa huduma hatakuja, wasiliana na timu yetu ya msaada mara moja. Tutakusaidia kuweka upya ratiba au tutatoa rudi kamili.',
  vietnamese: 'Nếu nhà cung cấp dịch vụ không xuất hiện, hãy liên hệ với đội ngũ hỗ trợ của chúng tôi ngay lập tức. Chúng tôi sẽ giúp bạn đặt lại lịch hoặc cung cấp hoàn tiền đầy đủ.',
};

export const faqPaymentMethodsQuestion: Translation = {
  amharic: 'ምን ዓይነት የክፍያ ዘዴዎችን ትቀበላላችሁ?',
  arabic: 'ما هي طرق الدفع التي تقبلونها؟',
  bengali: 'আপনারা কোন পেমেন্ট পদ্ধতি গ্রহণ করেন?',
  chinese: '您接受哪些支付方式？',
  english: 'What payment methods do you accept?',
  estonian: 'Milliseid makseviise te aktsepteerite?',
  filipino: 'Anong mga payment methods ang inyong tinatanggap?',
  french: 'Quelles méthodes de paiement acceptez-vous?',
  german: 'Welche Zahlungsmethoden akzeptieren Sie?',
  hindi: 'आप कौन से भुगतान तरीके स्वीकार करते हैं?',
  indonesian: 'Metode pembayaran apa yang Anda terima?',
  japanese: 'どのような支払い方法を受け付けていますか？',
  korean: '어떤 결제 방법을 받으시나요?',
  portuguese: 'Quais métodos de pagamento vocês aceitam?',
  russian: 'Какие способы оплаты вы принимаете?',
  spanish: '¿Qué métodos de pago aceptan?',
  swahili: 'Ni njia zipi za malipo mnazokubali?',
  vietnamese: 'Bạn chấp nhận những phương thức thanh toán nào?',
};

export const faqPaymentMethodsAnswer: Translation = {
  amharic: 'PayPal፣ Apple Pay እና Google Payን ጨምሮ ሁሉንም ዋና የክሬዲት ካርዶች፣ ዲቢት ካርዶች እና ዲጂታል የገንዘብ ቦርሳዎችን እንቀበላለን።',
  arabic: 'نقبل جميع بطاقات الائتمان والخصم الرئيسية والمحافظ الرقمية بما في ذلك PayPal وApple Pay وGoogle Pay.',
  bengali: 'আমরা PayPal, Apple Pay এবং Google Pay সহ সমস্ত প্রধান ক্রেডিট কার্ড, ডেবিট কার্ড এবং ডিজিটাল ওয়ালেট গ্রহণ করি।',
  chinese: '我们接受所有主要的信用卡、借记卡和数字钱包，包括PayPal、Apple Pay和Google Pay。',
  english: 'We accept all major credit cards, debit cards, and digital wallets including PayPal, Apple Pay, and Google Pay.',
  estonian: 'Aktsepteerime kõiki suuremaid krediitkaarte, deebetkaarte ja digitaalseid rahakotte, sealhulgas PayPal, Apple Pay ja Google Pay.',
  filipino: 'Tinatanggap namin ang lahat ng major credit cards, debit cards, at digital wallets kabilang ang PayPal, Apple Pay, at Google Pay.',
  french: 'Nous acceptons toutes les principales cartes de crédit, cartes de débit et portefeuilles numériques, y compris PayPal, Apple Pay et Google Pay.',
  german: 'Wir akzeptieren alle gängigen Kreditkarten, Debitkarten und digitalen Geldbörsen, einschließlich PayPal, Apple Pay und Google Pay.',
  hindi: 'हम सभी प्रमुख क्रेडिट कार्ड, डेबिट कार्ड और डिजिटल वॉलेट स्वीकार करते हैं जिसमें PayPal, Apple Pay और Google Pay शामिल हैं।',
  indonesian: 'Kami menerima semua kartu kredit utama, kartu debit, dan dompet digital termasuk PayPal, Apple Pay, dan Google Pay.',
  japanese: 'PayPal、Apple Pay、Google Payを含むすべての主要なクレジットカード、デビットカード、デジタルウォレットを受け付けています。',
  korean: 'PayPal, Apple Pay, Google Pay를 포함한 모든 주요 신용 카드, 직불 카드 및 디지털 지갑을 받습니다.',
  portuguese: 'Aceitamos todos os principais cartões de crédito, cartões de débito e carteiras digitais, incluindo PayPal, Apple Pay e Google Pay.',
  russian: 'Мы принимаем все основные кредитные карты, дебетовые карты и цифровые кошельки, включая PayPal, Apple Pay и Google Pay.',
  spanish: 'Aceptamos todas las principales tarjetas de crédito, tarjetas de débito y billeteras digitales, incluidas PayPal, Apple Pay y Google Pay.',
  swahili: 'Tunakubali kadi zote kuu za mkopo, kadi za debit, na pochi za dijitali ikiwemo PayPal, Apple Pay, na Google Pay.',
  vietnamese: 'Chúng tôi chấp nhận tất cả các thẻ tín dụng, thẻ ghi nợ và ví kỹ thuật số chính bao gồm PayPal, Apple Pay và Google Pay.',
};

export const faqPaymentRefundQuestion: Translation = {
  amharic: 'መመለሻዎች እንዴት ይሠራሉ?',
  arabic: 'كيف تعمل المبالغ المستردة؟',
  bengali: 'রিফান্ড কীভাবে কাজ করে?',
  chinese: '退款如何运作？',
  english: 'How do refunds work?',
  estonian: 'Kuidas tagastused toimivad?',
  filipino: 'Paano gumagana ang mga refund?',
  french: 'Comment fonctionnent les remboursements?',
  german: 'Wie funktionieren Rückerstattungen?',
  hindi: 'धनवापसी कैसे काम करती है?',
  indonesian: 'Bagaimana cara kerja pengembalian dana?',
  japanese: '返金はどのように機能しますか？',
  korean: '환불은 어떻게 작동하나요?',
  portuguese: 'Como funcionam os reembolsos?',
  russian: 'Как работают возвраты?',
  spanish: '¿Cómo funcionan los reembolsos?',
  swahili: 'Rudi zinafanya kazi vipi?',
  vietnamese: 'Hoàn tiền hoạt động như thế nào?',
};

export const faqPaymentRefundAnswer: Translation = {
  amharic: 'መመለሻዎች በ5-7 የስራ ቀናት ውስጥ ይከናወናሉ እና ወደ የመጀመሪያው የክፍያ ዘዴዎ ይመለሳሉ። ትክክለኛው የጊዜ ሰሌዳ በባንክዎ ወይም በክፍያ አቅራቢዎ ላይ የተመሰረተ ነው።',
  arabic: 'يتم معالجة المبالغ المستردة خلال 5-7 أيام عمل وسيتم إرجاعها إلى طريقة الدفع الأصلية الخاصة بك. الجدول الزمني الدقيق يعتمد على بنكك أو مزود الدفع.',
  bengali: 'রিফান্ড 5-7 কার্যদিবসের মধ্যে প্রক্রিয়া করা হয় এবং আপনার মূল পেমেন্ট পদ্ধতিতে ফেরত দেওয়া হবে। সঠিক সময়সীমা আপনার ব্যাঙ্ক বা পেমেন্ট প্রদানকারীর উপর নির্ভর করে।',
  chinese: '退款在5-7个工作日内处理，并将退还到您的原始付款方式。确切的时间取决于您的银行或支付提供商。',
  english: 'Refunds are processed within 5-7 business days and will be credited back to your original payment method. The exact timeline depends on your bank or payment provider.',
  estonian: 'Tagastused töödeldakse 5-7 tööpäeva jooksul ja krediteeritakse tagasi teie algsele makseviisile. Täpne ajakava sõltub teie pangast või maksepakkujast.',
  filipino: 'Ang mga refund ay na-proseso sa loob ng 5-7 business days at makakredito pabalik sa inyong original payment method. Ang eksaktong timeline ay depende sa inyong bank o payment provider.',
  french: 'Les remboursements sont traités dans les 5 à 7 jours ouvrables et seront crédités sur votre méthode de paiement originale. Le délai exact dépend de votre banque ou prestataire de paiement.',
  german: 'Rückerstattungen werden innerhalb von 5-7 Werktagen bearbeitet und auf Ihre ursprüngliche Zahlungsmethode gutgeschrieben. Der genaue Zeitplan hängt von Ihrer Bank oder Ihrem Zahlungsanbieter ab.',
  hindi: 'धनवापसी 5-7 व्यावसायिक दिनों के भीतर संसाधित की जाती है और आपके मूल भुगतान विधि में वापस जमा कर दी जाएगी। सटीक समयसीमा आपके बैंक या भुगतान प्रदाता पर निर्भर करती है।',
  indonesian: 'Pengembalian dana diproses dalam 5-7 hari kerja dan akan dikreditkan kembali ke metode pembayaran asli Anda. Waktu yang tepat tergantung pada bank atau penyedia pembayaran Anda.',
  japanese: '返金は5-7営業日以内に処理され、元の支払い方法に戻されます。正確なタイムラインは、お客様の銀行または支払いプロバイダーによって異なります。',
  korean: '환불은 5-7 영업일 이내에 처리되며 원래 결제 수단으로 다시 적립됩니다. 정확한 시간은 귀하의 은행 또는 결제 제공업체에 따라 다릅니다.',
  portuguese: 'Os reembolsos são processados em 5-7 dias úteis e serão creditados de volta ao seu método de pagamento original. O prazo exato depende do seu banco ou provedor de pagamento.',
  russian: 'Возвраты обрабатываются в течение 5-7 рабочих дней и будут зачислены обратно на ваш первоначальный способ оплаты. Точный график зависит от вашего банка или платежного провайдера.',
  spanish: 'Los reembolsos se procesan en 5-7 días hábiles y se acreditarán a su método de pago original. El tiempo exacto depende de su banco o proveedor de pago.',
  swahili: 'Rudi zinachakatwa ndani ya siku 5-7 za kazi na zitakopeshwa tena kwenye njia yako ya awali ya malipo. Muda halisi unategemea benki yako au mtoa huduma wa malipo.',
  vietnamese: 'Hoàn tiền được xử lý trong vòng 5-7 ngày làm việc và sẽ được ghi có lại vào phương thức thanh toán ban đầu của bạn. Thời gian chính xác phụ thuộc vào ngân hàng hoặc nhà cung cấp thanh toán của bạn.',
};

export const faqPaymentHiddenFeesQuestion: Translation = {
  amharic: 'ምንም የተደበቁ ክፍያዎች አሉ?',
  arabic: 'هل هناك رسوم مخفية؟',
  bengali: 'কোনো লুকানো ফি আছে?',
  chinese: '有隐藏费用吗？',
  english: 'Are there any hidden fees?',
  estonian: 'Kas on peidetud tasusid?',
  filipino: 'May mga nakatagong bayad ba?',
  french: 'Y a-t-il des frais cachés?',
  german: 'Gibt es versteckte Gebühren?',
  hindi: 'क्या कोई छुपी हुई फीस है?',
  indonesian: 'Apakah ada biaya tersembunyi?',
  japanese: '隠れた手数料はありますか？',
  korean: '숨겨진 수수료가 있나요?',
  portuguese: 'Há taxas ocultas?',
  russian: 'Есть ли скрытые комиссии?',
  spanish: '¿Hay tarifas ocultas?',
  swahili: 'Je, kuna ada za siri?',
  vietnamese: 'Có phí ẩn nào không?',
};

export const faqPaymentHiddenFeesAnswer: Translation = {
  amharic: 'ምንም የተደበቁ ክፍያዎች የሉም። ሁሉም ክፍያዎች ምዝገባዎን ከመጠናቀቅዎ በፊት በግልጽ ይታያሉ። ይህ የአገልግሎት ክፍያችንን እና ማንኛውም ተፈጻሚ ግብሮችን ያካትታል።',
  arabic: 'لا توجد رسوم مخفية. يتم عرض جميع الرسوم بوضوح قبل إتمام حجزك. يتضمن ذلك رسوم الخدمة وأي ضرائب قابلة للتطبيق.',
  bengali: 'কোনো লুকানো ফি নেই। আপনার বুকিং সম্পূর্ণ করার আগে সমস্ত ফি স্পষ্টভাবে প্রদর্শিত হয়। এর মধ্যে আমাদের সেবা ফি এবং প্রযোজ্য যেকোনো কর অন্তর্ভুক্ত।',
  chinese: '没有隐藏费用。所有费用在您完成预订前都会清楚显示。这包括我们的服务费和任何适用的税费。',
  english: 'No hidden fees. All fees are clearly displayed before you complete your booking. This includes our service fee and any applicable taxes.',
  estonian: 'Peidetud tasusid pole. Kõik tasud on selgelt nähtavad enne broneeringu lõpetamist. See sisaldab meie teenustasu ja kõiki kohaldatavaid makse.',
  filipino: 'Walang nakatagong bayad. Lahat ng mga bayad ay malinaw na ipinapakita bago ninyo makumpleto ang inyong booking. Kasama dito ang aming service fee at anumang applicable na buwis.',
  french: 'Aucun frais caché. Tous les frais sont clairement affichés avant de finaliser votre réservation. Cela inclut nos frais de service et toutes les taxes applicables.',
  german: 'Keine versteckten Gebühren. Alle Gebühren werden klar angezeigt, bevor Sie Ihre Buchung abschließen. Dies umfasst unsere Servicegebühr und alle anfallenden Steuern.',
  hindi: 'कोई छुपी हुई फीस नहीं। आपकी बुकिंग पूरी करने से पहले सभी शुल्क स्पष्ट रूप से प्रदर्शित किए जाते हैं। इसमें हमारी सेवा शुल्क और कोई भी लागू कर शामिल हैं।',
  indonesian: 'Tidak ada biaya tersembunyi. Semua biaya ditampilkan dengan jelas sebelum Anda menyelesaikan pemesanan Anda. Ini termasuk biaya layanan kami dan pajak yang berlaku.',
  japanese: '隠れた手数料はありません。すべての手数料は、予約を完了する前に明確に表示されます。これには、サービス料金と適用されるすべての税金が含まれます。',
  korean: '숨겨진 수수료 없음. 모든 수수료는 예약을 완료하기 전에 명확하게 표시됩니다. 여기에는 서비스 수수료 및 적용 가능한 모든 세금이 포함됩니다.',
  portuguese: 'Sem taxas ocultas. Todas as taxas são claramente exibidas antes de você concluir sua reserva. Isso inclui nossa taxa de serviço e todos os impostos aplicáveis.',
  russian: 'Никаких скрытых комиссий. Все комиссии четко отображаются перед завершением бронирования. Это включает нашу комиссию за услуги и все применимые налоги.',
  spanish: 'Sin tarifas ocultas. Todas las tarifas se muestran claramente antes de completar tu reserva. Esto incluye nuestra tarifa de servicio y todos los impuestos aplicables.',
  swahili: 'Hakuna ada za siri. Ada zote zinaonyeshwa wazi kabla ya kukamilisha uwekaji wako. Hii inajumuisha ada yetu ya huduma na kodi zozote zinazotumika.',
  vietnamese: 'Không có phí ẩn. Tất cả các khoản phí được hiển thị rõ ràng trước khi bạn hoàn tất đặt chỗ. Điều này bao gồm phí dịch vụ của chúng tôi và bất kỳ thuế nào áp dụng.',
};

export const navHome: Translation = {
  amharic: 'Home',
  arabic: 'Home',
  bengali: 'Home',
  chinese: 'Home',
  english: 'Home',
  estonian: 'Home',
  filipino: 'Home',
  french: 'Home',
  german: 'Home',
  hindi: 'Home',
  indonesian: 'Home',
  japanese: 'Home',
  korean: 'Home',
  portuguese: 'Home',
  russian: 'Home',
  spanish: 'Home',
  swahili: 'Home',
  vietnamese: 'Home',
};

export const navSignIn: Translation = {
  amharic: 'Sign in',
  arabic: 'Sign in',
  bengali: 'Sign in',
  chinese: 'Sign in',
  english: 'Sign in',
  estonian: 'Sign in',
  filipino: 'Sign in',
  french: 'Sign in',
  german: 'Sign in',
  hindi: 'Sign in',
  indonesian: 'Sign in',
  japanese: 'Sign in',
  korean: 'Sign in',
  portuguese: 'Sign in',
  russian: 'Sign in',
  spanish: 'Sign in',
  swahili: 'Sign in',
  vietnamese: 'Sign in',
};

export const navBecomeProvider: Translation = {
  amharic: 'Become a provider',
  arabic: 'Become a provider',
  bengali: 'Become a provider',
  chinese: 'Become a provider',
  english: 'Become a provider',
  estonian: 'Become a provider',
  filipino: 'Become a provider',
  french: 'Become a provider',
  german: 'Become a provider',
  hindi: 'Become a provider',
  indonesian: 'Become a provider',
  japanese: 'Become a provider',
  korean: 'Become a provider',
  portuguese: 'Become a provider',
  russian: 'Become a provider',
  spanish: 'Become a provider',
  swahili: 'Become a provider',
  vietnamese: 'Become a provider',
};

export const landingFooterTagline: Translation = {
  amharic: 'The local-services marketplace built on enforced trust.',
  arabic: 'The local-services marketplace built on enforced trust.',
  bengali: 'The local-services marketplace built on enforced trust.',
  chinese: 'The local-services marketplace built on enforced trust.',
  english: 'The local-services marketplace built on enforced trust.',
  estonian: 'The local-services marketplace built on enforced trust.',
  filipino: 'The local-services marketplace built on enforced trust.',
  french: 'The local-services marketplace built on enforced trust.',
  german: 'The local-services marketplace built on enforced trust.',
  hindi: 'The local-services marketplace built on enforced trust.',
  indonesian: 'The local-services marketplace built on enforced trust.',
  japanese: 'The local-services marketplace built on enforced trust.',
  korean: 'The local-services marketplace built on enforced trust.',
  portuguese: 'The local-services marketplace built on enforced trust.',
  russian: 'The local-services marketplace built on enforced trust.',
  spanish: 'The local-services marketplace built on enforced trust.',
  swahili: 'The local-services marketplace built on enforced trust.',
  vietnamese: 'The local-services marketplace built on enforced trust.',
};

export const landingFooterColProduct: Translation = {
  amharic: 'Product',
  arabic: 'Product',
  bengali: 'Product',
  chinese: 'Product',
  english: 'Product',
  estonian: 'Product',
  filipino: 'Product',
  french: 'Product',
  german: 'Product',
  hindi: 'Product',
  indonesian: 'Product',
  japanese: 'Product',
  korean: 'Product',
  portuguese: 'Product',
  russian: 'Product',
  spanish: 'Product',
  swahili: 'Product',
  vietnamese: 'Product',
};

export const landingFooterColCompany: Translation = {
  amharic: 'Company',
  arabic: 'Company',
  bengali: 'Company',
  chinese: 'Company',
  english: 'Company',
  estonian: 'Company',
  filipino: 'Company',
  french: 'Company',
  german: 'Company',
  hindi: 'Company',
  indonesian: 'Company',
  japanese: 'Company',
  korean: 'Company',
  portuguese: 'Company',
  russian: 'Company',
  spanish: 'Company',
  swahili: 'Company',
  vietnamese: 'Company',
};

export const landingFooterColTrust: Translation = {
  amharic: 'Trust',
  arabic: 'Trust',
  bengali: 'Trust',
  chinese: 'Trust',
  english: 'Trust',
  estonian: 'Trust',
  filipino: 'Trust',
  french: 'Trust',
  german: 'Trust',
  hindi: 'Trust',
  indonesian: 'Trust',
  japanese: 'Trust',
  korean: 'Trust',
  portuguese: 'Trust',
  russian: 'Trust',
  spanish: 'Trust',
  swahili: 'Trust',
  vietnamese: 'Trust',
};

export const landingFooterColLegal: Translation = {
  amharic: 'Legal',
  arabic: 'Legal',
  bengali: 'Legal',
  chinese: 'Legal',
  english: 'Legal',
  estonian: 'Legal',
  filipino: 'Legal',
  french: 'Legal',
  german: 'Legal',
  hindi: 'Legal',
  indonesian: 'Legal',
  japanese: 'Legal',
  korean: 'Legal',
  portuguese: 'Legal',
  russian: 'Legal',
  spanish: 'Legal',
  swahili: 'Legal',
  vietnamese: 'Legal',
};

export const landingFooterCopyright: Translation = {
  amharic: '© Workadabra. All rights reserved.',
  arabic: '© Workadabra. All rights reserved.',
  bengali: '© Workadabra. All rights reserved.',
  chinese: '© Workadabra. All rights reserved.',
  english: '© Workadabra. All rights reserved.',
  estonian: '© Workadabra. All rights reserved.',
  filipino: '© Workadabra. All rights reserved.',
  french: '© Workadabra. All rights reserved.',
  german: '© Workadabra. All rights reserved.',
  hindi: '© Workadabra. All rights reserved.',
  indonesian: '© Workadabra. All rights reserved.',
  japanese: '© Workadabra. All rights reserved.',
  korean: '© Workadabra. All rights reserved.',
  portuguese: '© Workadabra. All rights reserved.',
  russian: '© Workadabra. All rights reserved.',
  spanish: '© Workadabra. All rights reserved.',
  swahili: '© Workadabra. All rights reserved.',
  vietnamese: '© Workadabra. All rights reserved.',
};

export const rdHeroPre: Translation = {
  amharic: 'የዕለት ተዕለት አገልግሎቶች፣',
  arabic: 'الخدمات اليومية،',
  bengali: 'প্রতিদিনের পরিষেবা,',
  chinese: '日常服务，',
  english: 'Everyday services,',
  estonian: 'Igapäevased teenused,',
  filipino: 'Pang-araw-araw na serbisyo,',
  french: 'Les services du quotidien,',
  german: 'Alltägliche Dienste,',
  hindi: 'रोज़मर्रा की सेवाएँ,',
  indonesian: 'Layanan sehari-hari,',
  japanese: '毎日のサービスを、',
  korean: '일상 서비스,',
  portuguese: 'Serviços do dia a dia,',
  russian: 'Повседневные услуги,',
  spanish: 'Servicios cotidianos,',
  swahili: 'Huduma za kila siku,',
  vietnamese: 'Dịch vụ hằng ngày,',
};
export const rdHeroServed: Translation = {
  amharic: 'በትክክል ይከናወናሉ',
  arabic: 'تُنجَز بإتقان',
  bengali: 'সঠিকভাবে সম্পন্ন',
  chinese: '做到位',
  english: 'done right',
  estonian: 'tehtud korralikult',
  filipino: 'gawa nang tama',
  french: 'bien faits',
  german: 'richtig gemacht',
  hindi: 'सही ढंग से पूरी',
  indonesian: 'dikerjakan dengan benar',
  japanese: 'きちんと',
  korean: '제대로',
  portuguese: 'bem feitos',
  russian: 'сделанные правильно',
  spanish: 'bien hechos',
  swahili: 'zinazofanyika vizuri',
  vietnamese: 'làm đúng cách',
};
export const rdHeroEarn: Translation = {
  amharic: 'ክፍያ ያግኙ',
  arabic: 'واكسب',
  bengali: 'আয় করুন',
  chinese: '获得报酬',
  english: 'get paid',
  estonian: 'teeni raha',
  filipino: 'kumita',
  french: 'soyez payé',
  german: 'werde bezahlt',
  hindi: 'कमाई करें',
  indonesian: 'dibayar',
  japanese: '報酬を得る',
  korean: '수익을 얻으세요',
  portuguese: 'seja pago',
  russian: 'получайте оплату',
  spanish: 'cobra',
  swahili: 'lipwa',
  vietnamese: 'được trả công',
};
export const rdHeroPost: Translation = {
  amharic: 'ለማከናወን።',
  arabic: 'مقابل أدائها.',
  bengali: 'সেগুলো করার জন্য।',
  chinese: '来完成它们。',
  english: 'to do them.',
  estonian: 'nende tegemise eest.',
  filipino: 'sa paggawa ng mga ito.',
  french: 'pour les réaliser.',
  german: 'dafür, sie zu erledigen.',
  hindi: 'उन्हें करने के लिए।',
  indonesian: 'untuk mengerjakannya.',
  japanese: 'こなして。',
  korean: '그 일들을 해내고.',
  portuguese: 'por realizá-los.',
  russian: 'за их выполнение.',
  spanish: 'por hacerlos.',
  swahili: 'kwa kuzifanya.',
  vietnamese: 'khi thực hiện chúng.',
};
export const rdHeroSub: Translation = {
  amharic: 'ለጽዳት፣ ለሕፃናት እንክብካቤ፣ ለማብሰል፣ ለጥገናና ለሌሎችም የተረጋገጠ የአካባቢ ባለሙያ ያግኙ፣ ወይም የራስዎን ችሎታ ወደ የዕለቱ ገቢ ይቀይሩ። አንድ መተግበሪያ፣ ሁለት የማሸነፊያ መንገዶች።',
  arabic: 'اعثر على محترف محلي موثوق للتنظيف ورعاية الأطفال والطهي والإصلاحات والمزيد، أو حوّل مهاراتك إلى دخل في اليوم نفسه. تطبيق واحد، طريقتان للفوز.',
  bengali: 'পরিচ্ছন্নতা, শিশু পরিচর্যা, রান্না, মেরামত ও আরও অনেক কিছুর জন্য একজন যাচাইকৃত স্থানীয় পেশাদার খুঁজুন, অথবা নিজের দক্ষতাকে একই দিনের আয়ে পরিণত করুন। একটি অ্যাপ, জেতার দুটি উপায়।',
  chinese: '清洁、托育、烹饪、维修等服务，都能找到经过验证的本地专业人员，或把你的技能变成当天收入。一个应用，两种制胜方式。',
  english: 'Find a verified local pro for cleaning, childcare, cooking, repairs and more, or turn your own skills into same-day income. One app, two ways to win.',
  estonian: 'Leia kontrollitud kohalik spetsialist koristamiseks, lapsehoiuks, toiduvalmistamiseks, remondiks ja muuks, või muuda oma oskused samal päeval tuluks. Üks rakendus, kaks võiduteed.',
  filipino: 'Humanap ng beripikadong lokal na propesyonal para sa paglilinis, pag-aalaga ng bata, pagluluto, pagkukumpuni at higit pa, o gawing kita sa parehong araw ang iyong mga kasanayan. Isang app, dalawang paraan para manalo.',
  french: 'Trouvez un pro local vérifié pour le ménage, la garde d’enfants, la cuisine, les réparations et plus, ou transformez vos compétences en revenus le jour même. Une appli, deux façons de gagner.',
  german: 'Finde einen geprüften lokalen Profi für Reinigung, Kinderbetreuung, Kochen, Reparaturen und mehr, oder mache deine Fähigkeiten zu Einkommen am selben Tag. Eine App, zwei Wege zum Erfolg.',
  hindi: 'सफ़ाई, बच्चों की देखभाल, खाना पकाने, मरम्मत और बहुत कुछ के लिए एक सत्यापित स्थानीय पेशेवर खोजें, या अपने कौशल को उसी दिन की कमाई में बदलें। एक ऐप, जीतने के दो रास्ते।',
  indonesian: 'Temukan profesional lokal terverifikasi untuk bersih-bersih, pengasuhan anak, memasak, perbaikan, dan lainnya, atau ubah keahlian Anda menjadi penghasilan di hari yang sama. Satu aplikasi, dua cara untuk menang.',
  japanese: '掃除、育児、料理、修理などに対応した認証済みの地元プロを見つけよう。または自分のスキルを当日収入に。1つのアプリで、勝ち方は2通り。',
  korean: '청소, 육아, 요리, 수리 등 다양한 분야의 인증된 지역 전문가를 찾으세요. 또는 당신의 기술을 당일 수입으로 바꾸세요. 하나의 앱, 두 가지 성공 방법.',
  portuguese: 'Encontre um profissional local verificado para limpeza, cuidado infantil, culinária, reparos e mais, ou transforme suas habilidades em renda no mesmo dia. Um app, duas formas de ganhar.',
  russian: 'Найдите проверенного местного специалиста для уборки, ухода за детьми, готовки, ремонта и не только, или превратите свои навыки в доход в тот же день. Одно приложение, два способа выиграть.',
  spanish: 'Encuentra un profesional local verificado para limpieza, cuidado de niños, cocina, reparaciones y más, o convierte tus habilidades en ingresos el mismo día. Una app, dos formas de ganar.',
  swahili: 'Pata mtaalamu wa eneo lako aliyethibitishwa kwa usafi, malezi ya watoto, kupika, ukarabati na zaidi, au geuza ujuzi wako kuwa mapato ya siku hiyo hiyo. Programu moja, njia mbili za kushinda.',
  vietnamese: 'Tìm một chuyên gia địa phương đã được xác minh cho việc dọn dẹp, trông trẻ, nấu ăn, sửa chữa và hơn thế, hoặc biến kỹ năng của bạn thành thu nhập ngay trong ngày. Một ứng dụng, hai cách để thắng.',
};
export const rdFindService: Translation = {
  amharic: 'አገልግሎት ያግኙ',
  arabic: 'ابحث عن خدمة',
  bengali: 'পরিষেবা খুঁজুন',
  chinese: '寻找服务',
  english: 'Find a service',
  estonian: 'Leia teenus',
  filipino: 'Maghanap ng serbisyo',
  french: 'Trouver un service',
  german: 'Service finden',
  hindi: 'सेवा खोजें',
  indonesian: 'Cari layanan',
  japanese: 'サービスを探す',
  korean: '서비스 찾기',
  portuguese: 'Encontrar um serviço',
  russian: 'Найти услугу',
  spanish: 'Buscar un servicio',
  swahili: 'Tafuta huduma',
  vietnamese: 'Tìm dịch vụ',
};
export const rdBecomeProvider: Translation = {
  amharic: 'አቅራቢ ይሁኑ',
  arabic: 'كن مزوّدًا',
  bengali: 'প্রদানকারী হোন',
  chinese: '成为服务者',
  english: 'Become a provider',
  estonian: 'Hakka teenusepakkujaks',
  filipino: 'Maging provider',
  french: 'Devenir prestataire',
  german: 'Anbieter werden',
  hindi: 'प्रदाता बनें',
  indonesian: 'Jadi penyedia',
  japanese: 'プロバイダーになる',
  korean: '제공자 되기',
  portuguese: 'Tornar-se prestador',
  russian: 'Стать исполнителем',
  spanish: 'Hazte proveedor',
  swahili: 'Kuwa mtoa huduma',
  vietnamese: 'Trở thành nhà cung cấp',
};

export const rdHowHeading: Translation = {
  amharic: 'ሁለት ጉዞዎች፣ አንድ መድረክ',
  arabic: 'رحلتان، منصّة واحدة',
  bengali: 'দুটি যাত্রা, একটি প্ল্যাটফর্ম',
  chinese: '两段旅程，一个平台',
  english: 'Two journeys, one platform',
  estonian: 'Kaks teekonda, üks platvorm',
  filipino: 'Dalawang paglalakbay, isang plataporma',
  french: 'Deux parcours, une plateforme',
  german: 'Zwei Wege, eine Plattform',
  hindi: 'दो सफ़र, एक मंच',
  indonesian: 'Dua perjalanan, satu platform',
  japanese: '2つの道のり、1つのプラットフォーム',
  korean: '두 여정, 하나의 플랫폼',
  portuguese: 'Duas jornadas, uma plataforma',
  russian: 'Два пути, одна платформа',
  spanish: 'Dos caminos, una plataforma',
  swahili: 'Safari mbili, jukwaa moja',
  vietnamese: 'Hai hành trình, một nền tảng',
};
export const rdHowSub: Translation = {
  amharic: 'እጅ ቢያስፈልግዎ ወይም ችሎታው ያለዎት እርስዎ ቢሆኑ፣ መጀመር ደቂቃዎችን ብቻ ይወስዳል።',
  arabic: 'سواء كنت بحاجة إلى مساعدة أو كنت أنت صاحب المهارة، تبدأ في دقائق.',
  bengali: 'আপনার সাহায্য দরকার হোক বা দক্ষতা আপনারই থাকুক, শুরু করতে কয়েক মিনিট লাগে।',
  chinese: '无论你需要帮手，还是你正是有技能的人，几分钟即可上手。',
  english: 'Whether you need a hand or you’re the one with the skills, getting started takes minutes.',
  estonian: 'Olgu sul abi vaja või oled sa ise oskustega, alustamine võtab vaid minuteid.',
  filipino: 'Kailangan mo man ng tulong o ikaw ang may kasanayan, ilang minuto lang ang pagsisimula.',
  french: 'Que vous ayez besoin d’un coup de main ou que vous ayez les compétences, démarrer prend quelques minutes.',
  german: 'Ob du Hilfe brauchst oder selbst die Fähigkeiten hast, der Einstieg dauert nur Minuten.',
  hindi: 'चाहे आपको मदद चाहिए हो या कौशल आपके पास हो, शुरुआत में बस कुछ मिनट लगते हैं।',
  indonesian: 'Entah Anda butuh bantuan atau Andalah yang punya keahlian, memulai hanya butuh beberapa menit.',
  japanese: '手助けが必要でも、スキルを持つ側でも、始めるのは数分です。',
  korean: '도움이 필요하든, 기술을 가진 쪽이든, 시작하는 데 몇 분이면 됩니다.',
  portuguese: 'Seja você quem precisa de ajuda ou quem tem as habilidades, começar leva minutos.',
  russian: 'Нужна ли вам помощь или навыки есть у вас, начать можно за пару минут.',
  spanish: 'Tanto si necesitas una mano como si eres quien tiene las habilidades, empezar lleva minutos.',
  swahili: 'Iwe unahitaji msaada au ndiye mwenye ujuzi, kuanza huchukua dakika chache.',
  vietnamese: 'Dù bạn cần giúp đỡ hay chính bạn là người có kỹ năng, bắt đầu chỉ mất vài phút.',
};
export const rdSeekersTitle: Translation = {
  amharic: 'አገልግሎት ይቀበሉ',
  arabic: 'احصل على الخدمة',
  bengali: 'পরিষেবা নিন',
  chinese: '获得服务',
  english: 'Get served',
  estonian: 'Saa teenust',
  filipino: 'Mapaglingkuran',
  french: 'Être servi',
  german: 'Lass dich bedienen',
  hindi: 'सेवा पाएँ',
  indonesian: 'Dapatkan layanan',
  japanese: 'サービスを受ける',
  korean: '서비스 받기',
  portuguese: 'Seja atendido',
  russian: 'Получите услугу',
  spanish: 'Recibe el servicio',
  swahili: 'Pata huduma',
  vietnamese: 'Được phục vụ',
};
export const rdSeekersTag: Translation = {
  amharic: 'ለፈላጊዎች',
  arabic: 'للباحثين',
  bengali: 'সন্ধানকারীদের জন্য',
  chinese: '面向需求方',
  english: 'For seekers',
  estonian: 'Otsijatele',
  filipino: 'Para sa mga naghahanap',
  french: 'Pour les demandeurs',
  german: 'Für Suchende',
  hindi: 'खोजने वालों के लिए',
  indonesian: 'Untuk pencari',
  japanese: '依頼者向け',
  korean: '이용자용',
  portuguese: 'Para quem busca',
  russian: 'Для заказчиков',
  spanish: 'Para quien busca',
  swahili: 'Kwa watafutaji',
  vietnamese: 'Dành cho người tìm dịch vụ',
};
export const rdSeekStep1Title: Translation = {
  amharic: 'አገልግሎት ይጠይቁ',
  arabic: 'اطلب خدمة',
  bengali: 'একটি পরিষেবা অনুরোধ করুন',
  chinese: '申请服务',
  english: 'Request a service',
  estonian: 'Telli teenus',
  filipino: 'Humiling ng serbisyo',
  french: 'Demander un service',
  german: 'Service anfragen',
  hindi: 'सेवा का अनुरोध करें',
  indonesian: 'Minta layanan',
  japanese: 'サービスを依頼',
  korean: '서비스 요청',
  portuguese: 'Solicitar um serviço',
  russian: 'Запросите услугу',
  spanish: 'Solicita un servicio',
  swahili: 'Omba huduma',
  vietnamese: 'Yêu cầu dịch vụ',
};
export const rdSeekStep1Body: Translation = {
  amharic: 'አገልግሎት ይምረጡ እና የሚፈልጉትን ይግለጹ፣ በጥቂት ጠቅታዎች።',
  arabic: 'اختر خدمة وصِف ما تحتاجه، بنقرات قليلة.',
  bengali: 'একটি পরিষেবা বেছে নিন এবং আপনার যা প্রয়োজন তা বর্ণনা করুন, কয়েকটি ক্লিকে।',
  chinese: '选择服务并描述你的需求，只需点击几下。',
  english: 'Pick a service and describe what you need, in a few clicks.',
  estonian: 'Vali teenus ja kirjelda, mida vajad, vaid mõne klikiga.',
  filipino: 'Pumili ng serbisyo at ilarawan ang kailangan mo, sa ilang pag-click.',
  french: 'Choisissez un service et décrivez votre besoin, en quelques clics.',
  german: 'Wähle einen Service und beschreibe, was du brauchst, mit wenigen Klicks.',
  hindi: 'एक सेवा चुनें और बताएँ कि आपको क्या चाहिए, कुछ ही क्लिक में।',
  indonesian: 'Pilih layanan dan jelaskan kebutuhan Anda, dalam beberapa klik.',
  japanese: 'サービスを選び、必要なことを伝えるだけ。数クリックで。',
  korean: '서비스를 고르고 필요한 내용을 설명하세요. 몇 번의 클릭으로.',
  portuguese: 'Escolha um serviço e descreva o que precisa, em poucos cliques.',
  russian: 'Выберите услугу и опишите, что нужно, за пару кликов.',
  spanish: 'Elige un servicio y describe lo que necesitas, en unos clics.',
  swahili: 'Chagua huduma na ueleze unachohitaji, kwa mibofyo michache.',
  vietnamese: 'Chọn một dịch vụ và mô tả nhu cầu của bạn, chỉ trong vài cú nhấp.',
};
export const rdSeekStep2Title: Translation = {
  amharic: 'ባለሙያዎን ይምረጡ',
  arabic: 'اختر محترفك',
  bengali: 'আপনার পেশাদার বেছে নিন',
  chinese: '选择你的专业人员',
  english: 'Choose your pro',
  estonian: 'Vali oma spetsialist',
  filipino: 'Piliin ang iyong propesyonal',
  french: 'Choisir votre pro',
  german: 'Wähle deinen Profi',
  hindi: 'अपना पेशेवर चुनें',
  indonesian: 'Pilih profesional Anda',
  japanese: 'プロを選ぶ',
  korean: '전문가 선택',
  portuguese: 'Escolha seu profissional',
  russian: 'Выберите специалиста',
  spanish: 'Elige tu profesional',
  swahili: 'Chagua mtaalamu wako',
  vietnamese: 'Chọn chuyên gia của bạn',
};
export const rdSeekStep2Body: Translation = {
  amharic: 'በአቅራቢያ ያሉ የተረጋገጡ አቅራቢዎችን በደረጃ፣ በዋጋና በርቀት ያወዳድሩ።',
  arabic: 'قارن المزوّدين الموثوقين القريبين حسب التقييم والسعر والمسافة.',
  bengali: 'রেটিং, মূল্য ও দূরত্ব অনুযায়ী কাছের যাচাইকৃত প্রদানকারীদের তুলনা করুন।',
  chinese: '按评分、价格和距离比较附近经过验证的服务者。',
  english: 'Compare verified providers nearby by rating, price and distance.',
  estonian: 'Võrdle lähedalasuvaid kontrollitud pakkujaid hinnangu, hinna ja kauguse järgi.',
  filipino: 'Ikumpara ang mga beripikadong provider malapit sa iyo ayon sa rating, presyo at distansya.',
  french: 'Comparez les prestataires vérifiés proches selon la note, le prix et la distance.',
  german: 'Vergleiche geprüfte Anbieter in der Nähe nach Bewertung, Preis und Entfernung.',
  hindi: 'रेटिंग, कीमत और दूरी के अनुसार पास के सत्यापित प्रदाताओं की तुलना करें।',
  indonesian: 'Bandingkan penyedia terverifikasi di sekitar berdasarkan rating, harga, dan jarak.',
  japanese: '近くの認証済みプロバイダーを評価・価格・距離で比較。',
  korean: '평점, 가격, 거리로 주변의 인증된 제공자를 비교하세요.',
  portuguese: 'Compare prestadores verificados próximos por avaliação, preço e distância.',
  russian: 'Сравните проверенных исполнителей рядом по рейтингу, цене и расстоянию.',
  spanish: 'Compara proveedores verificados cercanos por valoración, precio y distancia.',
  swahili: 'Linganisha watoa huduma waliothibitishwa walio karibu kwa ukadiriaji, bei na umbali.',
  vietnamese: 'So sánh các nhà cung cấp đã xác minh ở gần theo đánh giá, giá và khoảng cách.',
};
export const rdSeekStep3Title: Translation = {
  amharic: 'በደህንነት ይክፈሉ',
  arabic: 'ادفع بأمان',
  bengali: 'নিরাপদে পরিশোধ করুন',
  chinese: '安全付款',
  english: 'Pay safely',
  estonian: 'Maksa turvaliselt',
  filipino: 'Magbayad nang ligtas',
  french: 'Payer en toute sécurité',
  german: 'Sicher bezahlen',
  hindi: 'सुरक्षित भुगतान करें',
  indonesian: 'Bayar dengan aman',
  japanese: '安全に支払う',
  korean: '안전하게 결제',
  portuguese: 'Pague com segurança',
  russian: 'Платите безопасно',
  spanish: 'Paga con seguridad',
  swahili: 'Lipa kwa usalama',
  vietnamese: 'Thanh toán an toàn',
};
export const rdSeekStep3Body: Translation = {
  amharic: 'ክፍያዎ በ escrow ይያዛል እና ሥራው ሲጠናቀቅ ብቻ ይለቀቃል።',
  arabic: 'يُحتفظ بدفعتك في حساب ضمان ولا تُحرَّر إلا عند إنجاز العمل.',
  bengali: 'আপনার পরিশোধ এসক্রোতে রাখা হয় এবং কাজ শেষ হলেই কেবল ছাড়া হয়।',
  chinese: '你的付款会托管在第三方，工作完成后才会放款。',
  english: 'Your payment is held in escrow and only released when the job’s done.',
  estonian: 'Sinu makse hoitakse tagatiskontol ja vabastatakse alles siis, kui töö on tehtud.',
  filipino: 'Ang iyong bayad ay nasa escrow at ilalabas lang kapag tapos na ang trabaho.',
  french: 'Votre paiement est conservé sous séquestre et n’est versé qu’une fois le travail terminé.',
  german: 'Deine Zahlung wird treuhänderisch verwahrt und erst freigegeben, wenn die Arbeit erledigt ist.',
  hindi: 'आपका भुगतान एस्क्रो में रखा जाता है और काम पूरा होने पर ही जारी होता है।',
  indonesian: 'Pembayaran Anda disimpan di escrow dan baru dilepaskan saat pekerjaan selesai.',
  japanese: '支払いはエスクローで保管され、仕事が完了したときだけ支払われます。',
  korean: '결제 금액은 에스크로에 보관되며 작업이 끝났을 때만 지급됩니다.',
  portuguese: 'Seu pagamento fica em garantia (escrow) e só é liberado quando o trabalho é concluído.',
  russian: 'Ваш платёж хранится на эскроу-счёте и переводится только после выполнения работы.',
  spanish: 'Tu pago se retiene en depósito de garantía y solo se libera cuando el trabajo está hecho.',
  swahili: 'Malipo yako huhifadhiwa kwenye escrow na hutolewa tu kazi ikiisha.',
  vietnamese: 'Khoản thanh toán của bạn được giữ trong ký quỹ và chỉ giải ngân khi công việc hoàn tất.',
};
export const rdProvidersTitle: Translation = {
  amharic: 'ክፍያ ያግኙ',
  arabic: 'احصل على أجرك',
  bengali: 'আয় করুন',
  chinese: '获得报酬',
  english: 'Get paid',
  estonian: 'Teeni raha',
  filipino: 'Kumita',
  french: 'Être payé',
  german: 'Werde bezahlt',
  hindi: 'कमाई करें',
  indonesian: 'Dapatkan bayaran',
  japanese: '報酬を得る',
  korean: '수익 받기',
  portuguese: 'Seja pago',
  russian: 'Получайте оплату',
  spanish: 'Cobra',
  swahili: 'Lipwa',
  vietnamese: 'Được trả công',
};
export const rdProvidersTag: Translation = {
  amharic: 'ለአቅራቢዎች',
  arabic: 'للمزوّدين',
  bengali: 'প্রদানকারীদের জন্য',
  chinese: '面向服务者',
  english: 'For providers',
  estonian: 'Teenusepakkujatele',
  filipino: 'Para sa mga provider',
  french: 'Pour les prestataires',
  german: 'Für Anbieter',
  hindi: 'प्रदाताओं के लिए',
  indonesian: 'Untuk penyedia',
  japanese: 'プロバイダー向け',
  korean: '제공자용',
  portuguese: 'Para prestadores',
  russian: 'Для исполнителей',
  spanish: 'Para proveedores',
  swahili: 'Kwa watoa huduma',
  vietnamese: 'Dành cho nhà cung cấp',
};
export const rdProvStep1Title: Translation = {
  amharic: 'ችሎታዎችዎን ይመዝግቡ',
  arabic: 'سجّل مهاراتك',
  bengali: 'আপনার দক্ষতা নিবন্ধন করুন',
  chinese: '登记你的技能',
  english: 'Register your skills',
  estonian: 'Registreeri oma oskused',
  filipino: 'Irehistro ang iyong mga kasanayan',
  french: 'Enregistrer vos compétences',
  german: 'Fähigkeiten registrieren',
  hindi: 'अपने कौशल पंजीकृत करें',
  indonesian: 'Daftarkan keahlian Anda',
  japanese: 'スキルを登録',
  korean: '기술 등록',
  portuguese: 'Registre suas habilidades',
  russian: 'Зарегистрируйте навыки',
  spanish: 'Registra tus habilidades',
  swahili: 'Sajili ujuzi wako',
  vietnamese: 'Đăng ký kỹ năng của bạn',
};
export const rdProvStep1Body: Translation = {
  amharic: 'ለማቅረብ ብቁ የሆኑ እስከ 3 አገልግሎቶችን ይዘርዝሩ እና ይረጋገጡ።',
  arabic: 'أدرج حتى 3 خدمات مؤهَّل لتقديمها واحصل على التوثيق.',
  bengali: 'আপনি প্রদানে যোগ্য এমন সর্বোচ্চ ৩টি পরিষেবা তালিকাভুক্ত করুন এবং যাচাই করান।',
  chinese: '列出最多 3 项你有资格提供的服务并完成验证。',
  english: 'List up to 3 services you’re qualified to provide and get verified.',
  estonian: 'Loetle kuni 3 teenust, mida oled pädev pakkuma, ja lase end kontrollida.',
  filipino: 'Ilista ang hanggang 3 serbisyong kwalipikado kang ibigay at magpa-verify.',
  french: 'Listez jusqu’à 3 services que vous êtes qualifié à fournir et faites-vous vérifier.',
  german: 'Liste bis zu 3 Services auf, für die du qualifiziert bist, und lass dich verifizieren.',
  hindi: 'आप जो अधिकतम 3 सेवाएँ देने के योग्य हैं, उन्हें सूचीबद्ध करें और सत्यापित हों।',
  indonesian: 'Daftarkan hingga 3 layanan yang Anda berkompeten dan dapatkan verifikasi.',
  japanese: '提供できる資格のあるサービスを最大3つ登録し、認証を受けましょう。',
  korean: '제공 자격이 있는 서비스를 최대 3개까지 등록하고 인증을 받으세요.',
  portuguese: 'Liste até 3 serviços que você é qualificado a oferecer e seja verificado.',
  russian: 'Укажите до 3 услуг, которые вы можете оказывать, и пройдите проверку.',
  spanish: 'Enumera hasta 3 servicios que estés cualificado para ofrecer y verifícate.',
  swahili: 'Orodhesha hadi huduma 3 unazoweza kutoa kisha uthibitishwe.',
  vietnamese: 'Liệt kê tối đa 3 dịch vụ bạn đủ điều kiện cung cấp và được xác minh.',
};
export const rdProvStep2Title: Translation = {
  amharic: 'በአቅራቢያ ሥራዎችን ይቀበሉ',
  arabic: 'اقبل أعمالًا قريبة',
  bengali: 'কাছের কাজ গ্রহণ করুন',
  chinese: '接受附近的工作',
  english: 'Accept gigs nearby',
  estonian: 'Võta vastu lähedasi töid',
  filipino: 'Tumanggap ng trabaho malapit',
  french: 'Accepter des missions proches',
  german: 'Aufträge in der Nähe annehmen',
  hindi: 'पास के काम स्वीकारें',
  indonesian: 'Terima pekerjaan di sekitar',
  japanese: '近くの仕事を受ける',
  korean: '주변 일감 수락',
  portuguese: 'Aceite trabalhos próximos',
  russian: 'Принимайте заказы рядом',
  spanish: 'Acepta trabajos cercanos',
  swahili: 'Kubali kazi za karibu',
  vietnamese: 'Nhận việc ở gần',
};
export const rdProvStep2Body: Translation = {
  amharic: 'በአካባቢዎ ካሉ ብቁ ጥያቄዎች ጋር ይዛመዱ።',
  arabic: 'تُطابَق مع الطلبات المؤهَّلة في منطقتك المحلية.',
  bengali: 'আপনার এলাকার উপযুক্ত অনুরোধগুলোর সঙ্গে মিলিয়ে দেওয়া হবে।',
  chinese: '与你所在区域内符合条件的请求进行匹配。',
  english: 'Get matched with eligible requests in your local area.',
  estonian: 'Sind kokku sobivate päringutega sinu piirkonnas.',
  filipino: 'Tumugma sa mga kwalipikadong kahilingan sa iyong lugar.',
  french: 'Soyez mis en relation avec les demandes éligibles dans votre zone.',
  german: 'Werde mit passenden Anfragen in deiner Umgebung verbunden.',
  hindi: 'अपने इलाके के योग्य अनुरोधों से जुड़ें।',
  indonesian: 'Dapatkan kecocokan dengan permintaan yang sesuai di area Anda.',
  japanese: '地域内の対象リクエストとマッチング。',
  korean: '내 지역의 적합한 요청과 매칭됩니다.',
  portuguese: 'Combine com solicitações elegíveis na sua região.',
  russian: 'Получайте подходящие заявки в вашем районе.',
  spanish: 'Te emparejamos con solicitudes elegibles en tu zona.',
  swahili: 'Unganishwa na maombi yanayostahili katika eneo lako.',
  vietnamese: 'Được ghép với các yêu cầu phù hợp trong khu vực của bạn.',
};
export const rdProvStep3Title: Translation = {
  amharic: 'በዕለቱ ክፍያ ያግኙ',
  arabic: 'احصل على أجرك في نفس اليوم',
  bengali: 'একই দিনে পরিশোধ পান',
  chinese: '当天获得报酬',
  english: 'Get paid same day',
  estonian: 'Saa tasu samal päeval',
  filipino: 'Mabayaran sa parehong araw',
  french: 'Être payé le jour même',
  german: 'Am selben Tag bezahlt werden',
  hindi: 'उसी दिन भुगतान पाएँ',
  indonesian: 'Dapatkan bayaran di hari yang sama',
  japanese: '当日中に報酬を受け取る',
  korean: '당일 지급받기',
  portuguese: 'Receba no mesmo dia',
  russian: 'Получайте оплату в тот же день',
  spanish: 'Cobra el mismo día',
  swahili: 'Lipwa siku hiyo hiyo',
  vietnamese: 'Được trả ngay trong ngày',
};
export const rdProvStep3Body: Translation = {
  amharic: 'ሥራውን ባጠናቀቁበት ቀን ገንዘቡ ወደ መለያዎ ይገባል።',
  arabic: 'تصل الأموال إلى حسابك يوم إنجازك للعمل.',
  bengali: 'যেদিন আপনি কাজ সম্পন্ন করবেন সেদিনই অর্থ আপনার অ্যাকাউন্টে আসবে।',
  chinese: '你完成工作的当天，资金即到账。',
  english: 'Funds land in your account the day you complete the job.',
  estonian: 'Raha laekub sinu kontole samal päeval, kui töö lõpetad.',
  filipino: 'Pumapasok ang pera sa iyong account sa araw na matapos mo ang trabaho.',
  french: 'Les fonds arrivent sur votre compte le jour où vous terminez le travail.',
  german: 'Das Geld landet am Tag der Fertigstellung auf deinem Konto.',
  hindi: 'जिस दिन आप काम पूरा करते हैं, उसी दिन पैसा आपके खाते में आ जाता है।',
  indonesian: 'Dana masuk ke akun Anda pada hari Anda menyelesaikan pekerjaan.',
  japanese: '仕事を完了した当日に、資金が口座に入金されます。',
  korean: '작업을 완료한 날 자금이 계좌로 입금됩니다.',
  portuguese: 'O dinheiro cai na sua conta no dia em que você conclui o trabalho.',
  russian: 'Деньги поступают на счёт в день завершения работы.',
  spanish: 'El dinero llega a tu cuenta el mismo día que completas el trabajo.',
  swahili: 'Fedha huingia kwenye akaunti yako siku unayomaliza kazi.',
  vietnamese: 'Tiền về tài khoản của bạn ngay trong ngày bạn hoàn thành công việc.',
};

export const rdServicesPaint: Translation = {
  amharic: 'የዕለት ተዕለት አገልግሎቶች',
  arabic: 'خدمات يومية',
  bengali: 'প্রতিদিনের পরিষেবা',
  chinese: '日常服务',
  english: 'Everyday services',
  estonian: 'Igapäevased teenused',
  filipino: 'Pang-araw-araw na serbisyo',
  french: 'Services du quotidien',
  german: 'Alltägliche Dienste',
  hindi: 'रोज़मर्रा की सेवाएँ',
  indonesian: 'Layanan sehari-hari',
  japanese: '毎日のサービス',
  korean: '일상 서비스',
  portuguese: 'Serviços do dia a dia',
  russian: 'Повседневные услуги',
  spanish: 'Servicios cotidianos',
  swahili: 'Huduma za kila siku',
  vietnamese: 'Dịch vụ hằng ngày',
};
export const rdServicesTail: Translation = {
  amharic: '፣ በአቅራቢያዎ',
  arabic: '، بالقرب منك',
  bengali: ', আপনার কাছে',
  chinese: '，就在你身边',
  english: '‚ near you',
  estonian: ', sinu lähedal',
  filipino: ', malapit sa iyo',
  french: ', près de chez vous',
  german: ', in deiner Nähe',
  hindi: ', आपके पास',
  indonesian: ', di dekat Anda',
  japanese: '、すぐ近くで',
  korean: ', 내 주변에서',
  portuguese: ', perto de você',
  russian: ', рядом с вами',
  spanish: ', cerca de ti',
  swahili: ', karibu nawe',
  vietnamese: ', ngay gần bạn',
};
export const rdServicesSub: Translation = {
  amharic: 'ከአንድ ጊዜ ሥራ እስከ መደበኛ እገዛ ድረስ፦ እውነተኛ ሰዎች፣ ለእርስዎ ቅርብ።',
  arabic: 'من مهمّة لمرّة واحدة إلى يد عون منتظمة: أشخاص حقيقيون قريبون منك.',
  bengali: 'একবারের কাজ থেকে নিয়মিত সহায়তা পর্যন্ত: সত্যিকারের মানুষ, আপনার কাছেই।',
  chinese: '从一次性的杂务到长期帮手：都是真实的人，就在你身边。',
  english: 'From a one-off chore to a regular helping hand: real people, local to you.',
  estonian: 'Ühekordsest tööst regulaarse abikäeni: päris inimesed sinu lähedal.',
  filipino: 'Mula sa isahang gawain hanggang regular na katulong: totoong tao, malapit sa iyo.',
  french: 'D’une tâche ponctuelle à un coup de main régulier : de vraies personnes, près de chez vous.',
  german: 'Von der einmaligen Aufgabe bis zur regelmäßigen Hilfe: echte Menschen in deiner Nähe.',
  hindi: 'एक बार के काम से लेकर नियमित मदद तक: असली लोग, आपके पास।',
  indonesian: 'Dari tugas sekali jalan hingga bantuan rutin: orang sungguhan, dekat dengan Anda.',
  japanese: '単発の用事から定期的なお手伝いまで: あなたの近くの本物の人々。',
  korean: '일회성 잡일부터 정기적인 도움까지: 내 주변의 진짜 사람들.',
  portuguese: 'De uma tarefa pontual a uma ajuda regular: pessoas reais, perto de você.',
  russian: 'От разовой задачи до регулярной помощи: реальные люди рядом с вами.',
  spanish: 'Desde una tarea puntual hasta una ayuda habitual: personas reales, cerca de ti.',
  swahili: 'Kuanzia kazi ya mara moja hadi msaada wa kawaida: watu halisi, karibu nawe.',
  vietnamese: 'Từ một việc vặt một lần đến sự giúp đỡ thường xuyên: những con người thật, ngay gần bạn.',
};
export const rdSvcCleaning: Translation = {
  amharic: 'ጽዳት',
  arabic: 'تنظيف',
  bengali: 'পরিচ্ছন্নতা',
  chinese: '清洁',
  english: 'Cleaning',
  estonian: 'Koristamine',
  filipino: 'Paglilinis',
  french: 'Ménage',
  german: 'Reinigung',
  hindi: 'सफ़ाई',
  indonesian: 'Bersih-bersih',
  japanese: '清掃',
  korean: '청소',
  portuguese: 'Limpeza',
  russian: 'Уборка',
  spanish: 'Limpieza',
  swahili: 'Usafi',
  vietnamese: 'Dọn dẹp',
};
export const rdSvcCleaningSub: Translation = {
  amharic: 'ቤቶችና ቢሮዎች',
  arabic: 'منازل ومكاتب',
  bengali: 'বাড়ি ও অফিস',
  chinese: '住宅与办公室',
  english: 'Homes & offices',
  estonian: 'Kodud ja kontorid',
  filipino: 'Mga bahay at opisina',
  french: 'Maisons & bureaux',
  german: 'Wohnungen & Büros',
  hindi: 'घर और दफ़्तर',
  indonesian: 'Rumah & kantor',
  japanese: '住宅・オフィス',
  korean: '집 & 사무실',
  portuguese: 'Casas e escritórios',
  russian: 'Дома и офисы',
  spanish: 'Hogares y oficinas',
  swahili: 'Nyumba na ofisi',
  vietnamese: 'Nhà & văn phòng',
};
export const rdSvcChildcare: Translation = {
  amharic: 'የሕፃናት እንክብካቤ',
  arabic: 'رعاية الأطفال',
  bengali: 'শিশু পরিচর্যা',
  chinese: '托育',
  english: 'Childcare',
  estonian: 'Lapsehoid',
  filipino: 'Pag-aalaga ng bata',
  french: 'Garde d’enfants',
  german: 'Kinderbetreuung',
  hindi: 'बच्चों की देखभाल',
  indonesian: 'Pengasuhan anak',
  japanese: '育児',
  korean: '육아',
  portuguese: 'Cuidado infantil',
  russian: 'Уход за детьми',
  spanish: 'Cuidado de niños',
  swahili: 'Malezi ya watoto',
  vietnamese: 'Trông trẻ',
};
export const rdSvcChildcareSub: Translation = {
  amharic: 'አሳዳጊዎችና ተንከባካቢዎች',
  arabic: 'مربّيات وجليسات',
  bengali: 'ন্যানি ও সিটার',
  chinese: '保姆与看护',
  english: 'Nannies & sitters',
  estonian: 'Lapsehoidjad',
  filipino: 'Mga yaya at tagapag-alaga',
  french: 'Nounous & baby-sitters',
  german: 'Nannys & Babysitter',
  hindi: 'नैनी और सिटर',
  indonesian: 'Pengasuh & penjaga',
  japanese: 'ベビーシッター',
  korean: '보모 & 돌보미',
  portuguese: 'Babás e cuidadores',
  russian: 'Няни и сиделки',
  spanish: 'Niñeras y cuidadores',
  swahili: 'Yaya na walezi',
  vietnamese: 'Bảo mẫu & người trông',
};
export const rdSvcCooking: Translation = {
  amharic: 'ምግብ ማብሰል',
  arabic: 'طهي',
  bengali: 'রান্না',
  chinese: '烹饪',
  english: 'Cooking',
  estonian: 'Toiduvalmistamine',
  filipino: 'Pagluluto',
  french: 'Cuisine',
  german: 'Kochen',
  hindi: 'खाना पकाना',
  indonesian: 'Memasak',
  japanese: '料理',
  korean: '요리',
  portuguese: 'Culinária',
  russian: 'Готовка',
  spanish: 'Cocina',
  swahili: 'Kupika',
  vietnamese: 'Nấu ăn',
};
export const rdSvcCookingSub: Translation = {
  amharic: 'ሼፎችና የምግብ ዝግጅት',
  arabic: 'طهاة وتحضير وجبات',
  bengali: 'শেফ ও মিল প্রিপ',
  chinese: '厨师与备餐',
  english: 'Chefs & meal prep',
  estonian: 'Kokad ja toiduvalmistus',
  filipino: 'Mga chef at meal prep',
  french: 'Chefs & préparation de repas',
  german: 'Köche & Essenszubereitung',
  hindi: 'शेफ और मील प्रेप',
  indonesian: 'Koki & persiapan makanan',
  japanese: 'シェフ・作り置き',
  korean: '셰프 & 식사 준비',
  portuguese: 'Chefs e preparo de refeições',
  russian: 'Повара и готовка блюд',
  spanish: 'Chefs y preparación de comidas',
  swahili: 'Wapishi na maandalizi ya chakula',
  vietnamese: 'Đầu bếp & chuẩn bị bữa ăn',
};
export const rdSvcRepairs: Translation = {
  amharic: 'ጥገናዎች',
  arabic: 'إصلاحات',
  bengali: 'মেরামত',
  chinese: '维修',
  english: 'Repairs',
  estonian: 'Remont',
  filipino: 'Pagkukumpuni',
  french: 'Réparations',
  german: 'Reparaturen',
  hindi: 'मरम्मत',
  indonesian: 'Perbaikan',
  japanese: '修理',
  korean: '수리',
  portuguese: 'Reparos',
  russian: 'Ремонт',
  spanish: 'Reparaciones',
  swahili: 'Ukarabati',
  vietnamese: 'Sửa chữa',
};
export const rdSvcRepairsSub: Translation = {
  amharic: 'የቧንቧና የእጅ ሥራ',
  arabic: 'سباكة وأعمال يدوية',
  bengali: 'প্লাম্বিং ও হাতের কাজ',
  chinese: '管道与杂修',
  english: 'Plumbing & handywork',
  estonian: 'Torutööd ja käsitöö',
  filipino: 'Tubero at handyman',
  french: 'Plomberie & bricolage',
  german: 'Klempnerei & Handwerk',
  hindi: 'प्लंबिंग और मरम्मत-कार्य',
  indonesian: 'Pipa & pertukangan',
  japanese: '配管・修繕',
  korean: '배관 & 잡일',
  portuguese: 'Encanamento e consertos',
  russian: 'Сантехника и мелкий ремонт',
  spanish: 'Fontanería y arreglos',
  swahili: 'Mabomba na kazi za mikono',
  vietnamese: 'Sửa ống nước & việc lặt vặt',
};
export const rdSvcBartending: Translation = {
  amharic: 'ባር አስተናጋጅነት',
  arabic: 'عمل الساقي',
  bengali: 'বার্টেন্ডিং',
  chinese: '调酒',
  english: 'Bartending',
  estonian: 'Baaritöö',
  filipino: 'Bartending',
  french: 'Service de bar',
  german: 'Barkeeping',
  hindi: 'बारटेंडिंग',
  indonesian: 'Bartending',
  japanese: 'バーテンダー',
  korean: '바텐딩',
  portuguese: 'Bar (bartender)',
  russian: 'Бармен',
  spanish: 'Barra (bartender)',
  swahili: 'Uhudumiaji wa baa',
  vietnamese: 'Pha chế quầy bar',
};
export const rdSvcBartendingSub: Translation = {
  amharic: 'ዝግጅቶችና ድግሶች',
  arabic: 'مناسبات وحفلات',
  bengali: 'অনুষ্ঠান ও পার্টি',
  chinese: '活动与派对',
  english: 'Events & parties',
  estonian: 'Üritused ja peod',
  filipino: 'Mga event at party',
  french: 'Événements & fêtes',
  german: 'Events & Partys',
  hindi: 'इवेंट और पार्टी',
  indonesian: 'Acara & pesta',
  japanese: 'イベント・パーティー',
  korean: '행사 & 파티',
  portuguese: 'Eventos e festas',
  russian: 'Мероприятия и вечеринки',
  spanish: 'Eventos y fiestas',
  swahili: 'Matukio na sherehe',
  vietnamese: 'Sự kiện & tiệc',
};
export const rdSvcGardening: Translation = {
  amharic: 'አትክልት ሥራ',
  arabic: 'بستنة',
  bengali: 'বাগান পরিচর্যা',
  chinese: '园艺',
  english: 'Gardening',
  estonian: 'Aiandus',
  filipino: 'Paghahalaman',
  french: 'Jardinage',
  german: 'Gartenarbeit',
  hindi: 'बागवानी',
  indonesian: 'Berkebun',
  japanese: '園芸',
  korean: '정원 관리',
  portuguese: 'Jardinagem',
  russian: 'Садоводство',
  spanish: 'Jardinería',
  swahili: 'Bustani',
  vietnamese: 'Làm vườn',
};
export const rdSvcGardeningSub: Translation = {
  amharic: 'ሣርና የመሬት ገጽታ',
  arabic: 'عشب وتنسيق حدائق',
  bengali: 'লন ও ল্যান্ডস্কেপিং',
  chinese: '草坪与景观',
  english: 'Lawns & landscaping',
  estonian: 'Murud ja haljastus',
  filipino: 'Damuhan at landscaping',
  french: 'Pelouses & aménagement',
  german: 'Rasen & Landschaftsbau',
  hindi: 'लॉन और भू-दृश्य',
  indonesian: 'Halaman & lanskap',
  japanese: '芝生・造園',
  korean: '잔디 & 조경',
  portuguese: 'Gramados e paisagismo',
  russian: 'Газоны и ландшафт',
  spanish: 'Césped y paisajismo',
  swahili: 'Nyasi na mandhari',
  vietnamese: 'Bãi cỏ & cảnh quan',
};
export const rdSvcMoving: Translation = {
  amharic: 'ማዘዋወር',
  arabic: 'نقل',
  bengali: 'স্থানান্তর',
  chinese: '搬运',
  english: 'Moving',
  estonian: 'Kolimine',
  filipino: 'Paglilipat',
  french: 'Déménagement',
  german: 'Umzug',
  hindi: 'सामान ढुलाई',
  indonesian: 'Pindahan',
  japanese: '引越し',
  korean: '이사',
  portuguese: 'Mudança',
  russian: 'Переезд',
  spanish: 'Mudanzas',
  swahili: 'Kuhamisha',
  vietnamese: 'Chuyển nhà',
};
export const rdSvcMovingSub: Translation = {
  amharic: 'ማንሳትና ማጓጓዝ',
  arabic: 'رفع ونقل',
  bengali: 'উত্তোলন ও পরিবহন',
  chinese: '搬抬与运输',
  english: 'Lifting & transport',
  estonian: 'Tõstmine ja transport',
  filipino: 'Pagbubuhat at transportasyon',
  french: 'Levage & transport',
  german: 'Heben & Transport',
  hindi: 'उठाना और परिवहन',
  indonesian: 'Angkat & transportasi',
  japanese: '運搬・輸送',
  korean: '운반 & 운송',
  portuguese: 'Carga e transporte',
  russian: 'Погрузка и перевозка',
  spanish: 'Carga y transporte',
  swahili: 'Kubeba na usafirishaji',
  vietnamese: 'Bốc xếp & vận chuyển',
};
export const rdSvcMore: Translation = {
  amharic: 'እና ሌሎችም',
  arabic: 'والمزيد',
  bengali: 'আরও',
  chinese: '更多',
  english: '& more',
  estonian: 'ja muud',
  filipino: 'at iba pa',
  french: '& plus',
  german: '& mehr',
  hindi: 'और भी',
  indonesian: '& lainnya',
  japanese: 'その他',
  korean: '외 더 보기',
  portuguese: 'e mais',
  russian: 'и другое',
  spanish: 'y más',
  swahili: 'na zaidi',
  vietnamese: '& nhiều hơn',
};
export const rdSvcMoreSub: Translation = {
  amharic: 'የራስዎን ይግለጹ',
  arabic: 'عرّف خدمتك',
  bengali: 'নিজের সংজ্ঞা দিন',
  chinese: '自定义',
  english: 'Define your own',
  estonian: 'Määra ise',
  filipino: 'Tukuyin ang sarili mo',
  french: 'Définissez le vôtre',
  german: 'Definiere deinen eigenen',
  hindi: 'अपना तय करें',
  indonesian: 'Tentukan sendiri',
  japanese: '自分で定義',
  korean: '직접 정의',
  portuguese: 'Defina o seu',
  russian: 'Задайте свой',
  spanish: 'Define el tuyo',
  swahili: 'Fafanua yako',
  vietnamese: 'Tự xác định',
};

export const rdEarnPre: Translation = {
  amharic: 'ችሎታዎችዎን',
  arabic: 'حوّل',
  bengali: 'अपने',
  chinese: '把你的',
  english: 'Turn your',
  estonian: 'Muuda oma',
  filipino: 'Gawing',
  french: 'Transformez vos',
  german: 'Mach deine',
  hindi: 'अपने',
  indonesian: 'Ubah',
  japanese: 'あなたの',
  korean: '당신의',
  portuguese: 'Transforme suas',
  russian: 'Превратите свои',
  spanish: 'Convierte tus',
  swahili: 'Geuza',
  vietnamese: 'Biến',
};
export const rdEarnPaint: Translation = {
  amharic: 'ወደ ገቢ ይቀይሩ',
  arabic: 'مهاراتك إلى دخل',
  bengali: 'দক্ষতাকে আয়ে',
  chinese: '技能变成收入',
  english: 'skills into income',
  estonian: 'oskused tuluks',
  filipino: 'kasanayan na kita',
  french: 'compétences en revenus',
  german: 'Fähigkeiten zu Einkommen',
  hindi: 'कौशल को आय में',
  indonesian: 'keahlian jadi penghasilan',
  japanese: 'スキルを収入に',
  korean: '기술을 수입으로',
  portuguese: 'habilidades em renda',
  russian: 'навыки в доход',
  spanish: 'habilidades en ingresos',
  swahili: 'ujuzi kuwa mapato',
  vietnamese: 'kỹ năng thành thu nhập',
};
export const rdEarnBody: Translation = {
  amharic: 'ሞግዚት፣ አጽጂ፣ ምግብ አብሳይ፣ ቧንቧ ሠራተኛ፣ ባር አስተናጋጅ፣ ችሎታ ካለዎት፣ Workadabra ወደ ክፍያ ሥራ ይቀይረዋል፣ በአቅራቢያዎ።',
  arabic: 'جليسة، عامل تنظيف، طاهٍ، سبّاك، ساقٍ، إن كانت لديك مهارة، فإن Workadabra تحوّلها إلى عمل مأجور قريب منك.',
  bengali: 'বেবিসিটার, ক্লিনার, রাঁধুনি, প্লাম্বার, বার্টেন্ডার, আপনার একটি দক্ষতা থাকলেই Workadabra তা আপনার কাছেই বেতনের কাজে পরিণত করে।',
  chinese: '保姆、清洁工、厨师、水管工、调酒师，只要你有一技之长，Workadabra 就能把它变成你身边的有偿工作。',
  english: 'Babysitter, cleaner, cook, plumber, bartender, if you’ve got a skill, Workadabra turns it into paid work near you.',
  estonian: 'Lapsehoidja, koristaja, kokk, torulukksepp, baarmen, kui sul on oskus, muudab Workadabra selle tasustatud tööks sinu lähedal.',
  filipino: 'Tagapag-alaga, tagalinis, kusinero, tubero, bartender, kung may kasanayan ka, ginagawa itong bayad na trabaho ng Workadabra malapit sa iyo.',
  french: 'Baby-sitter, agent d’entretien, cuisinier, plombier, barman, si vous avez une compétence, Workadabra la transforme en travail rémunéré près de chez vous.',
  german: 'Babysitter, Reinigungskraft, Koch, Klempner, Barkeeper, wenn du eine Fähigkeit hast, macht Workadabra daraus bezahlte Arbeit in deiner Nähe.',
  hindi: 'बेबीसिटर, सफ़ाईकर्मी, रसोइया, प्लंबर, बारटेंडर, अगर आपके पास कोई कौशल है, तो Workadabra उसे आपके पास की वेतन वाली नौकरी में बदल देता है।',
  indonesian: 'Pengasuh bayi, petugas kebersihan, juru masak, tukang ledeng, bartender, jika Anda punya keahlian, Workadabra mengubahnya jadi pekerjaan berbayar di dekat Anda.',
  japanese: 'ベビーシッター、清掃員、料理人、配管工、バーテンダー。スキルがあれば、Workadabra がそれを近くの有給の仕事に変えます。',
  korean: '베이비시터, 청소부, 요리사, 배관공, 바텐더. 기술이 있다면 Workadabra가 그것을 내 주변의 유급 일자리로 바꿔줍니다.',
  portuguese: 'Babá, faxineiro, cozinheiro, encanador, bartender, se você tem uma habilidade, a Workadabra a transforma em trabalho remunerado perto de você.',
  russian: 'Няня, уборщик, повар, сантехник, бармен, если у вас есть навык, Workadabra превратит его в оплачиваемую работу рядом с вами.',
  spanish: 'Niñera, persona de limpieza, cocinero, fontanero, bartender, si tienes una habilidad, Workadabra la convierte en trabajo remunerado cerca de ti.',
  swahili: 'Mlezi wa watoto, msafishaji, mpishi, fundi bomba, mhudumu wa baa, ukiwa na ujuzi, Workadabra huugeuza kuwa kazi ya malipo karibu nawe.',
  vietnamese: 'Trông trẻ, lao công, đầu bếp, thợ ống nước, nhân viên pha chế, nếu bạn có một kỹ năng, Workadabra biến nó thành công việc được trả lương ngay gần bạn.',
};
export const rdEarnBullet1: Translation = {
  amharic: 'እስከ 3 አገልግሎቶችን ይመዝግቡ እና አንዴ ይረጋገጡ',
  arabic: 'سجّل حتى 3 خدمات ووثّق مرّة واحدة',
  bengali: 'সর্বোচ্চ ৩টি পরিষেবা নিবন্ধন করুন এবং একবার যাচাই করান',
  chinese: '登记最多 3 项服务，验证一次',
  english: 'Register up to 3 services and get verified once',
  estonian: 'Registreeri kuni 3 teenust ja kontrolli end korra',
  filipino: 'Magrehistro ng hanggang 3 serbisyo at magpa-verify nang minsan',
  french: 'Enregistrez jusqu’à 3 services et vérifiez-vous une seule fois',
  german: 'Registriere bis zu 3 Services und verifiziere dich einmal',
  hindi: 'अधिकतम 3 सेवाएँ पंजीकृत करें और एक बार सत्यापित हों',
  indonesian: 'Daftarkan hingga 3 layanan dan verifikasi sekali',
  japanese: '最大3つのサービスを登録し、一度だけ認証',
  korean: '최대 3개의 서비스를 등록하고 한 번만 인증',
  portuguese: 'Registre até 3 serviços e verifique-se uma vez',
  russian: 'Зарегистрируйте до 3 услуг и пройдите проверку один раз',
  spanish: 'Registra hasta 3 servicios y verifícate una vez',
  swahili: 'Sajili hadi huduma 3 na uthibitishwe mara moja',
  vietnamese: 'Đăng ký tối đa 3 dịch vụ và xác minh một lần',
};
export const rdEarnBullet2: Translation = {
  amharic: 'ብቁና የተፈቀደልዎትን ሥራዎች ብቻ ይዩ',
  arabic: 'شاهد فقط الأعمال المؤهَّل والمسموح لك بها',
  bengali: 'শুধু সেই কাজ দেখুন যেগুলোর জন্য আপনি যোগ্য ও উপযুক্ত',
  chinese: '只看你符合资格的工作',
  english: 'Only see gigs you’re eligible and qualified for',
  estonian: 'Näe ainult töid, milleks oled sobiv ja pädev',
  filipino: 'Tingnan lang ang mga trabahong kwalipikado ka',
  french: 'Ne voyez que les missions pour lesquelles vous êtes éligible et qualifié',
  german: 'Sieh nur Aufträge, für die du geeignet und qualifiziert bist',
  hindi: 'केवल वही काम देखें जिनके आप पात्र और योग्य हैं',
  indonesian: 'Hanya lihat pekerjaan yang sesuai dan memenuhi syarat',
  japanese: '対象かつ資格のある仕事だけを表示',
  korean: '자격과 조건이 맞는 일감만 표시',
  portuguese: 'Veja apenas trabalhos para os quais você é elegível e qualificado',
  russian: 'Видите только заказы, для которых вы подходите и квалифицированы',
  spanish: 'Ve solo trabajos para los que eres elegible y estás cualificado',
  swahili: 'Ona kazi tu unazostahili na kuwa na sifa',
  vietnamese: 'Chỉ thấy những việc bạn đủ điều kiện và đủ năng lực',
};
export const rdEarnBullet3: Translation = {
  amharic: 'ተጨማሪ ሥራ የሚያስገኝ የአካባቢ ስም ይገንቡ',
  arabic: 'ابنِ سمعة محلية تجلب لك المزيد من العمل',
  bengali: 'আরও কাজ এনে দেয় এমন স্থানীয় সুনাম গড়ুন',
  chinese: '建立赢得更多工作的本地口碑',
  english: 'Build a local reputation that wins you more work',
  estonian: 'Ehita kohalik maine, mis toob rohkem tööd',
  filipino: 'Bumuo ng lokal na reputasyon na nagbibigay ng mas maraming trabaho',
  french: 'Bâtissez une réputation locale qui vous apporte plus de travail',
  german: 'Baue dir einen lokalen Ruf auf, der dir mehr Arbeit bringt',
  hindi: 'ऐसी स्थानीय साख बनाएँ जो आपको और काम दिलाए',
  indonesian: 'Bangun reputasi lokal yang mendatangkan lebih banyak pekerjaan',
  japanese: 'より多くの仕事につながる地元での評判を築く',
  korean: '더 많은 일을 가져다주는 지역 평판을 쌓으세요',
  portuguese: 'Construa uma reputação local que rende mais trabalho',
  russian: 'Создайте местную репутацию, которая приносит больше заказов',
  spanish: 'Construye una reputación local que te consiga más trabajo',
  swahili: 'Jenga sifa ya eneo lako inayokuletea kazi zaidi',
  vietnamese: 'Xây dựng uy tín tại địa phương để có thêm việc',
};
export const rdEarnBullet4: Translation = {
  amharic: 'ገቢዎን በዕለቱ ያውጡ',
  arabic: 'اسحب أرباحك في نفس اليوم',
  bengali: 'একই দিনে আপনার আয় তুলে নিন',
  chinese: '当天提取你的收入',
  english: 'Withdraw your earnings the same day',
  estonian: 'Võta oma teenistus välja samal päeval',
  filipino: 'I-withdraw ang kita mo sa parehong araw',
  french: 'Retirez vos gains le jour même',
  german: 'Zahle deine Einnahmen am selben Tag aus',
  hindi: 'उसी दिन अपनी कमाई निकालें',
  indonesian: 'Tarik penghasilan Anda di hari yang sama',
  japanese: 'その日のうちに収入を引き出す',
  korean: '당일에 수익을 인출하세요',
  portuguese: 'Saque seus ganhos no mesmo dia',
  russian: 'Выводите заработок в тот же день',
  spanish: 'Retira tus ganancias el mismo día',
  swahili: 'Toa mapato yako siku hiyo hiyo',
  vietnamese: 'Rút tiền của bạn ngay trong ngày',
};
export const rdEarnCta: Translation = {
  amharic: 'ማግኘት ይጀምሩ',
  arabic: 'ابدأ الكسب',
  bengali: 'আয় শুরু করুন',
  chinese: '开始赚钱',
  english: 'Start earning',
  estonian: 'Alusta teenimist',
  filipino: 'Simulang kumita',
  french: 'Commencer à gagner',
  german: 'Jetzt verdienen',
  hindi: 'कमाई शुरू करें',
  indonesian: 'Mulai menghasilkan',
  japanese: '収入を得始める',
  korean: '수익 시작하기',
  portuguese: 'Comece a ganhar',
  russian: 'Начать зарабатывать',
  spanish: 'Empieza a ganar',
  swahili: 'Anza kupata mapato',
  vietnamese: 'Bắt đầu kiếm tiền',
};
export const rdEarnCardLabel: Translation = {
  amharic: 'ለማውጣት ዝግጁ',
  arabic: 'متاح للسحب',
  bengali: 'উত্তোলনের জন্য প্রস্তুত',
  chinese: '可提取',
  english: 'Available to withdraw',
  estonian: 'Saadaval väljavõtmiseks',
  filipino: 'Available para i-withdraw',
  french: 'Disponible au retrait',
  german: 'Verfügbar zur Auszahlung',
  hindi: 'निकासी के लिए उपलब्ध',
  indonesian: 'Tersedia untuk ditarik',
  japanese: '引き出し可能',
  korean: '출금 가능',
  portuguese: 'Disponível para saque',
  russian: 'Доступно к выводу',
  spanish: 'Disponible para retirar',
  swahili: 'Inapatikana kutoa',
  vietnamese: 'Có thể rút',
};
export const rdEarnCardJobs: Translation = {
  amharic: 'በዚህ ሳምንት የተጠናቀቁ',
  arabic: 'المنجَز هذا الأسبوع',
  bengali: 'এই সপ্তাহে সম্পন্ন',
  chinese: '本周完成',
  english: 'Completed this week',
  estonian: 'Sel nädalal lõpetatud',
  filipino: 'Natapos ngayong linggo',
  french: 'Réalisés cette semaine',
  german: 'Diese Woche erledigt',
  hindi: 'इस सप्ताह पूरा हुआ',
  indonesian: 'Selesai minggu ini',
  japanese: '今週の完了数',
  korean: '이번 주 완료',
  portuguese: 'Concluídos esta semana',
  russian: 'Завершено за неделю',
  spanish: 'Completados esta semana',
  swahili: 'Zilizokamilika wiki hii',
  vietnamese: 'Hoàn thành tuần này',
};
export const rdEarnCardSpeed: Translation = {
  amharic: 'የክፍያ ፍጥነት',
  arabic: 'سرعة الدفع',
  bengali: 'পরিশোধের গতি',
  chinese: '到账速度',
  english: 'Payout speed',
  estonian: 'Väljamakse kiirus',
  filipino: 'Bilis ng payout',
  french: 'Vitesse de versement',
  german: 'Auszahlungstempo',
  hindi: 'भुगतान गति',
  indonesian: 'Kecepatan pencairan',
  japanese: '支払い速度',
  korean: '지급 속도',
  portuguese: 'Velocidade de pagamento',
  russian: 'Скорость выплаты',
  spanish: 'Velocidad de pago',
  swahili: 'Kasi ya malipo',
  vietnamese: 'Tốc độ chi trả',
};
export const rdEarnCardSpeedValue: Translation = {
  amharic: 'በዕለቱ',
  arabic: 'نفس اليوم',
  bengali: 'একই দিন',
  chinese: '当天',
  english: 'Same day',
  estonian: 'Samal päeval',
  filipino: 'Parehong araw',
  french: 'Le jour même',
  german: 'Am selben Tag',
  hindi: 'उसी दिन',
  indonesian: 'Hari yang sama',
  japanese: '当日',
  korean: '당일',
  portuguese: 'No mesmo dia',
  russian: 'В тот же день',
  spanish: 'El mismo día',
  swahili: 'Siku hiyo hiyo',
  vietnamese: 'Ngay trong ngày',
};

export const rdTrustHeading: Translation = {
  amharic: 'በታማኝነትና በደህንነት ላይ የተገነባ',
  arabic: 'مبنيّ على الثقة والأمان',
  bengali: 'আস্থা ও নিরাপত্তার ওপর গড়া',
  chinese: '建立在信任与安全之上',
  english: 'Built on trust and safety',
  estonian: 'Üles ehitatud usaldusele ja turvalisusele',
  filipino: 'Itinayo sa tiwala at kaligtasan',
  french: 'Bâti sur la confiance et la sécurité',
  german: 'Auf Vertrauen und Sicherheit gebaut',
  hindi: 'भरोसे और सुरक्षा पर बना',
  indonesian: 'Dibangun atas kepercayaan dan keamanan',
  japanese: '信頼と安全の上に',
  korean: '신뢰와 안전 위에 구축',
  portuguese: 'Construído sobre confiança e segurança',
  russian: 'Построено на доверии и безопасности',
  spanish: 'Construido sobre la confianza y la seguridad',
  swahili: 'Imejengwa juu ya uaminifu na usalama',
  vietnamese: 'Xây dựng trên sự tin cậy và an toàn',
};
export const rdTrustSub: Translation = {
  amharic: 'እያንዳንዱ አቅራቢ የተረጋገጠ፣ እያንዳንዱ ክፍያ የተጠበቀ፣ እያንዳንዱ ሥራ የተደረገበት።',
  arabic: 'كل مزوّد موثَّق، كل دفعة محميّة، كل عمل مقيَّم.',
  bengali: 'প্রতিটি প্রদানকারী যাচাইকৃত, প্রতিটি পরিশোধ সুরক্ষিত, প্রতিটি কাজ রেটেড।',
  chinese: '每位服务者都经过验证，每笔付款都受保护，每项工作都有评分。',
  english: 'Every provider verified, every payment protected, every job rated.',
  estonian: 'Iga pakkuja kontrollitud, iga makse kaitstud, iga töö hinnatud.',
  filipino: 'Bawat provider beripikado, bawat bayad protektado, bawat trabaho may rating.',
  french: 'Chaque prestataire vérifié, chaque paiement protégé, chaque mission notée.',
  german: 'Jeder Anbieter geprüft, jede Zahlung geschützt, jeder Auftrag bewertet.',
  hindi: 'हर प्रदाता सत्यापित, हर भुगतान सुरक्षित, हर काम रेटेड।',
  indonesian: 'Setiap penyedia terverifikasi, setiap pembayaran terlindungi, setiap pekerjaan dinilai.',
  japanese: 'すべてのプロバイダーが認証済み、すべての支払いが保護され、すべての仕事が評価されます。',
  korean: '모든 제공자는 인증되고, 모든 결제는 보호되며, 모든 작업은 평가됩니다.',
  portuguese: 'Cada prestador verificado, cada pagamento protegido, cada trabalho avaliado.',
  russian: 'Каждый исполнитель проверен, каждый платёж защищён, каждая работа оценена.',
  spanish: 'Cada proveedor verificado, cada pago protegido, cada trabajo valorado.',
  swahili: 'Kila mtoa huduma amethibitishwa, kila malipo yamelindwa, kila kazi imekadiriwa.',
  vietnamese: 'Mọi nhà cung cấp đều được xác minh, mọi khoản thanh toán đều được bảo vệ, mọi công việc đều được đánh giá.',
};
export const rdTrustVerifiedTitle: Translation = {
  amharic: 'የተረጋገጡ አቅራቢዎች',
  arabic: 'مزوّدون موثَّقون',
  bengali: 'যাচাইকৃত প্রদানকারী',
  chinese: '已验证的服务者',
  english: 'Verified providers',
  estonian: 'Kontrollitud pakkujad',
  filipino: 'Mga beripikadong provider',
  french: 'Prestataires vérifiés',
  german: 'Geprüfte Anbieter',
  hindi: 'सत्यापित प्रदाता',
  indonesian: 'Penyedia terverifikasi',
  japanese: '認証済みプロバイダー',
  korean: '인증된 제공자',
  portuguese: 'Prestadores verificados',
  russian: 'Проверенные исполнители',
  spanish: 'Proveedores verificados',
  swahili: 'Watoa huduma waliothibitishwa',
  vietnamese: 'Nhà cung cấp đã xác minh',
};
export const rdTrustVerifiedBody: Translation = {
  amharic: 'ማንም ሰው አገልግሎት ከማቅረቡ በፊት የማንነትና የብቃት ማረጋገጫዎች።',
  arabic: 'فحوصات الهوية والمؤهّلات قبل أن يتمكّن أي شخص من تقديم خدمة.',
  bengali: 'কেউ পরিষেবা প্রদান করার আগে পরিচয় ও যোগ্যতা যাচাই।',
  chinese: '任何人提供服务前都需进行身份与资质核验。',
  english: 'Identity and credential checks before anyone can provide a service.',
  estonian: 'Isiku- ja kvalifikatsioonikontroll enne, kui keegi saab teenust pakkuda.',
  filipino: 'Pagsusuri ng pagkakakilanlan at kredensyal bago makapagbigay ng serbisyo ang sinuman.',
  french: 'Vérification de l’identité et des références avant de pouvoir fournir un service.',
  german: 'Identitäts- und Qualifikationsprüfung, bevor jemand einen Service anbieten kann.',
  hindi: 'किसी के सेवा देने से पहले पहचान और प्रमाण-पत्र की जाँच।',
  indonesian: 'Pemeriksaan identitas dan kredensial sebelum siapa pun bisa memberi layanan.',
  japanese: '誰かがサービスを提供する前に、本人確認と資格チェックを行います。',
  korean: '누구든 서비스를 제공하기 전에 신원과 자격을 확인합니다.',
  portuguese: 'Verificação de identidade e credenciais antes que alguém possa prestar um serviço.',
  russian: 'Проверка личности и квалификации перед тем, как кто-либо сможет оказывать услугу.',
  spanish: 'Verificación de identidad y credenciales antes de que alguien pueda prestar un servicio.',
  swahili: 'Ukaguzi wa utambulisho na sifa kabla mtu yeyote kutoa huduma.',
  vietnamese: 'Kiểm tra danh tính và chứng chỉ trước khi bất kỳ ai có thể cung cấp dịch vụ.',
};
export const rdTrustEscrowTitle: Translation = {
  amharic: 'የ Escrow ክፍያዎች',
  arabic: 'مدفوعات بالضمان',
  bengali: 'এসক্রো পরিশোধ',
  chinese: '托管付款',
  english: 'Escrow payments',
  estonian: 'Tagatiskonto maksed',
  filipino: 'Mga bayad sa escrow',
  french: 'Paiements sous séquestre',
  german: 'Treuhand-Zahlungen',
  hindi: 'एस्क्रो भुगतान',
  indonesian: 'Pembayaran escrow',
  japanese: 'エスクロー決済',
  korean: '에스크로 결제',
  portuguese: 'Pagamentos em garantia',
  russian: 'Эскроу-платежи',
  spanish: 'Pagos en depósito de garantía',
  swahili: 'Malipo ya escrow',
  vietnamese: 'Thanh toán ký quỹ',
};
export const rdTrustEscrowBody: Translation = {
  amharic: 'ገንዘብ በደህንነት ይያዛል እና አገልግሎትዎ እስኪጠናቀቅ ድረስ ተመላሽ ይደረጋል።',
  arabic: 'يُحتفظ بالمال بأمان وقابل للاسترداد حتى إتمام خدمتك.',
  bengali: 'অর্থ নিরাপদে রাখা হয় এবং আপনার পরিষেবা শেষ না হওয়া পর্যন্ত ফেরতযোগ্য।',
  chinese: '款项被安全保管，在你的服务完成前可退款。',
  english: 'Money is held safely and refundable until your service is completed.',
  estonian: 'Raha hoitakse turvaliselt ja on tagastatav, kuni sinu teenus on lõpetatud.',
  filipino: 'Ligtas na hawak ang pera at refundable hanggang matapos ang serbisyo mo.',
  french: 'L’argent est conservé en sécurité et remboursable jusqu’à la fin de votre service.',
  german: 'Das Geld wird sicher verwahrt und ist erstattungsfähig, bis dein Service abgeschlossen ist.',
  hindi: 'पैसा सुरक्षित रखा जाता है और आपकी सेवा पूरी होने तक वापसी-योग्य रहता है।',
  indonesian: 'Uang disimpan dengan aman dan dapat dikembalikan hingga layanan Anda selesai.',
  japanese: 'お金は安全に保管され、サービスが完了するまで返金可能です。',
  korean: '돈은 안전하게 보관되며 서비스가 완료될 때까지 환불 가능합니다.',
  portuguese: 'O dinheiro é mantido em segurança e reembolsável até o serviço ser concluído.',
  russian: 'Деньги хранятся в безопасности и подлежат возврату до завершения услуги.',
  spanish: 'El dinero se guarda de forma segura y es reembolsable hasta que tu servicio se complete.',
  swahili: 'Fedha huhifadhiwa kwa usalama na zinaweza kurejeshwa hadi huduma yako ikamilike.',
  vietnamese: 'Tiền được giữ an toàn và có thể hoàn lại cho đến khi dịch vụ của bạn hoàn tất.',
};
export const rdTrustPayTitle: Translation = {
  amharic: 'በፈለጉት መንገድ ይክፈሉ',
  arabic: 'ادفع بطريقتك',
  bengali: 'আপনার পছন্দমতো পরিশোধ করুন',
  chinese: '按你喜欢的方式付款',
  english: 'Pay your way',
  estonian: 'Maksa nii nagu soovid',
  filipino: 'Magbayad sa paraang gusto mo',
  french: 'Payez à votre façon',
  german: 'Zahle, wie du willst',
  hindi: 'अपने तरीके से भुगतान करें',
  indonesian: 'Bayar sesuka Anda',
  japanese: '好きな方法で支払う',
  korean: '원하는 방식으로 결제',
  portuguese: 'Pague do seu jeito',
  russian: 'Платите как удобно',
  spanish: 'Paga a tu manera',
  swahili: 'Lipa kwa njia yako',
  vietnamese: 'Thanh toán theo cách của bạn',
};
export const rdTrustPayBody: Translation = {
  amharic: 'ክሪፕቶ፣ PayPal፣ ሞባይል ገንዘብና የባንክ ዝውውር፣ ሁሉም ይደገፋሉ።',
  arabic: 'العملات الرقمية، PayPal، المحفظة عبر الهاتف والتحويل البنكي، كلها مدعومة.',
  bengali: 'ক্রিপ্টো, PayPal, মোবাইল মানি ও ব্যাংক ট্রান্সফার, সবই সমর্থিত।',
  chinese: '加密货币、PayPal、移动支付和银行转账，全部支持。',
  english: 'Crypto, PayPal, mobile money and bank transfer, all supported.',
  estonian: 'Krüpto, PayPal, mobiiliraha ja pangaülekanne, kõik toetatud.',
  filipino: 'Crypto, PayPal, mobile money at bank transfer, lahat suportado.',
  french: 'Crypto, PayPal, mobile money et virement bancaire, tout est pris en charge.',
  german: 'Krypto, PayPal, Mobile Money und Banküberweisung, alles unterstützt.',
  hindi: 'क्रिप्टो, PayPal, मोबाइल मनी और बैंक ट्रांसफ़र, सभी समर्थित।',
  indonesian: 'Kripto, PayPal, mobile money, dan transfer bank, semua didukung.',
  japanese: '暗号資産、PayPal、モバイルマネー、銀行振込。すべて対応。',
  korean: '암호화폐, PayPal, 모바일 머니, 계좌 이체. 모두 지원합니다.',
  portuguese: 'Cripto, PayPal, dinheiro móvel e transferência bancária, tudo suportado.',
  russian: 'Криптовалюта, PayPal, мобильные деньги и банковский перевод, всё поддерживается.',
  spanish: 'Cripto, PayPal, dinero móvil y transferencia bancaria, todo compatible.',
  swahili: 'Crypto, PayPal, pesa za simu na uhamisho wa benki, vyote vinaungwa mkono.',
  vietnamese: 'Tiền mã hóa, PayPal, tiền di động và chuyển khoản ngân hàng, đều được hỗ trợ.',
};
export const rdTrustLocalTitle: Translation = {
  amharic: 'አካባቢያዊና ተገዢ',
  arabic: 'محليّ ومتوافق',
  bengali: 'স্থানীয় ও সম্মত',
  chinese: '本地且合规',
  english: 'Local & compliant',
  estonian: 'Kohalik ja nõuetekohane',
  filipino: 'Lokal at compliant',
  french: 'Local & conforme',
  german: 'Lokal & konform',
  hindi: 'स्थानीय और अनुपालक',
  indonesian: 'Lokal & patuh',
  japanese: '地域対応・法令順守',
  korean: '지역 기반 & 규정 준수',
  portuguese: 'Local e em conformidade',
  russian: 'Локально и по правилам',
  spanish: 'Local y conforme',
  swahili: 'Ya eneo na inayotii sheria',
  vietnamese: 'Địa phương & tuân thủ',
};
export const rdTrustLocalBody: Translation = {
  amharic: 'ለአካባቢዎ የተዛመደ፣ ከአገር-ተኮር መስፈርቶች ጋር ተግባራዊ ሆኖ።',
  arabic: 'مطابَق لمنطقتك مع تطبيق المتطلبات الخاصة بكل بلد.',
  bengali: 'আপনার এলাকার সঙ্গে মিলিয়ে দেওয়া, দেশভিত্তিক প্রয়োজনীয়তা প্রয়োগসহ।',
  chinese: '匹配你所在区域，并执行各国特定要求。',
  english: 'Matched to your area, with country-specific requirements enforced.',
  estonian: 'Sobitatud sinu piirkonnaga, riigipõhiste nõuetega.',
  filipino: 'Tugma sa iyong lugar, na may ipinatutupad na country-specific na requirement.',
  french: 'Adapté à votre zone, avec application des exigences propres à chaque pays.',
  german: 'Auf deine Region abgestimmt, mit länderspezifischen Anforderungen.',
  hindi: 'आपके इलाके के अनुसार, देश-विशिष्ट आवश्यकताओं के साथ।',
  indonesian: 'Disesuaikan dengan area Anda, dengan persyaratan khusus per negara.',
  japanese: '地域に合わせ、国ごとの要件を適用。',
  korean: '지역에 맞춰 국가별 요건을 적용합니다.',
  portuguese: 'Adaptado à sua região, com requisitos específicos de cada país.',
  russian: 'С учётом вашего региона и требований конкретной страны.',
  spanish: 'Adaptado a tu zona, con requisitos específicos de cada país.',
  swahili: 'Inayolingana na eneo lako, ikitekeleza mahitaji mahususi ya nchi.',
  vietnamese: 'Phù hợp với khu vực của bạn, áp dụng các yêu cầu riêng theo từng quốc gia.',
};

export const rdCtaSeekerTitle: Translation = {
  amharic: 'መሠራት ይፈልጋል?',
  arabic: 'تحتاج إنجازه؟',
  bengali: 'করিয়ে নিতে চান?',
  chinese: '需要找人做？',
  english: 'Need it done?',
  estonian: 'Vajad tehtud?',
  filipino: 'Kailangang magawa?',
  french: 'Besoin de le faire faire ?',
  german: 'Erledigt haben wollen?',
  hindi: 'करवाना है?',
  indonesian: 'Butuh dikerjakan?',
  japanese: 'やってもらいたい？',
  korean: '맡길 일이 있나요?',
  portuguese: 'Precisa de ajuda?',
  russian: 'Нужно сделать?',
  spanish: '¿Necesitas hacerlo?',
  swahili: 'Unahitaji kifanyike?',
  vietnamese: 'Cần làm việc đó?',
};
export const rdCtaSeekerBody: Translation = {
  amharic: 'የተረጋገጠ የአካባቢ ባለሙያ ያግኙና በደቂቃዎች ይያዙ።',
  arabic: 'اعثر على محترف محلي موثوق واحجز في دقائق.',
  bengali: 'একজন যাচাইকৃত স্থানীয় পেশাদার খুঁজুন এবং কয়েক মিনিটে বুক করুন।',
  chinese: '找到经过验证的本地专业人员，几分钟内预约。',
  english: 'Find a verified local pro and book in minutes.',
  estonian: 'Leia kontrollitud kohalik spetsialist ja broneeri minutitega.',
  filipino: 'Humanap ng beripikadong lokal na pro at mag-book sa ilang minuto.',
  french: 'Trouvez un pro local vérifié et réservez en quelques minutes.',
  german: 'Finde einen geprüften lokalen Profi und buche in Minuten.',
  hindi: 'सत्यापित स्थानीय पेशेवर खोजें और मिनटों में बुक करें।',
  indonesian: 'Temukan pro lokal terverifikasi dan pesan dalam hitungan menit.',
  japanese: '認証済みの地元プロを見つけて、数分で予約。',
  korean: '인증된 지역 전문가를 찾아 몇 분 만에 예약하세요.',
  portuguese: 'Encontre um profissional local verificado e agende em minutos.',
  russian: 'Найдите проверенного местного специалиста и забронируйте за минуты.',
  spanish: 'Encuentra un profesional local verificado y reserva en minutos.',
  swahili: 'Pata mtaalamu wa eneo lako aliyethibitishwa na uweke nafasi kwa dakika.',
  vietnamese: 'Tìm một chuyên gia địa phương đã xác minh và đặt lịch trong vài phút.',
};
export const rdCtaProviderTitle: Translation = {
  amharic: 'ለማግኘት ዝግጁ ነዎት?',
  arabic: 'جاهز للكسب؟',
  bengali: 'আয় করতে প্রস্তুত?',
  chinese: '准备好赚钱了吗？',
  english: 'Ready to earn?',
  estonian: 'Valmis teenima?',
  filipino: 'Handa nang kumita?',
  french: 'Prêt à gagner ?',
  german: 'Bereit zu verdienen?',
  hindi: 'कमाने को तैयार?',
  indonesian: 'Siap menghasilkan?',
  japanese: '稼ぐ準備はできた？',
  korean: '수익 낼 준비 됐나요?',
  portuguese: 'Pronto para ganhar?',
  russian: 'Готовы зарабатывать?',
  spanish: '¿Listo para ganar?',
  swahili: 'Tayari kupata mapato?',
  vietnamese: 'Sẵn sàng kiếm tiền?',
};
export const rdCtaProviderBody: Translation = {
  amharic: 'ችሎታዎችዎን ወደ የዕለቱ ገቢ ይቀይሩ፣ በአቅራቢያዎ።',
  arabic: 'حوّل مهاراتك إلى دخل في اليوم نفسه قريبًا منك.',
  bengali: 'আপনার দক্ষতাকে আপনার কাছেই একই দিনের আয়ে পরিণত করুন।',
  chinese: '把你的技能变成身边的当天收入。',
  english: 'Turn your skills into same-day income near you.',
  estonian: 'Muuda oma oskused samal päeval tuluks sinu lähedal.',
  filipino: 'Gawing kita sa parehong araw ang iyong mga kasanayan malapit sa iyo.',
  french: 'Transformez vos compétences en revenus le jour même, près de chez vous.',
  german: 'Mache deine Fähigkeiten zu Einkommen am selben Tag in deiner Nähe.',
  hindi: 'अपने कौशल को अपने पास की उसी दिन की कमाई में बदलें।',
  indonesian: 'Ubah keahlian Anda menjadi penghasilan di hari yang sama, dekat Anda.',
  japanese: 'スキルを近くで当日収入に変えましょう。',
  korean: '당신의 기술을 내 주변에서 당일 수입으로 바꾸세요.',
  portuguese: 'Transforme suas habilidades em renda no mesmo dia, perto de você.',
  russian: 'Превратите свои навыки в доход в тот же день рядом с вами.',
  spanish: 'Convierte tus habilidades en ingresos el mismo día cerca de ti.',
  swahili: 'Geuza ujuzi wako kuwa mapato ya siku hiyo hiyo karibu nawe.',
  vietnamese: 'Biến kỹ năng của bạn thành thu nhập ngay trong ngày, ngay gần bạn.',
};

export const rdNavLegal: Translation = {
  amharic: 'ሕጋዊ',
  arabic: 'قانوني',
  bengali: 'আইনি',
  chinese: '法律',
  english: 'Legal',
  estonian: 'Õiguslik',
  filipino: 'Legal',
  french: 'Mentions légales',
  german: 'Rechtliches',
  hindi: 'कानूनी',
  indonesian: 'Hukum',
  japanese: '法的事項',
  korean: '법적 고지',
  portuguese: 'Jurídico',
  russian: 'Правовое',
  spanish: 'Legal',
  swahili: 'Kisheria',
  vietnamese: 'Pháp lý',
};

// NOTE: the Seekers and Providers nav page strings in the low-resource locales are not yet review-checked.
export const rdSeekersPageTitle: Translation = {
  amharic: 'የዕለት ተዕለት አገልግሎቶችን ይሥሩ',
  arabic: 'أنجز خدماتك اليومية',
  bengali: 'প্রতিদিনের পরিষেবা সম্পন্ন করুন',
  chinese: '搞定日常服务',
  english: 'Get everyday services done',
  estonian: 'Saa igapäevased teenused tehtud',
  filipino: 'Maipagawa ang pang-araw-araw na serbisyo',
  french: 'Faites réaliser vos services du quotidien',
  german: 'Alltägliche Dienstleistungen erledigen lassen',
  hindi: 'रोज़मर्रा की सेवाएँ पूरी कराएँ',
  indonesian: 'Selesaikan layanan sehari-hari',
  japanese: '毎日のサービスを依頼',
  korean: '일상 서비스를 해결하세요',
  portuguese: 'Resolva serviços do dia a dia',
  russian: 'Решайте повседневные задачи',
  spanish: 'Resuelve tus servicios cotidianos',
  swahili: 'Kamilisha huduma za kila siku',
  vietnamese: 'Hoàn thành dịch vụ hằng ngày',
};
export const rdSeekersPageSub: Translation = {
  amharic: 'በአቅራቢያዎ የተረጋገጠ ባለሙያ ያግኙ፣ እና ሥራው ሲጠናቀቅ ብቻ በደህንነት ይክፈሉ።',
  arabic: 'اعثر على محترف محلي موثوق بالقرب منك، وادفع بأمان فقط عند إتمام العمل.',
  bengali: 'আপনার কাছে একজন যাচাইকৃত স্থানীয় পেশাদার খুঁজুন, এবং কাজ শেষ হলেই নিরাপদে পরিশোধ করুন।',
  chinese: '在附近找到经过验证的本地专业人员，工作完成后再安全付款。',
  english: 'Find a verified local pro near you, and pay safely, only when the job’s done.',
  estonian: 'Leia enda lähedalt kontrollitud spetsialist, ja maksa turvaliselt alles siis, kui töö on tehtud.',
  filipino: 'Humanap ng beripikadong lokal na propesyonal malapit sa iyo, at magbayad nang ligtas, kapag tapos na ang trabaho.',
  french: 'Trouvez près de chez vous un pro local vérifié, et payez en toute sécurité, une fois le travail terminé.',
  german: 'Finde einen geprüften lokalen Profi in deiner Nähe, und zahle sicher, erst wenn die Arbeit erledigt ist.',
  hindi: 'अपने पास एक सत्यापित स्थानीय पेशेवर खोजें, और काम पूरा होने पर ही सुरक्षित भुगतान करें।',
  indonesian: 'Temukan profesional lokal terverifikasi di dekat Anda, dan bayar dengan aman, hanya saat pekerjaan selesai.',
  japanese: '近くの認証済みのプロを見つけて、仕事が完了したときだけ安全に支払い。',
  korean: '내 주변의 인증된 지역 전문가를 찾고, 작업이 끝났을 때만 안전하게 결제하세요.',
  portuguese: 'Encontre um profissional local verificado perto de você, e pague com segurança, só quando o serviço estiver concluído.',
  russian: 'Найдите проверенного местного специалиста рядом, и платите безопасно только после выполнения работы.',
  spanish: 'Encuentra un profesional local verificado cerca de ti, y paga de forma segura solo cuando el trabajo esté hecho.',
  swahili: 'Pata mtaalamu wa eneo lako aliyethibitishwa, na ulipe kwa usalama, kazi ikikamilika tu.',
  vietnamese: 'Tìm một chuyên gia địa phương đã xác minh gần bạn, và thanh toán an toàn chỉ khi công việc hoàn tất.',
};
export const rdSeekersStepsHead: Translation = {
  amharic: 'ለፈላጊዎች እንዴት እንደሚሰራ',
  arabic: 'كيف يعمل للباحثين عن الخدمة',
  bengali: 'যারা সেবা খোঁজেন তাদের জন্য কীভাবে কাজ করে',
  chinese: '需求方使用方式',
  english: 'How it works for seekers',
  estonian: 'Kuidas see otsijatele toimib',
  filipino: 'Paano ito gumagana para sa mga naghahanap',
  french: 'Comment ça marche pour les demandeurs',
  german: 'So funktioniert es für Suchende',
  hindi: 'खोजकर्ताओं के लिए यह कैसे काम करता है',
  indonesian: 'Cara kerjanya untuk pencari',
  japanese: '依頼者の利用の流れ',
  korean: '서비스를 찾는 분을 위한 이용 방법',
  portuguese: 'Como funciona para quem busca',
  russian: 'Как это работает для заказчиков',
  spanish: 'Cómo funciona para quienes buscan',
  swahili: 'Jinsi inavyofanya kazi kwa watafutaji',
  vietnamese: 'Cách hoạt động cho người tìm dịch vụ',
};
export const rdProvidersPageTitle: Translation = {
  amharic: 'ችሎታዎን ወደ ገቢ ይቀይሩ',
  arabic: 'حوّل مهاراتك إلى دخل',
  bengali: 'আপনার দক্ষতাকে আয়ে পরিণত করুন',
  chinese: '把技能变成收入',
  english: 'Turn your skills into income',
  estonian: 'Muuda oma oskused sissetulekuks',
  filipino: 'Gawing kita ang iyong kasanayan',
  french: 'Transformez vos compétences en revenus',
  german: 'Mach aus deinen Fähigkeiten Einkommen',
  hindi: 'अपने कौशल को आय में बदलें',
  indonesian: 'Ubah keterampilan Anda menjadi penghasilan',
  japanese: 'スキルを収入に変える',
  korean: '당신의 기술을 수입으로',
  portuguese: 'Transforme suas habilidades em renda',
  russian: 'Превратите навыки в доход',
  spanish: 'Convierte tus habilidades en ingresos',
  swahili: 'Geuza ujuzi wako kuwa kipato',
  vietnamese: 'Biến kỹ năng của bạn thành thu nhập',
};
export const rdProvidersPageSub: Translation = {
  amharic: 'ብቁ የሆኑበትን በአቅራቢያ ያሉ ሥራዎችን ይቀበሉ እና በዚያው ቀን ይከፈሉ።',
  arabic: 'اقبل المهام المحلية المؤهَّل لها واحصل على أجرك في اليوم نفسه.',
  bengali: 'আপনি যোগ্য এমন স্থানীয় কাজ গ্রহণ করুন এবং একই দিনে অর্থ পান।',
  chinese: '接受您符合资格的本地工作，并当天获得报酬。',
  english: 'Accept local gigs you’re qualified for and get paid the same day.',
  estonian: 'Võta vastu kohalikud tööd, milleks oled kvalifitseeritud, ja saa tasu samal päeval.',
  filipino: 'Tanggapin ang lokal na trabahong kwalipikado ka at mabayaran sa parehong araw.',
  french: 'Acceptez des missions locales pour lesquelles vous êtes qualifié et soyez payé le jour même.',
  german: 'Nimm lokale Aufträge an, für die du qualifiziert bist, und werde noch am selben Tag bezahlt.',
  hindi: 'जिन स्थानीय कामों के लिए आप योग्य हैं उन्हें स्वीकार करें और उसी दिन भुगतान पाएँ।',
  indonesian: 'Terima pekerjaan lokal sesuai kualifikasi Anda dan dibayar di hari yang sama.',
  japanese: '資格のある地元の仕事を受けて、その日のうちに報酬を受け取る。',
  korean: '자격이 되는 지역 일감을 수락하고 당일에 정산받으세요.',
  portuguese: 'Aceite trabalhos locais para os quais você se qualifica e receba no mesmo dia.',
  russian: 'Берите местные заказы по своей квалификации и получайте оплату в тот же день.',
  spanish: 'Acepta trabajos locales para los que estás calificado y cobra el mismo día.',
  swahili: 'Pokea kazi za eneo lako unazostahili na ulipwe siku hiyo hiyo.',
  vietnamese: 'Nhận các công việc địa phương phù hợp năng lực và được trả ngay trong ngày.',
};
export const rdProvidersStepsHead: Translation = {
  amharic: 'ለአቅራቢዎች እንዴት እንደሚሰራ',
  arabic: 'كيف يعمل لمقدّمي الخدمة',
  bengali: 'প্রদানকারীদের জন্য কীভাবে কাজ করে',
  chinese: '服务方使用方式',
  english: 'How it works for providers',
  estonian: 'Kuidas see teenusepakkujatele toimib',
  filipino: 'Paano ito gumagana para sa mga provider',
  french: 'Comment ça marche pour les prestataires',
  german: 'So funktioniert es für Anbieter',
  hindi: 'प्रदाताओं के लिए यह कैसे काम करता है',
  indonesian: 'Cara kerjanya untuk penyedia',
  japanese: '提供者の利用の流れ',
  korean: '제공자를 위한 이용 방법',
  portuguese: 'Como funciona para prestadores',
  russian: 'Как это работает для исполнителей',
  spanish: 'Cómo funciona para proveedores',
  swahili: 'Jinsi inavyofanya kazi kwa watoa huduma',
  vietnamese: 'Cách hoạt động cho nhà cung cấp',
};

export const rdNavProviders: Translation = {
  amharic: 'አቅራቢዎች',
  arabic: 'مقدّمو الخدمة',
  bengali: 'প্রদানকারী',
  chinese: '服务方',
  english: 'Providers',
  estonian: 'Teenusepakkujad',
  filipino: 'Mga Provider',
  french: 'Prestataires',
  german: 'Anbieter',
  hindi: 'प्रदाता',
  indonesian: 'Penyedia',
  japanese: '提供者',
  korean: '제공자',
  portuguese: 'Prestadores',
  russian: 'Исполнители',
  spanish: 'Proveedores',
  swahili: 'Watoa huduma',
  vietnamese: 'Nhà cung cấp',
};
export const rdNavSeekers: Translation = {
  amharic: 'ፈላጊዎች',
  arabic: 'الباحثون عن الخدمة',
  bengali: 'সেবা প্রার্থী',
  chinese: '需求方',
  english: 'Seekers',
  estonian: 'Otsijad',
  filipino: 'Mga Naghahanap',
  french: 'Demandeurs',
  german: 'Suchende',
  hindi: 'खोजकर्ता',
  indonesian: 'Pencari',
  japanese: '依頼者',
  korean: '서비스 요청자',
  portuguese: 'Quem busca',
  russian: 'Заказчики',
  spanish: 'Quien busca',
  swahili: 'Watafutaji',
  vietnamese: 'Người tìm dịch vụ',
};

export const rdAboutEyebrow: Translation = {
  amharic: 'ስለ እኛ',
  arabic: 'من نحن',
  bengali: 'আমাদের সম্পর্কে',
  chinese: '关于',
  english: 'About',
  estonian: 'Meist',
  filipino: 'Tungkol',
  french: 'À propos',
  german: 'Über uns',
  hindi: 'परिचय',
  indonesian: 'Tentang',
  japanese: '会社概要',
  korean: '소개',
  portuguese: 'Sobre',
  russian: 'О нас',
  spanish: 'Acerca de',
  swahili: 'Kuhusu',
  vietnamese: 'Giới thiệu',
};
export const rdCareersEyebrow: Translation = {
  amharic: 'ሥራዎች',
  arabic: 'وظائف',
  bengali: 'ক্যারিয়ার',
  chinese: '招聘',
  english: 'Careers',
  estonian: 'Karjäär',
  filipino: 'Karera',
  french: 'Carrières',
  german: 'Karriere',
  hindi: 'करियर',
  indonesian: 'Karier',
  japanese: '採用情報',
  korean: '채용',
  portuguese: 'Carreiras',
  russian: 'Карьера',
  spanish: 'Empleo',
  swahili: 'Kazi',
  vietnamese: 'Tuyển dụng',
};
export const rdCommunityEyebrow: Translation = {
  amharic: 'ማህበረሰብ',
  arabic: 'المجتمع',
  bengali: 'কমিউনিটি',
  chinese: '社区',
  english: 'Community',
  estonian: 'Kogukond',
  filipino: 'Komunidad',
  french: 'Communauté',
  german: 'Community',
  hindi: 'समुदाय',
  indonesian: 'Komunitas',
  japanese: 'コミュニティ',
  korean: '커뮤니티',
  portuguese: 'Comunidade',
  russian: 'Сообщество',
  spanish: 'Comunidad',
  swahili: 'Jamii',
  vietnamese: 'Cộng đồng',
};
export const rdContactEyebrow: Translation = {
  amharic: 'አግኙን',
  arabic: 'تواصل معنا',
  bengali: 'যোগাযোগ',
  chinese: '联系我们',
  english: 'Contact',
  estonian: 'Kontakt',
  filipino: 'Makipag-ugnayan',
  french: 'Contact',
  german: 'Kontakt',
  hindi: 'संपर्क',
  indonesian: 'Kontak',
  japanese: 'お問い合わせ',
  korean: '문의',
  portuguese: 'Contato',
  russian: 'Контакты',
  spanish: 'Contacto',
  swahili: 'Wasiliana',
  vietnamese: 'Liên hệ',
};
export const rdHelpEyebrow: Translation = {
  amharic: 'እገዛ',
  arabic: 'المساعدة',
  bengali: 'সহায়তা',
  chinese: '帮助',
  english: 'Help',
  estonian: 'Abi',
  filipino: 'Tulong',
  french: 'Aide',
  german: 'Hilfe',
  hindi: 'सहायता',
  indonesian: 'Bantuan',
  japanese: 'ヘルプ',
  korean: '도움말',
  portuguese: 'Ajuda',
  russian: 'Помощь',
  spanish: 'Ayuda',
  swahili: 'Msaada',
  vietnamese: 'Trợ giúp',
};
export const rdSecurityEyebrow: Translation = {
  amharic: 'ደህንነት',
  arabic: 'الأمان',
  bengali: 'নিরাপত্তা',
  chinese: '安全',
  english: 'Security',
  estonian: 'Turvalisus',
  filipino: 'Seguridad',
  french: 'Sécurité',
  german: 'Sicherheit',
  hindi: 'सुरक्षा',
  indonesian: 'Keamanan',
  japanese: 'セキュリティ',
  korean: '보안',
  portuguese: 'Segurança',
  russian: 'Безопасность',
  spanish: 'Seguridad',
  swahili: 'Usalama',
  vietnamese: 'Bảo mật',
};

export const rdContactResp24h: Translation = {
  amharic: 'በ24 ሰዓታት ውስጥ',
  arabic: 'خلال 24 ساعة',
  bengali: '২৪ ঘণ্টার মধ্যে',
  chinese: '24 小时内',
  english: 'Within 24 hours',
  estonian: '24 tunni jooksul',
  filipino: 'Sa loob ng 24 oras',
  french: 'Sous 24 heures',
  german: 'Innerhalb von 24 Stunden',
  hindi: '24 घंटे के भीतर',
  indonesian: 'Dalam 24 jam',
  japanese: '24時間以内',
  korean: '24시간 이내',
  portuguese: 'Em até 24 horas',
  russian: 'В течение 24 часов',
  spanish: 'En menos de 24 horas',
  swahili: 'Ndani ya saa 24',
  vietnamese: 'Trong vòng 24 giờ',
};
export const rdContactRespBusiness: Translation = {
  amharic: 'ሰኞ–ዓርብ፣ 9AM–6PM',
  arabic: 'الاثنين–الجمعة، 9 ص–6 م',
  bengali: 'সোম–শুক্র, সকাল ৯টা–সন্ধ্যা ৬টা',
  chinese: '周一至周五 9:00–18:00',
  english: 'Mon–Fri, 9AM–6PM',
  estonian: 'E–R, 9–18',
  filipino: 'Lun–Biy, 9AM–6PM',
  french: 'Lun–ven, 9h–18h',
  german: 'Mo–Fr, 9–18 Uhr',
  hindi: 'सोम–शुक्र, सुबह 9–शाम 6',
  indonesian: 'Sen–Jum, 09.00–18.00',
  japanese: '月〜金 9:00〜18:00',
  korean: '월–금, 오전 9시–오후 6시',
  portuguese: 'Seg–Sex, 9h–18h',
  russian: 'Пн–Пт, 9:00–18:00',
  spanish: 'Lun–Vie, 9–18 h',
  swahili: 'Jumatatu–Ijumaa, 9AM–6PM',
  vietnamese: 'Thứ 2–6, 9h–18h',
};

export const navPrivacy: Translation = {
  amharic: 'ግላዊነት',
  arabic: 'الخصوصية',
  bengali: 'গোপনীয়তা',
  chinese: '隐私',
  english: 'Privacy',
  estonian: 'Privaatsus',
  filipino: 'Privacy',
  french: 'Confidentialité',
  german: 'Datenschutz',
  hindi: 'गोपनीयता',
  indonesian: 'Privasi',
  japanese: 'プライバシー',
  korean: '개인정보',
  portuguese: 'Privacidade',
  russian: 'Конфиденциальность',
  spanish: 'Privacidad',
  swahili: 'Faragha',
  vietnamese: 'Quyền riêng tư',
};

export const navTerms: Translation = {
  amharic: 'ውሎች',
  arabic: 'الشروط',
  bengali: 'শর্তাবলী',
  chinese: '条款',
  english: 'Terms',
  estonian: 'Tingimused',
  filipino: 'Mga Tuntunin',
  french: 'Conditions',
  german: 'Bedingungen',
  hindi: 'शर्तें',
  indonesian: 'Ketentuan',
  japanese: '規約',
  korean: '약관',
  portuguese: 'Termos',
  russian: 'Условия',
  spanish: 'Términos',
  swahili: 'Masharti',
  vietnamese: 'Điều khoản',
};

export const navCookies: Translation = {
  amharic: 'ኩኪዎች',
  arabic: 'ملفات الارتباط',
  bengali: 'কুকিজ',
  chinese: 'Cookie',
  english: 'Cookies',
  estonian: 'Küpsised',
  filipino: 'Cookies',
  french: 'Cookies',
  german: 'Cookies',
  hindi: 'कुकीज़',
  indonesian: 'Cookie',
  japanese: 'クッキー',
  korean: '쿠키',
  portuguese: 'Cookies',
  russian: 'Cookie',
  spanish: 'Cookies',
  swahili: 'Vidakuzi',
  vietnamese: 'Cookie',
};

export const skipToContent: Translation = {
  amharic: 'ወደ ዋናው ይዘት ዝለል',
  arabic: 'تخطّ إلى المحتوى الرئيسي',
  bengali: 'মূল বিষয়বস্তুতে যান',
  chinese: '跳到主要内容',
  english: 'Skip to main content',
  estonian: 'Liigu põhisisu juurde',
  filipino: 'Lumaktaw sa pangunahing nilalaman',
  french: 'Passer au contenu principal',
  german: 'Zum Hauptinhalt springen',
  hindi: 'मुख्य सामग्री पर जाएं',
  indonesian: 'Lewati ke konten utama',
  japanese: 'メインコンテンツへ移動',
  korean: '본문으로 건너뛰기',
  portuguese: 'Ir para o conteúdo principal',
  russian: 'Перейти к основному содержанию',
  spanish: 'Saltar al contenido principal',
  swahili: 'Rukia hadi maudhui makuu',
  vietnamese: 'Chuyển đến nội dung chính',
};

export const noscriptMessage: Translation = {
  amharic: 'ይህን መተግበሪያ ለማስኬድ JavaScript ማንቃት አለብዎት።',
  arabic: 'يجب تفعيل JavaScript لتشغيل هذا التطبيق.',
  bengali: 'এই অ্যাপটি চালাতে আপনাকে JavaScript সক্ষম করতে হবে।',
  chinese: '您需要启用 JavaScript 才能运行此应用。',
  english: 'You need to enable JavaScript to run this app.',
  estonian: 'Selle rakenduse käivitamiseks pead lubama JavaScripti.',
  filipino: 'Kailangan mong paganahin ang JavaScript para patakbuhin ang app na ito.',
  french: 'Vous devez activer JavaScript pour exécuter cette application.',
  german: 'Sie müssen JavaScript aktivieren, um diese App auszuführen.',
  hindi: 'इस ऐप को चलाने के लिए आपको JavaScript सक्षम करना होगा।',
  indonesian: 'Anda perlu mengaktifkan JavaScript untuk menjalankan aplikasi ini.',
  japanese: 'このアプリを実行するには JavaScript を有効にする必要があります。',
  korean: '이 앱을 실행하려면 JavaScript를 활성화해야 합니다.',
  portuguese: 'Você precisa ativar o JavaScript para executar este aplicativo.',
  russian: 'Для работы этого приложения необходимо включить JavaScript.',
  spanish: 'Necesitas habilitar JavaScript para ejecutar esta aplicación.',
  swahili: 'Unahitaji kuwezesha JavaScript ili kuendesha programu hii.',
  vietnamese: 'Bạn cần bật JavaScript để chạy ứng dụng này.',
};

export const errorFallbackMessage: Translation = {
  amharic: 'ውይ! የሆነ ስህተት ተፈጥሯል።',
  arabic: 'عذرًا! حدث خطأ ما.',
  bengali: 'ওহো! কিছু একটা ভুল হয়েছে।',
  chinese: '哎呀！出了点问题。',
  english: 'Oops! Something went wrong.',
  estonian: 'Oih! Midagi läks valesti.',
  filipino: 'Ay! May nangyaring mali.',
  french: 'Oups ! Une erreur est survenue.',
  german: 'Hoppla! Etwas ist schiefgelaufen.',
  hindi: 'ओह! कुछ गलत हो गया।',
  indonesian: 'Ups! Terjadi kesalahan.',
  japanese: 'おっと！問題が発生しました。',
  korean: '이런! 문제가 발생했습니다.',
  portuguese: 'Ops! Algo deu errado.',
  russian: 'Упс! Что-то пошло не так.',
  spanish: '¡Vaya! Algo salió mal.',
  swahili: 'Lo! Hitilafu imetokea.',
  vietnamese: 'Rất tiếc! Đã xảy ra lỗi.',
};

export const legalEyebrow: Translation = {
  amharic: 'ሕጋዊ',
  arabic: 'قانوني',
  bengali: 'আইনি',
  chinese: '法律',
  english: 'Legal',
  estonian: 'Õiguslik',
  filipino: 'Legal',
  french: 'Mentions légales',
  german: 'Rechtliches',
  hindi: 'कानूनी',
  indonesian: 'Hukum',
  japanese: '法的事項',
  korean: '법률',
  portuguese: 'Jurídico',
  russian: 'Юридическое',
  spanish: 'Legal',
  swahili: 'Kisheria',
  vietnamese: 'Pháp lý',
};

export const legalLastUpdated: Translation = {
  amharic: 'መጨረሻ የተዘመነው ሰኔ 16, 2026',
  arabic: 'آخر تحديث 16 يونيو 2026',
  bengali: 'সর্বশেষ আপডেট ১৬ জুন, ২০২৬',
  chinese: '最后更新于 2026 年 6 月 16 日',
  english: 'Last updated June 16, 2026',
  estonian: 'Viimati uuendatud 16. juuni 2026',
  filipino: 'Huling na-update Hunyo 16, 2026',
  french: 'Dernière mise à jour le 16 juin 2026',
  german: 'Zuletzt aktualisiert am 16. Juni 2026',
  hindi: 'अंतिम बार अपडेट किया गया 16 जून, 2026',
  indonesian: 'Terakhir diperbarui 16 Juni 2026',
  japanese: '最終更新日 2026年6月16日',
  korean: '최종 업데이트 2026년 6월 16일',
  portuguese: 'Última atualização em 16 de junho de 2026',
  russian: 'Последнее обновление 16 июня 2026 г.',
  spanish: 'Última actualización 16 de junio de 2026',
  swahili: 'Imesasishwa mwisho Juni 16, 2026',
  vietnamese: 'Cập nhật lần cuối ngày 16 tháng 6 năm 2026',
};

export const legalQuestionsEmail: Translation = {
  amharic: 'ጥያቄዎች? በ {email} ይላኩልን።',
  arabic: 'أسئلة؟ راسلنا على {email}.',
  bengali: 'প্রশ্ন আছে? আমাদের {email}-এ ইমেল করুন।',
  chinese: '有疑问？请发送电子邮件至 {email}。',
  english: 'Questions? Email us at {email}.',
  estonian: 'Küsimusi? Kirjuta meile aadressil {email}.',
  filipino: 'May tanong? Mag-email sa amin sa {email}.',
  french: 'Des questions ? Écrivez-nous à {email}.',
  german: 'Fragen? Schreiben Sie uns an {email}.',
  hindi: 'प्रश्न हैं? हमें {email} पर ईमेल करें।',
  indonesian: 'Ada pertanyaan? Email kami di {email}.',
  japanese: 'ご質問は {email} までメールでお問い合わせください。',
  korean: '문의 사항이 있으신가요? {email}으로 이메일을 보내주세요.',
  portuguese: 'Dúvidas? Envie-nos um e-mail para {email}.',
  russian: 'Вопросы? Напишите нам на {email}.',
  spanish: '¿Preguntas? Escríbenos a {email}.',
  swahili: 'Maswali? Tutumie barua pepe kwa {email}.',
  vietnamese: 'Có thắc mắc? Gửi email cho chúng tôi tại {email}.',
};

export const cookiePolicyMetaTitle: Translation = {
  amharic: 'የኩኪ ፖሊሲ',
  arabic: 'سياسة ملفات الارتباط',
  bengali: 'কুকি নীতি',
  chinese: 'Cookie 政策',
  english: 'Cookie Policy',
  estonian: 'Küpsiste poliitika',
  filipino: 'Patakaran sa Cookie',
  french: 'Politique de cookies',
  german: 'Cookie-Richtlinie',
  hindi: 'कुकी नीति',
  indonesian: 'Kebijakan Cookie',
  japanese: 'クッキーポリシー',
  korean: '쿠키 정책',
  portuguese: 'Política de Cookies',
  russian: 'Политика использования файлов cookie',
  spanish: 'Política de cookies',
  swahili: 'Sera ya Vidakuzi',
  vietnamese: 'Chính sách Cookie',
};

export const cookiePolicyMetaDescription: Translation = {
  amharic: 'Workadabra ኩኪዎችን እንዴት እንደሚጠቀም ይወቁ።',
  arabic: 'تعرّف على كيفية استخدام Workadabra لملفات الارتباط.',
  bengali: 'Workadabra কীভাবে কুকিজ ব্যবহার করে তা জানুন।',
  chinese: '了解 Workadabra 如何使用 Cookie。',
  english: 'Learn how Workadabra uses cookies.',
  estonian: 'Saa teada, kuidas Workadabra küpsiseid kasutab.',
  filipino: 'Alamin kung paano gumagamit ng cookies ang Workadabra.',
  french: 'Découvrez comment Workadabra utilise les cookies.',
  german: 'Erfahren Sie, wie Workadabra Cookies verwendet.',
  hindi: 'जानें कि Workadabra कुकीज़ का उपयोग कैसे करता है।',
  indonesian: 'Pelajari cara Workadabra menggunakan cookie.',
  japanese: 'Workadabra のクッキーの使用方法をご覧ください。',
  korean: 'Workadabra가 쿠키를 사용하는 방법을 알아보세요.',
  portuguese: 'Saiba como a Workadabra utiliza cookies.',
  russian: 'Узнайте, как Workadabra использует файлы cookie.',
  spanish: 'Descubre cómo Workadabra utiliza las cookies.',
  swahili: 'Jifunze jinsi Workadabra inavyotumia vidakuzi.',
  vietnamese: 'Tìm hiểu cách Workadabra sử dụng cookie.',
};

export const cookiePolicyIntro: Translation = {
  amharic: 'ይህ ፖሊሲ Workadabra በ workadabra.com እና በ Workadabra መተግበሪያ ውስጥ ኩኪዎችን እና ተመሳሳይ ቴክኖሎጂዎችን እንዴት እንደሚጠቀም ያብራራል።',
  arabic: 'توضّح هذه السياسة كيفية استخدام Workadabra لملفات الارتباط والتقنيات المماثلة على workadabra.com وفي تطبيق Workadabra.',
  bengali: 'এই নীতিটি ব্যাখ্যা করে যে Workadabra কীভাবে workadabra.com এবং Workadabra অ্যাপে কুকিজ ও অনুরূপ প্রযুক্তি ব্যবহার করে।',
  chinese: '本政策说明 Workadabra 如何在 workadabra.com 及 Workadabra 应用中使用 Cookie 和类似技术。',
  english: 'This policy explains how Workadabra uses cookies and similar technologies on workadabra.com and in the Workadabra app.',
  estonian: 'See poliitika selgitab, kuidas Workadabra kasutab küpsiseid ja sarnaseid tehnoloogiaid veebilehel workadabra.com ja Workadabra rakenduses.',
  filipino: 'Ipinapaliwanag ng patakarang ito kung paano gumagamit ang Workadabra ng cookies at mga katulad na teknolohiya sa workadabra.com at sa Workadabra app.',
  french: 'Cette politique explique comment Workadabra utilise les cookies et technologies similaires sur workadabra.com et dans l’application Workadabra.',
  german: 'Diese Richtlinie erläutert, wie Workadabra Cookies und ähnliche Technologien auf workadabra.com und in der Workadabra-App verwendet.',
  hindi: 'यह नीति बताती है कि Workadabra workadabra.com और Workadabra ऐप पर कुकीज़ और समान तकनीकों का उपयोग कैसे करता है।',
  indonesian: 'Kebijakan ini menjelaskan cara Workadabra menggunakan cookie dan teknologi serupa di workadabra.com dan di aplikasi Workadabra.',
  japanese: 'このポリシーでは、Workadabra が workadabra.com および Workadabra アプリでクッキーや類似の技術をどのように使用するかを説明します。',
  korean: '이 정책은 Workadabra가 workadabra.com과 Workadabra 앱에서 쿠키 및 유사 기술을 사용하는 방법을 설명합니다.',
  portuguese: 'Esta política explica como a Workadabra usa cookies e tecnologias semelhantes no workadabra.com e no aplicativo Workadabra.',
  russian: 'Эта политика объясняет, как Workadabra использует файлы cookie и аналогичные технологии на workadabra.com и в приложении Workadabra.',
  spanish: 'Esta política explica cómo Workadabra utiliza cookies y tecnologías similares en workadabra.com y en la aplicación Workadabra.',
  swahili: 'Sera hii inaeleza jinsi Workadabra inavyotumia vidakuzi na teknolojia zinazofanana kwenye workadabra.com na katika programu ya Workadabra.',
  vietnamese: 'Chính sách này giải thích cách Workadabra sử dụng cookie và các công nghệ tương tự trên workadabra.com và trong ứng dụng Workadabra.',
};

export const cookiePolicyCookiesWeUseHeading: Translation = {
  amharic: 'የምንጠቀምባቸው ኩኪዎች',
  arabic: 'ملفات الارتباط التي نستخدمها',
  bengali: 'আমরা যে কুকিজ ব্যবহার করি',
  chinese: '我们使用的 Cookie',
  english: 'Cookies we use',
  estonian: 'Küpsised, mida kasutame',
  filipino: 'Mga cookie na ginagamit namin',
  french: 'Cookies que nous utilisons',
  german: 'Von uns verwendete Cookies',
  hindi: 'हम जिन कुकीज़ का उपयोग करते हैं',
  indonesian: 'Cookie yang kami gunakan',
  japanese: '当社が使用するクッキー',
  korean: '당사가 사용하는 쿠키',
  portuguese: 'Cookies que utilizamos',
  russian: 'Используемые нами файлы cookie',
  spanish: 'Cookies que utilizamos',
  swahili: 'Vidakuzi tunavyotumia',
  vietnamese: 'Cookie chúng tôi sử dụng',
};

export const cookiePolicyEssential: Translation = {
  amharic: 'አስፈላጊ: መግቢያ፣ ደህንነት እና የቋንቋ እና የገጽታ ምርጫዎን ማስታወስ።',
  arabic: 'أساسية: تسجيل الدخول والأمان وتذكّر تفضيلات اللغة والمظهر لديك.',
  bengali: 'অপরিহার্য: সাইন-ইন, নিরাপত্তা এবং আপনার ভাষা ও থিম পছন্দ মনে রাখা।',
  chinese: '必要: 登录、安全，以及记住您的语言和主题偏好。',
  english: 'Essential: sign-in, security, and remembering your language and theme preference.',
  estonian: 'Hädavajalikud: sisselogimine, turvalisus ning sinu keele- ja teemaeelistuse meeldejätmine.',
  filipino: 'Mahalaga: pag-sign in, seguridad, at pag-alala sa iyong wika at tema preference.',
  french: 'Essentiels : connexion, sécurité et mémorisation de vos préférences de langue et de thème.',
  german: 'Unverzichtbar: Anmeldung, Sicherheit und Speicherung Ihrer Sprach- und Designeinstellung.',
  hindi: 'आवश्यक: साइन-इन, सुरक्षा, और आपकी भाषा व थीम वरीयता को याद रखना।',
  indonesian: 'Penting: masuk, keamanan, dan mengingat preferensi bahasa dan tema Anda.',
  japanese: '必須: サインイン、セキュリティ、言語とテーマの設定の記憶。',
  korean: '필수: 로그인, 보안, 언어 및 테마 환경설정 기억.',
  portuguese: 'Essenciais: login, segurança e memorização das suas preferências de idioma e tema.',
  russian: 'Необходимые: вход, безопасность и сохранение ваших настроек языка и темы.',
  spanish: 'Esenciales: inicio de sesión, seguridad y memorización de tus preferencias de idioma y tema.',
  swahili: 'Muhimu: kuingia, usalama, na kukumbuka mapendeleo yako ya lugha na mandhari.',
  vietnamese: 'Thiết yếu: đăng nhập, bảo mật và ghi nhớ tùy chọn ngôn ngữ và giao diện của bạn.',
};

export const cookiePolicyAnalytics: Translation = {
  amharic: 'ትንታኔ: ምርቱን ለማሻሻል የማይታወቅ አጠቃቀም።',
  arabic: 'تحليلات: استخدام مجهول الهوية لمساعدتنا على تحسين المنتج.',
  bengali: 'অ্যানালিটিক্স: পণ্যটি উন্নত করতে বেনামী ব্যবহার।',
  chinese: '分析: 匿名使用数据，帮助我们改进产品。',
  english: 'Analytics: anonymous usage so we can improve the product.',
  estonian: 'Analüütika: anonüümne kasutus, et saaksime toodet parandada.',
  filipino: 'Analytics: anonymous na paggamit upang mapabuti namin ang produkto.',
  french: 'Analytique : utilisation anonyme pour améliorer le produit.',
  german: 'Analyse: anonyme Nutzung, damit wir das Produkt verbessern können.',
  hindi: 'एनालिटिक्स: अनाम उपयोग ताकि हम उत्पाद को बेहतर बना सकें।',
  indonesian: 'Analitik: penggunaan anonim agar kami dapat meningkatkan produk.',
  japanese: '分析: 製品を改善するための匿名の利用状況。',
  korean: '분석: 제품을 개선할 수 있도록 익명 사용 데이터.',
  portuguese: 'Análise: uso anônimo para que possamos melhorar o produto.',
  russian: 'Аналитика: анонимное использование, чтобы мы могли улучшать продукт.',
  spanish: 'Analítica: uso anónimo para que podamos mejorar el producto.',
  swahili: 'Uchanganuzi: matumizi yasiyojulikana ili tuweze kuboresha bidhaa.',
  vietnamese: 'Phân tích: sử dụng ẩn danh để chúng tôi cải thiện sản phẩm.',
};

export const cookiePolicyPreferences: Translation = {
  amharic: 'ምርጫዎች: ተሞክሮውን የእርስዎ የሚያደርጉ ትናንሽ ቅንብሮች።',
  arabic: 'التفضيلات: إعدادات صغيرة تجعل التجربة خاصة بك.',
  bengali: 'পছন্দসমূহ: ছোট সেটিংস যা অভিজ্ঞতাকে আপনার করে তোলে।',
  chinese: '偏好: 让体验更符合您需求的小设置。',
  english: 'Preferences: small settings that make the experience yours.',
  estonian: 'Eelistused: väikesed sätted, mis muudavad kogemuse sinu omaks.',
  filipino: 'Mga Kagustuhan: maliliit na setting na nagpapasaiyo ng karanasan.',
  french: 'Préférences : petits réglages qui personnalisent votre expérience.',
  german: 'Einstellungen: kleine Einstellungen, die das Erlebnis zu Ihrem machen.',
  hindi: 'प्राथमिकताएं: छोटी सेटिंग्स जो अनुभव को आपका बनाती हैं।',
  indonesian: 'Preferensi: pengaturan kecil yang membuat pengalaman menjadi milik Anda.',
  japanese: '設定: 体験をあなた仕様にする小さな設定。',
  korean: '환경설정: 경험을 나만의 것으로 만드는 작은 설정.',
  portuguese: 'Preferências: pequenas configurações que tornam a experiência sua.',
  russian: 'Предпочтения: небольшие настройки, которые делают взаимодействие вашим.',
  spanish: 'Preferencias: pequeños ajustes que hacen tuya la experiencia.',
  swahili: 'Mapendeleo: mipangilio midogo inayofanya tajriba kuwa yako.',
  vietnamese: 'Tùy chọn: các cài đặt nhỏ giúp trải nghiệm là của riêng bạn.',
};

export const cookiePolicyManagingHeading: Translation = {
  amharic: 'ኩኪዎችን ማስተዳደር',
  arabic: 'إدارة ملفات الارتباط',
  bengali: 'কুকিজ পরিচালনা',
  chinese: '管理 Cookie',
  english: 'Managing cookies',
  estonian: 'Küpsiste haldamine',
  filipino: 'Pamamahala ng cookies',
  french: 'Gérer les cookies',
  german: 'Cookies verwalten',
  hindi: 'कुकीज़ प्रबंधित करना',
  indonesian: 'Mengelola cookie',
  japanese: 'クッキーの管理',
  korean: '쿠키 관리',
  portuguese: 'Gerir cookies',
  russian: 'Управление файлами cookie',
  spanish: 'Gestionar cookies',
  swahili: 'Kudhibiti vidakuzi',
  vietnamese: 'Quản lý cookie',
};

export const cookiePolicyManagingBody: Translation = {
  amharic: 'ኩኪዎችን በአሳሽዎ ቅንብሮች ውስጥ ማጽዳት ወይም ማገድ ይችላሉ፤ ጣቢያው እንዲሰራ አስፈላጊ ኩኪዎች ያስፈልጋሉ።',
  arabic: 'يمكنك مسح أو حظر ملفات الارتباط من إعدادات متصفحك؛ ملفات الارتباط الأساسية مطلوبة لكي يعمل الموقع.',
  bengali: 'আপনি আপনার ব্রাউজার সেটিংসে কুকিজ মুছতে বা ব্লক করতে পারেন; সাইটটি কাজ করার জন্য অপরিহার্য কুকিজ প্রয়োজন।',
  chinese: '您可以在浏览器设置中清除或阻止 Cookie；网站正常运行需要必要的 Cookie。',
  english: 'You can clear or block cookies in your browser settings; essential cookies are required for the site to work.',
  estonian: 'Saad küpsiseid kustutada või blokeerida oma brauseri sätetes; hädavajalikud küpsised on saidi toimimiseks vajalikud.',
  filipino: 'Maaari mong i-clear o i-block ang cookies sa mga setting ng iyong browser; kinakailangan ang essential cookies para gumana ang site.',
  french: 'Vous pouvez effacer ou bloquer les cookies dans les paramètres de votre navigateur ; les cookies essentiels sont nécessaires au fonctionnement du site.',
  german: 'Sie können Cookies in Ihren Browsereinstellungen löschen oder blockieren; unverzichtbare Cookies sind für die Funktion der Website erforderlich.',
  hindi: 'आप अपने ब्राउज़र सेटिंग्स में कुकीज़ साफ़ या ब्लॉक कर सकते हैं; साइट के काम करने के लिए आवश्यक कुकीज़ ज़रूरी हैं।',
  indonesian: 'Anda dapat menghapus atau memblokir cookie di pengaturan browser Anda; cookie penting diperlukan agar situs berfungsi.',
  japanese: 'ブラウザの設定でクッキーを消去またはブロックできます。サイトの動作には必須クッキーが必要です。',
  korean: '브라우저 설정에서 쿠키를 지우거나 차단할 수 있습니다. 사이트가 작동하려면 필수 쿠키가 필요합니다.',
  portuguese: 'Você pode limpar ou bloquear cookies nas configurações do seu navegador; cookies essenciais são necessários para o site funcionar.',
  russian: 'Вы можете удалить или заблокировать файлы cookie в настройках браузера; необходимые файлы cookie требуются для работы сайта.',
  spanish: 'Puedes borrar o bloquear las cookies en la configuración de tu navegador; las cookies esenciales son necesarias para que el sitio funcione.',
  swahili: 'Unaweza kufuta au kuzuia vidakuzi katika mipangilio ya kivinjari chako; vidakuzi muhimu vinahitajika ili tovuti ifanye kazi.',
  vietnamese: 'Bạn có thể xóa hoặc chặn cookie trong cài đặt trình duyệt; cookie thiết yếu là bắt buộc để trang web hoạt động.',
};

export const gdprMetaTitle: Translation = {
  amharic: 'GDPR',
  arabic: 'اللائحة العامة لحماية البيانات',
  bengali: 'GDPR',
  chinese: 'GDPR',
  english: 'GDPR',
  estonian: 'GDPR',
  filipino: 'GDPR',
  french: 'RGPD',
  german: 'DSGVO',
  hindi: 'GDPR',
  indonesian: 'GDPR',
  japanese: 'GDPR',
  korean: 'GDPR',
  portuguese: 'GDPR',
  russian: 'GDPR',
  spanish: 'GDPR',
  swahili: 'GDPR',
  vietnamese: 'GDPR',
};

export const gdprMetaDescription: Translation = {
  amharic: 'በ GDPR መሠረት የውሂብ መብቶችዎን Workadabra እንዴት እንደሚያከብር ይወቁ።',
  arabic: 'تعرّف على كيفية احترام Workadabra لحقوق بياناتك بموجب اللائحة العامة لحماية البيانات.',
  bengali: 'GDPR-এর অধীনে Workadabra কীভাবে আপনার ডেটা অধিকারকে সম্মান করে তা জানুন।',
  chinese: '了解 Workadabra 如何根据 GDPR 尊重您的数据权利。',
  english: 'Learn how Workadabra honours your data rights under the GDPR.',
  estonian: 'Saa teada, kuidas Workadabra austab sinu andmeõigusi GDPR-i alusel.',
  filipino: 'Alamin kung paano iginagalang ng Workadabra ang iyong mga karapatan sa data sa ilalim ng GDPR.',
  french: 'Découvrez comment Workadabra respecte vos droits sur les données dans le cadre du RGPD.',
  german: 'Erfahren Sie, wie Workadabra Ihre Datenrechte gemäß der DSGVO wahrt.',
  hindi: 'जानें कि Workadabra GDPR के तहत आपके डेटा अधिकारों का सम्मान कैसे करता है।',
  indonesian: 'Pelajari cara Workadabra menghormati hak data Anda berdasarkan GDPR.',
  japanese: 'GDPR の下で Workadabra がお客様のデータ権利をどのように尊重するかをご覧ください。',
  korean: 'Workadabra가 GDPR에 따라 귀하의 데이터 권리를 어떻게 존중하는지 알아보세요.',
  portuguese: 'Saiba como a Workadabra respeita os seus direitos de dados ao abrigo do RGPD.',
  russian: 'Узнайте, как Workadabra соблюдает ваши права на данные в соответствии с GDPR.',
  spanish: 'Descubre cómo Workadabra respeta tus derechos de datos conforme al RGPD.',
  swahili: 'Jifunze jinsi Workadabra inavyoheshimu haki zako za data chini ya GDPR.',
  vietnamese: 'Tìm hiểu cách Workadabra tôn trọng quyền dữ liệu của bạn theo GDPR.',
};

export const gdprIntro: Translation = {
  amharic: 'በ EU/EEA ወይም በዩኬ ውስጥ ከሆኑ፣ የጠቅላላ የውሂብ ጥበቃ ደንብ በግል ውሂብዎ ላይ መብቶችን ይሰጥዎታል። ይህ ገጽ Workadabra እነዚህን እንዴት እንደሚያከብር ያጠቃልላል።',
  arabic: 'إذا كنت في الاتحاد الأوروبي/المنطقة الاقتصادية الأوروبية أو المملكة المتحدة، فإن اللائحة العامة لحماية البيانات تمنحك حقوقًا على بياناتك الشخصية. تلخّص هذه الصفحة كيفية احترام Workadabra لها.',
  bengali: 'আপনি যদি EU/EEA বা যুক্তরাজ্যে থাকেন, জেনারেল ডেটা প্রোটেকশন রেগুলেশন আপনাকে আপনার ব্যক্তিগত ডেটার উপর অধিকার দেয়। এই পৃষ্ঠাটি সংক্ষেপে জানায় Workadabra কীভাবে সেগুলো সম্মান করে।',
  chinese: '如果您位于欧盟/欧洲经济区或英国，《通用数据保护条例》赋予您对个人数据的权利。本页概述 Workadabra 如何尊重这些权利。',
  english: 'If you are in the EU/EEA or UK, the General Data Protection Regulation gives you rights over your personal data. This page summarises how Workadabra honours them.',
  estonian: 'Kui asud ELis/EMPs või Ühendkuningriigis, annab isikuandmete kaitse üldmäärus sulle õigused oma isikuandmete üle. See leht võtab kokku, kuidas Workadabra neid austab.',
  filipino: 'Kung nasa EU/EEA o UK ka, binibigyan ka ng General Data Protection Regulation ng mga karapatan sa iyong personal na data. Binubuod ng pahinang ito kung paano ito iginagalang ng Workadabra.',
  french: 'Si vous êtes dans l’UE/EEE ou au Royaume-Uni, le Règlement général sur la protection des données vous confère des droits sur vos données personnelles. Cette page résume comment Workadabra les respecte.',
  german: 'Wenn Sie sich in der EU/dem EWR oder im Vereinigten Königreich befinden, gewährt Ihnen die Datenschutz-Grundverordnung Rechte an Ihren personenbezogenen Daten. Diese Seite fasst zusammen, wie Workadabra sie wahrt.',
  hindi: 'यदि आप EU/EEA या UK में हैं, तो जनरल डेटा प्रोटेक्शन रेगुलेशन आपको अपने व्यक्तिगत डेटा पर अधिकार देता है। यह पृष्ठ बताता है कि Workadabra इनका सम्मान कैसे करता है।',
  indonesian: 'Jika Anda berada di UE/EEA atau Inggris, General Data Protection Regulation memberi Anda hak atas data pribadi Anda. Halaman ini merangkum cara Workadabra menghormatinya.',
  japanese: 'EU/EEA または英国にお住まいの場合、一般データ保護規則によりお客様の個人データに対する権利が認められます。このページでは Workadabra がそれらをどのように尊重するかを要約します。',
  korean: 'EU/EEA 또는 영국에 거주하는 경우 일반 데이터 보호 규정(GDPR)에 따라 개인 데이터에 대한 권리가 부여됩니다. 이 페이지는 Workadabra가 이를 어떻게 존중하는지 요약합니다.',
  portuguese: 'Se você estiver na UE/EEE ou no Reino Unido, o Regulamento Geral sobre a Proteção de Dados concede-lhe direitos sobre os seus dados pessoais. Esta página resume como a Workadabra os respeita.',
  russian: 'Если вы находитесь в ЕС/ЕЭЗ или Великобритании, Общий регламент по защите данных предоставляет вам права на ваши персональные данные. На этой странице кратко описано, как Workadabra их соблюдает.',
  spanish: 'Si te encuentras en la UE/EEE o el Reino Unido, el Reglamento General de Protección de Datos te otorga derechos sobre tus datos personales. Esta página resume cómo Workadabra los respeta.',
  swahili: 'Ikiwa uko katika EU/EEA au Uingereza, Kanuni ya Jumla ya Ulinzi wa Data inakupa haki juu ya data yako binafsi. Ukurasa huu unafupisha jinsi Workadabra inavyoziheshimu.',
  vietnamese: 'Nếu bạn ở EU/EEA hoặc Vương quốc Anh, Quy định chung về bảo vệ dữ liệu trao cho bạn các quyền đối với dữ liệu cá nhân của bạn. Trang này tóm tắt cách Workadabra tôn trọng chúng.',
};

export const gdprYourRightsHeading: Translation = {
  amharic: 'መብቶችዎ',
  arabic: 'حقوقك',
  bengali: 'আপনার অধিকার',
  chinese: '您的权利',
  english: 'Your rights',
  estonian: 'Sinu õigused',
  filipino: 'Iyong mga karapatan',
  french: 'Vos droits',
  german: 'Ihre Rechte',
  hindi: 'आपके अधिकार',
  indonesian: 'Hak Anda',
  japanese: 'お客様の権利',
  korean: '귀하의 권리',
  portuguese: 'Os seus direitos',
  russian: 'Ваши права',
  spanish: 'Tus derechos',
  swahili: 'Haki zako',
  vietnamese: 'Quyền của bạn',
};

export const gdprRightAccess: Translation = {
  amharic: 'የግል ውሂብዎን ይድረሱ፣ ያስተካክሉ ወይም ይሰርዙ።',
  arabic: 'الوصول إلى بياناتك الشخصية أو تصحيحها أو حذفها.',
  bengali: 'আপনার ব্যক্তিগত ডেটা অ্যাক্সেস, সংশোধন বা মুছে ফেলুন।',
  chinese: '访问、更正或删除您的个人数据。',
  english: 'Access, correct, or delete your personal data.',
  estonian: 'Pääse ligi oma isikuandmetele, paranda või kustuta need.',
  filipino: 'I-access, itama, o tanggalin ang iyong personal na data.',
  french: 'Accéder à vos données personnelles, les corriger ou les supprimer.',
  german: 'Zugriff auf Ihre personenbezogenen Daten, deren Berichtigung oder Löschung.',
  hindi: 'अपने व्यक्तिगत डेटा तक पहुंचें, सुधारें या हटाएं।',
  indonesian: 'Mengakses, memperbaiki, atau menghapus data pribadi Anda.',
  japanese: '個人データへのアクセス、訂正、削除。',
  korean: '개인 데이터에 접근, 수정 또는 삭제.',
  portuguese: 'Aceder, corrigir ou eliminar os seus dados pessoais.',
  russian: 'Доступ к вашим персональным данным, их исправление или удаление.',
  spanish: 'Acceder, corregir o eliminar tus datos personales.',
  swahili: 'Fikia, sahihisha, au futa data yako binafsi.',
  vietnamese: 'Truy cập, chỉnh sửa hoặc xóa dữ liệu cá nhân của bạn.',
};

export const gdprRightExport: Translation = {
  amharic: 'ውሂብዎን በተንቀሳቃሽ ቅርጸት ይላኩ።',
  arabic: 'تصدير بياناتك بصيغة قابلة للنقل.',
  bengali: 'আপনার ডেটা পোর্টেবল ফরম্যাটে এক্সপোর্ট করুন।',
  chinese: '以可移植格式导出您的数据。',
  english: 'Export your data in a portable format.',
  estonian: 'Ekspordi oma andmed teisaldatavas vormingus.',
  filipino: 'I-export ang iyong data sa portable na format.',
  french: 'Exporter vos données dans un format portable.',
  german: 'Exportieren Sie Ihre Daten in einem portablen Format.',
  hindi: 'अपने डेटा को पोर्टेबल प्रारूप में निर्यात करें।',
  indonesian: 'Mengekspor data Anda dalam format portabel.',
  japanese: 'データをポータブル形式でエクスポート。',
  korean: '데이터를 이동 가능한 형식으로 내보내기.',
  portuguese: 'Exportar os seus dados num formato portátil.',
  russian: 'Экспорт ваших данных в переносимом формате.',
  spanish: 'Exportar tus datos en un formato portátil.',
  swahili: 'Hamisha data yako katika muundo unaohamishika.',
  vietnamese: 'Xuất dữ liệu của bạn ở định dạng di động.',
};

export const gdprRightRestrict: Translation = {
  amharic: 'የተወሰነ ሂደትን ይገድቡ ወይም ይቃወሙ፣ እና ፈቃድን ይውሰዱ።',
  arabic: 'تقييد معالجة معيّنة أو الاعتراض عليها، وسحب الموافقة.',
  bengali: 'নির্দিষ্ট প্রক্রিয়াকরণ সীমিত বা আপত্তি জানান এবং সম্মতি প্রত্যাহার করুন।',
  chinese: '限制或反对某些处理，并撤回同意。',
  english: 'Restrict or object to certain processing, and withdraw consent.',
  estonian: 'Piira teatud töötlemist või esita selle suhtes vastuväiteid ja võta nõusolek tagasi.',
  filipino: 'Paghigpitan o tutulan ang ilang pagproseso, at bawiin ang pahintulot.',
  french: 'Limiter certains traitements ou vous y opposer, et retirer votre consentement.',
  german: 'Bestimmte Verarbeitungen einschränken oder ihnen widersprechen und die Einwilligung widerrufen.',
  hindi: 'कुछ प्रसंस्करण को प्रतिबंधित या आपत्ति करें, और सहमति वापस लें।',
  indonesian: 'Membatasi atau menolak pemrosesan tertentu, dan menarik persetujuan.',
  japanese: '特定の処理を制限または異議を申し立て、同意を撤回。',
  korean: '특정 처리를 제한하거나 이의를 제기하고 동의를 철회.',
  portuguese: 'Restringir ou opor-se a determinado tratamento e retirar o consentimento.',
  russian: 'Ограничить определённую обработку или возразить против неё и отозвать согласие.',
  spanish: 'Restringir u oponerte a ciertos tratamientos y retirar el consentimiento.',
  swahili: 'Zuia au kupinga uchakataji fulani, na uondoe idhini.',
  vietnamese: 'Hạn chế hoặc phản đối một số hoạt động xử lý nhất định và rút lại sự đồng ý.',
};

export const gdprRightComplaint: Translation = {
  amharic: 'ለአካባቢዎ ቁጥጥር ባለሥልጣን ቅሬታ ያቅርቡ።',
  arabic: 'تقديم شكوى لدى السلطة الإشرافية المحلية لديك.',
  bengali: 'আপনার স্থানীয় তত্ত্বাবধায়ক কর্তৃপক্ষের কাছে অভিযোগ দায়ের করুন।',
  chinese: '向您当地的监管机构提出投诉。',
  english: 'Lodge a complaint with your local supervisory authority.',
  estonian: 'Esita kaebus oma kohalikule järelevalveasutusele.',
  filipino: 'Maghain ng reklamo sa iyong lokal na supervisory authority.',
  french: 'Déposer une plainte auprès de votre autorité de contrôle locale.',
  german: 'Eine Beschwerde bei Ihrer örtlichen Aufsichtsbehörde einreichen.',
  hindi: 'अपने स्थानीय पर्यवेक्षी प्राधिकरण के पास शिकायत दर्ज करें।',
  indonesian: 'Mengajukan keluhan ke otoritas pengawas setempat Anda.',
  japanese: '地域の監督機関に苦情を申し立てる。',
  korean: '현지 감독 기관에 불만을 제기.',
  portuguese: 'Apresentar uma reclamação à sua autoridade de controlo local.',
  russian: 'Подать жалобу в местный надзорный орган.',
  spanish: 'Presentar una reclamación ante tu autoridad de control local.',
  swahili: 'Wasilisha malalamiko kwa mamlaka yako ya usimamizi ya eneo lako.',
  vietnamese: 'Gửi khiếu nại đến cơ quan giám sát địa phương của bạn.',
};

export const gdprLawfulBasisHeading: Translation = {
  amharic: 'ሕጋዊ መሠረት እና ጥያቄዎች',
  arabic: 'الأساس القانوني والطلبات',
  bengali: 'আইনি ভিত্তি ও অনুরোধ',
  chinese: '合法依据与请求',
  english: 'Lawful basis & requests',
  estonian: 'Õiguslik alus ja taotlused',
  filipino: 'Legal na batayan at mga kahilingan',
  french: 'Base légale et demandes',
  german: 'Rechtsgrundlage & Anfragen',
  hindi: 'कानूनी आधार और अनुरोध',
  indonesian: 'Dasar hukum & permintaan',
  japanese: '法的根拠とリクエスト',
  korean: '법적 근거 및 요청',
  portuguese: 'Base legal e pedidos',
  russian: 'Правовое основание и запросы',
  spanish: 'Base jurídica y solicitudes',
  swahili: 'Msingi wa kisheria na maombi',
  vietnamese: 'Cơ sở pháp lý & yêu cầu',
};

export const gdprLawfulBasisBody: Translation = {
  amharic: 'አገልግሎቱን ለማቅረብ (ውል)፣ ማኅበረሰቡን ደህንነቱ የተጠበቀ ለማድረግ እና ሕጋዊ ግዴታዎችን ለማሟላት እና በሚያስፈልግበት ጊዜ በፈቃድዎ ውሂብ እንሰራለን። ማንኛውንም መብት ለመጠቀም በ {email} ይላኩ፣ በአንድ ወር ውስጥ እንመልሳለን።',
  arabic: 'نعالج البيانات لتقديم الخدمة (عقد)، وللحفاظ على أمان المجتمع والوفاء بالالتزامات القانونية، وبموافقتك عند الحاجة. لممارسة أي حق، راسلنا على {email}، نردّ خلال شهر واحد.',
  bengali: 'আমরা পরিষেবা প্রদানের জন্য (চুক্তি), সম্প্রদায়কে নিরাপদ রাখতে ও আইনি বাধ্যবাধকতা পূরণ করতে এবং প্রয়োজনে আপনার সম্মতিতে ডেটা প্রক্রিয়া করি। যেকোনো অধিকার প্রয়োগ করতে {email}-এ ইমেল করুন, আমরা এক মাসের মধ্যে সাড়া দিই।',
  chinese: '我们处理数据是为了提供服务（合同）、保障社区安全并履行法律义务，并在需要时取得您的同意。要行使任何权利，请发送电子邮件至 {email}，我们将在一个月内回复。',
  english: 'We process data to provide the service (contract), to keep the community safe and meet legal obligations, and with your consent where required. To exercise any right, email {email}, we respond within one month.',
  estonian: 'Töötleme andmeid teenuse osutamiseks (leping), kogukonna turvalisena hoidmiseks ja juriidiliste kohustuste täitmiseks ning vajaduse korral sinu nõusolekul. Mis tahes õiguse kasutamiseks kirjuta aadressil {email}, vastame ühe kuu jooksul.',
  filipino:
    'Pinoproseso namin ang data upang maibigay ang serbisyo (kontrata), upang panatilihing ligtas ang komunidad at matugunan ang mga legal na obligasyon, at sa iyong pahintulot kung kinakailangan. Upang gamitin ang anumang karapatan, mag-email sa {email}, tumutugon kami sa loob ng isang buwan.',
  french: 'Nous traitons les données pour fournir le service (contrat), assurer la sécurité de la communauté et respecter nos obligations légales, et avec votre consentement le cas échéant. Pour exercer un droit, écrivez à {email}, nous répondons sous un mois.',
  german: 'Wir verarbeiten Daten, um den Dienst bereitzustellen (Vertrag), die Community sicher zu halten und gesetzliche Pflichten zu erfüllen, sowie bei Bedarf mit Ihrer Einwilligung. Um ein Recht auszuüben, schreiben Sie an {email}, wir antworten innerhalb eines Monats.',
  hindi: 'हम सेवा प्रदान करने (अनुबंध) के लिए, समुदाय को सुरक्षित रखने और कानूनी दायित्वों को पूरा करने के लिए, और जहां आवश्यक हो आपकी सहमति से डेटा संसाधित करते हैं। किसी भी अधिकार का उपयोग करने के लिए {email} पर ईमेल करें, हम एक महीने के भीतर जवाब देते हैं।',
  indonesian: 'Kami memproses data untuk menyediakan layanan (kontrak), menjaga keamanan komunitas dan memenuhi kewajiban hukum, serta dengan persetujuan Anda bila diperlukan. Untuk menggunakan hak apa pun, email {email}, kami merespons dalam satu bulan.',
  japanese: '当社は、サービスの提供（契約）、コミュニティの安全確保と法的義務の履行のため、また必要に応じてお客様の同意を得てデータを処理します。権利を行使するには {email} までメールしてください。1か月以内に対応します。',
  korean: '당사는 서비스 제공(계약), 커뮤니티 보호 및 법적 의무 이행을 위해, 그리고 필요한 경우 귀하의 동의를 받아 데이터를 처리합니다. 권리를 행사하려면 {email}으로 이메일을 보내주세요. 한 달 이내에 답변드립니다.',
  portuguese: 'Processamos dados para fornecer o serviço (contrato), manter a comunidade segura e cumprir obrigações legais, e com o seu consentimento quando necessário. Para exercer qualquer direito, envie um e-mail para {email}, respondemos no prazo de um mês.',
  russian: 'Мы обрабатываем данные для предоставления услуги (договор), обеспечения безопасности сообщества и выполнения юридических обязательств, а также с вашего согласия, когда это требуется. Чтобы воспользоваться любым правом, напишите на {email}, мы отвечаем в течение одного месяца.',
  spanish: 'Procesamos datos para prestar el servicio (contrato), mantener segura a la comunidad y cumplir obligaciones legales, y con tu consentimiento cuando sea necesario. Para ejercer cualquier derecho, escribe a {email}, respondemos en el plazo de un mes.',
  swahili: 'Tunachakata data ili kutoa huduma (mkataba), kuweka jamii salama na kutimiza wajibu wa kisheria, na kwa idhini yako pale inapohitajika. Ili kutumia haki yoyote, tutumie barua pepe {email}, tunajibu ndani ya mwezi mmoja.',
  vietnamese: 'Chúng tôi xử lý dữ liệu để cung cấp dịch vụ (hợp đồng), giữ an toàn cho cộng đồng và đáp ứng các nghĩa vụ pháp lý, và với sự đồng ý của bạn khi cần. Để thực hiện bất kỳ quyền nào, hãy gửi email tới {email}, chúng tôi phản hồi trong vòng một tháng.',
};

export const privacyMetaTitle: Translation = {
  amharic: 'የግላዊነት ፖሊሲ',
  arabic: 'سياسة الخصوصية',
  bengali: 'গোপনীয়তা নীতি',
  chinese: '隐私政策',
  english: 'Privacy Policy',
  estonian: 'Privaatsuspoliitika',
  filipino: 'Patakaran sa Privacy',
  french: 'Politique de confidentialité',
  german: 'Datenschutzrichtlinie',
  hindi: 'गोपनीयता नीति',
  indonesian: 'Kebijakan Privasi',
  japanese: 'プライバシーポリシー',
  korean: '개인정보 보호정책',
  portuguese: 'Política de Privacidade',
  russian: 'Политика конфиденциальности',
  spanish: 'Política de privacidad',
  swahili: 'Sera ya Faragha',
  vietnamese: 'Chính sách Bảo mật',
};

export const privacyMetaDescription: Translation = {
  amharic: 'Workadabra የእርስዎን መረጃ እንዴት እንደሚሰበስብ፣ እንደሚጠቀም እና እንደሚጠብቅ ይወቁ።',
  arabic: 'تعرّف على كيفية جمع Workadabra لمعلوماتك واستخدامها وحمايتها.',
  bengali: 'Workadabra কীভাবে আপনার তথ্য সংগ্রহ, ব্যবহার ও সুরক্ষা করে তা জানুন।',
  chinese: '了解 Workadabra 如何收集、使用和保护您的信息。',
  english: 'Learn how Workadabra collects, uses, and protects your information.',
  estonian: 'Saa teada, kuidas Workadabra sinu teavet kogub, kasutab ja kaitseb.',
  filipino: 'Alamin kung paano kinokolekta, ginagamit, at pinoprotektahan ng Workadabra ang iyong impormasyon.',
  french: 'Découvrez comment Workadabra collecte, utilise et protège vos informations.',
  german: 'Erfahren Sie, wie Workadabra Ihre Informationen erfasst, verwendet und schützt.',
  hindi: 'जानें कि Workadabra आपकी जानकारी कैसे एकत्र, उपयोग और सुरक्षित करता है।',
  indonesian: 'Pelajari cara Workadabra mengumpulkan, menggunakan, dan melindungi informasi Anda.',
  japanese: 'Workadabra がお客様の情報をどのように収集・利用・保護するかをご覧ください。',
  korean: 'Workadabra가 귀하의 정보를 수집, 사용 및 보호하는 방법을 알아보세요.',
  portuguese: 'Saiba como a Workadabra recolhe, utiliza e protege as suas informações.',
  russian: 'Узнайте, как Workadabra собирает, использует и защищает вашу информацию.',
  spanish: 'Descubre cómo Workadabra recopila, utiliza y protege tu información.',
  swahili: 'Jifunze jinsi Workadabra inavyokusanya, kutumia, na kulinda taarifa zako.',
  vietnamese: 'Tìm hiểu cách Workadabra thu thập, sử dụng và bảo vệ thông tin của bạn.',
};

export const privacyIntro: Translation = {
  amharic: 'ይህ ፖሊሲ Workadabra ("እኛ"፣ "የእኛ") workadabra.com እና አገልግሎት ፈላጊዎችን ከአካባቢ አቅራቢዎች ጋር የሚያገናኘውን Workadabra መተግበሪያ ሲጠቀሙ መረጃን እንዴት እንደሚሰበስብ፣ እንደሚጠቀም እና እንደሚጠብቅ ያብራራል።',
  arabic: 'توضّح هذه السياسة كيفية قيام Workadabra ("نحن") بجمع المعلومات واستخدامها وحمايتها عند استخدامك لـ workadabra.com وتطبيق Workadabra الذي يربط الباحثين عن الخدمات بمزوّدين محليين.',
  bengali: 'এই নীতিটি ব্যাখ্যা করে যে আপনি যখন workadabra.com এবং Workadabra অ্যাপ ব্যবহার করেন তখন Workadabra ("আমরা") কীভাবে তথ্য সংগ্রহ, ব্যবহার ও সুরক্ষা করে, যা পরিষেবা প্রত্যাশীদের স্থানীয় প্রদানকারীদের সাথে সংযুক্ত করে।',
  chinese: '本政策说明当您使用 workadabra.com 及 Workadabra 应用（连接服务需求者与本地服务者）时，Workadabra（“我们”）如何收集、使用和保护信息。',
  english: 'This policy explains how Workadabra ("we", "us") collects, uses, and protects information when you use workadabra.com and the Workadabra app, which connects service seekers with local providers.',
  estonian: 'See poliitika selgitab, kuidas Workadabra ("meie") kogub, kasutab ja kaitseb teavet, kui kasutad veebilehte workadabra.com ja Workadabra rakendust, mis ühendab teenuseotsijad kohalike teenusepakkujatega.',
  filipino: 'Ipinapaliwanag ng patakarang ito kung paano kinokolekta, ginagamit, at pinoprotektahan ng Workadabra ("kami") ang impormasyon kapag ginagamit mo ang workadabra.com at ang Workadabra app, na nag-uugnay sa mga naghahanap ng serbisyo sa mga lokal na provider.',
  french: 'Cette politique explique comment Workadabra (« nous ») collecte, utilise et protège les informations lorsque vous utilisez workadabra.com et l’application Workadabra, qui met en relation les demandeurs de services avec des prestataires locaux.',
  german: 'Diese Richtlinie erläutert, wie Workadabra („wir“) Informationen erfasst, verwendet und schützt, wenn Sie workadabra.com und die Workadabra-App nutzen, die Dienstleistungssuchende mit lokalen Anbietern verbindet.',
  hindi: 'यह नीति बताती है कि जब आप workadabra.com और Workadabra ऐप का उपयोग करते हैं, जो सेवा चाहने वालों को स्थानीय प्रदाताओं से जोड़ता है, तब Workadabra ("हम") जानकारी कैसे एकत्र, उपयोग और सुरक्षित करता है।',
  indonesian: 'Kebijakan ini menjelaskan cara Workadabra ("kami") mengumpulkan, menggunakan, dan melindungi informasi saat Anda menggunakan workadabra.com dan aplikasi Workadabra, yang menghubungkan pencari layanan dengan penyedia lokal.',
  japanese: 'このポリシーでは、サービスを求める人と地域のプロバイダーをつなぐ workadabra.com および Workadabra アプリを利用する際に、Workadabra（「当社」）がどのように情報を収集・利用・保護するかを説明します。',
  korean: '이 정책은 서비스 이용자를 지역 제공자와 연결하는 workadabra.com 및 Workadabra 앱을 사용할 때 Workadabra("당사")가 정보를 수집, 사용 및 보호하는 방법을 설명합니다.',
  portuguese: 'Esta política explica como a Workadabra ("nós") recolhe, utiliza e protege informações quando você usa o workadabra.com e o aplicativo Workadabra, que liga quem procura serviços a prestadores locais.',
  russian: 'Эта политика объясняет, как Workadabra («мы») собирает, использует и защищает информацию, когда вы используете workadabra.com и приложение Workadabra, которое связывает заказчиков услуг с местными исполнителями.',
  spanish: 'Esta política explica cómo Workadabra ("nosotros") recopila, utiliza y protege la información cuando usas workadabra.com y la aplicación Workadabra, que conecta a quienes buscan servicios con proveedores locales.',
  swahili: 'Sera hii inaeleza jinsi Workadabra ("sisi") inavyokusanya, kutumia, na kulinda taarifa unapotumia workadabra.com na programu ya Workadabra, inayounganisha watafutaji wa huduma na watoa huduma wa eneo lako.',
  vietnamese: 'Chính sách này giải thích cách Workadabra ("chúng tôi") thu thập, sử dụng và bảo vệ thông tin khi bạn sử dụng workadabra.com và ứng dụng Workadabra, nơi kết nối người tìm dịch vụ với nhà cung cấp địa phương.',
};

export const privacyCollectHeading: Translation = {
  amharic: 'የምንሰበስበው መረጃ',
  arabic: 'المعلومات التي نجمعها',
  bengali: 'আমরা যে তথ্য সংগ্রহ করি',
  chinese: '我们收集的信息',
  english: 'Information we collect',
  estonian: 'Teave, mida kogume',
  filipino: 'Impormasyong kinokolekta namin',
  french: 'Informations que nous collectons',
  german: 'Informationen, die wir erfassen',
  hindi: 'हम जो जानकारी एकत्र करते हैं',
  indonesian: 'Informasi yang kami kumpulkan',
  japanese: '当社が収集する情報',
  korean: '당사가 수집하는 정보',
  portuguese: 'Informações que recolhemos',
  russian: 'Информация, которую мы собираем',
  spanish: 'Información que recopilamos',
  swahili: 'Taarifa tunazokusanya',
  vietnamese: 'Thông tin chúng tôi thu thập',
};

export const privacyCollectAccount: Translation = {
  amharic: 'የሚያቀርቡት የመለያ ዝርዝሮች: ስም፣ ኢሜይል፣ ስልክ እና (ለአቅራቢዎች) የሚያቀርቧቸው አገልግሎቶች እና የማረጋገጫ ሰነዶች።',
  arabic: 'تفاصيل الحساب التي تقدّمها: الاسم والبريد الإلكتروني والهاتف و(للمزوّدين) الخدمات التي تقدّمها ووثائق التحقق.',
  bengali: 'আপনি যে অ্যাকাউন্ট বিবরণ প্রদান করেন: নাম, ইমেল, ফোন এবং (প্রদানকারীদের জন্য) আপনি যে পরিষেবা দেন ও যাচাইকরণ নথি।',
  chinese: '您提供的账户信息: 姓名、电子邮件、电话，以及（对于服务者）您提供的服务和验证文件。',
  english: 'Account details you provide: name, email, phone, and (for providers) the services you offer and verification documents.',
  estonian: 'Sinu esitatud kontoandmed: nimi, e-post, telefon ja (teenusepakkujatel) pakutavad teenused ja kinnitusdokumendid.',
  filipino: 'Mga detalye ng account na ibinibigay mo: pangalan, email, telepono, at (para sa mga provider) ang mga serbisyong inaalok mo at mga dokumento ng beripikasyon.',
  french: 'Les informations de compte que vous fournissez : nom, e-mail, téléphone et (pour les prestataires) les services proposés et les documents de vérification.',
  german: 'Von Ihnen angegebene Kontodaten: Name, E-Mail, Telefon und (bei Anbietern) die angebotenen Dienste sowie Verifizierungsdokumente.',
  hindi: 'आपके द्वारा प्रदान किए गए खाता विवरण: नाम, ईमेल, फ़ोन, और (प्रदाताओं के लिए) आपकी दी जाने वाली सेवाएं और सत्यापन दस्तावेज़।',
  indonesian: 'Detail akun yang Anda berikan: nama, email, telepon, dan (untuk penyedia) layanan yang Anda tawarkan dan dokumen verifikasi.',
  japanese: 'お客様が提供するアカウント情報: 氏名、メール、電話、および（プロバイダーの場合）提供サービスと本人確認書類。',
  korean: '귀하가 제공하는 계정 정보: 이름, 이메일, 전화번호, 그리고 (제공자의 경우) 제공하는 서비스 및 인증 서류.',
  portuguese: 'Detalhes da conta que você fornece: nome, e-mail, telefone e (para prestadores) os serviços que oferece e documentos de verificação.',
  russian: 'Предоставляемые вами данные учётной записи: имя, электронная почта, телефон и (для исполнителей) предлагаемые услуги и документы для проверки.',
  spanish: 'Los datos de la cuenta que proporcionas: nombre, correo electrónico, teléfono y (para proveedores) los servicios que ofreces y los documentos de verificación.',
  swahili: 'Maelezo ya akaunti unayotoa: jina, barua pepe, simu, na (kwa watoa huduma) huduma unazotoa na hati za uthibitishaji.',
  vietnamese: 'Thông tin tài khoản bạn cung cấp: tên, email, điện thoại, và (đối với nhà cung cấp) các dịch vụ bạn cung cấp và tài liệu xác minh.',
};

export const privacyCollectLocation: Translation = {
  amharic: 'አካባቢ፣ ፈላጊዎችን ከአቅራቢያ አቅራቢዎች ጋር ለማዛመድ እና የአገር-ተኮር መስፈርቶችን ለማስፈጸም።',
  arabic: 'الموقع، حتى نتمكّن من مطابقة الباحثين مع مزوّدين قريبين وتطبيق المتطلبات الخاصة بكل بلد.',
  bengali: 'অবস্থান, যাতে আমরা প্রত্যাশীদের কাছাকাছি প্রদানকারীদের সাথে মেলাতে এবং দেশ-নির্দিষ্ট প্রয়োজনীয়তা প্রয়োগ করতে পারি।',
  chinese: '位置，以便我们将需求者与附近的服务者匹配并执行特定国家/地区的要求。',
  english: 'Location, so we can match seekers with nearby providers and enforce country-specific requirements.',
  estonian: 'Asukoht, et saaksime sobitada otsijaid lähedalasuvate teenusepakkujatega ja jõustada riigipõhiseid nõudeid.',
  filipino: 'Lokasyon, upang maitugma namin ang mga naghahanap sa mga kalapit na provider at maipatupad ang mga partikular na kinakailangan sa bansa.',
  french: 'La localisation, afin de mettre en relation les demandeurs avec des prestataires à proximité et d’appliquer les exigences propres à chaque pays.',
  german: 'Standort, damit wir Suchende mit nahegelegenen Anbietern abgleichen und länderspezifische Anforderungen durchsetzen können.',
  hindi: 'स्थान, ताकि हम चाहने वालों को आस-पास के प्रदाताओं से मिला सकें और देश-विशिष्ट आवश्यकताओं को लागू कर सकें।',
  indonesian: 'Lokasi, agar kami dapat mencocokkan pencari dengan penyedia terdekat dan menerapkan persyaratan khusus negara.',
  japanese: '位置情報。近くのプロバイダーとマッチングし、国別の要件を適用するために使用します。',
  korean: '위치 정보로, 이용자를 인근 제공자와 매칭하고 국가별 요건을 적용할 수 있습니다.',
  portuguese: 'Localização, para podermos associar quem procura a prestadores próximos e aplicar requisitos específicos de cada país.',
  russian: 'Местоположение, чтобы мы могли подбирать заказчикам ближайших исполнителей и применять требования конкретной страны.',
  spanish: 'Ubicación, para poder emparejar a quienes buscan con proveedores cercanos y aplicar requisitos específicos de cada país.',
  swahili: 'Eneo, ili tuweze kuunganisha watafutaji na watoa huduma walio karibu na kutekeleza mahitaji mahususi ya nchi.',
  vietnamese: 'Vị trí, để chúng tôi có thể ghép người tìm dịch vụ với nhà cung cấp gần đó và áp dụng các yêu cầu riêng theo quốc gia.',
};

export const privacyCollectRequests: Translation = {
  amharic: 'በመድረኩ ላይ የተለዋወጡ የአገልግሎት ጥያቄዎች፣ መልዕክቶች እና ደረጃዎች።',
  arabic: 'طلبات الخدمة والرسائل والتقييمات المتبادلة على المنصّة.',
  bengali: 'প্ল্যাটফর্মে আদান-প্রদান হওয়া পরিষেবা অনুরোধ, বার্তা ও রেটিং।',
  chinese: '在平台上交换的服务请求、消息和评分。',
  english: 'Service requests, messages, and ratings exchanged on the platform.',
  estonian: 'Platvormil vahetatud teenusetaotlused, sõnumid ja hinnangud.',
  filipino: 'Mga kahilingan sa serbisyo, mensahe, at rating na ipinagpapalitan sa platform.',
  french: 'Les demandes de services, messages et évaluations échangés sur la plateforme.',
  german: 'Über die Plattform ausgetauschte Serviceanfragen, Nachrichten und Bewertungen.',
  hindi: 'प्लेटफ़ॉर्म पर आदान-प्रदान की गई सेवा अनुरोध, संदेश और रेटिंग।',
  indonesian: 'Permintaan layanan, pesan, dan peringkat yang dipertukarkan di platform.',
  japanese: 'プラットフォーム上でやり取りされたサービスリクエスト、メッセージ、評価。',
  korean: '플랫폼에서 주고받은 서비스 요청, 메시지 및 평점.',
  portuguese: 'Pedidos de serviço, mensagens e avaliações trocados na plataforma.',
  russian: 'Запросы услуг, сообщения и оценки, которыми обмениваются на платформе.',
  spanish: 'Solicitudes de servicio, mensajes y valoraciones intercambiados en la plataforma.',
  swahili: 'Maombi ya huduma, ujumbe, na ukadiriaji vinavyobadilishwa kwenye jukwaa.',
  vietnamese: 'Yêu cầu dịch vụ, tin nhắn và đánh giá được trao đổi trên nền tảng.',
};

export const privacyCollectPayment: Translation = {
  amharic: 'በክፍያ አስኬጃዎቻችን የሚስተናገዱ የክፍያ ዝርዝሮች፣ ሙሉ የካርድ ወይም የቦርሳ ምስክርነቶችዎን ፈጽሞ አናከማችም።',
  arabic: 'تفاصيل الدفع التي تتولّاها جهات معالجة الدفع لدينا، لا نخزّن أبدًا بيانات بطاقتك أو محفظتك الكاملة.',
  bengali: 'আমাদের পেমেন্ট প্রসেসরদের দ্বারা পরিচালিত পেমেন্ট বিবরণ, আমরা কখনই আপনার সম্পূর্ণ কার্ড বা ওয়ালেট তথ্য সংরক্ষণ করি না।',
  chinese: '由我们的支付处理方处理的付款信息，我们绝不存储您的完整银行卡或钱包凭证。',
  english: 'Payment details handled by our payment processors, we never store your full card or wallet credentials.',
  estonian: 'Makseandmed, mida käitlevad meie maksetöötlejad, me ei salvesta kunagi sinu täielikke kaardi- ega rahakotiandmeid.',
  filipino: 'Mga detalye ng pagbabayad na hinahawakan ng aming mga payment processor, hindi namin kailanman iniimbak ang iyong buong card o wallet credentials.',
  french: 'Les informations de paiement gérées par nos prestataires de paiement, nous ne stockons jamais l’intégralité de vos identifiants de carte ou de portefeuille.',
  german: 'Zahlungsdaten, die von unseren Zahlungsdienstleistern verarbeitet werden, wir speichern niemals Ihre vollständigen Karten- oder Wallet-Daten.',
  hindi: 'हमारे भुगतान प्रोसेसर द्वारा संभाले गए भुगतान विवरण, हम आपके पूरे कार्ड या वॉलेट क्रेडेंशियल कभी संग्रहीत नहीं करते।',
  indonesian: 'Detail pembayaran yang ditangani oleh pemroses pembayaran kami, kami tidak pernah menyimpan kredensial kartu atau dompet lengkap Anda.',
  japanese: '当社の決済処理事業者が取り扱う支払い情報。お客様のカードやウォレットの完全な認証情報を保存することはありません。',
  korean: '결제 처리업체가 처리하는 결제 정보. 당사는 귀하의 전체 카드 또는 지갑 자격 증명을 저장하지 않습니다.',
  portuguese: 'Detalhes de pagamento tratados pelos nossos processadores de pagamento, nunca armazenamos os seus dados completos de cartão ou carteira.',
  russian: 'Платёжные данные, обрабатываемые нашими платёжными провайдерами, мы никогда не храним полные данные вашей карты или кошелька.',
  spanish: 'Los datos de pago gestionados por nuestros procesadores de pago, nunca almacenamos las credenciales completas de tu tarjeta o monedero.',
  swahili: 'Maelezo ya malipo yanayoshughulikiwa na wachakataji wetu wa malipo, hatuhifadhi kamwe taarifa kamili za kadi au pochi yako.',
  vietnamese: 'Thông tin thanh toán do các đơn vị xử lý thanh toán của chúng tôi xử lý, chúng tôi không bao giờ lưu trữ toàn bộ thông tin thẻ hoặc ví của bạn.',
};

export const privacyUseHeading: Translation = {
  amharic: 'እንዴት እንደምንጠቀምበት',
  arabic: 'كيف نستخدمها',
  bengali: 'আমরা কীভাবে এটি ব্যবহার করি',
  chinese: '我们如何使用',
  english: 'How we use it',
  estonian: 'Kuidas me seda kasutame',
  filipino: 'Paano namin ginagamit',
  french: 'Comment nous l’utilisons',
  german: 'Wie wir sie verwenden',
  hindi: 'हम इसका उपयोग कैसे करते हैं',
  indonesian: 'Bagaimana kami menggunakannya',
  japanese: '当社の利用方法',
  korean: '사용 방법',
  portuguese: 'Como a utilizamos',
  russian: 'Как мы её используем',
  spanish: 'Cómo la utilizamos',
  swahili: 'Jinsi tunavyoitumia',
  vietnamese: 'Cách chúng tôi sử dụng',
};

export const privacyUseMatch: Translation = {
  amharic: 'ጥያቄዎችን በአካባቢዎ ካሉ ብቁ፣ የተረጋገጡ አቅራቢዎች ጋር ለማዛመድ።',
  arabic: 'لمطابقة الطلبات مع مزوّدين مؤهّلين وموثّقين في منطقتك.',
  bengali: 'আপনার এলাকায় যোগ্য, যাচাইকৃত প্রদানকারীদের সাথে অনুরোধ মেলাতে।',
  chinese: '将请求与您所在区域内合格、经过验证的服务者匹配。',
  english: 'To match requests with eligible, verified providers in your area.',
  estonian: 'Et sobitada taotlusi sinu piirkonna sobivate, kinnitatud teenusepakkujatega.',
  filipino: 'Upang itugma ang mga kahilingan sa mga karapat-dapat, beripikadong provider sa iyong lugar.',
  french: 'Pour associer les demandes à des prestataires éligibles et vérifiés dans votre région.',
  german: 'Um Anfragen mit geeigneten, verifizierten Anbietern in Ihrer Umgebung abzugleichen.',
  hindi: 'अनुरोधों को आपके क्षेत्र के योग्य, सत्यापित प्रदाताओं से मिलाने के लिए।',
  indonesian: 'Untuk mencocokkan permintaan dengan penyedia yang memenuhi syarat dan terverifikasi di area Anda.',
  japanese: 'お客様の地域の適格で認証済みのプロバイダーとリクエストをマッチングするため。',
  korean: '귀하 지역의 자격을 갖춘 인증된 제공자와 요청을 매칭하기 위해.',
  portuguese: 'Para associar pedidos a prestadores elegíveis e verificados na sua região.',
  russian: 'Чтобы сопоставлять запросы с подходящими проверенными исполнителями в вашем районе.',
  spanish: 'Para emparejar solicitudes con proveedores aptos y verificados de tu zona.',
  swahili: 'Ili kuunganisha maombi na watoa huduma wanaostahili na waliothibitishwa katika eneo lako.',
  vietnamese: 'Để ghép các yêu cầu với nhà cung cấp đủ điều kiện, đã xác minh trong khu vực của bạn.',
};

export const privacyUseEscrow: Translation = {
  amharic: 'ክፍያዎችን በማስቀመጫ ለመያዝ እና አገልግሎቱ ሲጠናቀቅ ለመልቀቅ።',
  arabic: 'للاحتفاظ بالمدفوعات في حساب ضمان والإفراج عنها عند اكتمال الخدمة.',
  bengali: 'পেমেন্ট এসক্রোতে রাখতে এবং পরিষেবা সম্পন্ন হলে ছেড়ে দিতে।',
  chinese: '将款项托管，并在服务完成时放款。',
  english: 'To hold payments in escrow and release them when a service is completed.',
  estonian: 'Et hoida makseid deposiidis ja vabastada need teenuse lõpetamisel.',
  filipino: 'Upang itago ang mga bayad sa escrow at ilabas ang mga ito kapag natapos ang serbisyo.',
  french: 'Pour conserver les paiements sous séquestre et les libérer une fois le service terminé.',
  german: 'Um Zahlungen treuhänderisch zu halten und sie nach Abschluss eines Service freizugeben.',
  hindi: 'भुगतान को एस्क्रो में रखने और सेवा पूरी होने पर जारी करने के लिए।',
  indonesian: 'Untuk menyimpan pembayaran di escrow dan melepaskannya saat layanan selesai.',
  japanese: '支払いをエスクローで保持し、サービス完了時に解放するため。',
  korean: '결제 대금을 에스크로에 보관하고 서비스가 완료되면 지급하기 위해.',
  portuguese: 'Para manter os pagamentos em garantia e liberá-los quando um serviço é concluído.',
  russian: 'Чтобы удерживать платежи на счёте эскроу и переводить их по завершении услуги.',
  spanish: 'Para mantener los pagos en depósito de garantía y liberarlos cuando se completa un servicio.',
  swahili: 'Ili kushikilia malipo katika escrow na kuyaachilia huduma inapokamilika.',
  vietnamese: 'Để giữ các khoản thanh toán trong ký quỹ và giải ngân khi dịch vụ hoàn thành.',
};

export const privacyUseVerify: Translation = {
  amharic: 'ማንነትን እና የአገልግሎት መስፈርቶችን ለማረጋገጥ እና ማኅበረሰቡን ደህንነቱ የተጠበቀ ለማድረግ።',
  arabic: 'للتحقق من الهوية ومتطلبات الخدمة، والحفاظ على أمان المجتمع.',
  bengali: 'পরিচয় ও পরিষেবার প্রয়োজনীয়তা যাচাই করতে এবং সম্প্রদায়কে নিরাপদ রাখতে।',
  chinese: '验证身份和服务要求，并保障社区安全。',
  english: 'To verify identity and service requirements, and keep the community safe.',
  estonian: 'Et kontrollida isikut ja teenusenõudeid ning hoida kogukond turvalisena.',
  filipino: 'Upang i-verify ang pagkakakilanlan at mga kinakailangan sa serbisyo, at panatilihing ligtas ang komunidad.',
  french: 'Pour vérifier l’identité et les exigences de service, et assurer la sécurité de la communauté.',
  german: 'Um Identität und Serviceanforderungen zu prüfen und die Community sicher zu halten.',
  hindi: 'पहचान और सेवा आवश्यकताओं को सत्यापित करने और समुदाय को सुरक्षित रखने के लिए।',
  indonesian: 'Untuk memverifikasi identitas dan persyaratan layanan, serta menjaga keamanan komunitas.',
  japanese: '本人確認とサービス要件を検証し、コミュニティの安全を保つため。',
  korean: '신원 및 서비스 요건을 확인하고 커뮤니티를 안전하게 유지하기 위해.',
  portuguese: 'Para verificar a identidade e os requisitos do serviço e manter a comunidade segura.',
  russian: 'Чтобы проверять личность и требования к услугам и обеспечивать безопасность сообщества.',
  spanish: 'Para verificar la identidad y los requisitos del servicio, y mantener segura a la comunidad.',
  swahili: 'Ili kuthibitisha utambulisho na mahitaji ya huduma, na kuweka jamii salama.',
  vietnamese: 'Để xác minh danh tính và yêu cầu dịch vụ, đồng thời giữ an toàn cho cộng đồng.',
};

export const privacyUseSupport: Translation = {
  amharic: 'ድጋፍ ለመስጠት እና ከአገልግሎት ጋር የተያያዙ ማሳወቂያዎችን ለመላክ።',
  arabic: 'لتقديم الدعم وإرسال الإشعارات المتعلقة بالخدمة.',
  bengali: 'সহায়তা প্রদান করতে এবং পরিষেবা-সম্পর্কিত বিজ্ঞপ্তি পাঠাতে।',
  chinese: '提供支持并发送与服务相关的通知。',
  english: 'To provide support and send service-related notifications.',
  estonian: 'Et pakkuda tuge ja saata teenusega seotud teavitusi.',
  filipino: 'Upang magbigay ng suporta at magpadala ng mga abiso kaugnay ng serbisyo.',
  french: 'Pour fournir une assistance et envoyer des notifications liées au service.',
  german: 'Um Support zu leisten und servicebezogene Benachrichtigungen zu senden.',
  hindi: 'सहायता प्रदान करने और सेवा-संबंधी सूचनाएं भेजने के लिए।',
  indonesian: 'Untuk memberikan dukungan dan mengirim notifikasi terkait layanan.',
  japanese: 'サポートを提供し、サービス関連の通知を送信するため。',
  korean: '지원을 제공하고 서비스 관련 알림을 보내기 위해.',
  portuguese: 'Para prestar suporte e enviar notificações relacionadas ao serviço.',
  russian: 'Чтобы оказывать поддержку и отправлять уведомления, связанные с услугами.',
  spanish: 'Para brindar soporte y enviar notificaciones relacionadas con el servicio.',
  swahili: 'Ili kutoa msaada na kutuma arifa zinazohusiana na huduma.',
  vietnamese: 'Để cung cấp hỗ trợ và gửi thông báo liên quan đến dịch vụ.',
};

export const privacySharingHeading: Translation = {
  amharic: 'ማጋራት',
  arabic: 'المشاركة',
  bengali: 'শেয়ারিং',
  chinese: '共享',
  english: 'Sharing',
  estonian: 'Jagamine',
  filipino: 'Pagbabahagi',
  french: 'Partage',
  german: 'Weitergabe',
  hindi: 'साझा करना',
  indonesian: 'Berbagi',
  japanese: '共有',
  korean: '공유',
  portuguese: 'Partilha',
  russian: 'Передача',
  spanish: 'Compartir',
  swahili: 'Kushiriki',
  vietnamese: 'Chia sẻ',
};

export const privacySharingBody: Translation = {
  amharic: 'አገልግሎቱ የሚፈልገውን ብቻ እናጋራለን፦ ጥያቄ ከተቀበለ በኋላ ፈላጊ እና አቅራቢ የእርስ በርስ ተዛማጅ መገለጫ እና አካባቢ ይያያሉ። ለክፍያ፣ ለመልዕክት እና ለማረጋገጥ የታመኑ አስኬጃዎችን እንጠቀማለን። ውሂብዎን ፈጽሞ አንሸጥም።',
  arabic: 'نشارك فقط ما تتطلّبه الخدمة: يرى الباحث والمزوّد الملف الشخصي والموقع ذي الصلة لكلٍّ منهما بمجرّد قبول الطلب. نستخدم جهات معالجة موثوقة للمدفوعات والمراسلة والتحقق. لا نبيع بياناتك أبدًا.',
  bengali: 'একটি পরিষেবার যা প্রয়োজন কেবল তাই আমরা শেয়ার করি: অনুরোধ গৃহীত হওয়ার পর একজন প্রত্যাশী ও প্রদানকারী একে অপরের প্রাসঙ্গিক প্রোফাইল ও অবস্থান দেখেন। আমরা পেমেন্ট, বার্তা ও যাচাইয়ের জন্য বিশ্বস্ত প্রসেসর ব্যবহার করি। আমরা কখনই আপনার ডেটা বিক্রি করি না।',
  chinese: '我们只共享服务所需的信息: 请求被接受后，需求者与服务者可看到彼此的相关资料和位置。我们使用可信的处理方进行支付、消息和验证。我们绝不出售您的数据。',
  english: "We share only what a service needs: a seeker and provider see each other's relevant profile and location once a request is accepted. We use trusted processors for payments, messaging, and verification. We never sell your data.",
  estonian: 'Jagame ainult seda, mida teenus vajab: pärast taotluse vastuvõtmist näevad otsija ja teenusepakkuja teineteise asjakohast profiili ja asukohta. Kasutame maksete, sõnumite ja kinnitamise jaoks usaldusväärseid töötlejaid. Me ei müü kunagi sinu andmeid.',
  filipino:
    "Ibinabahagi lang namin ang kailangan ng isang serbisyo: nakikita ng naghahanap at provider ang kaugnay na profile at lokasyon ng isa't isa kapag tinanggap na ang kahilingan. Gumagamit kami ng pinagkakatiwalaang processor para sa pagbabayad, pagmemensahe, at beripikasyon. Hindi namin kailanman ibinebenta ang iyong data.",
  french:
    'Nous ne partageons que ce dont un service a besoin : une fois une demande acceptée, le demandeur et le prestataire voient leurs profils et localisations pertinents respectifs. Nous faisons appel à des prestataires de confiance pour les paiements, la messagerie et la vérification. Nous ne vendons jamais vos données.',
  german:
    'Wir geben nur das weiter, was ein Service benötigt: sobald eine Anfrage angenommen wurde, sehen Suchender und Anbieter das jeweils relevante Profil und den Standort des anderen. Für Zahlungen, Nachrichten und Verifizierung nutzen wir vertrauenswürdige Dienstleister. Wir verkaufen Ihre Daten niemals.',
  hindi: 'हम केवल वही साझा करते हैं जो किसी सेवा के लिए आवश्यक है: अनुरोध स्वीकार होने पर एक चाहने वाला और प्रदाता एक-दूसरे की प्रासंगिक प्रोफ़ाइल और स्थान देखते हैं। हम भुगतान, संदेश और सत्यापन के लिए विश्वसनीय प्रोसेसर का उपयोग करते हैं। हम आपका डेटा कभी नहीं बेचते।',
  indonesian: 'Kami hanya membagikan apa yang dibutuhkan suatu layanan: pencari dan penyedia melihat profil dan lokasi relevan satu sama lain setelah permintaan diterima. Kami menggunakan pemroses tepercaya untuk pembayaran, pesan, dan verifikasi. Kami tidak pernah menjual data Anda.',
  japanese: '当社はサービスに必要な情報のみを共有します: リクエストが承認されると、依頼者とプロバイダーは互いの関連するプロフィールと位置情報を確認できます。支払い、メッセージ、本人確認には信頼できる事業者を利用します。お客様のデータを販売することは決してありません。',
  korean: '당사는 서비스에 필요한 정보만 공유합니다: 요청이 수락되면 이용자와 제공자는 서로의 관련 프로필과 위치를 확인합니다. 결제, 메시지 및 인증에는 신뢰할 수 있는 처리업체를 이용합니다. 당사는 귀하의 데이터를 절대 판매하지 않습니다.',
  portuguese: 'Partilhamos apenas o que um serviço necessita: quem procura e o prestador veem o perfil e a localização relevantes um do outro assim que um pedido é aceite. Usamos processadores de confiança para pagamentos, mensagens e verificação. Nunca vendemos os seus dados.',
  russian: 'Мы передаём только то, что необходимо для услуги: после принятия запроса заказчик и исполнитель видят соответствующие профили и местоположение друг друга. Для платежей, обмена сообщениями и проверки мы используем доверенных провайдеров. Мы никогда не продаём ваши данные.',
  spanish: 'Compartimos solo lo que un servicio necesita: una vez aceptada una solicitud, quien busca y el proveedor ven el perfil y la ubicación relevantes del otro. Usamos procesadores de confianza para pagos, mensajería y verificación. Nunca vendemos tus datos.',
  swahili: 'Tunashiriki tu kile huduma inahitaji: mtafutaji na mtoa huduma huona wasifu na eneo husika la kila mmoja mara ombi linapokubaliwa. Tunatumia wachakataji wanaoaminika kwa malipo, ujumbe, na uthibitishaji. Hatuuzi kamwe data yako.',
  vietnamese: 'Chúng tôi chỉ chia sẻ những gì một dịch vụ cần: người tìm dịch vụ và nhà cung cấp xem hồ sơ và vị trí liên quan của nhau khi một yêu cầu được chấp nhận. Chúng tôi sử dụng các đơn vị xử lý đáng tin cậy cho thanh toán, nhắn tin và xác minh. Chúng tôi không bao giờ bán dữ liệu của bạn.',
};

export const privacyRightsHeading: Translation = {
  amharic: 'መብቶችዎ እና ግንኙነት',
  arabic: 'حقوقك والتواصل',
  bengali: 'আপনার অধিকার ও যোগাযোগ',
  chinese: '您的权利与联系方式',
  english: 'Your rights & contact',
  estonian: 'Sinu õigused ja kontakt',
  filipino: 'Iyong mga karapatan at contact',
  french: 'Vos droits et contact',
  german: 'Ihre Rechte & Kontakt',
  hindi: 'आपके अधिकार और संपर्क',
  indonesian: 'Hak & kontak Anda',
  japanese: 'お客様の権利とお問い合わせ',
  korean: '귀하의 권리 및 연락처',
  portuguese: 'Os seus direitos e contacto',
  russian: 'Ваши права и контакты',
  spanish: 'Tus derechos y contacto',
  swahili: 'Haki zako na mawasiliano',
  vietnamese: 'Quyền của bạn & liên hệ',
};

export const privacyRightsBody: Translation = {
  amharic: 'ውሂብዎን በማንኛውም ጊዜ መድረስ፣ ማስተካከል ወይም መሰረዝ እና ፈቃድን መውሰድ ይችላሉ። ለማንኛውም የግላዊነት ጥያቄ በ {email} ያግኙን።',
  arabic: 'يمكنك الوصول إلى بياناتك أو تصحيحها أو حذفها وسحب موافقتك في أي وقت. لأي طلب يتعلق بالخصوصية، تواصل معنا على {email}.',
  bengali: 'আপনি যেকোনো সময় আপনার ডেটা অ্যাক্সেস, সংশোধন বা মুছে ফেলতে এবং সম্মতি প্রত্যাহার করতে পারেন। যেকোনো গোপনীয়তা অনুরোধের জন্য {email}-এ আমাদের সাথে যোগাযোগ করুন।',
  chinese: '您可以随时访问、更正或删除您的数据，并撤回同意。如有任何隐私请求，请通过 {email} 与我们联系。',
  english: 'You can access, correct, or delete your data, and withdraw consent at any time. For any privacy request, contact us at {email}.',
  estonian: 'Saad igal ajal oma andmetele ligi pääseda, neid parandada või kustutada ja nõusoleku tagasi võtta. Mis tahes privaatsustaotluse korral võta meiega ühendust aadressil {email}.',
  filipino: 'Maaari mong i-access, itama, o tanggalin ang iyong data, at bawiin ang pahintulot anumang oras. Para sa anumang kahilingan sa privacy, makipag-ugnayan sa amin sa {email}.',
  french: 'Vous pouvez accéder à vos données, les corriger ou les supprimer, et retirer votre consentement à tout moment. Pour toute demande relative à la confidentialité, contactez-nous à {email}.',
  german: 'Sie können jederzeit auf Ihre Daten zugreifen, sie korrigieren oder löschen und Ihre Einwilligung widerrufen. Bei Datenschutzanfragen kontaktieren Sie uns unter {email}.',
  hindi: 'आप किसी भी समय अपने डेटा तक पहुंच सकते हैं, उसे सुधार या हटा सकते हैं, और सहमति वापस ले सकते हैं। किसी भी गोपनीयता अनुरोध के लिए हमें {email} पर संपर्क करें।',
  indonesian: 'Anda dapat mengakses, memperbaiki, atau menghapus data Anda, dan menarik persetujuan kapan saja. Untuk permintaan privasi apa pun, hubungi kami di {email}.',
  japanese: 'お客様はいつでもデータにアクセス、訂正、削除でき、同意を撤回できます。プライバシーに関するご請求は {email} までご連絡ください。',
  korean: '귀하는 언제든지 데이터에 접근, 수정 또는 삭제하고 동의를 철회할 수 있습니다. 개인정보 관련 요청은 {email}으로 연락해 주세요.',
  portuguese: 'Você pode aceder, corrigir ou eliminar os seus dados e retirar o consentimento a qualquer momento. Para qualquer pedido de privacidade, contacte-nos em {email}.',
  russian: 'Вы можете в любое время получить доступ к своим данным, исправить или удалить их и отозвать согласие. По любому запросу о конфиденциальности свяжитесь с нами по адресу {email}.',
  spanish: 'Puedes acceder a tus datos, corregirlos o eliminarlos y retirar el consentimiento en cualquier momento. Para cualquier solicitud de privacidad, contáctanos en {email}.',
  swahili: 'Unaweza kufikia, kusahihisha, au kufuta data yako, na kuondoa idhini wakati wowote. Kwa ombi lolote la faragha, wasiliana nasi kwa {email}.',
  vietnamese: 'Bạn có thể truy cập, chỉnh sửa hoặc xóa dữ liệu của mình và rút lại sự đồng ý bất cứ lúc nào. Đối với bất kỳ yêu cầu nào về quyền riêng tư, hãy liên hệ với chúng tôi tại {email}.',
};

export const termsMetaTitle: Translation = {
  amharic: 'የአገልግሎት ውሎች',
  arabic: 'شروط الخدمة',
  bengali: 'সেবার শর্তাবলী',
  chinese: '服务条款',
  english: 'Terms of Service',
  estonian: 'Kasutustingimused',
  filipino: 'Mga Tuntunin ng Serbisyo',
  french: 'Conditions d’utilisation',
  german: 'Nutzungsbedingungen',
  hindi: 'सेवा की शर्तें',
  indonesian: 'Ketentuan Layanan',
  japanese: '利用規約',
  korean: '서비스 약관',
  portuguese: 'Termos de Serviço',
  russian: 'Условия использования',
  spanish: 'Términos de servicio',
  swahili: 'Masharti ya Huduma',
  vietnamese: 'Điều khoản Dịch vụ',
};

export const termsMetaDescription: Translation = {
  amharic: 'Workadabra የመጠቀም ውሎችን ይወቁ።',
  arabic: 'تعرّف على شروط استخدام Workadabra.',
  bengali: 'Workadabra ব্যবহারের শর্তাবলী জানুন।',
  chinese: '了解使用 Workadabra 的条款。',
  english: 'Learn the terms that govern your use of Workadabra.',
  estonian: 'Tutvu tingimustega, mis reguleerivad Workadabra kasutamist.',
  filipino: 'Alamin ang mga tuntuning namamahala sa iyong paggamit ng Workadabra.',
  french: 'Découvrez les conditions qui régissent votre utilisation de Workadabra.',
  german: 'Erfahren Sie die Bedingungen, die Ihre Nutzung von Workadabra regeln.',
  hindi: 'उन शर्तों को जानें जो Workadabra के आपके उपयोग को नियंत्रित करती हैं।',
  indonesian: 'Pelajari ketentuan yang mengatur penggunaan Workadabra oleh Anda.',
  japanese: 'Workadabra の利用を規定する条件をご確認ください。',
  korean: 'Workadabra 사용을 규율하는 약관을 알아보세요.',
  portuguese: 'Conheça os termos que regem a sua utilização da Workadabra.',
  russian: 'Ознакомьтесь с условиями, регулирующими использование Workadabra.',
  spanish: 'Conoce los términos que rigen tu uso de Workadabra.',
  swahili: 'Jifunze masharti yanayoongoza matumizi yako ya Workadabra.',
  vietnamese: 'Tìm hiểu các điều khoản điều chỉnh việc bạn sử dụng Workadabra.',
};

export const termsIntro: Translation = {
  amharic: 'እነዚህ ውሎች Workadabra የመጠቀምዎን ይቆጣጠራሉ። መለያ በመፍጠር ይስማማሉ። Workadabra አገልግሎት ፈላጊዎችን ከአካባቢ አቅራቢዎች ጋር የሚያገናኝ መድረክ ነው፤ በመካከላቸው በሚከናወኑ አገልግሎቶች ውስጥ እኛ አካል አይደለንም።',
  arabic: 'تحكم هذه الشروط استخدامك لـ Workadabra. بإنشاء حساب فإنك توافق عليها. Workadabra سوق يربط الباحثين عن الخدمات بمزوّدين محليين؛ ولسنا طرفًا في الخدمات المُنفّذة بينهم.',
  bengali: 'এই শর্তাবলী Workadabra-এর আপনার ব্যবহার নিয়ন্ত্রণ করে। অ্যাকাউন্ট তৈরি করে আপনি এতে সম্মত হন। Workadabra একটি মার্কেটপ্লেস যা পরিষেবা প্রত্যাশীদের স্থানীয় প্রদানকারীদের সাথে সংযুক্ত করে; তাদের মধ্যে সম্পাদিত পরিষেবায় আমরা পক্ষ নই।',
  chinese: '这些条款约束您对 Workadabra 的使用。创建账户即表示您同意这些条款。Workadabra 是一个连接服务需求者与本地服务者的市场；我们不是双方之间所提供服务的当事方。',
  english: 'These terms govern your use of Workadabra. By creating an account you agree to them. Workadabra is a marketplace that connects service seekers with local providers; we are not a party to the services performed between them.',
  estonian: 'Need tingimused reguleerivad Workadabra kasutamist. Konto loomisega nõustud nendega. Workadabra on turg, mis ühendab teenuseotsijad kohalike teenusepakkujatega; me ei ole nende vahel osutatavate teenuste osapool.',
  filipino:
    'Pinamamahalaan ng mga tuntuning ito ang iyong paggamit ng Workadabra. Sa paggawa ng account, sumasang-ayon ka sa mga ito. Ang Workadabra ay isang marketplace na nag-uugnay sa mga naghahanap ng serbisyo sa mga lokal na provider; hindi kami parte sa mga serbisyong isinasagawa sa pagitan nila.',
  french: 'Ces conditions régissent votre utilisation de Workadabra. En créant un compte, vous les acceptez. Workadabra est une place de marché qui met en relation les demandeurs de services avec des prestataires locaux ; nous ne sommes pas partie aux services réalisés entre eux.',
  german: 'Diese Bedingungen regeln Ihre Nutzung von Workadabra. Mit der Erstellung eines Kontos stimmen Sie ihnen zu. Workadabra ist ein Marktplatz, der Dienstleistungssuchende mit lokalen Anbietern verbindet; wir sind nicht Vertragspartei der zwischen ihnen erbrachten Dienstleistungen.',
  hindi: 'ये शर्तें Workadabra के आपके उपयोग को नियंत्रित करती हैं। खाता बनाकर आप इनसे सहमत होते हैं। Workadabra एक मार्केटप्लेस है जो सेवा चाहने वालों को स्थानीय प्रदाताओं से जोड़ता है; उनके बीच की जाने वाली सेवाओं में हम पक्ष नहीं हैं।',
  indonesian: 'Ketentuan ini mengatur penggunaan Workadabra oleh Anda. Dengan membuat akun, Anda menyetujuinya. Workadabra adalah marketplace yang menghubungkan pencari layanan dengan penyedia lokal; kami bukan pihak dalam layanan yang dilakukan di antara mereka.',
  japanese: 'これらの規約は、お客様による Workadabra の利用を規定します。アカウントを作成することで、これらに同意したものとみなされます。Workadabra はサービスを求める人と地域のプロバイダーをつなぐマーケットプレイスであり、当社は両者の間で行われるサービスの当事者ではありません。',
  korean: '이 약관은 귀하의 Workadabra 사용을 규율합니다. 계정을 생성함으로써 약관에 동의하게 됩니다. Workadabra는 서비스 이용자를 지역 제공자와 연결하는 마켓플레이스이며, 당사는 양자 간에 수행되는 서비스의 당사자가 아닙니다.',
  portuguese: 'Estes termos regem a sua utilização da Workadabra. Ao criar uma conta, você concorda com eles. A Workadabra é um marketplace que liga quem procura serviços a prestadores locais; não somos parte nos serviços prestados entre eles.',
  russian: 'Эти условия регулируют использование вами Workadabra. Создавая учётную запись, вы соглашаетесь с ними. Workadabra: это площадка, связывающая заказчиков услуг с местными исполнителями; мы не являемся стороной услуг, оказываемых между ними.',
  spanish: 'Estos términos rigen tu uso de Workadabra. Al crear una cuenta, los aceptas. Workadabra es un mercado que conecta a quienes buscan servicios con proveedores locales; no somos parte de los servicios prestados entre ellos.',
  swahili: 'Masharti haya yanaongoza matumizi yako ya Workadabra. Kwa kuunda akaunti unakubaliana nayo. Workadabra ni soko linalounganisha watafutaji wa huduma na watoa huduma wa eneo lako; sisi si sehemu ya huduma zinazotolewa kati yao.',
  vietnamese: 'Các điều khoản này điều chỉnh việc bạn sử dụng Workadabra. Bằng việc tạo tài khoản, bạn đồng ý với chúng. Workadabra là một sàn giao dịch kết nối người tìm dịch vụ với nhà cung cấp địa phương; chúng tôi không phải là một bên trong các dịch vụ được thực hiện giữa họ.',
};

export const termsAccountsHeading: Translation = {
  amharic: 'መለያዎች እና ብቁነት',
  arabic: 'الحسابات والأهلية',
  bengali: 'অ্যাকাউন্ট ও যোগ্যতা',
  chinese: '账户与资格',
  english: 'Accounts & eligibility',
  estonian: 'Kontod ja sobivus',
  filipino: 'Mga account at pagiging karapat-dapat',
  french: 'Comptes et éligibilité',
  german: 'Konten & Berechtigung',
  hindi: 'खाते और पात्रता',
  indonesian: 'Akun & kelayakan',
  japanese: 'アカウントと利用資格',
  korean: '계정 및 자격',
  portuguese: 'Contas e elegibilidade',
  russian: 'Учётные записи и право на использование',
  spanish: 'Cuentas y elegibilidad',
  swahili: 'Akaunti na ustahili',
  vietnamese: 'Tài khoản & điều kiện',
};

export const termsAccountAge: Translation = {
  amharic: 'በአገርዎ የሕግ ዕድሜ ላይ መሆን እና ትክክለኛ መረጃ ማቅረብ አለብዎት።',
  arabic: 'يجب أن تكون في السنّ القانونية في بلدك وأن تقدّم معلومات دقيقة.',
  bengali: 'আপনাকে আপনার দেশে আইনি বয়সের হতে হবে এবং সঠিক তথ্য প্রদান করতে হবে।',
  chinese: '您必须达到您所在国家/地区的法定年龄并提供准确信息。',
  english: 'You must be of legal age in your country and provide accurate information.',
  estonian: 'Pead olema oma riigis seadusliku eaga ja esitama täpset teavet.',
  filipino: 'Dapat ay nasa legal na edad ka sa iyong bansa at magbigay ng tumpak na impormasyon.',
  french: 'Vous devez avoir l’âge légal dans votre pays et fournir des informations exactes.',
  german: 'Sie müssen in Ihrem Land volljährig sein und korrekte Angaben machen.',
  hindi: 'आपको अपने देश में कानूनी आयु का होना चाहिए और सटीक जानकारी प्रदान करनी चाहिए।',
  indonesian: 'Anda harus cukup umur secara hukum di negara Anda dan memberikan informasi yang akurat.',
  japanese: 'お住まいの国で法定年齢に達しており、正確な情報を提供する必要があります。',
  korean: '거주 국가에서 법적 연령에 도달해야 하며 정확한 정보를 제공해야 합니다.',
  portuguese: 'Você deve ter a maioridade legal no seu país e fornecer informações precisas.',
  russian: 'Вы должны достичь совершеннолетия в своей стране и предоставлять точную информацию.',
  spanish: 'Debes tener la edad legal en tu país y proporcionar información precisa.',
  swahili: 'Lazima uwe na umri wa kisheria katika nchi yako na utoe taarifa sahihi.',
  vietnamese: 'Bạn phải đủ tuổi hợp pháp ở quốc gia của mình và cung cấp thông tin chính xác.',
};

export const termsAccountVerify: Translation = {
  amharic: 'አቅራቢዎች አገልግሎት ከማቅረባቸው በፊት የማንነት ማረጋገጫ እና ማንኛውንም የአገልግሎት እና የአገር-ተኮር መስፈርቶችን ማለፍ አለባቸው።',
  arabic: 'يجب أن يجتاز المزوّدون التحقق من الهوية وأي متطلبات خاصة بالخدمة وبالبلد قبل تقديم الخدمة.',
  bengali: 'প্রদানকারীদের একটি পরিষেবা প্রদানের আগে পরিচয় যাচাই এবং যেকোনো পরিষেবা- ও দেশ-নির্দিষ্ট প্রয়োজনীয়তা পাস করতে হবে।',
  chinese: '服务者在提供服务前必须通过身份验证以及任何特定于服务和国家/地区的要求。',
  english: 'Providers must pass identity verification and any service- and country-specific requirements before offering a service.',
  estonian: 'Teenusepakkujad peavad enne teenuse pakkumist läbima isikutuvastuse ning kõik teenuse- ja riigipõhised nõuded.',
  filipino: 'Dapat pumasa ang mga provider sa pag-verify ng pagkakakilanlan at anumang partikular sa serbisyo at bansang kinakailangan bago mag-alok ng serbisyo.',
  french: 'Les prestataires doivent passer la vérification d’identité et toutes les exigences propres au service et au pays avant de proposer un service.',
  german: 'Anbieter müssen vor dem Anbieten eines Service die Identitätsprüfung sowie alle service- und länderspezifischen Anforderungen bestehen.',
  hindi: 'प्रदाताओं को सेवा प्रदान करने से पहले पहचान सत्यापन और किसी भी सेवा- और देश-विशिष्ट आवश्यकताओं को पास करना होगा।',
  indonesian: 'Penyedia harus lulus verifikasi identitas dan persyaratan khusus layanan dan negara sebelum menawarkan layanan.',
  japanese: 'プロバイダーは、サービスを提供する前に本人確認、ならびにサービス別および国別の要件を満たす必要があります。',
  korean: '제공자는 서비스를 제공하기 전에 신원 확인 및 서비스별·국가별 요건을 통과해야 합니다.',
  portuguese: 'Os prestadores devem passar pela verificação de identidade e por quaisquer requisitos específicos do serviço e do país antes de oferecer um serviço.',
  russian: 'Перед предоставлением услуги исполнители должны пройти проверку личности и любые требования, зависящие от услуги и страны.',
  spanish: 'Los proveedores deben superar la verificación de identidad y cualquier requisito específico del servicio y del país antes de ofrecer un servicio.',
  swahili: 'Watoa huduma lazima wapite uthibitishaji wa utambulisho na mahitaji yoyote mahususi ya huduma na nchi kabla ya kutoa huduma.',
  vietnamese: 'Nhà cung cấp phải vượt qua xác minh danh tính và bất kỳ yêu cầu cụ thể nào theo dịch vụ và theo quốc gia trước khi cung cấp dịch vụ.',
};

export const termsAccountResponsible: Translation = {
  amharic: 'በመለያዎ ላይ ለሚደረግ እንቅስቃሴ እና የመግቢያ ምስክርነቶችዎን ደህንነታቸውን ለመጠበቅ ኃላፊነቱ የእርስዎ ነው።',
  arabic: 'أنت مسؤول عن النشاط على حسابك وعن الحفاظ على أمان بيانات اعتماد تسجيل الدخول الخاصة بك.',
  bengali: 'আপনার অ্যাকাউন্টের কার্যকলাপের জন্য এবং আপনার লগইন তথ্য সুরক্ষিত রাখার জন্য আপনি দায়ী।',
  chinese: '您对账户中的活动以及妥善保管登录凭证负责。',
  english: 'You are responsible for activity on your account and for keeping your credentials secure.',
  estonian: 'Sina vastutad oma kontol toimuva tegevuse ja oma sisselogimisandmete turvalisena hoidmise eest.',
  filipino: 'Ikaw ang responsable sa aktibidad sa iyong account at sa pagpapanatiling ligtas ng iyong mga kredensyal.',
  french: 'Vous êtes responsable de l’activité sur votre compte et de la sécurité de vos identifiants.',
  german: 'Sie sind für die Aktivitäten in Ihrem Konto und für die Sicherheit Ihrer Anmeldedaten verantwortlich.',
  hindi: 'आप अपने खाते की गतिविधि और अपने क्रेडेंशियल को सुरक्षित रखने के लिए जिम्मेदार हैं।',
  indonesian: 'Anda bertanggung jawab atas aktivitas di akun Anda dan menjaga keamanan kredensial Anda.',
  japanese: 'お客様は、ご自身のアカウント上の活動および認証情報の安全な管理について責任を負います。',
  korean: '귀하는 계정 활동과 자격 증명을 안전하게 유지할 책임이 있습니다.',
  portuguese: 'Você é responsável pela atividade na sua conta e por manter as suas credenciais seguras.',
  russian: 'Вы несёте ответственность за действия в вашей учётной записи и за сохранность ваших учётных данных.',
  spanish: 'Eres responsable de la actividad en tu cuenta y de mantener seguras tus credenciales.',
  swahili: 'Wewe ndiye unayehusika na shughuli kwenye akaunti yako na kuweka taarifa zako za kuingia salama.',
  vietnamese: 'Bạn chịu trách nhiệm về hoạt động trên tài khoản của mình và về việc giữ an toàn cho thông tin đăng nhập.',
};

export const termsPaymentsHeading: Translation = {
  amharic: 'ክፍያዎች',
  arabic: 'المدفوعات',
  bengali: 'পেমেন্ট',
  chinese: '付款',
  english: 'Payments',
  estonian: 'Maksed',
  filipino: 'Mga Pagbabayad',
  french: 'Paiements',
  german: 'Zahlungen',
  hindi: 'भुगतान',
  indonesian: 'Pembayaran',
  japanese: '支払い',
  korean: '결제',
  portuguese: 'Pagamentos',
  russian: 'Платежи',
  spanish: 'Pagos',
  swahili: 'Malipo',
  vietnamese: 'Thanh toán',
};

export const termsPaymentsBody: Translation = {
  amharic: 'ለአገልግሎት የሚደረግ ክፍያ በማስቀመጫ ይያዛል እና አገልግሎቱ ሲጠናቀቅ ለአቅራቢው ይለቀቃል። እስከ መጠናቀቅ ድረስ ተመላሽ ይደረጋል፣ በተመላሽ እና በክርክር ሂደታችን መሠረት። Workadabra በተጠናቀቀ ሥራ ላይ ትንሽ ኮሚሽን ያስከፍላል፤ ምዝገባዎች የሉም።',
  arabic: 'يُحتفظ بالدفع مقابل الخدمة في حساب ضمان ويُفرج عنه للمزوّد عند اكتمال الخدمة. وهو قابل للاسترداد حتى الاكتمال، وفقًا لعملية الاسترداد وحل النزاعات لدينا. تفرض Workadabra عمولة صغيرة لكل مهمة مكتملة؛ ولا توجد اشتراكات.',
  bengali: 'একটি পরিষেবার পেমেন্ট এসক্রোতে রাখা হয় এবং পরিষেবা সম্পন্ন হলে প্রদানকারীকে ছেড়ে দেওয়া হয়। সম্পন্ন হওয়া পর্যন্ত এটি ফেরতযোগ্য, আমাদের ফেরত ও বিরোধ প্রক্রিয়া সাপেক্ষে। Workadabra প্রতিটি সম্পন্ন কাজে সামান্য কমিশন নেয়; কোনো সাবস্ক্রিপশন নেই।',
  chinese: '服务款项将被托管，并在服务完成时放款给服务者。在完成前可退款，须遵循我们的退款与争议流程。Workadabra 对每笔已完成的工作收取少量佣金；没有订阅费。',
  english: 'Payment for a service is held in escrow and released to the provider when the service is completed. It is refundable until completion, subject to our refund and dispute process. Workadabra charges a small commission per completed job; there are no subscriptions.',
  estonian: 'Teenuse eest tasutud makse hoitakse deposiidis ja vabastatakse teenusepakkujale teenuse lõpetamisel. See on tagastatav kuni lõpetamiseni, järgides meie tagasimakse- ja vaidlusprotsessi. Workadabra võtab iga lõpetatud töö eest väikese vahendustasu; tellimusi ei ole.',
  filipino:
    'Ang bayad para sa isang serbisyo ay itinatago sa escrow at ibinibigay sa provider kapag natapos na ang serbisyo. Maaari itong i-refund hanggang sa pagtatapos, alinsunod sa aming refund at dispute process. Naniningil ang Workadabra ng maliit na komisyon kada natapos na trabaho; walang subscription.',
  french:
    'Le paiement d’un service est conservé sous séquestre et versé au prestataire à l’achèvement du service. Il est remboursable jusqu’à l’achèvement, sous réserve de notre processus de remboursement et de litige. Workadabra prélève une petite commission par mission terminée ; il n’y a pas d’abonnement.',
  german:
    'Die Zahlung für einen Service wird treuhänderisch verwahrt und nach Abschluss des Service an den Anbieter freigegeben. Sie ist bis zum Abschluss erstattungsfähig, vorbehaltlich unseres Erstattungs- und Streitbeilegungsprozesses. Workadabra erhebt pro abgeschlossenem Auftrag eine kleine Provision; es gibt keine Abonnements.',
  hindi: 'किसी सेवा का भुगतान एस्क्रो में रखा जाता है और सेवा पूरी होने पर प्रदाता को जारी किया जाता है। यह पूरा होने तक वापसी योग्य है, हमारी रिफंड और विवाद प्रक्रिया के अधीन। Workadabra प्रति पूर्ण कार्य एक छोटा कमीशन लेता है; कोई सदस्यता नहीं है।',
  indonesian: 'Pembayaran untuk suatu layanan disimpan di escrow dan dilepaskan ke penyedia saat layanan selesai. Dapat dikembalikan hingga selesai, sesuai proses pengembalian dana dan sengketa kami. Workadabra mengenakan komisi kecil per pekerjaan yang selesai; tidak ada langganan.',
  japanese: 'サービスの支払いはエスクローで保管され、サービス完了時にプロバイダーへ支払われます。完了までは、当社の返金および紛争処理プロセスに従って返金可能です。Workadabra は完了した仕事ごとに少額の手数料を請求します。サブスクリプションはありません。',
  korean: '서비스 대금은 에스크로에 보관되며 서비스가 완료되면 제공자에게 지급됩니다. 완료 전까지는 환불 및 분쟁 절차에 따라 환불이 가능합니다. Workadabra는 완료된 작업당 소액의 수수료를 부과하며, 구독료는 없습니다.',
  portuguese: 'O pagamento de um serviço é mantido em garantia e liberado ao prestador quando o serviço é concluído. É reembolsável até a conclusão, sujeito ao nosso processo de reembolso e disputa. A Workadabra cobra uma pequena comissão por trabalho concluído; não há assinaturas.',
  russian: 'Оплата за услугу удерживается на счёте эскроу и переводится исполнителю по завершении услуги. Она подлежит возврату до завершения в соответствии с нашим процессом возврата и разрешения споров. Workadabra взимает небольшую комиссию за каждый выполненный заказ; подписок нет.',
  spanish:
    'El pago de un servicio se mantiene en depósito de garantía y se libera al proveedor cuando el servicio se completa. Es reembolsable hasta la finalización, sujeto a nuestro proceso de reembolso y disputa. Workadabra cobra una pequeña comisión por cada trabajo completado; no hay suscripciones.',
  swahili: 'Malipo ya huduma huhifadhiwa katika escrow na kuachiliwa kwa mtoa huduma huduma inapokamilika. Yanaweza kurejeshwa hadi kukamilika, kulingana na mchakato wetu wa kurejesha pesa na migogoro. Workadabra hutoza kamisheni ndogo kwa kila kazi iliyokamilika; hakuna usajili.',
  vietnamese:
    'Khoản thanh toán cho một dịch vụ được giữ trong ký quỹ và giải ngân cho nhà cung cấp khi dịch vụ hoàn thành. Khoản này có thể được hoàn lại cho đến khi hoàn thành, tùy theo quy trình hoàn tiền và giải quyết tranh chấp của chúng tôi. Workadabra thu một khoản hoa hồng nhỏ cho mỗi công việc hoàn thành; không có gói đăng ký.',
};

export const termsConductHeading: Translation = {
  amharic: 'ምግባር እና ማቋረጥ',
  arabic: 'السلوك والإنهاء',
  bengali: 'আচরণ ও সমাপ্তি',
  chinese: '行为与终止',
  english: 'Conduct & termination',
  estonian: 'Käitumine ja lõpetamine',
  filipino: 'Pag-uugali at pagwawakas',
  french: 'Conduite et résiliation',
  german: 'Verhalten & Kündigung',
  hindi: 'आचरण और समाप्ति',
  indonesian: 'Perilaku & penghentian',
  japanese: '行為と利用停止',
  korean: '행동 및 해지',
  portuguese: 'Conduta e rescisão',
  russian: 'Поведение и прекращение',
  spanish: 'Conducta y terminación',
  swahili: 'Mwenendo na kusitishwa',
  vietnamese: 'Ứng xử & chấm dứt',
};

export const termsConductBody: Translation = {
  amharic: 'ሌሎችን በአክብሮት ይያዙ፣ ሕግን እና የማኅበረሰብ መመሪያዎቻችንን ይከተሉ እና መድረኩን አላግባብ አይጠቀሙ። እነዚህን ውሎች የሚጥሱ ወይም ማኅበረሰቡን ለአደጋ የሚያጋልጡ መለያዎችን ልናግድ ወይም ልናቋርጥ እንችላለን።',
  arabic: 'عامل الآخرين باحترام، والتزم بالقانون وبإرشادات مجتمعنا، ولا تُسئ استخدام المنصّة. قد نعلّق أو ننهي الحسابات التي تنتهك هذه الشروط أو تعرّض المجتمع للخطر.',
  bengali: 'অন্যদের সাথে সম্মানের সাথে আচরণ করুন, আইন ও আমাদের কমিউনিটি নির্দেশিকা মেনে চলুন এবং প্ল্যাটফর্মের অপব্যবহার করবেন না। যেসব অ্যাকাউন্ট এই শর্ত লঙ্ঘন করে বা সম্প্রদায়কে ঝুঁকিতে ফেলে, সেগুলো আমরা স্থগিত বা বন্ধ করতে পারি।',
  chinese: '尊重他人，遵守法律及我们的社区准则，不得滥用平台。对于违反这些条款或危及社区的账户，我们可能予以暂停或终止。',
  english: "Treat others with respect, follow the law and our community guidelines, and don't misuse the platform. We may suspend or terminate accounts that violate these terms or put the community at risk.",
  estonian: 'Suhtu teistesse austusega, järgi seadust ja meie kogukonna juhiseid ning ära kuritarvita platvormi. Võime peatada või lõpetada kontod, mis rikuvad neid tingimusi või seavad kogukonna ohtu.',
  filipino: 'Igalang ang iba, sundin ang batas at ang aming community guidelines, at huwag abusuhin ang platform. Maaari naming suspindihin o wakasan ang mga account na lumalabag sa mga tuntuning ito o naglalagay sa panganib sa komunidad.',
  french: 'Traitez les autres avec respect, respectez la loi et nos règles communautaires, et n’abusez pas de la plateforme. Nous pouvons suspendre ou résilier les comptes qui enfreignent ces conditions ou mettent la communauté en danger.',
  german: 'Behandeln Sie andere mit Respekt, befolgen Sie das Gesetz und unsere Community-Richtlinien und missbrauchen Sie die Plattform nicht. Wir können Konten sperren oder kündigen, die gegen diese Bedingungen verstoßen oder die Community gefährden.',
  hindi: 'दूसरों के साथ सम्मान से पेश आएं, कानून और हमारे सामुदायिक दिशानिर्देशों का पालन करें, और प्लेटफ़ॉर्म का दुरुपयोग न करें। हम उन खातों को निलंबित या समाप्त कर सकते हैं जो इन शर्तों का उल्लंघन करते हैं या समुदाय को जोखिम में डालते हैं।',
  indonesian: 'Perlakukan orang lain dengan hormat, patuhi hukum dan pedoman komunitas kami, dan jangan menyalahgunakan platform. Kami dapat menangguhkan atau menghentikan akun yang melanggar ketentuan ini atau membahayakan komunitas.',
  japanese: '他者を敬い、法律および当社のコミュニティガイドラインに従い、プラットフォームを悪用しないでください。本規約に違反する、またはコミュニティを危険にさらすアカウントは、停止または解約する場合があります。',
  korean: '타인을 존중하고 법률과 커뮤니티 가이드라인을 준수하며 플랫폼을 오용하지 마세요. 당사는 본 약관을 위반하거나 커뮤니티를 위험에 빠뜨리는 계정을 정지하거나 해지할 수 있습니다.',
  portuguese: 'Trate os outros com respeito, cumpra a lei e as nossas diretrizes da comunidade e não faça uso indevido da plataforma. Podemos suspender ou encerrar contas que violem estes termos ou coloquem a comunidade em risco.',
  russian: 'Относитесь к другим с уважением, соблюдайте закон и наши правила сообщества и не злоупотребляйте платформой. Мы можем приостановить или закрыть учётные записи, нарушающие эти условия или подвергающие сообщество риску.',
  spanish: 'Trata a los demás con respeto, cumple la ley y nuestras normas comunitarias, y no hagas un uso indebido de la plataforma. Podemos suspender o cancelar cuentas que infrinjan estos términos o pongan en riesgo a la comunidad.',
  swahili: 'Watendee wengine kwa heshima, fuata sheria na miongozo yetu ya jamii, na usitumie jukwaa vibaya. Tunaweza kusimamisha au kusitisha akaunti zinazokiuka masharti haya au kuhatarisha jamii.',
  vietnamese: 'Hãy tôn trọng người khác, tuân thủ pháp luật và nguyên tắc cộng đồng của chúng tôi, và không lạm dụng nền tảng. Chúng tôi có thể tạm ngưng hoặc chấm dứt các tài khoản vi phạm các điều khoản này hoặc gây rủi ro cho cộng đồng.',
};

export const termsContactHeading: Translation = {
  amharic: 'ግንኙነት',
  arabic: 'التواصل',
  bengali: 'যোগাযোগ',
  chinese: '联系',
  english: 'Contact',
  estonian: 'Kontakt',
  filipino: 'Contact',
  french: 'Contact',
  german: 'Kontakt',
  hindi: 'संपर्क',
  indonesian: 'Kontak',
  japanese: 'お問い合わせ',
  korean: '연락처',
  portuguese: 'Contacto',
  russian: 'Контакты',
  spanish: 'Contacto',
  swahili: 'Mawasiliano',
  vietnamese: 'Liên hệ',
};

export const termsContactBody: Translation = {
  amharic: 'ስለ እነዚህ ውሎች ጥያቄዎች? በ {email} ያግኙን።',
  arabic: 'أسئلة حول هذه الشروط؟ تواصل معنا على {email}.',
  bengali: 'এই শর্তাবলী সম্পর্কে প্রশ্ন? আমাদের সাথে {email}-এ যোগাযোগ করুন।',
  chinese: '对这些条款有疑问？请通过 {email} 与我们联系。',
  english: 'Questions about these terms? Reach us at {email}.',
  estonian: 'Küsimusi nende tingimuste kohta? Võta meiega ühendust aadressil {email}.',
  filipino: 'May tanong tungkol sa mga tuntuning ito? Makipag-ugnayan sa amin sa {email}.',
  french: 'Des questions sur ces conditions ? Contactez-nous à {email}.',
  german: 'Fragen zu diesen Bedingungen? Kontaktieren Sie uns unter {email}.',
  hindi: 'इन शर्तों के बारे में प्रश्न? हमसे {email} पर संपर्क करें।',
  indonesian: 'Ada pertanyaan tentang ketentuan ini? Hubungi kami di {email}.',
  japanese: 'これらの規約についてご質問は？ {email} までご連絡ください。',
  korean: '이 약관에 대해 궁금한 점이 있으신가요? {email}으로 문의해 주세요.',
  portuguese: 'Dúvidas sobre estes termos? Fale connosco em {email}.',
  russian: 'Вопросы об этих условиях? Свяжитесь с нами по адресу {email}.',
  spanish: '¿Preguntas sobre estos términos? Contáctanos en {email}.',
  swahili: 'Maswali kuhusu masharti haya? Wasiliana nasi kwa {email}.',
  vietnamese: 'Có thắc mắc về các điều khoản này? Liên hệ với chúng tôi tại {email}.',
};
